{
  "tooltipsButtons": {
    "chat": {
      "composer": {
        "attachFile": "Attach file",
        "emoji": "Insert emoji",
        "insertMention": "Mention contact",
        "send": "Send message",
        "stop": "Stop response",
        "startVoice": "Start voice recording",
        "stopVoice": "Stop voice recording"
      },
      "codeBlock": {
        "copy": "Copy code",
        "copied": "Copied",
        "download": "Download code"
      },
      "webPreview": {
        "refresh": "Refresh preview",
        "openExternal": "Open in new tab",
        "back": "Go back",
        "forward": "Go forward"
      },
      "manageQuickReplies": {
        "addReply": "Add reply",
        "deleteSection": "Delete section",
        "editLabel": "Click to edit label",
        "renameSection": "Click to rename section",
        "openColorPicker": "Choose section color",
        "dragHandle": "Drag to reorder"
      },
      "messenger": {
        "exitFullscreen": "Exit fullscreen",
        "back": "Back to contacts",
        "clearSearch": "Clear search"
      }
    },
    "eventTypes": {
      "card": {
        "edit": "Edit event type",
        "deactivate": "Deactivate event type",
        "dragHandle": "Drag to reorder"
      },
      "customFields": {
        "removeField": "Remove field"
      }
    },
    "auth": {
      "passwordToggle": {
        "show": "Show password",
        "hide": "Hide password"
      }
    },
    "shared": {
      "copy": "Copy to clipboard",
      "copied": "Copied",
      "togglePlan": "Toggle plan"
    },
    "notifications": {
      "open": "Open notifications"
    },
    "settings": {
      "open": "Open settings",
      "close": "Close settings",
      "vacation": {
        "add": "Add vacation period",
        "remove": "Delete vacation period",
        "recordStart": "Record start date",
        "recordEnd": "Record end date",
        "stopRecord": "Stop recording",
        "pickDateRange": "Pick date range",
        "templates": "Open templates"
      }
    },
    "navigation": {
      "openSidebar": "Open sidebar",
      "closeSidebar": "Close sidebar",
      "documents": "Documents",
      "calendar": "Calendar",
      "dashboard": "Dashboard",
      "previous": "Previous",
      "next": "Next"
    },
    "documents": {
      "editDefaultTemplate": "Edit default document template",
      "openCalendar": "Open calendar"
    },
    "admin": {
      "orgSecrets": {
        "toggleVisibility": "Toggle visibility",
        "close": "Close"
      }
    }
  },
  "tooltipsTours": {
    "dashboard": {
      "step1Title": "Your dashboard at a glance",
      "step1Description": "Real-time numbers about your activity.",
      "step1Item0Title": "Total events",
      "step1Item0Caption": "Track every event booked in the selected range — see what's trending period over period.",
      "step1Item0KpiLabel": "Total events",
      "step1Item0KpiValue": "1,247",
      "step1Item0KpiDelta": "+12.4%",
      "step1Item0KpiFooter": "vs. previous period",
      "step1Item1Title": "Response time",
      "step1Item1Caption": "How fast your agent replies — watch the line drop as you tune playbooks.",
      "step1Item1ChartLabel": "Avg response time (min)",
      "step1Item2Title": "Message heatmap",
      "step1Item2Caption": "Spot the busy hours so you can staff coverage when it actually matters.",
      "step1Item2HeatmapLabel": "Busy hours · last 7 days",
      "step2Title": "Read your KPIs",
      "step2Description": "What the big numbers actually mean.",
      "step2KpiConvTitle": "Total events",
      "step2KpiConvValue": "1,247",
      "step2KpiConvDelta": "+12.4%",
      "step2KpiConvHelp": "Events booked in the selected range. Look at the delta — anything above +5% means real demand growth.",
      "step2KpiResponseTitle": "Conversion rate",
      "step2KpiResponseValue": "38%",
      "step2KpiResponseDelta": "+3.1%",
      "step2KpiResponseHelp": "Share of conversations that end in a booked event. A rising delta means the agent is closing more.",
      "step2KpiAvgTimeTitle": "Avg response",
      "step2KpiAvgTimeValue": "3.2m",
      "step2KpiAvgTimeDelta": "-18.0%",
      "step2KpiAvgTimeHelp": "Median time to first reply. Down arrow is good — faster replies, happier customers.",
      "step2KpiActiveTitle": "Active users",
      "step2KpiActiveValue": "47",
      "step2KpiActiveDelta": "+6.2%",
      "step2KpiActiveHelp": "Distinct contacts active in the selected range. Use it to plan capacity.",
      "step3Title": "Spot trends fast",
      "step3Description": "Charts auto-update; hover for exact values.",
      "step3LineChartTitle": "Response time · 7 days",
      "step3LineChartCaption": "Median minutes to first reply, day by day.",
      "step3BarChartTitle": "Events by day",
      "step3BarChartCaption": "Events created, broken down by weekday.",
      "step3HoverHint": "Hover any point or bar to see the exact value.",
      "step4Title": "Pro tips",
      "step4Description": "Get the most out of your dashboard.",
      "step4TipsHeading": "Tips",
      "step4Tip1": "Five tabs — Overview, Trends, Messages, Insights, Feedback — each with its own charts.",
      "step4Tip2": "Pick any date range from the header — every card and chart follows it.",
      "step4Tip3": "Use the Insights tab for AI-generated summaries.",
      "step4Tip4": "Export the whole dashboard as CSV, PDF, JSON, or DOCX from the export button in the header.",
      "completeLabel": "Got it",
      "dayMon": "Mon",
      "dayTue": "Tue",
      "dayWed": "Wed",
      "dayThu": "Thu",
      "dayFri": "Fri",
      "daySat": "Sat",
      "daySun": "Sun"
    },
    "config": {
      "step1Title": "Configure your workspace",
      "step1Description": "6 tabs cover everything from hours to notifications.",
      "step1FeatureGeneralTitle": "General",
      "step1FeatureGeneralDescription": "Workspace language, default country, and global agent prompts.",
      "step1FeatureCalendarDisplayTitle": "Calendar display",
      "step1FeatureCalendarDisplayDescription": "Choose what's visible on the calendar — colors, badges, and slot density.",
      "step1FeatureColumnsTitle": "Columns",
      "step1FeatureColumnsDescription": "Toggle which fields appear in your data tables and in what order.",
      "step1FeatureEmailTemplatesTitle": "Email templates",
      "step1FeatureEmailTemplatesDescription": "Edit the automated emails sent on bookings, reminders, and follow-ups.",
      "step1FeatureNotificationsTitle": "Notifications",
      "step1FeatureNotificationsDescription": "Route alerts per channel and silence them during quiet hours.",
      "step1FeatureWorkingHoursTitle": "Working hours",
      "step1FeatureWorkingHoursDescription": "Set when your team is available — defaults, overrides, and custom ranges.",
      "step1ItemCounter": "Tab {{n}} of {{total}}",
      "step2Title": "Working hours, your way",
      "step2Description": "Set core hours, custom ranges, and per-day overrides.",
      "step2CardTitle": "Working Days",
      "step2CardDescription": "Choose working days and default hours.",
      "step2WorkingDaysLabel": "Working days",
      "step2WorkingDaysTooltip": "Days of the week your business takes bookings. Disabled days show as closed in the calendar.",
      "step2DayMon": "Mon",
      "step2DayTue": "Tue",
      "step2DayWed": "Wed",
      "step2DayThu": "Thu",
      "step2DayFri": "Fri",
      "step2DaySat": "Sat",
      "step2DaySun": "Sun",
      "step2DefaultHoursLabel": "Default hours",
      "step2StartTimeLabel": "Start",
      "step2EndTimeLabel": "End",
      "step2SlotDurationLabel": "Slot duration",
      "step2SlotDurationTooltip": "Length of each bookable slot. Choose from durations that evenly divide your working window.",
      "step2SlotDurationValue": "1h",
      "step2CustomRangeTitle": "Custom range",
      "step2CustomRangeBadge": "1 active",
      "step2CustomRangeName": "Wednesday short day",
      "step2CustomRangeMeta": "Wednesday · 10:00 – 14:00",
      "step3Title": "Saving changes",
      "step3Description": "Edit freely; save when you're ready.",
      "step3SaveBarLabel": "Unsaved changes",
      "step3DiscardLabel": "Discard",
      "step3SaveButtonIdle": "Save changes (3)",
      "step3SaveButtonSaving": "Saving…",
      "step3SaveButtonSaved": "Saved",
      "step3Subtitle": "We track unsaved edits in the bottom bar. Discard rolls back; Save commits everything at once.",
      "step4Title": "Power-user tips",
      "step4Description": "Things most teams miss.",
      "step4TipsTitle": "Tips",
      "step4Tip1": "Each tab saves independently — no need to commit all at once.",
      "step4Tip2": "Working hours feed into the calendar's availability indicator.",
      "step4Tip3": "Email templates support liquid-style variables: {{contactName}}, {{eventDate}}.",
      "step4Tip4": "Notifications can route per-event-type — open the Notifications tab to set rules.",
      "completeLabel": "Start configuring",
      "welcome": {
        "title": "Configure your workspace",
        "description": "Six tabs cover the main areas."
      },
      "overview": {
        "general": {
          "title": "General",
          "description": "Language and default behavior for the whole workspace."
        },
        "calendarDisplay": {
          "title": "Calendar display",
          "description": "What shows on the calendar — views, colors, and density."
        },
        "columns": {
          "title": "Columns",
          "description": "Data table column visibility and ordering."
        },
        "emailTemplates": {
          "title": "Email templates",
          "description": "Automated message content for confirmations and reminders."
        },
        "notifications": {
          "title": "Notifications",
          "description": "Channel routing and quiet hours per event type."
        },
        "workingHours": {
          "title": "Working hours",
          "description": "When the team is available to take bookings."
        }
      },
      "workingHours": {
        "title": "Working hours, your way",
        "description": "Set core hours, custom ranges, and per-day overrides.",
        "daysCard": {
          "title": "Working days",
          "description": "Choose working days and the default hours that apply to each."
        },
        "startTime": {
          "label": "Start time",
          "tooltip": "Earliest time of day appointments can be booked. Slots before this time will be hidden."
        },
        "endTime": {
          "label": "End time",
          "tooltip": "Latest time of day appointments can be booked. Slots after this time will be hidden."
        },
        "customCard": {
          "title": "Custom calendar ranges",
          "description": "Override the default hours for specific days or date ranges."
        },
        "customRange": {
          "tag": "Custom"
        }
      },
      "save": {
        "title": "Saving changes",
        "description": "Edit freely, save when ready.",
        "actionsLabel": "Actions",
        "button": "Save",
        "undo": "Undo",
        "discard": "Discard",
        "explainer": {
          "batched": "Edits are tracked in the bottom bar and committed together when you press Save.",
          "discard": "Discard rolls back every pending change at once — nothing is touched until you save."
        }
      },
      "tips": {
        "title": "Power-user tips",
        "description": "Things most teams miss.",
        "perTab": "Each tab tracks its own pending changes — counts on the side bar tell you exactly where edits live.",
        "availability": "Working hours feed the calendar's availability indicator and gate which slots can be booked.",
        "templates": "Email templates support variables like {{contactName}} and {{eventDate}} — they expand at send time.",
        "routing": "Notifications can be routed per event type from the Notifications tab — pair quiet hours with channel overrides."
      }
    },
    "account": {
      "welcome": {
        "title": "Your account, your control",
        "description": "Tour the sections in under a minute."
      },
      "overview": {
        "profile": {
          "title": "Profile",
          "description": "Your name, email, and avatar — the basics other people see."
        },
        "security": {
          "title": "Security",
          "description": "Active sessions and passkeys, all in one place."
        },
        "privacy": {
          "title": "Privacy",
          "description": "Set retention windows and export your data anytime."
        },
        "appearance": {
          "title": "Appearance",
          "description": "Theme mode, colors, and component style — make it yours."
        }
      },
      "preview": {
        "profile": {
          "name": "Aisha Saleh",
          "email": "aisha@bavard.com"
        },
        "security": {
          "heading": "All clear",
          "session1": "Chrome on macOS",
          "thisDevice": "This device",
          "passkey": "MacBook Pro · Passkey"
        },
        "privacy": {
          "heading": "Conversations",
          "conversations": "Auto-delete window"
        },
        "appearance": {
          "heading": "Theme"
        }
      },
      "security": {
        "title": "Keep your account secure",
        "description": "Passkeys are easier and safer than passwords.",
        "sessionsTitle": "Active sessions",
        "sessionsSubtitle": "Devices currently signed in to your account.",
        "session": {
          "current": {
            "label": "Chrome on macOS",
            "meta": "Riyadh · 2 minutes ago"
          },
          "old": {
            "label": "Safari on iPhone 14",
            "meta": "Jeddah · 6 days ago"
          }
        },
        "thisDevice": "This device",
        "revoke": "Revoke",
        "passkeyLabel": "MacBook Pro",
        "passkeyMeta": "Added Apr 28, 2026",
        "passkeyExplainer": "A passkey lets you sign in with your fingerprint or face — no passwords needed."
      },
      "privacy": {
        "title": "Your data, your terms",
        "description": "Set retention windows and export anytime.",
        "retentionTitle": "Data retention",
        "retentionSubtitle": "How long each kind of data sticks around before automatic deletion.",
        "retention": {
          "conversations": "Conversations",
          "attachments": "Attachments",
          "auditLogs": "Audit logs"
        },
        "exportLabel": "Export my data",
        "exportExplainer": "Get a ZIP of everything we have on you, anytime.",
        "exportCta": "Export"
      },
      "appearance": {
        "title": "Make it yours",
        "description": "Mode, theme color, and component style — all switchable.",
        "theme": "Theme",
        "style": "Style",
        "colors": "Theme color",
        "light": "Light",
        "dark": "Dark",
        "system": "System",
        "embossed": "Embossed",
        "flat": "Flat",
        "tipTheme": "Theme follows your system by default — toggle Light or Dark to override.",
        "tipColors": "Hover a theme color to preview it live — nothing changes until you click.",
        "tipStyle": "Embossed gives controls depth and texture; Flat keeps them minimal. Switch anytime."
      },
      "completeLabel": "Got it"
    },
    "calendar": {
      "closeAriaLabel": "Close tour",
      "skipLabel": "Skip tour",
      "backLabel": "Back",
      "nextLabel": "Next",
      "completeLabel": "Get started",
      "step1": {
        "title": "Welcome to your calendar",
        "description": "Here's how to get the most out of it — three minutes, four screens.",
        "item": {
          "conversations": {
            "title": "Every conversation in one place",
            "caption": "WhatsApp, Telegram, Instagram, and webchat threads sit beside the calendar so you reply without losing context."
          },
          "calendar": {
            "title": "A calendar that bends to you",
            "caption": "Drag, drop, and resize events. Switch between day, week, and month views — your changes save instantly."
          },
          "notifications": {
            "title": "Stay on top of every update",
            "caption": "Mentions, new bookings, and reminders surface in one tidy panel — never an overwhelming inbox."
          }
        }
      },
      "step2": {
        "title": "Manage your conversations",
        "description": "Pin, archive, or jump into any chat from the sidebar.",
        "surface": {
          "label": "Conversations"
        },
        "annotation": {
          "pin": {
            "label": "Pin priority chats",
            "description": "Keep VIP customers and active threads anchored to the top."
          },
          "archive": {
            "label": "Archive when done",
            "description": "Hide closed threads without deleting their history."
          },
          "search": {
            "label": "Find anyone fast",
            "description": "Search by name, phone, or message contents at any time."
          }
        },
        "tips": {
          "title": "Tips"
        },
        "tip": {
          "open": "Click a conversation to open it in the main panel.",
          "reorder": "Pin the chats you're working on and archive the done ones — unread and mention badges keep the rest visible.",
          "search": "Use search to find old conversations even after they're archived."
        }
      },
      "step3": {
        "title": "Schedule your day",
        "description": "Drag to move, click to edit, click empty time to create.",
        "subtext": "Drag any event to reschedule. Click empty time to add a new one.",
        "choice": {
          "move": {
            "title": "Drag to reschedule",
            "description": "Grab an event and drop it on a new time slot — changes save instantly."
          },
          "create": {
            "title": "Click empty time to add",
            "description": "Click any open slot to create a new event with a single keystroke."
          }
        }
      },
      "step4": {
        "title": "Notifications keep you informed",
        "description": "The bell icon shows what's new the moment it happens.",
        "surface": {
          "label": "Notifications"
        },
        "tips": {
          "title": "Tips"
        },
        "tip": {
          "click": "Click a notification to jump straight to its source — message, event, or contact.",
          "autoread": "Notifications mark themselves read once you've opened the panel."
        }
      },
      "preview": {
        "conversations": {
          "label": "Inbox"
        },
        "calendar": {
          "label": "Today"
        },
        "notifications": {
          "label": "Recent"
        }
      },
      "mock": {
        "contact": {
          "alex": "Alex Rivera",
          "maya": "Maya Park",
          "sam": "Sam Lloyd"
        },
        "preview": {
          "alex": "Confirming our 11am — see you then ☕",
          "maya": "@you can we move design review?",
          "sam": "Thanks! Talk next week."
        },
        "event": {
          "standup": "Daily standup",
          "coffee": "Coffee with Alex",
          "review": "Design review"
        },
        "notification": {
          "message": {
            "title": "New message from Maya",
            "subtitle": "Mentioned you in a thread."
          },
          "event": {
            "title": "Event reminder · Coffee with Alex",
            "subtitle": "Starting in one hour."
          }
        }
      }
    },
    "documents": {
      "welcome": {
        "title": "A handwritten document for every contact",
        "description": "Write freely on a drawing canvas with your tablet pen — each contact gets their own document."
      },
      "skipAriaLabel": "Close tour",
      "backLabel": "Back",
      "nextLabel": "Next",
      "completeLabel": "Got it",
      "overview": {
        "write": {
          "title": "Write naturally",
          "description": "A full drawing canvas with pen, shapes, and text — built for tablet and stylus, works with a mouse too."
        },
        "contact": {
          "title": "One document per contact",
          "description": "The details panel on top shows whose document you're on — everything you write is kept with that contact."
        },
        "autosave": {
          "title": "Saves as you write",
          "description": "Every stroke is saved automatically — the status indicator tells you when everything is safely stored."
        }
      },
      "preview": {
        "write": {
          "toolbarLabel": "Draw, write, erase"
        },
        "contact": {
          "heading": "Contact details",
          "nameLabel": "Name",
          "nameValue": "Sarah Chen",
          "phoneLabel": "Phone"
        },
        "autosave": {
          "savedLabel": "Saved"
        }
      },
      "canvas": {
        "title": "The contact drives the canvas",
        "description": "The panel above the canvas shows the loaded contact — complete their details and the canvas is yours.",
        "editLabel": "Edit",
        "canvasCaption": "Write anywhere on the canvas — your ink is kept exactly as you drew it.",
        "lockHint": "The canvas stays locked until the contact's required fields are filled in."
      },
      "tips": {
        "title": "Good to know",
        "description": "Three things that make the documents page click.",
        "heading": "Try these next"
      },
      "tip": {
        "loadContact": "Switch documents from the calendar drawer — press Ctrl+Alt+S and use \"Load contact\".",
        "lock": "Canvas locked? Fill in the contact's required fields in the panel above it first.",
        "viewer": "Enable the viewer in the page settings for a split reading pane, or go fullscreen for distraction-free writing."
      }
    },
    "activity": {
      "welcome": {
        "title": "Every change, in one feed",
        "description": "Activity captures who did what and when — across your entire workspace."
      },
      "skipAriaLabel": "Close tour",
      "backLabel": "Back",
      "nextLabel": "Next",
      "completeLabel": "Got it",
      "overview": {
        "changes": {
          "title": "See what changed",
          "description": "Live notifications when teammates create, edit, or remove anything that touches your work."
        },
        "tabs": {
          "title": "Focus with All / Unread",
          "description": "Two tabs at the top: everything, or only what you haven't seen. Mark all read clears the backlog in one tap."
        },
        "actions": {
          "title": "Act right from the feed",
          "description": "Reply to messages inline, jump to the event a notification points at, or dismiss the noise."
        }
      },
      "preview": {
        "changes": {
          "heading": "Latest activity",
          "line1": "Sarah created \"Quarterly review\"",
          "line2": "Calendar · 2 minutes ago"
        },
        "tabs": {
          "all": "All",
          "unread": "Unread"
        },
        "actions": {
          "messageTitle": "Maya: \"Can we move our 4pm?\"",
          "messageMeta": "WhatsApp · just now",
          "reply": "Reply",
          "viewEvent": "View event",
          "dismiss": "Dismiss"
        }
      },
      "timeline": {
        "title": "Read the timeline",
        "description": "Entries are grouped into Today and Earlier, freshest first. Updates show what changed right on the card.",
        "heading": "Activity",
        "markAll": "Mark all read",
        "bucket": {
          "today": "Today",
          "earlier": "Earlier"
        }
      },
      "feed": {
        "sarahCreate": {
          "title": "Sarah Chen created \"Quarterly review\"",
          "subtitle": "Calendar event · 30 min, scheduled for Friday"
        },
        "tomUpdate": {
          "title": "Tom Hardy updated working hours",
          "subtitle": "Config · Mondays moved 9am → 8am"
        },
        "systemNotify": {
          "title": "System sent a re-engagement notification",
          "subtitle": "Notifications · 12 inactive contacts"
        },
        "alexInvite": {
          "title": "Alex Park invited a teammate",
          "subtitle": "Members · jordan@bavard.com joined as Editor"
        },
        "mayaCancel": {
          "title": "Maya Patel cancelled \"Intro call\"",
          "subtitle": "Calendar event · was scheduled for Apr 30"
        }
      },
      "tips": {
        "title": "Get more from activity",
        "description": "Three habits that keep the feed working for you.",
        "heading": "Try these next"
      },
      "tip": {
        "click": "Message notifications have a Reply button — answer inline without ever leaving the feed.",
        "filter": "Live on the Unread tab and hit Mark all read once you've caught up — the badge stays honest.",
        "export": "Keep scrolling: older entries load automatically until you reach the end of your history."
      }
    },
    "admin": {
      "welcome": {
        "title": "Run the workspace",
        "description": "Approve users, manage organizations, and invite whole teams from one place."
      },
      "skipAriaLabel": "Close tour",
      "backLabel": "Back",
      "nextLabel": "Next",
      "completeLabel": "Got it",
      "overview": {
        "awaiting": {
          "title": "Users awaiting approval",
          "description": "New sign-ups land here — review, assign, and unblock them in seconds."
        },
        "orgs": {
          "title": "Org management",
          "description": "Edit organizations inline in the grid — name, slug, plan, active state — then save everything in one batch."
        },
        "invites": {
          "title": "Invitations",
          "description": "Invite members by email with a role — the org's seat limit is enforced automatically."
        }
      },
      "preview": {
        "awaiting": {
          "heading": "Awaiting assignment",
          "user": "Priya Patel · priya.patel@acme.co"
        },
        "orgs": {
          "heading": "Active organizations",
          "acme": "Acme Co.",
          "north": "Northwind Labs",
          "pine": "Pinegrove Studio"
        },
        "invites": {
          "heading": "Invite a teammate",
          "subtitle": "Email + role — counted against the org's plan seats.",
          "cta": "Send invite"
        }
      },
      "approve": {
        "title": "Assign waiting users",
        "description": "Each row carries the plan the user signed up for — assign them to a fresh org or an existing one.",
        "heading": "Waiting users",
        "refreshLabel": "Auto-refreshing",
        "column": {
          "user": "User",
          "plan": "Plan",
          "actions": "Actions"
        },
        "approve": "New org",
        "decline": "Existing org"
      },
      "tips": {
        "title": "Admin best practices",
        "description": "Three rules that keep your workspace healthy.",
        "heading": "Try these next"
      },
      "tip": {
        "assign": "Assign to new org creates a paid org with the plan the user signed up for and makes them its owner — one click.",
        "invite": "Grid edits are batched — the tab badge counts pending changes until you hit Save.",
        "audit": "The waiting-users list refreshes itself every 30 seconds — no need to reload the page."
      }
    }
  },
  "tooltipsTabs": {
    "account": {
      "credentialsSessions": "Email, password, passkeys, and active sign-in sessions",
      "privacyData": "Export your data, manage retention, and control privacy",
      "profile": "Display name, avatar, and personal contact details",
      "notifications": "How and when you're notified across categories",
      "appearance": "Pick the theme, accent color, and language for your account"
    },
    "activity": {
      "all": "Every notification you've received, read or unread",
      "unread": "Only notifications you haven't opened yet"
    },
    "admin": {
      "overview": "High-level admin metrics across all organizations",
      "waiting": "Users awaiting approval to join an organization",
      "organizations": "Manage organizations, plans, and billing",
      "members": "Browse and manage every member account in the system",
      "roles": "Define roles and the permissions each role grants",
      "system": "Live health, queues, and resource usage of the platform",
      "feedback": "User-submitted feedback and bug reports for the app"
    },
    "adminSecrets": {
      "whatsapp": "WhatsApp Cloud API credentials and webhook verification",
      "messenger": "Facebook Messenger page access tokens and app secret",
      "slack": "Slack bot token, signing secret, and OAuth client",
      "discord": "Discord bot token and application credentials",
      "telegram": "Telegram bot identity, routing handle, and webhook credentials",
      "teams": "Microsoft Teams app registration credentials",
      "gchat": "Google Chat service account credentials JSON",
      "github": "GitHub personal access token or App credentials",
      "linear": "Linear API key and OAuth client credentials",
      "ai": "API keys for AI providers (OpenRouter)",
      "instagram": "Instagram professional-account credentials and webhook verification",
      "x": "X application credentials, organization account tokens, webhook, and encrypted Chat setup"
    },
    "config": {
      "schedule": "Working hours, slot length, and per-event-type scheduling",
      "eventTypes": "Define the bookable event types your customers can choose",
      "calendarDisplay": "Calendar layout, default view, time format, and color scheme",
      "columns": "Pick which columns appear on the calendar and documents tables",
      "appearance": "Themes, fonts, and the languages users can switch to",
      "aiAssistant": "AI persona, system prompts, and response behavior",
      "business": "Country, timezone, currency, and business location",
      "notificationRules": "Reminders and follow-ups sent automatically for events",
      "whatsapp": "Control the AI tools available on every customer messaging channel",
      "emailTemplates": "Reusable email templates for confirmations and reminders"
    },
    "configContent": {
      "calendarColumns": "Choose which columns appear on the calendar/data table page",
      "documentsColumns": "Choose which columns appear on the documents page"
    },
    "documentsViewSettings": {
      "documents": "Settings for the document editor and reading pane",
      "calendar": "Settings for the calendar pane shown beside documents"
    },
    "eventTypes": {
      "basics": "Name, color, and core settings for this event type",
      "duration": "Slot length, buffer time, and minimum notice",
      "fields": "Custom fields collected when booking this event",
      "rules": "Booking limits, availability windows, and recurrence"
    },
    "settings": {
      "view": "Layout density, default view, and visible columns",
      "general": "Theme, language, time format, and other defaults",
      "vacation": "Block off date ranges so the calendar refuses bookings"
    }
  },
  "system_error_try_later": "System error, please try again later",
  "event_manager": "Bavard",
  "chat": "Chat",
  "left_calendar": "Left Calendar",
  "right_calendar": "Right Calendar",
  "cancel_event": "Cancel Event",
  "cancelled_event": "Cancelled Event",
  "reinstate_event": "Reinstate Event",
  "past_event": "Past Event",
  "open_conversation": "Open Conversation",
  "open_document": "Open Document",
  "view_details": "View Details",
  "save_error": "Save Error",
  "config_save_no_changes": "No changes to save",
  "config_save_version_conflict": "Configuration was changed elsewhere. Reload the latest version and try again.",
  "config_conflict_dialog_title": "Resolve setting conflicts",
  "config_conflict_dialog_desc": "Everything else has been merged already. These settings were changed by someone else while you were editing them — pick which value to keep.",
  "config_conflict_mine_label": "Yours",
  "config_conflict_theirs_label": "Theirs",
  "config_conflict_take_all_mine": "Keep all mine",
  "config_conflict_take_all_theirs": "Take all theirs",
  "config_conflict_cancel": "Cancel save",
  "config_conflict_save_merged": "Save merged",
  "config_save_conflict_cancelled": "Save cancelled.",
  "config_save_ignored_keys": "{{count}} unrecognized setting(s) were ignored while saving.",
  "theme_changed": "Theme changed",
  "validation_errors": "Validation Errors",
  "missing_required_fields": "Missing required fields",
  "please_fill_prefix": "Please fill: ",
  "create_failed": "Create Failed",
  "create_failed_verbose": "Failed to create event",
  "cancel_failed": "Cancel Failed",
  "update_failed": "Update Failed",
  "request_label": "Request",
  "reason_label": "reason",
  "view_default": "Default",
  "view_default_tooltip_title": "Default view",
  "view_default_tooltip_desc": "Standard single calendar layout with a balanced, familiar UI.",
  "view_free": "Free",
  "view_free_tooltip_title": "Free roam",
  "view_free_tooltip_desc": "Flexible navigation and layout for fast, unconstrained browsing.",
  "view_dual": "Dual",
  "view_dual_tooltip_title": "Dual calendar",
  "view_dual_tooltip_desc": "View two calendars side by side for comparison and parallel planning.",
  "chat_type_message": "Type a message…",
  "chat_x_ttl_label": "Expires after",
  "chat_x_ttl_placeholder": "Milliseconds",
  "chat_x_ttl_help": "Optional for encrypted X Chat messages; leave blank for no override.",
  "chat_voice_start_recording": "Start voice input",
  "chat_voice_stop_recording": "Stop voice input",
  "chat_voice_permission_denied": "Microphone permission denied",
  "chat_voice_hold_to_record": "Press and hold to record",
  "chat_voice_release_to_send": "Release to send",
  "chat_voice_slide_to_cancel": "Slide to cancel",
  "chat_voice_release_to_cancel": "Release to cancel",
  "chat_voice_cancel_recording": "Cancel recording",
  "chat_voice_release_to_lock": "Release to lock",
  "chat_voice_locked": "Hands-free recording",
  "chat_voice_paused": "Paused",
  "chat_voice_pause": "Pause recording",
  "chat_voice_resume": "Resume recording",
  "chat_voice_send": "Send voice message",
  "chat_mic_select": "Select microphone",
  "chat_mic_default": "Default microphone",
  "chat_mic_permission": "Allow microphone access to see devices",
  "chat_voice_recording": "Recording…",
  "chat_voice_send_failed": "Failed to send voice message",
  "chat_audio_play": "Play",
  "chat_audio_pause": "Pause",
  "chat_audio_seek_forward": "Skip forward 10 seconds",
  "chat_audio_seek_back": "Skip back 10 seconds",
  "chat_audio_playback_speed": "Playback speed",
  "chat_audio_attachment_alt": "Voice message",
  "chat_audio_load_failed": "Couldn't load audio",
  "chat_attachment_preview": "Attachment preview",
  "chat_attachment_open": "Open in new tab",
  "chat_attachment_preview_unavailable": "This format cannot be previewed in the browser. You can still open or download it.",
  "chat_attachment_download_failed": "Couldn't download the attachment",
  "chat_no_conversation": "Select a conversation to start chatting",
  "chat_no_messages": "No messages in this conversation yet",
  "chat_start_conversation": "Start the conversation by sending a message",
  "chat_system_agent_greeting_hello": "Hello there!",
  "chat_system_agent_greeting_help": "How can I help you today?",
  "chat_cannot_message_no_conversation": "You can't send messages to users who haven't started a conversation",
  "chat_messaging_unavailable": "Messaging unavailable after 24h inactivity",
  "chat_ai_not_configured": "AI assistant not configured. Contact your administrator.",
  "chat_loading_conversation": "Loading conversation…",
  "chat_loading_conversations": "Loading conversations…",
  "chat_select_conversation": "Select a conversation",
  "chat_contact_no_messaging_address": "This contact has no messaging address.",
  "chat_no_conversations": "No conversations available",
  "chat_message_sent": "Message sent",
  "chat_message_failed": "Failed to send message",
  "chat_instagram_routing_unavailable": "Instagram conversation routing is unavailable",
  "chat_instagram_send_failed": "Failed to send Instagram message",
  "chat_backend_unavailable": "Chat service is temporarily unavailable. Please try again.",
  "chat_demo_limit_reached": "You've reached the demo limit — sign up to continue.",
  "chat_today": "Today",
  "chat_yesterday": "Yesterday",
  "tool_approval_required_title": "Approval Required",
  "tool_approval_required_description": "The tool {toolName} requires your approval before execution.",
  "tool_approval_required_parameters": "Parameters",
  "tool_approval_required_approve": "Approve",
  "tool_approval_required_deny": "Deny",
  "tool_approval_required_processing": "Processing approval…",
  "chat_actions_label": "Conversation actions",
  "chat_actions_trigger_label": "Open conversation actions",
  "chat_action_add_favorite": "Add to favorites",
  "chat_action_remove_favorite": "Remove from favorites",
  "chat_action_block": "Block user",
  "chat_action_unblock": "Unblock user",
  "chat_action_download": "Export…",
  "chat_action_disable_ai": "Disable AI",
  "chat_action_clear": "Clear conversation",
  "chat_action_summarize": "Summarize with AI",
  "chat_action_save_as_qa": "Save as Q&A",
  "summary_dialog_title": "Conversation summary",
  "summary_dialog_streaming": "Generating summary in real time…",
  "summary_dialog_done": "Summary ready.",
  "summary_dialog_error": "Could not generate summary.",
  "summary_dialog_saving": "Saving…",
  "summary_dialog_saved": "Saved to dashboard.",
  "summary_dialog_thinking": "Thinking…",
  "summary_dialog_save": "Save",
  "summary_dialog_saved_short": "Saved",
  "summary_dialog_download": "Download",
  "summary_dialog_close": "Close",
  "summary_section_overview": "Overview",
  "summary_section_reservations": "Reservations",
  "summary_section_feedback": "Feedback",
  "summary_section_notes": "Notes",
  "summary_section_issues": "Open issues",
  "summary_col_date": "Date",
  "summary_col_time": "Time",
  "summary_col_type": "Type",
  "summary_col_status": "Status",
  "clear_conversation": "Clear conversation",
  "clear_conversation_warning": "Are you sure you want to clear this conversation? This action cannot be undone.",
  "clearing": "Clearing…",
  "clear": "Clear",
  "chat_action_favorited": "Added to favorites",
  "chat_action_unfavorited": "Removed from favorites",
  "chat_action_blocked": "Contact blocked",
  "chat_action_unblocked": "Contact unblocked",
  "chat_action_cleared": "Conversation cleared",
  "chat_action_error": "Action failed. Please try again.",
  "ai_stream_error_title": "The assistant ran into a problem",
  "chat_blocked_notice": "You blocked this contact. Unblock to continue messaging.",
  "chat_approval_pending_badge": "Needs approval",
  "chat_approval_pending_tooltip": "An AI tool call is waiting for your approval",
  "chat_tool_approval_failed": "Failed to submit the approval decision",
  "chat_system_agent_disabled_notice": "The system agent is turned off for this workspace. Enable it in Configuration → AI Assistant to chat with it again.",
  "messenger_contacts": "Conversations",
  "messenger_inbox_title": "Inbox",
  "messenger_unread_count_label": "unread conversations",
  "messenger_refresh": "Refresh",
  "messenger_sort_and_actions": "Sort and actions",
  "messenger_sort_by": "Sort by",
  "messenger_sort_date_newest": "Date (newest first)",
  "messenger_sort_date_oldest": "Date (oldest first)",
  "messenger_sort_sender": "Sender",
  "messenger_actions": "Actions",
  "messenger_mark_all_read": "Mark all as read",
  "messenger_archive_all_read": "Archive all read",
  "messenger_compose": "Compose",
  "messenger_compose_disabled": "Compose (coming soon)",
  "messenger_tab_all": "All",
  "messenger_tab_unread": "Unread",
  "messenger_tab_files": "Files",
  "messenger_tab_starred": "Starred",
  "messenger_channel_filter": "Filter by channel",
  "messenger_channel_all": "All",
  "messenger_filter_tabs": "Filter conversations",
  "messenger_tag": "Tag",
  "messenger_labels": "Labels",
  "messenger_no_labels": "No labels yet",
  "messenger_new_label": "New label…",
  "messenger_reorder_label": "Reorder {{label}}",
  "messenger_label_order_failed": "Couldn't save tag order",
  "messenger_archived": "Archived",
  "messenger_download": "Download attachment",
  "messenger_archive": "Archive",
  "messenger_unarchive": "Unarchive",
  "messenger_new_label_title": "New label",
  "messenger_label_name": "Name",
  "messenger_label_name_placeholder": "e.g. Design, Work, Finance",
  "messenger_label_color": "Color",
  "messenger_label_preview": "Preview",
  "messenger_create_label": "Create label",
  "messenger_conversations": "conversations",
  "messenger_search_placeholder": "Search contacts…",
  "messenger_search_clear": "Clear search",
  "messenger_no_results": "No conversations found",
  "messenger_try_different_search": "Try a different search term",
  "messenger_exit_fullscreen": "Exit fullscreen",
  "messenger_welcome_title": "Welcome to Messenger",
  "messenger_welcome_description": "Select a conversation from the left panel to start chatting. Your messages are synced in real-time.",
  "messenger_shortcut_hint": "Press to exit fullscreen",
  "messenger_tap_to_view": "Tap to view messages",
  "messenger_start_conversation": "Start a conversation",
  "documents": "Documents",
  "documents_calendar": "Documents Calendar",
  "documents_no_user_loaded_title": "No contact loaded",
  "documents_no_user_loaded_hint": "Open the calendar drawer and use Load contact to pick a contact.",
  "documents_default_document_loaded": "Loading the default document — no contact details to show.",
  "documents_load_contact": "Find a contact",
  "save": "Save",
  "loading": "Loading…",
  "saving": "Saving…",
  "saved": "Saved",
  "saved_local": "Saved — local",
  "ready": "Ready",
  "error": "Error",
  "age_recorded": "Age recorded",
  "save_failed": "Save failed",
  "locked": "Locked",
  "unsaved_changes": "Unsaved changes",
  "default_contact": "Default",
  "typing": "Typing",
  "document_unlock_prompt": "Enter name and phone to unlock",
  "document_lock_message": "Please enter both name and phone, or load a user",
  "document_loading": "Loading document…",
  "documents_empty_title": "No document open",
  "documents_empty_description": "Enter a name and phone number to open a document, or find the contact by name or from one of their appointments.",
  "documents_empty_load_client": "Open a contact's documents",
  "documents_empty_load_via_appointment": "Open from an appointment",
  "documents_switch_contact": "Switch to another contact",
  "documents_find_contact": "Find a contact…",
  "documents_from_appointment": "From an appointment…",
  "documents_switch_contact_short": "Switch contact",
  "documents_open_appointment_short": "From appointment",
  "documents_layout_label": "Page layout",
  "documents_layout_single": "One page",
  "documents_layout_side_by_side": "Two pages side by side",
  "documents_layout_stacked": "Two pages stacked",
  "local": "Local",
  "view_changed": "View changed",
  "load_more": "Load More",
  "settings": "Settings",
  "configuration": "Configuration",
  "breadcrumb_home": "Home",
  "breadcrumb_navigation": "Breadcrumb navigation",
  "breadcrumb_campaign_new": "New campaign",
  "breadcrumb_campaign_details": "Campaign details",
  "config_header_subtitle": "Configure your application preferences",
  "config_header_badge": "Control center",
  "config_header_status_synced": "Synced",
  "config_header_updated_label": "Updated",
  "config_dock_last_saved_label": "Last saved",
  "config_header_timezone_label": "Timezone",
  "timezone_country_choose_button": "Choose country timezone",
  "timezone_country_choose": "This country has multiple timezones. Choose your business timezone.",
  "timezone_auto_button": "Use country timezone",
  "timezone_auto_badge": "Country",
  "timezone_auto_badge_hint": "Timezone for your selected phone country",
  "timezone_auto_select_country": "Select a country first",
  "timezone_auto_already_set": "Already set to the country's timezone",
  "working_days_auto_button": "Auto",
  "working_days_auto_select_country": "Select a country first",
  "working_days_auto_already_set": "Already matches the country's standard working days",
  "working_days_auto_unavailable": "No working-day data for this country",
  "first_day_auto_button": "Auto",
  "first_day_auto_select_country": "Select a country first",
  "first_day_auto_already_set": "Already matches the country's first day of week",
  "first_day_auto_unavailable": "No first-day-of-week data for this country",
  "config_header_languages_label": "Languages",
  "config_nav_group_scheduling": "Scheduling",
  "config_nav_group_calendar": "Calendar",
  "config_nav_group_data": "Data",
  "config_nav_group_appearance": "Appearance",
  "config_nav_group_ai_business": "AI & Business",
  "config_nav_group_integrations": "Integrations",
  "config_nav_group_administration": "Administration",
  "config_nav_group_display": "Display",
  "config_nav_group_business": "Business",
  "config_nav_group_ai": "AI",
  "config_nav_group_communications": "Communications",
  "config_nav_scheduling": "Scheduling",
  "config_nav_availability": "Availability",
  "config_nav_display": "Display",
  "config_nav_table_columns": "Table Columns",
  "config_nav_themes_languages": "Languages",
  "config_nav_ai_assistant": "AI Assistant",
  "config_nav_ai_agents": "AI Agents",
  "config_nav_ai_agents_tooltip": "Multi-agent RAG answering: researcher and verifier subagents",
  "config_agents_mode_title": "Answering Mode",
  "config_agents_mode_description": "How the assistant answers from your knowledge base. Higher modes add agents that ground and fact-check answers — at extra cost and latency.",
  "config_agents_mode_single": "Single",
  "config_agents_mode_single_hint": "One agent answers directly with grounded citations. Fastest and cheapest — no extra model calls.",
  "config_agents_mode_researcher": "Researcher",
  "config_agents_mode_researcher_hint": "A researcher subagent gathers evidence first, then the main agent answers from it. More accurate on complex questions; adds one extra model.",
  "config_agents_mode_verifier": "Researcher + Verifier",
  "config_agents_mode_verifier_hint": "Adds a verifier that fact-checks every claim against its citation and loops fixes. Most faithful; highest cost and latency.",
  "config_agents_researcher_model_label": "Researcher Model",
  "config_agents_researcher_model_description": "Model the researcher subagent uses to gather evidence. Unlocked in Researcher and Researcher + Verifier modes.",
  "config_agents_verifier_model_label": "Verifier Model",
  "config_agents_verifier_model_description": "Model the verifier uses to fact-check claims. A cheap utility-tier model is recommended. Unlocked in Researcher + Verifier mode.",
  "config_agents_verifier_max_loops_label": "Verifier Max Loops",
  "config_agents_verifier_max_loops_tooltip": "How many times the verifier may send fixes back before finalizing (1–3). More loops catch more issues but cost more.",
  "config_document_summary_model_group_title": "Document Summary",
  "config_document_summary_model_group_description": "The model that writes a one-paragraph summary of each document when it is ingested. Summaries ground retrieval and document overviews.",
  "config_document_summary_model_label": "Document Summary Model",
  "config_document_summary_model_description": "Model used at ingest to summarize documents. A cheap, fast model is recommended. Leave on Auto to use the default.",
  "config_sensitive_guard_group_title": "Sensitive Data Guard",
  "config_sensitive_guard_group_description": "Mask sensitive numbers pulled from your documents before the assistant sends a reply, on every channel. Detection is checksum-validated, so real card and bank numbers are caught while ordinary numbers are left alone.",
  "config_sensitive_guard_cards_label": "Mask card numbers",
  "config_sensitive_guard_cards_description": "Replace Luhn-valid payment card numbers with a masked value, keeping only the last four digits.",
  "config_sensitive_guard_ibans_label": "Mask bank IBANs",
  "config_sensitive_guard_ibans_description": "Replace valid IBANs with a masked value, keeping the country prefix and last four characters.",
  "config_sensitive_guard_national_ids_label": "Mask national IDs",
  "config_sensitive_guard_national_ids_description": "Replace national identity numbers with a masked value. Requires a country so the number format can be recognized.",
  "config_sensitive_guard_country_label": "National ID country",
  "config_sensitive_guard_country_description": "The country whose national ID format the guard looks for.",
  "config_sensitive_guard_country_sa": "Saudi Arabia",
  "config_sensitive_guard_country_eg": "Egypt",
  "config_agents_prompts_title": "Agent Prompts",
  "config_agents_prompts_description": "The instructions the researcher and verifier subagents run with.",
  "config_agents_prompts_readonly_note": "These prompts are shown for reference and are not editable yet. The pipeline runs with these defaults.",
  "cfgpage_read_only": "Read-only",
  "config_agents_researcher_prompt_label": "Researcher Prompt",
  "config_agents_researcher_prompt_description": "Instructions for the evidence-gathering researcher subagent.",
  "config_agents_researcher_prompt_placeholder": "Leave empty to use the built-in researcher instructions.",
  "config_agents_verifier_prompt_label": "Verifier Prompt",
  "config_agents_verifier_prompt_description": "Instructions for the citation-faithfulness verifier.",
  "config_agents_verifier_prompt_placeholder": "Leave empty to use the built-in verifier instructions.",
  "config_agents_editor_unavailable": "Editor unavailable",
  "rag_preview_open_aria": "Preview {{filename}}",
  "config_nav_business_regional": "Business & Regional",
  "config_nav_notifications": "Notifications",
  "config_nav_whatsapp": "AI tool permissions",
  "config_nav_user_management": "User Management",
  "config_available_themes_title": "Available Themes",
  "config_available_themes_description": "Control which visual themes appear inside the in-app theme picker",
  "config_available_themes_placeholder": "Select themes…",
  "config_available_themes_validation": "At least one theme must remain available",
  "config_available_themes_hint": "Users only see the themes you keep enabled here.",
  "config_available_languages_title": "Available Languages",
  "config_available_languages_description": "Choose which languages are available to end users.",
  "config_available_languages_placeholder": "Select languages…",
  "config_available_languages_always_enabled": "(always enabled)",
  "config_available_languages_installed_count": "{{count}} installed",
  "config_default_country_prefix_title": "Default Country Prefix",
  "config_default_country_prefix_description": "Default country code used for phone selectors",
  "config_import_select_all": "Select All",
  "config_import_no_fields_found": "No fields found",
  "config_more_count": "+{{count}} more",
  "tab_view": "View",
  "tab_general": "General",
  "tab_vacation": "Vacation",
  "settings_view": "View Settings",
  "sync_settings_title": "Offline Sync",
  "sync_auto_toggle": "Auto Sync",
  "sync_auto_toggle_desc": "Sync automatically on reconnect and every minute while online",
  "sync_auto_enabled_toast": "Auto sync enabled",
  "sync_auto_disabled_toast": "Auto sync disabled",
  "sync_window_title": "Documents to keep offline",
  "sync_window_desc": "Use a moving recent window or choose an exact modification-date range",
  "sync_window_rolling": "Rolling window",
  "sync_window_custom": "Date range",
  "sync_months_label": "Recent document activity",
  "sync_months_option": "Last {{count}} months",
  "sync_date_from": "Modified from",
  "sync_date_to": "Modified through",
  "sync_contacts_optional": "Specific contacts (optional)",
  "sync_contacts_optional_desc": "Leave empty to sync every contact in the date window. Selecting contacts overrides the date window.",
  "sync_contacts_choose": "Choose contacts",
  "sync_contacts_dialog_title": "Choose offline contacts",
  "sync_contacts_dialog_desc": "Search the complete contact directory. Leave this list empty to keep the date window unrestricted.",
  "sync_contacts_selected": "Selected contacts",
  "sync_contacts_none_hint": "None selected — the date window applies to every contact.",
  "sync_contacts_override_hint": "Only these contacts will be kept in the automatic offline scope.",
  "sync_contacts_clear": "Clear all",
  "sync_contacts_remove": "Remove {{contact}}",
  "sync_progress_preparing": "Preparing sync",
  "sync_progress_contacts": "Syncing contacts",
  "sync_progress_uploading": "Uploading offline edits",
  "sync_progress_downloading": "Downloading documents",
  "sync_scope_all": "Sync All Documents",
  "sync_scope_all_desc": "Turn off to choose specific documents to keep offline",
  "sync_manage_button": "Manage",
  "sync_now_button": "Sync now",
  "sync_status_synced_prefix": "Last synced",
  "sync_status_never": "Not synced yet",
  "sync_status_syncing": "Syncing…",
  "sync_status_offline": "Offline — changes are saved on this device",
  "sync_status_error_prefix": "Sync error",
  "sync_pending_docs": "pending",
  "sync_conflicts_button": "Resolve conflicts",
  "sync_conflict_dialog_title": "Sync Conflicts",
  "sync_conflict_dialog_desc": "These items changed both on this device and on the server. Compare the versions and their times, then choose which one to keep.",
  "sync_conflict_local_label": "This device",
  "sync_conflict_server_label": "Server",
  "sync_conflict_keep_local": "Keep this device's version",
  "sync_conflict_keep_server": "Keep server version",
  "sync_conflict_version_prefix": "Version",
  "sync_conflict_side_meta": "{{pages}} pages · {{size}}",
  "sync_conflict_contact_title": "Contact name conflict",
  "sync_conflict_contact_desc": "This phone already exists on the server with a different name.",
  "sync_resolved_toast": "Conflict resolved",
  "sync_resolve_failed_toast": "Failed to resolve conflict",
  "sync_preview_enlarge": "Click to enlarge",
  "sync_preview_empty": "No preview",
  "sync_manage_dialog_title": "Offline Documents",
  "sync_manage_dialog_desc": "Choose which documents stay available offline, and open any of them — even without a connection.",
  "sync_manage_search_placeholder": "Search contacts",
  "sync_manage_open": "Open",
  "sync_manage_pending_badge": "Pending sync",
  "sync_manage_conflict_badge": "Conflict",
  "sync_manage_empty": "No offline documents yet",
  "settings_chat": "Chat Settings",
  "settings_viewer_enable": "Enable Viewer",
  "settings_viewer_enable_desc": "Show the top viewer canvas for document preview",
  "settings_viewer_enabled": "Viewer enabled",
  "settings_viewer_disabled": "Viewer disabled",
  "settings_viewer_split_lock": "Lock Split Pane",
  "settings_viewer_split_lock_desc": "Prevent the resizable split pane from being moved",
  "settings_viewer_split_locked": "Split pane locked",
  "settings_viewer_split_unlocked": "Split pane unlocked",
  "settings_viewer_toolbar_hide": "Hide Viewer Toolbar",
  "settings_viewer_toolbar_hide_desc": "Hide the bottom toolbar (select, hand, laser) in the viewer",
  "settings_viewer_toolbar_hidden": "Viewer toolbar hidden",
  "settings_viewer_toolbar_visible": "Viewer toolbar visible",
  "settings_editor": "Editor",
  "settings_editor_toolbar_size": "Toolbar Size",
  "settings_editor_toolbar_size_desc": "Resize the top-left toolbar buttons",
  "settings_toolbar_size_set_prefix": "Toolbar size set to",
  "settings_calendar_density": "Calendar Density",
  "settings_calendar_density_desc": "Adjust event text and spacing size",
  "settings_calendar_density_set_prefix": "Calendar density set to",
  "settings_calendar_density_decrease": "Decrease calendar density",
  "settings_calendar_density_increase": "Increase calendar density",
  "settings_calendar_density_input": "Calendar density percentage",
  "already_showing_today": "Already showing today",
  "go_to_today": "Go to today",
  "copy": "Copy",
  "copied": "Copied",
  "close_dialog": "Close dialog",
  "discard_changes": "Discard Changes",
  "save_and_close": "Save & Close",
  "cancel": "Cancel",
  "external_link_title": "Open external link?",
  "external_link_description": "You're about to visit an external website.",
  "copy_link": "Copy link",
  "open_link": "Open link",
  "data_editor_title": "Data Editor",
  "data_editor_description": "Editor for managing events and user data",
  "data_editor_empty_title": "No events scheduled",
  "data_editor_empty_desc": "There are no events in this time range yet. Add one to get started.",
  "data_editor_empty_add": "Add event",
  "save_changes": "Save",
  "unsaved_changes_prompt": "You have unsaved changes. Would you like to save your changes before closing?",
  "user_data_change_warning_title": "Update user data?",
  "user_data_change_warning_prompt": "Changing the name or phone here will update the user's data. Do you want to continue?",
  "save_and_update_user": "Save & Update User",
  "calendar": "Calendar",
  "contacts": "Contacts",
  "widgets": "Widgets",
  "msg_previous": "Previous",
  "msg_next": "Next",
  "feat_pagination_page_of": "Page {from} of {count}",
  "validation_issues": "Validation Issues",
  "validation_issues_details": "Please fix these issues before saving",
  "row": "Row",
  "cm_sort_asc": "Sort ascending",
  "cm_sort_desc": "Sort descending",
  "cm_pin_column": "Pin column",
  "cm_unpin_column": "Unpin column",
  "cm_hide_column": "Hide column",
  "cm_autosize_column": "Autosize column",
  "cm_format": "Format",
  "cm_format_automatic": "Automatic",
  "cm_format_localized": "Localized",
  "cm_format_distance": "Distance",
  "cm_format_calendar": "Calendar",
  "cm_close": "Close",
  "cm_filter_search": "Search values…",
  "cm_filter_select_all": "Select All",
  "cm_filter_no_matching": "No matching values",
  "cm_filter_no_values": "No values available",
  "cm_filter_clear": "Clear Filter",
  "field_scheduled_time": "Scheduled Time",
  "field_phone": "Phone",
  "field_type": "Type",
  "field_name": "Name",
  "field_age": "Age",
  "toast_event_created": "Event created",
  "toast_event_modified": "Event modified",
  "toast_event_modified_no_changes": "Event updated",
  "toast_event_cancelled": "Event cancelled",
  "toast_event_reinstated": "Event restored",
  "toast_event_modification_failed": "Event modification failed",
  "toast_event_creation_failed": "Event creation failed",
  "toast_event_cancellation_failed": "Event cancellation failed",
  "toast_user_active_updated": "Contact status updated",
  "toast_user_blocked": "Contact blocked",
  "toast_user_unblocked": "Contact unblocked",
  "toast_error_prefix": "Error",
  "toast_new_message": "Message",
  "toast_dismiss": "Dismiss",
  "toast_undo": "Undo",
  "toast_undo_successful": "Successfully undone",
  "toast_undo_failed": "Undo failed",
  "toast_error_generic": "An error occurred",
  "toast_no_connection_title": "No internet connection",
  "toast_no_connection_subtitle": "Your change wasn't saved. Reconnect and try again.",
  "phone_new_number_label": "New Phone Number",
  "dashboard_title": "Dashboard",
  "dashboard_subtitle": "Overview of your event and messaging performance",
  "dashboard_error_title": "Unable to load dashboard",
  "dashboard_try_again": "Try again",
  "dashboard_overview": "Overview",
  "dashboard_trends": "Trends",
  "dashboard_messages": "Messages",
  "dashboard_insights": "Insights",
  "dashboard_feedbacks_summaries": "Reports",
  "dashboard_feedbacks_summaries_short": "Reports",
  "dashboard_nav_feedbacks_summaries_desc": "AI-generated summaries and customer feedback",
  "feedbacks_summaries_eyebrow": "AI archive",
  "feedbacks_summaries_title": "Feedbacks & Summaries",
  "feedbacks_summaries_subtitle": "Saved AI summaries of conversations and feedback the assistant captured from customers.",
  "reports_load_error_title": "Unable to load this report",
  "reports_load_error_body": "The report request failed. Retry before treating this period as having no data.",
  "feedbacks_summaries_segment_summaries": "Summaries",
  "feedbacks_summaries_segment_feedbacks": "Feedbacks",
  "summaries_new_summary": "New summary",
  "summaries_empty_cta": "Summarize a conversation",
  "summarize_dialog_title": "Summarize a conversation",
  "summarize_dialog_subtitle": "Load a contact, choose the part of the conversation to summarize, and let the assistant write the summary.",
  "summarize_dialog_pick_contact": "Load a contact",
  "summarize_dialog_change_contact": "Change",
  "summarize_dialog_scope_title": "What to summarize",
  "summarize_dialog_last_messages": "Last messages",
  "summarize_dialog_last_messages_hint": "Caps both the preview and the summary request.",
  "summarize_dialog_date_range": "Date range",
  "summarize_dialog_date_range_any": "All time",
  "summarize_dialog_date_range_clear": "Clear date range",
  "summarize_dialog_preview_title": "Conversation preview",
  "summarize_dialog_preview_hint": "Only messages allowed by the controls above appear here. Optionally choose a start and end; every message between them will be included.",
  "summarize_dialog_boundary_clear": "Clear selection",
  "summarize_dialog_included_count": "{count} messages will be summarized",
  "summarize_dialog_loading_preview": "Loading conversation…",
  "summarize_dialog_preview_empty": "No messages match the current date range and limit.",
  "summarize_dialog_generate": "Generate summary",
  "summarize_dialog_cancel": "Cancel",
  "summaries_empty_title": "No summaries yet",
  "summaries_empty_body": "Open any conversation, click \"Summarize with AI\" in the menu, and save the result to see it here.",
  "summaries_no_overview": "No overview generated.",
  "summaries_chip_reservations": "reservations",
  "summaries_chip_feedback": "feedback",
  "summaries_chip_issues": "issues",
  "summaries_chip_messages": "messages",
  "summaries_delete": "Delete",
  "summaries_delete_confirm": "Permanently delete this summary? This cannot be undone.",
  "feedbacks_empty_title": "No feedback recorded yet",
  "feedbacks_empty_body": "When customers volunteer feedback, the assistant captures it here automatically.",
  "feedbacks_delete": "Delete",
  "feedbacks_delete_confirm": "Permanently delete this feedback? This cannot be undone.",
  "feedbacks_expand": "Expand feedback",
  "feedbacks_collapse": "Collapse feedback",
  "feedbacks_open_source_message": "Open message",
  "feedbacks_discussion": "Admin discussion",
  "feedbacks_comment_placeholder": "Add a comment for other admins…",
  "feedbacks_comment_send": "Send comment",
  "feedbacks_comments_empty": "No comments yet. Start the discussion.",
  "feedbacks_deleted_admin": "Deleted admin",
  "sentiment_all": "All",
  "sentiment_positive": "Positive",
  "sentiment_negative": "Negative",
  "sentiment_neutral": "Neutral",
  "dashboard_day": "day",
  "dashboard_days": "days",
  "dashboard_events": "events",
  "dashboard_select_date_range": "Select date range",
  "dashboard_seven_days": "7 days",
  "dashboard_thirty_days": "30 days",
  "dashboard_export": "Export",
  "dashboard_nav_overview_desc": "High-level KPIs and operations health",
  "dashboard_nav_trends_desc": "Bookings, cancellations, and funnel evolution",
  "dashboard_nav_messages_desc": "Conversation quality, response time, and peak hours",
  "dashboard_nav_insights_desc": "Actionable recommendations and system signals",
  "vacation": "Vacation",
  "msg_minutes": "min",
  "msg_seconds": "s",
  "notifications": "Notifications",
  "all": "All",
  "mark_all_as_read": "Mark all as read",
  "unread": "Unread",
  "no_notifications": "No notifications",
  "notifications_empty_state_description": "No new notifications at this time.",
  "view_all_notifications": "View all notifications",
  "conversation_navigation": "Conversation navigation",
  "older": "Older",
  "more_recent": "More Recent",
  "new_message": "New message",
  "backend_connection_ensure_localhost": "Ensure the server is running on http://localhost:8000",
  "phone_country_search_placeholder": "Search countries…",
  "phone_country_select_placeholder": "Select country",
  "phone_no_country_found": "No country found.",
  "phone_filter_country": "Country",
  "phone_filter_date_range": "Date Range",
  "media_filter_label": "Media",
  "media_kind_images": "Images",
  "media_kind_videos": "Videos",
  "media_kind_voice": "Voice notes",
  "media_kind_pdfs": "PDFs",
  "media_kind_documents": "Documents",
  "media_kind_spreadsheets": "Spreadsheets",
  "media_kind_text_files": "Text, CSV and JSON",
  "media_kind_other_files": "Other files",
  "chat_search_filters": "Search filters",
  "phone_filter_messages": "Messages",
  "phone_filter_events": "Events",
  "phone_filter_registration": "Registration",
  "phone_filter_registration_registered": "Registered",
  "phone_filter_registration_unknown": "Unknown",
  "phone_filter_status": "Status",
  "phone_filter_status_registered": "Registered",
  "phone_filter_status_unregistered": "Unregistered",
  "phone_filter_status_has_document": "Has a document",
  "phone_filter_status_blocked": "Blocked",
  "phone_filter_status_inactive": "Inactive",
  "phone_filter_status_active": "Active",
  "phone_filter_status_no_document": "No Doc",
  "phone_filter_status_has_doc_short": "Has Doc",
  "phone_filter_status_no_doc_short": "No Doc",
  "phone_filter_status_section_status": "Status",
  "phone_filter_status_section_moderation": "Moderation",
  "calendar_filter_title": "Filter",
  "calendar_new_booking": "New booking",
  "calendar_filter_clear_all": "Clear all",
  "calendar_filter_search_placeholder": "Search name or phone…",
  "calendar_filter_event_type": "Event Type",
  "calendar_filter_resource": "Resource",
  "calendar_filter_resource_only": "Resource events only",
  "calendar_filter_resource_only_overridden": "Off while an event type without a resource is selected.",
  "calendar_filter_booking_status": "Booking status",
  "phone_add_filter_button": "Add filter",
  "date_preset_today": "Today",
  "date_preset_yesterday": "Yesterday",
  "date_preset_last_7_days": "Last 7 days",
  "date_preset_last_14_days": "Last 14 days",
  "date_preset_last_30_days": "Last 30 days",
  "date_preset_month_to_date": "Month to date",
  "date_preset_this_month": "This month",
  "date_preset_last_month": "Last month",
  "date_preset_last_quarter": "Last quarter",
  "date_preset_year_to_date": "Year to date",
  "date_preset_last_year": "Last year",
  "date_preset_clear": "Clear",
  "date_preset_quick_select": "Quick Select",
  "date_preset_presets": "Presets",
  "date_preset_past": "Past",
  "date_preset_future": "Future",
  "date_preset_tomorrow": "Tomorrow",
  "date_preset_next_7_days": "Next 7 days",
  "date_preset_next_14_days": "Next 14 days",
  "date_preset_next_30_days": "Next 30 days",
  "date_preset_rest_of_month": "Rest of month",
  "date_preset_next_month": "Next month",
  "date_preset_rest_of_year": "Rest of year",
  "date_preset_next_year": "Next year",
  "date_range_picker_quick_range": "Quick range",
  "date_range_picker_custom": "Custom",
  "date_range_picker_from": "From",
  "date_range_picker_to": "To",
  "date_range_picker_reset": "Reset",
  "date_range_picker_apply": "Apply range",
  "date_range_picker_hide_presets": "Hide presets",
  "date_range_picker_show_presets": "Show presets",
  "date_range_picker_one_day": "1 day",
  "date_range_picker_days_count": "{count} days",
  "phone_search_placeholder": "Search names/phones",
  "beneficiary_search_placeholder": "Search contacts or beneficiaries",
  "phone_search_clear": "Clear search",
  "phone_search_start_typing": "Start typing to search people…",
  "searching": "Searching…",
  "phone_search_no_matches": "No matches for \"{query}\".",
  "phone_filter_no_matches": "No contacts match the selected filters.",
  "phone_search_try_different": "Try a different search term.",
  "phone_offline_no_synced_contacts": "No contacts are saved for offline use on this device yet.",
  "phone_selector_expand_beneficiaries": "Show beneficiaries",
  "search_error": "Failed to search. Please try again.",
  "phone_no_phone_found": "No phone number found.",
  "phone_add_number_label": "Add \"{value}\" as new phone number",
  "phone_add_new_title": "Add new phone number",
  "phone_add_new_description": "We couldn't find this number. Create it to start tracking conversations.",
  "phone_add_inline_title": "Add this phone number",
  "phone_add_inline_hint": "Save it as a reusable contact.",
  "phone_add_button": "Add number",
  "phone_add_number_placeholder": "Enter a phone number",
  "beneficiary_add_name_placeholder": "Type a beneficiary name",
  "beneficiary_add_new_title": "Add new beneficiary",
  "beneficiary_add_new_description": "Create this beneficiary under the selected main contact.",
  "beneficiary_add_inline_title": "Add as new beneficiary",
  "beneficiary_add_inline_hint": "The event will be booked for this person through the main contact.",
  "beneficiary_add_button": "Add beneficiary",
  "name_add_name_placeholder": "Type a contact name",
  "name_add_new_title": "Use this contact name",
  "name_add_new_description": "Use this name for the new phone contact.",
  "name_add_inline_title": "Use as the contact name",
  "name_add_inline_hint": "A new main contact will be created when you save.",
  "name_add_button": "Use name",
  "phone_select_placeholder": "Select a phone number",
  "phone_unknown_label": "Unknown",
  "phone_group_recent": "Recent",
  "phone_group_all": "All",
  "phone_group_selected": "Selected",
  "phone_group_favorites": "Favorites",
  "phone_no_results_title": "No results for your search",
  "phone_no_results_description": "Try using different keywords or check the spelling. You can also browse our categories to find what you're looking for.",
  "phone_failed_to_load_title": "Failed to load",
  "phone_failed_to_load_description": "Could not fetch data",
  "phone_retry_button": "Retry",
  "no_results_found": "No results found",
  "close": "Close",
  "cursor_hint_open": "Open",
  "cursor_hint_preview": "Preview",
  "cursor_hint_drag": "Drag to reorder",
  "delete": "Delete",
  "vacation_parse_error": "Failed to load vacation data",
  "chat_edit_message_not_found": "Could not find message to edit. Please try again.",
  "settings_show_tool_calls": "Show Tool Calls",
  "settings_tool_calls_hint": "Show tool call details and JSON in chat messages",
  "settings_tool_calls_on": "Tool calls will be shown in chat",
  "settings_tool_calls_off": "Tool calls will be hidden in chat",
  "settings_send_typing": "Send Typing Indicator",
  "settings_send_typing_on": "Typing indicator will be sent to the user while typing",
  "settings_send_typing_off": "Typing indicator sending is disabled",
  "settings_toolbar_size_decrease": "Decrease toolbar size",
  "settings_toolbar_size_input": "Toolbar size percentage",
  "settings_toolbar_size_increase": "Increase toolbar size",
  "msg_total": "Total",
  "msg_page": "Page",
  "msg_of": "of",
  "msg_total_conversations": "Total Conversations",
  "msg_word_cloud": "Word cloud",
  "msg_avg_messages_per_conversation": "Avg/Conv",
  "msg_per_conversation": "per conversation",
  "msg_messages_per_conversation": "Msg/Conv",
  "msg_pagination": "Pagination",
  "msg_previous_page": "Previous page",
  "msg_next_page": "Next page",
  "msg_word_source_tabs": "Word source",
  "response_time_samples": "Response Samples",
  "operation_activity_breakdown": "Activity Breakdown",
  "activity_attribution_made_by": "Made by",
  "activity_attribution_ai": "AI agent",
  "activity_attribution_system_agent": "System agent",
  "activity_attribution_via": "via",
  "activity_attribution_org_member": "Org member",
  "activity_attribution_external_user": "External user",
  "activity_attribution_system": "System",
  "activity_attribution_unknown": "Unknown",
  "event_history_menu_item": "Event history",
  "event_history_title": "Event history",
  "event_history_description": "Full lifecycle of this event and who made each change.",
  "event_history_booked_under": "Booked under {{name}}",
  "event_history_empty": "No history recorded for this event yet.",
  "event_history_error": "Failed to load event history.",
  "event_history_by": "by",
  "event_history_field_time": "Time",
  "event_history_field_type": "Type",
  "event_history_field_name": "Name",
  "event_history_action_created": "Created",
  "event_history_action_rescheduled": "Rescheduled",
  "event_history_action_updated": "Updated",
  "event_history_action_cancelled": "Cancelled",
  "event_history_action_reinstated": "Reinstated",
  "event_history_action_completed": "Completed",
  "event_history_action_no_show": "No-show",
  "activity_open_chat_history": "Chat history",
  "operation_origin_breakdown": "Operation Origin",
  "operation_ai_handled": "AI handled",
  "operation_member_handled": "Org member handled",
  "operation_external_handled": "Customer self-service",
  "operation_unattributed": "Unattributed",
  "operation_by_model": "By model",
  "kpi_by_ai": "by AI",
  "msg_assistant_replies": "Assistant replies",
  "msg_inbound_messages": "Inbound messages",
  "kpi_total_events": "Total Events",
  "kpi_from_last_month": "from last month",
  "kpi_active_users": "Active Booking Customers",
  "kpi_unique_users": "Unique users",
  "kpi_cancellations": "Cancellations",
  "kpi_this_period": "this period",
  "kpi_conversion_rate": "Conversion Rate",
  "kpi_conversation_to_booking": "Conversation to booking",
  "kpi_returning_rate": "Returning Rate",
  "kpi_user_retention": "User retention",
  "kpi_improvement": "improvement",
  "kpi_avg_response_time": "Avg Response Time",
  "kpi_returning_users": "Repeat Booking Customers",
  "kpi_avg_followups": "Avg Repeat Bookings",
  "kpi_performance_metrics": "Performance Metrics",
  "kpi_total_events_tooltip": "Total events in selected period vs previous similar period",
  "kpi_active_users_desc": "Distinct customers with non-cancelled bookings in this period",
  "kpi_total_events_desc": "All bookings scheduled in this period",
  "kpi_cancellations_desc": "Bookings scheduled in this period that are currently cancelled",
  "kpi_conversion_rate_desc": "Messaging customers with a non-cancelled booking in this period",
  "kpi_avg_response_time_desc": "Time to reply to user messages",
  "kpi_new_users": "Booking Customers",
  "kpi_new_users_desc": "Distinct customers with a booking in this period",
  "kpi_returning_users_desc": "Customers with two or more bookings in this period",
  "kpi_avg_followups_desc": "Additional bookings per repeat booking customer",
  "kpi_leads_collected": "Leads Captured",
  "kpi_leads_collected_desc": "Contacts the assistant qualified with the collectLead tool",
  "kpi_positive_feedback": "Positive Feedback",
  "kpi_positive_feedback_desc": "Customer messages saved with happy / satisfied sentiment",
  "kpi_negative_feedback": "Negative Feedback",
  "kpi_negative_feedback_desc": "Customer messages saved with unhappy / frustrated sentiment",
  "kpi_neutral_feedback": "Neutral Feedback",
  "kpi_neutral_feedback_desc": "Customer messages saved without a positive or negative sentiment",
  "insights_capture_summary_title": "Capture & Sentiment",
  "insights_capture_summary_desc": "Leads and customer feedback gathered by the assistant in this window",
  "kpi_vs_previous_period": "vs previous period",
  "kpi_active_users_tooltip": "Customers with at least one non-cancelled booking in the selected period",
  "kpi_cancellations_tooltip": "Cancellations within selected period vs previous similar period",
  "kpi_avg_response_time_tooltip": "Average time for assistant to reply to user (user→assistant) vs previous period",
  "kpi_avg_followups_tooltip": "Average additional follow-up bookings per returning user vs previous period",
  "kpi_unique_users_tooltip": "Users whose first event occurred in this period vs previous similar period",
  "chat_toolbar_bold": "Bold",
  "chat_toolbar_italic": "Italic",
  "chat_toolbar_strike": "Strikethrough",
  "chat_toolbar_code": "Monospace",
  "chat_toolbar_ai": "AI",
  "chat_ai_input_placeholder": "Tell AI what to do…",
  "chat_ai_followup_placeholder": "Refine further…",
  "chat_ai_submit_hint": "⌘+Enter to submit",
  "chat_ai_back": "Back",
  "chat_ai_submit": "Rewrite",
  "chat_ai_replace": "Replace",
  "chat_ai_close": "Close",
  "chat_ai_title": "Rewrite with AI",
  "chat_ai_insert": "Insert",
  "chat_ai_refine": "Refine",
  "ai_action_add": "Add",
  "ai_action_clear": "Clear",
  "ai_action_diff": "Diff",
  "ai_action_result": "Result",
  "ai_action_generate": "Generate",
  "ai_mode_refining": "Refining selection",
  "ai_mode_writing": "Writing from scratch",
  "ai_generate_placeholder": "Describe what you'd like the AI to write…",
  "ai_vacation_generate_title": "Generate vacation message",
  "ai_vacation_generate_placeholder": "Describe your absence (dates, fallback contact, urgency)...",
  "ai_vacation_generate_instruction": "Write a warm, professional out-of-office auto-reply for whoever messages during this absence: briefly acknowledge their message, note that you're away, and set expectations for when you'll respond. Use only the details in the description below — if a return date or fallback contact is given, include it; otherwise just say you'll reply as soon as possible.",
  "ai_vacation_trigger_label": "Draft with AI",
  "system_prompt_ai_rewrite_label": "Rewrite with AI",
  "system_prompt_ai_rewrite_tooltip": "Open the AI rewrite panel. With text selected, only that part is rewritten. With nothing selected, the entire prompt is refined.",
  "system_prompt_ai_rewrite_selection_title": "Rewrite selection",
  "system_prompt_ai_rewrite_full_title": "Refine entire prompt",
  "chat_ai_loading": "Rewriting…",
  "chat_ai_failed": "AI rewrite failed",
  "chat_ai_unavailable": "AI is not configured",
  "chat_ai_original_label": "Original",
  "chat_ai_result_label": "AI",
  "chat_ai_turn_label": "Turn {n}",
  "chat_ai_preset_summarize": "Summarize",
  "chat_ai_preset_professional": "Professional",
  "chat_ai_preset_friendly": "Friendly",
  "chat_ai_preset_concise": "Concise",
  "chat_ai_preset_expand": "Expand",
  "chat_ai_preset_grammar": "Fix grammar",
  "emoji_search": "Search emoji…",
  "kpi_cpu_usage": "CPU Usage",
  "kpi_current_usage": "Current usage",
  "kpi_demo_data": "Demo data",
  "kpi_memory_usage": "Memory Usage",
  "kpi_success_rate": "Success Rate",
  "kpi_operational_rate": "Operational rate",
  "tooltip_success_rate": "Success rate calculated from operation metrics",
  "operation_metrics_title": "Operation Metrics",
  "operation_attempts": "Attempts",
  "operation_success": "Success",
  "operation_failed": "Failed",
  "operation_events": "Reservations",
  "operation_cancellations": "Cancellations",
  "operation_modifications": "Modifications",
  "response_time_analysis_title": "Response Time Analysis",
  "response_time_score": "Score",
  "response_time_average": "Average",
  "response_time_median": "Median",
  "response_time_maximum": "Maximum",
  "response_time_performance": "Response time performance",
  "response_time_performance_desc": "Higher is better",
  "response_time_slow": "Slow",
  "response_time_fast": "Fast",
  "response_time_insights": "Response time performance insights",
  "response_time_excellent": "Excellent response time",
  "response_time_good": "Good response time",
  "response_time_needs_improvement": "Needs improvement",
  "response_time_poor": "Poor response time",
  "chart_daily_trends_overview": "Daily Trends",
  "chart_no_data": "No data available",
  "chart_showing_all_data": "Showing all data",
  "chart_showing_last_days": "Showing last days",
  "chart_appointment_type_distribution": "Appointment Type Distribution",
  "chart_popular_time_slots": "Popular Time Slots",
  "chart_weekly_activity_pattern": "Weekly Activity Pattern",
  "chart_monthly_performance_trends": "Monthly Performance Trends",
  "chart_user_segments": "User Segments",
  "chart_avg_events_per_type": "Avg Events per User by Type",
  "chart_avg_events_per_type_desc": "Average number of events per user for each appointment type",
  "chart_avg_per_user": "Avg per User",
  "chart_total_events": "Total Events",
  "chart_unique_users": "Unique Users",
  "msg_total_messages": "Total Messages",
  "msg_avg_message_length": "Avg Message Length",
  "msg_chars": "chars",
  "msg_words_avg": "words avg",
  "msg_median": "median",
  "msg_messages_per_user": "Messages per User",
  "msg_volume_heatmap": "Message Volume Heatmap",
  "msg_activity_patterns": "Activity patterns by day and hour",
  "msg_users": "Users",
  "msg_assistant": "Assistant",
  "msg_less": "Less",
  "msg_more": "More",
  "chart_all_data": "All data",
  "chart_last_30_days": "Last 30 days",
  "chart_last_14_days": "Last 14 days",
  "chart_last_7_days": "Last 7 days",
  "appt_checkup": "Checkup",
  "appt_followup": "Follow-up",
  "appt_unknown": "Unknown",
  "slot_regular": "Regular",
  "slot_saturday": "Saturday",
  "slot_ramadan": "Ramadan",
  "slot_unknown": "Unknown",
  "funnel_messaging_customers": "Messaging customers",
  "funnel_made_event": "AI booking created",
  "funnel_returned_for_another": "Returned for another AI booking",
  "funnel_cancelled": "Cancelled",
  "segment_one_booking_in_period": "1 booking in period",
  "segment_two_five_bookings_in_period": "2–5 bookings in period",
  "segment_six_plus_bookings_in_period": "6+ bookings in period",
  "segment_new_users": "New users",
  "segment_regular_users": "Regular users",
  "segment_vip_users": "VIP users",
  "segment_inactive_users": "Inactive users",
  "day_monday": "Monday",
  "day_tuesday": "Tuesday",
  "day_wednesday": "Wednesday",
  "day_thursday": "Thursday",
  "day_friday": "Friday",
  "day_saturday": "Saturday",
  "day_sunday": "Sunday",
  "day_mon": "Mon",
  "day_tue": "Tue",
  "day_wed": "Wed",
  "day_thu": "Thu",
  "day_fri": "Fri",
  "day_sat": "Sat",
  "day_sun": "Sun",
  "slot_duration_minutes": "{{minutes}} min",
  "slot_duration_hour": "{{hours}} hour",
  "slot_duration_hours": "{{hours}} hours",
  "slot_duration_hm": "{{hours}}h {{minutes}}m",
  "msg_across_all_conversations": "Across all conversations",
  "msg_avg_response_time": "Avg Response Time",
  "msg_average_conversation_length": "Average Conversation Length",
  "msg_most_active_users": "Most Active Users",
  "msg_last": "Last",
  "msg_msgs": "msgs",
  "msg_bookings": "Bookings",
  "msg_most_common_words": "Most Common Words",
  "msg_peak_messages": "Peak Messages",
  "msg_peak_hour": "Peak Hour",
  "msg_busiest_day": "Busiest Day",
  "msg_avg_per_hour": "Avg/Hour",
  "msg_user_words": "User Words",
  "msg_assistant_words": "Assistant Words",
  "msg_total_usage": "Total Usage",
  "msg_morning": "Morning",
  "msg_afternoon": "Afternoon",
  "msg_evening": "Evening",
  "msg_no_messages": "No messages",
  "msg_very_low": "Very Low",
  "msg_low": "Low",
  "msg_medium": "Medium",
  "msg_high": "High",
  "msg_very_high": "Very High",
  "msg_activity": "activity",
  "kpi_users_with_multiple_bookings": "Users With Multiple Bookings",
  "kpi_additional_bookings_per_returning_user": "Additional Bookings Per Returning User",
  "conversation_analysis_title": "Conversation Analysis",
  "conversation_length_average": "Conversation Length Average",
  "conversation_length_median": "Conversation Length Median",
  "conversation_length_maximum": "Conversation Length Maximum",
  "conversation_per_user": "Conversation Per User",
  "conversation_overview": "Conversation Overview",
  "msg_unique_users": "Unique Users",
  "conversation_avg_per_user": "Conversation Avg Per User",
  "conversation_engagement": "Conversation Engagement",
  "conversation_engagement_level": "Conversation Engagement Level",
  "engagement_high": "Engagement High",
  "engagement_medium": "Engagement Medium",
  "engagement_low": "Engagement Low",
  "response_time_avg_desc": "Average response time across conversations",
  "response_time_median_desc": "Median response time across conversations",
  "response_time_max_desc": "Longest response time recorded",
  "response_time_calculated": "Calculated",
  "response_time_progress_desc": "Performance indicator: higher bar = faster responses (0-60 min scale)",
  "dashboard_this_month": "This Month",
  "dashboard_demo_mode": "Demo Mode",
  "dashboard_demo_description": "You are viewing demo data. Connect the backend to load real data.",
  "demo_data_warning": "Demo Data Warning",
  "real_data_available": "Real Data Available",
  "dashboard_business_insights": "Business Insights",
  "dashboard_peak_hours_title": "Peak Booking Time",
  "dashboard_peak_hours_desc": "{{time}} · {{count}} bookings",
  "dashboard_user_retention_title": "Repeat Booking Rate",
  "dashboard_user_retention_desc": "{{returningRate}}% of booking customers had multiple bookings in this range",
  "dashboard_response_time_title": "Response Time",
  "dashboard_response_time_desc": "Average response time is {{seconds}} seconds",
  "backend_connection_error_title": "Cannot connect to backend",
  "backend_offline_documents_title": "Offline — your documents are saved on this device and will sync when you reconnect",
  "backend_connection_error_description": "We couldn't reach the backend. Ensure it's running and reachable.",
  "backend_connection_error_instructions": "Click retry after confirming the server is up.",
  "backend_connection_checking": "Checking connection…",
  "backend_connection_error_retry": "Retry",
  "authorization_error_title": "Authorization Required",
  "authorization_error_description": "Your session has expired or you don't have permission to access this resource.",
  "authorization_error_instructions": "Sign in to your account or create a new one to continue.",
  "authorization_error_go_to_login": "Sign In",
  "authorization_error_go_to_signup": "Create Account",
  "authorization_error_or_divider": "or",
  "lib_access_denied_title": "Access denied",
  "lib_access_denied_role_message": "You don't have the required role to view this page. Contact an organization owner or admin if you need access.",
  "lib_access_denied_admin_message": "This section is available to organization owners and admins only. Contact an admin if you need access.",
  "cm_format_percentage": "Percentage",
  "cm_format_scientific": "Scientific",
  "cm_format_accounting": "Accounting",
  "theme_mode_system": "System",
  "theme_mode_light": "Light",
  "theme_mode_dark": "Dark",
  "calendar_events": "events",
  "chart_loading": "Loading chart…",
  "conversation_insights": "Conversation Insights",
  "conversation_insight_high": "High engagement",
  "conversation_insight_medium": "Medium engagement",
  "conversation_insight_low": "Low engagement",
  "msg_messages": "Messages",
  "msg_default": "Default",
  "period_current": "Current period",
  "period_previous": "Previous period",
  "scroll_to_bottom": "Scroll to bottom",
  "toast_request_timeout": "Request timed out",
  "toast_vacation_periods_updated": "Vacation periods updated",
  "slot_fully_booked": "This time slot is fully booked. Please choose another slot.",
  "slot_at_capacity": "Slot is at capacity ({{count}}/{{capacity}} events). Cannot add more events to this slot.",
  "grid.none": "None",
  "calendar_legend_show_button": "Show color legend",
  "calendar_legend_title": "Legend",
  "calendar_legend_shortcuts": "Shortcuts",
  "calendar_legend_change_view_up": "Change view up",
  "calendar_legend_previous_date": "Previous date",
  "calendar_legend_arrow_left_hint": "Arrow Left: Navigate date",
  "calendar_legend_next_date": "Next date",
  "calendar_legend_arrow_right_hint": "Arrow Right: Navigate date",
  "calendar_legend_change_view_down": "Change view down",
  "calendar_legend_arrow_repeat_hint": "Arrow Left/Right: Navigate date (hold to repeat)",
  "calendar_legend_ctrl_arrow_hint": "Change view",
  "calendar_legend_navigate_date": "Navigate date",
  "calendar_legend_navigate_users": "Navigate users",
  "calendar_legend_sidebar_closed": "Sidebar closed",
  "calendar_legend_sidebar_open": "Sidebar open",
  "calendar_legend_search_users": "Search users",
  "calendar_legend_system_agent": "System agent",
  "calendar_tutorial_title": "Tutorial",
  "calendar_tutorial_thumbnail_alt": "Booking System Tutorial",
  "calendar_tutorial_hint": "Watch how to use the system",
  "calendar_legend_conversation": "Conversation",
  "user_last_message": "Last message",
  "user_unknown": "Unknown User",
  "user_since": "User since",
  "user_events": "Events",
  "user_no_events": "No events",
  "status_label": "Status",
  "message_label": "Message",
  "search_placeholder": "Search…",
  "message_in": "In",
  "message_out": "Out",
  "activity_scheduled_events": "Scheduled events",
  "activity_message_history": "Message history",
  "activity_no_messages": "No messages yet",
  "activity_timeline": "Timeline",
  "activity_timeline_switch_label": "History view",
  "activity_timeline_empty": "No activity yet",
  "activity_timeline_error": "Couldn't load this contact's activity",
  "activity_timeline_show_lifecycle": "Booking history",
  "activity_messages_count": "{loaded} of {total} messages loaded",
  "activity_contact_messages_count": "{count} messages",
  "user_show_details": "Show details",
  "user_view_events": "View events",
  "user_collapse": "Collapse",
  "user_copy_phone": "Copy phone number",
  "user_phone_copied": "Phone number copied",
  "date_unknown": "Unknown date",
  "date_label": "Date",
  "time_label": "Time",
  "view_year": "Year",
  "view_month": "Month",
  "view_week": "Week",
  "view_day": "Day",
  "view_list": "List",
  "view_timeline": "Timeline",
  "view_timeline_range": "Timeline range",
  "calendar_view": "Calendar view",
  "view_resources": "Resources",
  "resource_unassigned": "Unassigned",
  "field_event_end": "Event end",
  "field_event_interval": "Event time",
  "field_time_scheduled": "Event start",
  "field_time_stay_continues": "Ongoing stay — edit checkout",
  "validation_errors_title": "Validation Errors",
  "validation.required": "{{field}} is required",
  "validation.thisFieldIsRequired": "This field is required",
  "validation.invalidFormat": "Invalid format",
  "validation.invalidDate": "Invalid date",
  "validation.invalidTime": "Invalid time",
  "validation.invalidPhone": "Invalid phone number",
  "validation.phoneFormatNotRecognized": "Phone format not recognized",
  "validation.phoneHasInvalidCountryCode": "Phone has invalid country code",
  "validation.phoneContainsInvalidCharacters": "Phone contains invalid characters",
  "validation.phoneIsTooShort": "Phone number is too short",
  "validation.phoneIsTooLong": "Phone number is too long",
  "validation.phoneHasInvalidLengthForCountry": "Phone has invalid length for country",
  "validation.phoneInvalidFormat": "Phone number format is invalid",
  "validation.phoneMayHaveInvalidAreaCode": "Phone may have invalid area code",
  "validation.phoneFormatIsInvalid": "Phone format is invalid",
  "validation.invalidName": "Invalid name",
  "validation.nameRequired": "Name is required",
  "validation.nameTooShort": "Name is too short",
  "validation.nameInvalidCharacters": "Name contains invalid characters",
  "validation.nameWordsTooShort": "Name words are too short",
  "validation.nameTooLong": "Name is too long",
  "notification_sent_message": "New message",
  "notification_created_event": "New booking",
  "notification_updated_event": "Booking details updated",
  "notification_rescheduled_event": "Booking rescheduled",
  "notification_reinstated_event": "Booking restored",
  "notification_vacation_updated": "Vacation dates updated",
  "notification_messages_group": "New messages",
  "notification_cancelled_event": "Booking cancelled",
  "notification_updated_contact_status": "Contact status changed",
  "notification_status_active": "Active",
  "notification_status_inactive": "Inactive",
  "notification_system_update": "system update",
  "notification_user": "User",
  "vacation_add": "Add vacation",
  "vacation_period_label": "Period {{index}}",
  "vacation_delete_period": "Remove period",
  "vacation_start": "Start",
  "vacation_end": "End",
  "vacation_recording": "Recording",
  "vacation_stop": "Stop",
  "vacation_stop_recording": "Stop recording",
  "vacation_start_recording": "Record start",
  "vacation_end_recording": "Record end",
  "vacation_no_periods": "No vacation periods",
  "language_label": "Language",
  "language_toggle_hint": "Switch between Arabic and English",
  "language_switched_to_arabic": "Switched to Arabic",
  "language_english": "English",
  "language_ar": "Arabic",
  "language_arabic": "العربية",
  "calendar_locale_label": "Calendar Locale",
  "calendar_locale_hint": "Choose the calendar system (Gregorian or Hijri). Day and month names follow the app language.",
  "calendar_locale_gregorian": "Gregorian",
  "calendar_locale_hijri": "Hijri",
  "calendar_locale_en": "English",
  "calendar_locale_ar": "Arabic",
  "calendar_locale_ar_sa": "Hijri",
  "theme_label": "Theme",
  "theme_unknown": "Unknown Theme",
  "theme_default": "Default",
  "theme_clerk": "Clerk",
  "theme_amethyst_haze": "Amethyst Haze",
  "theme_claude": "Claude",
  "theme_art_deco": "Art Deco",
  "theme_neo_brutalism": "Neo Brutalism",
  "theme_perpetuity": "Perpetuity",
  "theme_retro_arcade": "Retro Arcade",
  "theme_soft_pop": "Soft Pop",
  "theme_ghibli_studio": "Ghibli Studio",
  "theme_valorant": "Valorant",
  "theme_t3chat": "T3Chat",
  "theme_perplexity": "Perplexity",
  "theme_neomorphism": "Neomorphism",
  "column_menu_unpin": "Unpin Column",
  "column_menu_filter": "Filter",
  "column_menu_copy": "Copy Column",
  "column_menu_text_format": "Text Format",
  "column_menu_number_format": "Number Format",
  "column_menu_date_format": "Date Format",
  "cancel_incomplete_data": "Missing waId/date to cancel",
  "cancel_system_error": "System error, try later",
  "undo_success": "Undo successful",
  "undo_unknown_error": "Unknown error",
  "undo_failed": "Undo failed",
  "undo_processing": "Undoing",
  "time_am": "AM",
  "time_pm": "PM",
  "time_just_now": "just now",
  "time_minutes_ago": "min ago",
  "time_hours_ago": "h ago",
  "time_days_ago": "d ago",
  "press_esc_to_exit_fullscreen": "Press ESC to exit fullscreen",
  "country_AC": "Ascension Island",
  "country_AD": "Andorra",
  "country_AE": "United Arab Emirates",
  "country_AF": "Afghanistan",
  "country_AG": "Antigua and Barbuda",
  "country_AI": "Anguilla",
  "country_AL": "Albania",
  "country_AM": "Armenia",
  "country_AO": "Angola",
  "country_AR": "Argentina",
  "country_AS": "American Samoa",
  "country_AT": "Austria",
  "country_AU": "Australia",
  "country_AW": "Aruba",
  "country_AX": "Åland Islands",
  "country_AZ": "Azerbaijan",
  "country_BA": "Bosnia and Herzegovina",
  "country_BB": "Barbados",
  "country_BD": "Bangladesh",
  "country_BE": "Belgium",
  "country_BF": "Burkina Faso",
  "country_BG": "Bulgaria",
  "country_BH": "Bahrain",
  "country_BI": "Burundi",
  "country_BJ": "Benin",
  "country_BL": "Saint Barthélemy",
  "country_BM": "Bermuda",
  "country_BN": "Brunei Darussalam",
  "country_BO": "Bolivia",
  "country_BQ": "Bonaire, Sint Eustatius and Saba",
  "country_BR": "Brazil",
  "country_BS": "Bahamas",
  "country_BT": "Bhutan",
  "country_BW": "Botswana",
  "country_BY": "Belarus",
  "country_BZ": "Belize",
  "country_CA": "Canada",
  "country_CC": "Cocos (Keeling) Islands",
  "country_CD": "Congo, Democratic Republic of the",
  "country_CF": "Central African Republic",
  "country_CG": "Congo",
  "country_CH": "Switzerland",
  "country_CI": "Cote d'Ivoire",
  "country_CK": "Cook Islands",
  "country_CL": "Chile",
  "country_CM": "Cameroon",
  "country_CN": "China",
  "country_CO": "Colombia",
  "country_CR": "Costa Rica",
  "country_CU": "Cuba",
  "country_CV": "Cape Verde",
  "country_CW": "Curaçao",
  "country_CX": "Christmas Island",
  "country_CY": "Cyprus",
  "country_CZ": "Czech Republic",
  "country_DE": "Germany",
  "country_DJ": "Djibouti",
  "country_DK": "Denmark",
  "country_DM": "Dominica",
  "country_DO": "Dominican Republic",
  "country_DZ": "Algeria",
  "country_EC": "Ecuador",
  "country_EE": "Estonia",
  "country_EG": "Egypt",
  "country_EH": "Western Sahara",
  "country_ER": "Eritrea",
  "country_ES": "Spain",
  "country_ET": "Ethiopia",
  "country_FI": "Finland",
  "country_FJ": "Fiji",
  "country_FK": "Falkland Islands",
  "country_FM": "Federated States of Micronesia",
  "country_FO": "Faroe Islands",
  "country_FR": "France",
  "country_GA": "Gabon",
  "country_GB": "United Kingdom",
  "country_GD": "Grenada",
  "country_GE": "Georgia",
  "country_GF": "French Guiana",
  "country_GG": "Guernsey",
  "country_GH": "Ghana",
  "country_GI": "Gibraltar",
  "country_GL": "Greenland",
  "country_GM": "Gambia",
  "country_GN": "Guinea",
  "country_GP": "Guadeloupe",
  "country_GQ": "Equatorial Guinea",
  "country_GR": "Greece",
  "country_GT": "Guatemala",
  "country_GU": "Guam",
  "country_GW": "Guinea-Bissau",
  "country_GY": "Guyana",
  "country_HK": "Hong Kong",
  "country_HN": "Honduras",
  "country_HR": "Croatia",
  "country_HT": "Haiti",
  "country_HU": "Hungary",
  "country_ID": "Indonesia",
  "country_IE": "Ireland",
  "country_IL": "Israel",
  "country_IM": "Isle of Man",
  "country_IN": "India",
  "country_IO": "British Indian Ocean Territory",
  "country_IQ": "Iraq",
  "country_IR": "Iran",
  "country_IS": "Iceland",
  "country_IT": "Italy",
  "country_JE": "Jersey",
  "country_JM": "Jamaica",
  "country_JO": "Jordan",
  "country_JP": "Japan",
  "country_KE": "Kenya",
  "country_KG": "Kyrgyzstan",
  "country_KH": "Cambodia",
  "country_KI": "Kiribati",
  "country_KM": "Comoros",
  "country_KN": "Saint Kitts and Nevis",
  "country_KP": "North Korea",
  "country_KR": "South Korea",
  "country_KW": "Kuwait",
  "country_KY": "Cayman Islands",
  "country_KZ": "Kazakhstan",
  "country_LA": "Laos",
  "country_LB": "Lebanon",
  "country_LC": "Saint Lucia",
  "country_LI": "Liechtenstein",
  "country_LK": "Sri Lanka",
  "country_LR": "Liberia",
  "country_LS": "Lesotho",
  "country_LT": "Lithuania",
  "country_LU": "Luxembourg",
  "country_LV": "Latvia",
  "country_LY": "Libya",
  "country_MA": "Morocco",
  "country_MC": "Monaco",
  "country_MD": "Moldova",
  "country_ME": "Montenegro",
  "country_MF": "Saint Martin (French Part)",
  "country_MG": "Madagascar",
  "country_MH": "Marshall Islands",
  "country_MK": "North Macedonia",
  "country_ML": "Mali",
  "country_MM": "Myanmar",
  "country_MN": "Mongolia",
  "country_MO": "Macao",
  "country_MP": "Northern Mariana Islands",
  "country_MQ": "Martinique",
  "country_MR": "Mauritania",
  "country_MS": "Montserrat",
  "country_MT": "Malta",
  "country_MU": "Mauritius",
  "country_MV": "Maldives",
  "country_MW": "Malawi",
  "country_MX": "Mexico",
  "country_MY": "Malaysia",
  "country_MZ": "Mozambique",
  "country_NA": "Namibia",
  "country_NC": "New Caledonia",
  "country_NE": "Niger",
  "country_NF": "Norfolk Island",
  "country_NG": "Nigeria",
  "country_NI": "Nicaragua",
  "country_NL": "Netherlands",
  "country_NO": "Norway",
  "country_NP": "Nepal",
  "country_NR": "Nauru",
  "country_NU": "Niue",
  "country_NZ": "New Zealand",
  "country_OM": "Oman",
  "country_PA": "Panama",
  "country_PE": "Peru",
  "country_PF": "French Polynesia",
  "country_PG": "Papua New Guinea",
  "country_PH": "Philippines",
  "country_PK": "Pakistan",
  "country_PL": "Poland",
  "country_PM": "Saint Pierre and Miquelon",
  "country_PR": "Puerto Rico",
  "country_PS": "Palestine",
  "country_PT": "Portugal",
  "country_PW": "Palau",
  "country_PY": "Paraguay",
  "country_QA": "Qatar",
  "country_RE": "Reunion",
  "country_RO": "Romania",
  "country_RS": "Serbia",
  "country_RU": "Russia",
  "country_RW": "Rwanda",
  "country_SA": "Saudi Arabia",
  "country_SB": "Solomon Islands",
  "country_SC": "Seychelles",
  "country_SD": "Sudan",
  "country_SE": "Sweden",
  "country_SG": "Singapore",
  "country_SH": "Saint Helena",
  "country_SI": "Slovenia",
  "country_SJ": "Svalbard and Jan Mayen",
  "country_SK": "Slovakia",
  "country_SL": "Sierra Leone",
  "country_SM": "San Marino",
  "country_SN": "Senegal",
  "country_SO": "Somalia",
  "country_SR": "Suriname",
  "country_SS": "South Sudan",
  "country_ST": "Sao Tome and Principe",
  "country_SV": "El Salvador",
  "country_SX": "Sint Maarten",
  "country_SY": "Syria",
  "country_SZ": "Swaziland",
  "country_TA": "Tristan da Cunha",
  "country_TC": "Turks and Caicos Islands",
  "country_TD": "Chad",
  "country_TG": "Togo",
  "country_TH": "Thailand",
  "country_TJ": "Tajikistan",
  "country_TK": "Tokelau",
  "country_TL": "Timor-Leste",
  "country_TM": "Turkmenistan",
  "country_TN": "Tunisia",
  "country_TO": "Tonga",
  "country_TR": "Turkey",
  "country_TT": "Trinidad and Tobago",
  "country_TV": "Tuvalu",
  "country_TW": "Taiwan",
  "country_TZ": "Tanzania",
  "country_UA": "Ukraine",
  "country_UG": "Uganda",
  "country_US": "United States",
  "country_UY": "Uruguay",
  "country_UZ": "Uzbekistan",
  "country_VA": "Holy See (Vatican City State)",
  "country_VC": "Saint Vincent and the Grenadines",
  "country_VE": "Venezuela",
  "country_VG": "Virgin Islands, British",
  "country_VI": "Virgin Islands, U.S.",
  "country_VN": "Vietnam",
  "country_VU": "Vanuatu",
  "country_WF": "Wallis and Futuna",
  "country_WS": "Samoa",
  "country_XK": "Kosovo",
  "country_YE": "Yemen",
  "country_YT": "Mayotte",
  "country_ZA": "South Africa",
  "country_ZM": "Zambia",
  "country_ZW": "Zimbabwe",
  "not_found_status": "Status · 404",
  "not_found_title": "We can't find that page.",
  "not_found_description": "The link may be old, or the page may have moved. Check the URL or head back to somewhere you know.",
  "not_found_go_back": "Go back",
  "not_found_take_me_home": "Take me home",
  "not_found_resource_home_label": "Home",
  "not_found_resource_home_description": "Return to your starting point and pick a new destination.",
  "not_found_resource_dashboard_label": "Dashboard",
  "not_found_resource_dashboard_description": "Review automation health, events, and metrics.",
  "not_found_resource_docs_label": "Knowledge Base",
  "not_found_resource_docs_description": "Troubleshoot flows or explore feature walkthroughs.",
  "not_found_button_return_home": "Return home",
  "not_found_button_explore_dashboard": "Explore dashboard",
  "not_found_button_back_home": "Back to home",
  "global_error_title": "Something went wrong",
  "global_error_description": "An unexpected error interrupted your session. You can retry or head back to the dashboard while we keep things safe.",
  "global_error_reference": "Error reference:",
  "global_error_button_try_again": "Try again",
  "global_error_button_return_home": "Return home",
  "sign_in_title": "Sign In",
  "sign_in_subtitle": "",
  "sign_in_email_label": "Email",
  "sign_in_email_placeholder": "you@company.com",
  "sign_in_password_label": "Password",
  "sign_in_password_placeholder": "Your password",
  "sign_in_forgot_password": "Forgot your Password ?",
  "sign_in_button": "Sign In",
  "sign_in_loading": "Signing in…",
  "sign_in_or_continue": "Or continue With",
  "sign_in_no_account": "Don't have an account?",
  "sign_in_create_account": "Create account",
  "sign_up_title": "Create an Account",
  "sign_up_subtitle": "",
  "sign_up_firstname_label": "Firstname",
  "sign_up_firstname_placeholder": "First name (optional)",
  "sign_up_lastname_label": "Lastname",
  "sign_up_lastname_placeholder": "Last name (optional)",
  "sign_up_email_label": "Email",
  "sign_up_email_placeholder": "you@company.com",
  "sign_up_email_error_required": "Email is required",
  "sign_up_email_error_invalid": "Please enter a valid email address",
  "sign_up_password_label": "Password",
  "sign_up_password_placeholder": "Enter password",
  "sign_up_confirm_password_label": "Confirm Password",
  "sign_up_confirm_password_placeholder": "Confirm password",
  "sign_up_confirm_password_description": "Re-enter your password to confirm.",
  "sign_up_password_requirement_min": "At least 8 characters",
  "sign_up_password_requirement_upper": "One uppercase letter",
  "sign_up_password_requirement_lower": "One lowercase letter",
  "sign_up_password_requirement_number": "One number",
  "sign_up_password_requirement_special": "One special character",
  "sign_up_password_error_min": "Password must be at least 8 characters",
  "sign_up_password_error_match": "Passwords don't match",
  "sign_up_name_error_invalid": "Name can only contain letters, spaces, hyphens, and apostrophes",
  "sign_up_button": "Sign Up",
  "sign_up_loading": "Creating account…",
  "sign_up_or_continue": "Or continue With",
  "sign_up_has_account": "Have an account?",
  "sign_up_sign_in": "Sign In",
  "sign_in_error_email_required": "Email is required",
  "sign_in_error_invalid_email": "Please enter a valid email address",
  "sign_in_error_invalid_credentials": "Invalid credentials",
  "sign_in_error_failed": "Sign in failed. Please check your credentials.",
  "sign_in_success": "Signed in successfully!",
  "sign_up_error_failed": "Failed to create account",
  "sign_up_error_signin_failed": "Account created but sign-in failed. Please try signing in manually.",
  "sign_up_success": "Account created! Signed in successfully!",
  "sign_up_agree_prefix": "I agree to Bavard's",
  "sign_up_terms_link": "Terms of Service",
  "sign_up_agree_and": "and",
  "sign_up_privacy_link": "Privacy Policy",
  "auth_continue_agree_prefix": "By continuing, you agree to our",
  "reset_title": "Reset Password",
  "reset_subtitle": "Enter your email to receive a reset code",
  "reset_email_placeholder": "you@company.com",
  "reset_send_code": "Send Code",
  "reset_sending": "Sending…",
  "reset_otp_title": "Check Your Email",
  "reset_otp_subtitle": "We sent a 6-digit code to",
  "reset_otp_label": "Verification code",
  "reset_otp_resend": "Resend code",
  "reset_otp_didnt_receive": "Didn't receive the code?",
  "reset_otp_next": "Continue",
  "reset_password_title": "New Password",
  "reset_password_subtitle": "Choose a strong password for your account",
  "reset_password_placeholder": "New password",
  "reset_confirm_placeholder": "Confirm new password",
  "reset_password_button": "Reset Password",
  "reset_resetting": "Resetting…",
  "reset_success": "Password reset successfully! You can now sign in.",
  "reset_error_failed": "Failed to reset password. Please try again.",
  "reset_error_invalid_code": "Invalid or expired code. Please try again.",
  "reset_back_to_login": "Back to Sign In",
  "email_code_button": "Sign in with email code",
  "email_code_title": "Email Code",
  "email_code_subtitle": "We'll send a sign-in code to your email",
  "email_code_email_placeholder": "you@company.com",
  "email_code_send": "Send Code",
  "email_code_sending": "Sending…",
  "email_code_otp_title": "Check Your Email",
  "email_code_otp_subtitle": "We sent a 6-digit code to",
  "email_code_otp_label": "Sign-in code",
  "otp_slot_aria_label": "Digit {{index}} of {{total}}",
  "otp_code_complete": "Verification code complete",
  "email_code_otp_didnt_receive": "Didn't receive the code?",
  "email_code_sent_toast": "Code sent! Check your email.",
  "email_code_resend": "Resend code",
  "email_code_verify": "Sign In",
  "email_code_verifying": "Signing in…",
  "email_code_error_failed": "Failed to send code. Please try again.",
  "email_code_error_invalid_code": "Invalid code. Please try again.",
  "email_code_error_expired": "Code expired. Please request a new one.",
  "email_code_expired_label": "Code expired",
  "email_code_expires_in": "Expires in",
  "email_code_change_email": "Change email",
  "email_code_or_password": "Use password instead",
  "anonymous_try_demo": "Try without an account",
  "anonymous_loading": "Setting up…",
  "model_filter_variant": "Model Variant",
  "model_filter_variant_label": "Filter by variant",
  "model_filter_all_variants": "All Variants",
  "model_filter_variant_standard": "Standard",
  "model_filter_variant_standard_desc": "Models without special variant",
  "model_filter_variant_free": "Free",
  "model_filter_variant_free_desc": "Free version with possible rate limits",
  "model_filter_variant_extended": "Extended",
  "model_filter_variant_extended_desc": "Extended context window version",
  "model_filter_variant_exacto": "Exacto",
  "model_filter_variant_exacto_desc": "High precision/accuracy version",
  "model_filter_variant_nitro": "Nitro",
  "model_filter_variant_nitro_desc": "Higher throughput routing",
  "model_filter_variant_floor": "Floor",
  "model_filter_variant_floor_desc": "Lowest price routing",
  "model_filter_variant_thinking": "Thinking",
  "model_filter_variant_thinking_desc": "Reasoning/thinking enabled",
  "model_filter_variant_online": "Online",
  "model_filter_variant_online_desc": "Real-time/online capable",
  "model_filter_endpoint_provider": "Endpoint Provider",
  "model_filter_author_search": "Search authors…",
  "model_filter_no_authors": "No authors found.",
  "model_filter_all_authors": "All Authors",
  "model_filter_provider_search": "Search providers…",
  "model_filter_no_providers": "No providers found.",
  "model_filter_all_providers": "All Providers",
  "model_filter_supported_params": "Supported Parameters",
  "model_filter_supported_params_label": "Filter by capabilities",
  "model_filter_clear_params": "Clear all",
  "model_filter_param_tools": "Tools",
  "model_filter_param_tools_desc": "Supports function/tool calling",
  "model_filter_param_reasoning": "Reasoning",
  "model_filter_param_reasoning_desc": "Supports reasoning/thinking mode",
  "model_filter_param_parallel_tools": "Parallel Tools",
  "model_filter_param_parallel_tools_desc": "Supports parallel tool calls",
  "model_filter_param_max_tokens": "Max Tokens",
  "model_filter_param_max_tokens_desc": "Supports max_tokens parameter",
  "model_filter_param_json_mode": "JSON Mode",
  "model_filter_param_json_mode_desc": "Supports JSON response format",
  "model_filter_param_vision": "Vision",
  "model_filter_param_vision_desc": "Supports image inputs",
  "model_filter_param_streaming": "Streaming",
  "model_filter_param_streaming_desc": "Supports streaming responses",
  "reasoning_thinking": "Thinking…",
  "reasoning_thought_for": "Thought for {{duration}}s",
  "button_retry": "Retry",
  "button_refresh": "Refresh",
  "search_emojis_placeholder": "Search emojis…",
  "recent_emojis_label": "Recent emojis",
  "search_status_placeholder": "Search status…",
  "search_views_placeholder": "Search views…",
  "search_locale_placeholder": "Search locale…",
  "search_models_placeholder": "Search models…",
  "search_timezone_placeholder": "Search city or offset (e.g. +3, GMT-5)…",
  "search_themes_placeholder": "Search themes…",
  "search_languages_placeholder": "Search languages…",
  "empty_no_emojis_found": "No emojis found.",
  "empty_no_status_found": "No status found.",
  "empty_no_models_found": "No models found",
  "empty_unable_to_load_models": "Unable to load models",
  "empty_no_language_found": "No language found.",
  "empty_no_theme_found": "No theme found.",
  "empty_no_view_found": "No view found.",
  "empty_no_locale_found": "No locale found.",
  "empty_no_users_found": "No users found",
  "empty_no_tools_available": "No tools available",
  "tool_fixed_to_category": "Tool is fixed to its category",
  "empty_no_capacity_available": "No capacity available",
  "empty_no_options_found": "No options found.",
  "empty_no_option_found": "No option found.",
  "empty_no_day_found": "No day found.",
  "loading_emojis": "Loading emojis…",
  "loading_models": "Loading models…",
  "loading_emoji_picker": "Loading emoji picker…",
  "error_calendar_loading_title": "Calendar Loading Error",
  "error_calendar_loading_message": "There was an issue loading the calendar. This is likely a temporary development server issue.",
  "error_details": "Error Details",
  "error_config_failed_title": "Failed to load configuration",
  "error_config_failed_message": "Please check your connection and try again.",
  "error_config_failed_details": "Check the browser console for detailed error information.",
  "emoji_category_smileys_people": "Smileys & People",
  "emoji_category_animals_nature": "Animals & Nature",
  "emoji_category_food_drink": "Food & Drink",
  "emoji_category_travel_places": "Travel & Places",
  "emoji_category_activities": "Activities",
  "emoji_category_objects": "Objects",
  "emoji_category_symbols": "Symbols",
  "emoji_category_flags": "Flags",
  "aria_open_emoji_picker": "Open emoji picker",
  "aria_select_emoji": "Select emoji",
  "aria_grid_data_editor": "Grid data editor",
  "aria_document_actions": "Document actions",
  "aria_edit_default_document_template": "Edit default document template",
  "aria_close": "Close",
  "aria_phone_editor_button_group": "Phone editor button group",
  "aria_open_phone_options": "Open phone options",
  "aria_select_option": "Select option",
  "aria_open_date_range_picker": "Open date range picker",
  "aria_data_grid_container": "Data grid container",
  "aria_document_stroke_color_picker": "Document stroke color picker",
  "aria_document_stroke_hex_value": "Document stroke hex value",
  "aria_previous_source": "Previous source",
  "aria_next_source": "Next source",
  "aria_clear_selection": "Clear selection",
  "aria_open_popup": "Open popup",
  "aria_resize_sidebar": "Resize sidebar",
  "aria_open_video": "Open video",
  "aria_close_video_overlay": "Close video overlay",
  "aria_scroll_to_bottom": "Scroll to bottom",
  "aria_error_icon": "Error icon",
  "aria_reset_preview": "Reset preview",
  "aria_previous": "Previous",
  "aria_next": "Next",
  "aria_previous_branch": "Previous branch",
  "aria_next_branch": "Next branch",
  "aria_robot_icon": "Robot icon",
  "aria_grid_toolbar": "Grid toolbar",
  "aria_clock_icon": "Clock icon",
  "aria_calendar_icon": "Calendar icon",
  "aria_loading": "Loading",
  "aria_analytics_chart": "Analytics chart",
  "aria_age_selector": "Age selector",
  "aria_open_sidebar": "Open Sidebar",
  "aria_close_sidebar": "Close Sidebar",
  "aria_open_calendar": "Open Calendar",
  "config_auto_use_default": "Auto (use default)",
  "config_none_disable_fallback": "None (disable fallback)",
  "actions": "Actions",
  "export": "Export",
  "import": "Import",
  "discard": "Discard",
  "undo": "Undo",
  "settings_documents_viewer_subtitle": "Document viewer settings",
  "settings_documents_editor_subtitle": "Customize editor behavior",
  "settings_chat_subtitle": "Manage tools and typing indicators",
  "theme_subtitle": "Choose your style",
  "component_style_label": "Component Style",
  "component_style_hint": "Choose button appearance style",
  "calendar_locale_en_native": "English",
  "calendar_locale_ar_native": "Arabic",
  "calendar_locale_ar_sa_native": "Arabic (Hijri)",
  "trends_time_analysis": "Time Analysis",
  "trends_time_analysis_desc": "Activity patterns across different time periods",
  "trends_event_distribution": "Event Distribution",
  "trends_event_distribution_desc": "Breakdown of events by type and category",
  "trends_user_behavior": "User Behavior",
  "trends_user_behavior_desc": "User journey and segmentation insights",
  "total_operations": "total operations",
  "name_required_for_event": "Name is required to create a reservation",
  "name_cannot_be_placeholder": "Please provide a real name, not 'Unknown'",
  "name_cannot_be_phone": "Name cannot be the phone number",
  "emoji_category_smileys_emotion": "Smileys & Emotion",
  "emoji_category_people_body": "People & Body",
  "emoji_category_people": "People",
  "aria_remove_filter": "Remove filter",
  "aria_previous_month": "Previous month",
  "aria_next_month": "Next month",
  "aria_user_profile_menu": "User profile menu",
  "aria_analytics_dashboard": "Analytics Dashboard",
  "aria_dashboard_overview": "Dashboard overview",
  "aria_key_performance_indicators": "Key Performance Indicators",
  "aria_loading_dashboard": "Loading dashboard",
  "aria_message_analysis": "Message analysis",
  "aria_trends_analysis": "Trends analysis",
  "aria_analytics_breakdown": "Analytics breakdown",
  "aria_chart_visualization": "Chart visualization",
  "aria_chart_legend": "Chart legend",
  "aria_open_date_picker": "Open date picker",
  "aria_open_time_picker": "Open time picker",
  "aria_time_hours": "Hours",
  "aria_time_minutes": "Minutes",
  "aria_time_meridiem": "AM/PM",
  "aria_open_style_panel": "Open style panel",
  "aria_previous_page": "Previous page",
  "aria_next_page": "Next page",
  "aria_document_viewer_canvas": "Document viewer canvas",
  "aria_documents_data_grid": "Documents data grid",
  "aria_document_viewer_panel": "Document viewer panel",
  "aria_loading_editor": "Loading editor",
  "aria_toggle_sidebar": "Toggle Sidebar",
  "aria_notifications_count": "Notifications:",
  "aria_events_count": "Events:",
  "chat_skip_thinking": "Skip thinking",
  "chat_stop_response": "Stop response",
  "chat_send_message": "Send message",
  "chat_attach_file": "Attach file",
  "chat_emoji_label": "Emoji",
  "chat_mention_kbd_navigate": "navigate",
  "chat_mention_kbd_insert": "insert",
  "chat_action_edit": "Edit",
  "chat_action_like": "Like",
  "chat_action_react": "React",
  "chat_action_reply": "Reply",
  "chat_reply_to": "Replying to",
  "chat_reply_cancel": "Cancel reply",
  "chat_reply_message_not_loaded": "Original message isn't loaded yet",
  "chat_reminder_label": "Reminder",
  "chat_role_customer": "Customer",
  "chat_role_secretary": "You",
  "chat_role_assistant": "Assistant",
  "chat_show_more": "Show more",
  "chat_appointment_reminder": "Appointment reminder",
  "chat_reminder_template_unavailable": "Template name unavailable",
  "chat_reminder_content_unavailable": "The original sent reminder content was not saved and cannot be recovered.",
  "chat_show_less": "Show less",
  "chat_thinking": "Thinking",
  "chat_view_as_json": "View as JSON",
  "chat_view_as_diagram": "View as diagram",
  "chat_tool_show_tool_call": "Show tool call",
  "chat_tool_hide_tool_call": "Hide tool call",
  "chat_tool_show_widget": "Show widget",
  "chat_tool_booking_booked": "Booked",
  "chat_tool_booking_waitlist_added": "Added to waitlist",
  "chat_tool_booking_waitlisted": "Waitlisted",
  "chat_tool_booking_failed": "Booking failed",
  "chat_tool_usage_ai": "AI usage",
  "chat_tool_usage_credits": "Credits",
  "chat_tool_location_sent": "Business location sent",
  "chat_tool_location_open_maps": "Open in Google Maps",
  "chat_workflow_title": "Answer workflow",
  "chat_workflow_step_research": "Researching knowledge base",
  "chat_workflow_step_research_more": "Gathering more evidence",
  "chat_workflow_step_draft": "Drafting answer",
  "chat_workflow_step_verify": "Verifying answer",
  "chat_workflow_step_verify_loop": "Verifying answer (pass {{loop}})",
  "chat_workflow_step_revise": "Revising answer",
  "chat_workflow_evidence_count": "Evidence collected: {{count}}",
  "chat_workflow_verify_passed": "All claims supported",
  "chat_workflow_verify_problems": "Claims flagged: {{count}}",
  "chat_workflow_outcome_success": "Workflow complete",
  "chat_workflow_outcome_failed": "Workflow failed",
  "event_status_pending": "Pending",
  "chat_tool_calls_group_label": "Used {{count}} tools",
  "chat_generating_image": "Generating Image…",
  "chat_reasoning": "Reasoning",
  "chat_reasoned_for_seconds": "Reasoned for a few seconds",
  "chat_toggle_plan": "Toggle plan",
  "toast_copied_to_clipboard": "Copied to clipboard!",
  "toast_no_text_to_copy": "There's no text to copy!",
  "toast_message_liked": "Message liked!",
  "toast_message_reacted": "Reaction sent!",
  "toast_message_reaction_failed": "Failed to send reaction",
  "toast_cannot_move_to_past": "Cannot move appointments to the past",
  "toast_template_error": "Template Error",
  "toast_user_creation_error": "An error occurred while creating the user",
  "toast_language_not_available": "This language is not available",
  "icon_document": "Document icon",
  "icon_loader": "Loader",
  "icon_vercel": "Vercel icon",
  "icon_git": "Git icon",
  "icon_box": "Box icon",
  "icon_home": "Home icon",
  "icon_gps": "GPS icon",
  "icon_invoice": "Invoice icon",
  "icon_google_logo": "Google logo",
  "icon_anthropic_logo": "Anthropic logo",
  "icon_route": "Route icon",
  "icon_upload": "Upload icon",
  "icon_menu": "Menu icon",
  "icon_checked_square": "Checked square icon",
  "icon_unchecked_square": "Unchecked square icon",
  "icon_more": "More icon",
  "icon_info": "Info icon",
  "icon_paperclip": "Paperclip icon",
  "icon_more_horizontal": "More horizontal icon",
  "icon_undo": "Undo icon",
  "icon_redo": "Redo icon",
  "icon_delta": "Delta icon",
  "icon_cpu": "CPU icon",
  "icon_pen": "Pen icon",
  "icon_summarize": "Summarize icon",
  "icon_sidebar_left": "Sidebar left icon",
  "icon_plus": "Plus icon",
  "icon_thumb_up": "Thumb up icon",
  "icon_thumb_down": "Thumb down icon",
  "icon_check_circle_fill": "Check circle fill icon",
  "icon_globe": "Globe icon",
  "icon_lock": "Lock icon",
  "icon_eye": "Eye icon",
  "icon_share": "Share icon",
  "icon_code": "Code icon",
  "icon_play": "Play icon",
  "icon_python": "Python icon",
  "icon_terminal_window": "Terminal window icon",
  "icon_terminal": "Terminal icon",
  "icon_clock_rewind": "Clock rewind icon",
  "icon_logs": "Logs icon",
  "icon_download": "Download icon",
  "icon_line_chart": "Line chart icon",
  "icon_warning": "Warning icon",
  "icon_sun": "Sun icon",
  "icon_moon": "Moon icon",
  "icon_cloud": "Cloud icon",
  "icon_chevron_down": "Chevron down icon",
  "icon_chevron_up": "Chevron up icon",
  "icon_spinner": "Spinner icon",
  "icon_expand_collapse": "Expand/Collapse",
  "icon_grid_pattern_background": "Decorative grid pattern background",
  "icon_animated_grid_overlay": "Animated grid pattern overlay",
  "icon_grid_pattern": "Grid pattern background",
  "icon_plus_title": "Plus",
  "icon_minus_title": "Minus",
  "icon_check_title": "Check",
  "icon_clear_title": "Clear",
  "icon_open_title": "Open",
  "icon_remove": "Remove",
  "auth_google": "Google",
  "auth_microsoft": "Microsoft",
  "preview_no_console_output": "No console output",
  "preview_sandbox": "Sandbox",
  "preview_web_preview": "Web preview",
  "preview_url": "Preview URL",
  "preview_title": "Preview",
  "preview_hero_video": "Hero video",
  "sidebar_title": "Sidebar",
  "documents_styles": "Styles",
  "dashboard_failed_to_load": "Failed to load dashboard",
  "documents_failed_to_load": "Failed to load documents",
  "calendar_failed_to_load": "Failed to load calendar",
  "documents_failed_to_load_viewer": "Failed to load viewer",
  "loading_users": "Loading users…",
  "updating": "Updating…",
  "status_completed": "Completed",
  "status_pending": "Pending",
  "status_in_progress": "In Progress",
  "status_failed": "Failed",
  "access_denied": "Access Denied",
  "landing_no_credit_card": "No credit card required",
  "landing_section_ai_whatsapp": "AI-Powered",
  "landing_section_features": "Features",
  "landing_section_integrations": "Integrations",
  "landing_section_ecosystem": "Connected Ecosystem",
  "landing_section_explore": "Explore",
  "landing_section_pricing": "Pricing",
  "landing_pricing_title": "Pricing that scales with your conversations",
  "landing_pricing_most_popular": "Most Popular",
  "landing_section_how_it_works": "How It Works",
  "landing_how_it_works_subtitle": "Live in under an hour",
  "landing_how_it_works_title": "How does Bavard work?",
  "landing_footer_product": "Product",
  "landing_footer_resources": "Resources",
  "landing_footer_contact": "Contact",
  "landing_social_facebook": "Facebook",
  "landing_social_twitter": "X (Twitter)",
  "landing_social_instagram": "Instagram",
  "landing_events": "Events",
  "landing_chart_event_types": "Event Types",
  "landing_chart_conversion_funnel": "Conversion Funnel",
  "landing_chart_weekly_activity": "Weekly Activity",
  "landing_ai_assistant": "AI Assistant",
  "landing_customer": "Customer",
  "landing_conversations": "Conversations",
  "debug_loading_redis_status": "Loading Redis status…",
  "debug_no_redis_status": "No Redis status available",
  "debug_connected": "Connected:",
  "debug_has_redis_client": "Has Redis Client:",
  "debug_redis_connected_prop": "Redis Connected Prop:",
  "debug_ping_result": "Ping Result:",
  "debug_ping_error": "Ping Error:",
  "debug_error": "Error:",
  "debug_orpc_connection_status": "oRPC Connection Status",
  "debug_connection_state": "Connection State:",
  "debug_heartbeat_health": "Heartbeat Health:",
  "debug_time_since_pong": "Time Since Last Pong:",
  "debug_ready_state": "Ready State:",
  "debug_last_message": "Last Message:",
  "debug_redis_status": "Redis Status",
  "debug_test_connections": "Test Connections",
  "debug_test_messages": "Test Messages",
  "debug_environment_variables": "Environment Variables",
  "demo_search_placeholder": "Search…",
  "demo_user_avatar_alt": "User avatar",
  "demo_more_info": "More info",
  "demo_enter_account_name": "Enter account name",
  "validation_issues_label": "Validation issues",
  "validation_fix_before_saving": "Please fix these issues before saving",
  "config_validation_booking_requirement": "At least one of Require Name or Require Phone must be enabled for events.",
  "config_validation_lead_fields_required": "Add at least one lead field before enabling lead collection.",
  "config_validation_tool_language_save_feedback": "saveFeedback is enabled but has no valid feedback summary language. Pick one from the display languages.",
  "config_validation_tool_language_summarize": "summarizeConversation is enabled but has no valid summary language. Pick one from the display languages.",
  "config_validation_warnings_label": "Warnings",
  "config_validation_warnings_description": "These don't block saving, but may need your attention.",
  "validation_go_to_issue": "Go to",
  "user_management_title": "User Management",
  "sidebar_mobile_description": "Displays the mobile sidebar.",
  "admin_staff_members": "Staff Members",
  "admin_member": "member",
  "admin_members": "members",
  "admin_seats_used": "seats used",
  "admin_upgrade_plan": "Upgrade plan",
  "admin_plan_your_plan": "your",
  "admin_seat_limit_reached_title": "Seat limit reached",
  "admin_seat_limit_reached_body": "You've reached the {plan} plan's seat limit ({limit}). Upgrade to add more members.",
  "admin_save_changes": "Save Changes",
  "admin_org": "org",
  "admin_orgs": "orgs",
  "admin_tenant_org_demo_excluded": "tenant org (demo excluded)",
  "admin_tenant_orgs_demo_excluded": "tenant orgs (demo excluded)",
  "admin_failed_to_load_members": "Failed to load members: ",
  "admin_failed_to_load_organizations": "Failed to load organizations: ",
  "admin_member_changes_saved": "Member changes saved.",
  "admin_failed_to_save_member_changes": "Failed to save member changes.",
  "admin_members_custom_role_column": "Custom Role",
  "admin_members_custom_role_none": "—",
  "admin_members_custom_role_unassigned": "(unassigned)",
  "admin_members_custom_role_default_suffix": "(default)",
  "admin_validation_failed": "Validation failed.",
  "admin_save_org_first": "Save the organization first, then you can manage its secrets.",
  "admin_org_changes_saved": "Organization changes saved.",
  "admin_failed_to_save_org_changes": "Failed to save organization changes.",
  "admin_validation_issue": "validation issue",
  "admin_validation_issues": "validation issues",
  "admin_col_organization": "Organization",
  "admin_col_slug": "Slug",
  "admin_col_plan": "Plan",
  "admin_col_status": "Status",
  "admin_col_users": "Users",
  "admin_col_events": "Events",
  "admin_col_messages": "Messages",
  "admin_status_active": "Active",
  "admin_status_inactive": "Inactive",
  "admin_total_organizations": "Total Organizations",
  "admin_active": "active",
  "admin_total_users": "Total Users",
  "admin_total_events": "Total Events",
  "admin_total_messages": "Total Messages",
  "admin_conversations": "Conversations",
  "admin_active_orgs": "Active Orgs",
  "admin_of_total": "of",
  "admin_total": "total",
  "admin_inactive_orgs": "Inactive Orgs",
  "admin_failed_to_load_dashboard": "Failed to load dashboard: ",
  "admin_section_platform_overview": "Platform Overview",
  "admin_section_activity_breakdown": "Activity Breakdown",
  "admin_section_analytics": "Analytics",
  "admin_section_per_org_breakdown": "Per-Organization Breakdown",
  "admin_no_organizations_found": "No organizations found",
  "admin_tabs_roles": "Roles & Permissions",
  "admin_roles_title": "Roles & permissions",
  "admin_roles_subtitle": "{{roleCount}} roles · {{capCount}} capabilities",
  "admin_roles_section_features": "Features",
  "admin_roles_capability_chat": "Chat",
  "admin_roles_capability_calendar": "Calendar",
  "admin_roles_capability_documents": "Documents",
  "admin_roles_capability_sidebar": "Sidebar",
  "admin_roles_section_contacts": "Contacts",
  "admin_roles_section_config": "Config",
  "admin_roles_section_org": "Organization",
  "admin_roles_category_workspace": "Workspace",
  "admin_roles_category_configuration": "Configuration",
  "admin_roles_category_administration": "Administration",
  "admin_roles_summary_allowed": "allowed",
  "admin_roles_group_members": "Members",
  "admin_roles_group_campaigns": "Campaigns",
  "admin_roles_group_waitlist": "Waitlist",
  "admin_roles_group_templates": "Templates",
  "admin_roles_group_secrets": "Secrets",
  "admin_roles_group_webhooks": "Webhooks",
  "admin_roles_group_schedulers": "Schedulers",
  "admin_roles_group_privacy": "Privacy",
  "admin_roles_group_feedback": "Feedback",
  "admin_roles_action_view": "View",
  "admin_roles_action_edit": "Edit",
  "admin_roles_action_reply": "Reply",
  "admin_roles_action_manage": "Manage",
  "admin_roles_action_manage_roles": "Manage roles",
  "admin_roles_action_manage_billing": "Manage billing",
  "admin_roles_filter_placeholder": "Filter capabilities…",
  "admin_roles_show_diff_only": "Show only differences",
  "admin_roles_legend_allowed": "Allowed",
  "admin_roles_legend_denied": "Not allowed",
  "admin_roles_legend_na": "Not applicable",
  "admin_roles_editing_as": "Editing as",
  "admin_roles_create_custom": "Create custom role",
  "admin_roles_create_dialog_title": "Create role",
  "admin_roles_create_dialog_name_label": "Role name",
  "admin_roles_remove_role": "Remove role",
  "admin_roles_remove_confirm_body": "Remove the \"{{role}}\" role? Members assigned to this role will lose its permissions.",
  "admin_roles_default_tag": "Default",
  "admin_roles_members_count": "{{count}} members",
  "admin_roles_plan_locked_hint": "Not available on your plan",
  "admin_roles_no_results": "No capabilities match \"{{query}}\".",
  "admin_roles_failed_to_load": "Failed to load roles: ",
  "admin_roles_failed_to_save": "Failed to save role changes.",
  "admin_roles_changes_saved": "Role changes saved.",
  "retry": "Retry",
  "error_boundary_title": "Something went wrong",
  "error_boundary_details": "Error details",
  "error_boundary_suggestion": "Please refresh the page or try again.",
  "error_boundary_refresh": "Refresh Page",
  "error_boundary_try_again": "Try Again",
  "error_boundary_recovering": "Recovering…",
  "error_boundary_recovering_description": "The application is being restored. Please wait…",
  "error_boundary_recovering_attempt": "Attempting to recover from the error. Please wait…",
  "error_boundary_error_in": "Error in: {{context}}",
  "error_boundary_retry_count": "Retry attempts: {{count}} / {{max}}",
  "ai_error_boundary_default": "Something went wrong while rendering the AI response.",
  "ai_error_boundary_unexpected": "An unexpected error occurred.",
  "config_calendar_locale_title": "Calendar Locale & Direction",
  "config_calendar_locale_description": "Configure available calendar locales and text direction",
  "config_available_calendar_locales": "Available Calendar Locales",
  "config_calendar_locales_infotip": "Calendar locales control day/month names and date formatting. English is always included.",
  "config_more_locales": "+{{count}} more",
  "config_select_locales_placeholder": "Select locales…",
  "config_always_enabled": "always enabled",
  "config_text_direction": "Text Direction",
  "config_direction_ltr": "Left to Right",
  "config_direction_rtl": "Right to Left",
  "config_direction_auto": "Auto (detect from locale)",
  "config_direction_ltr_short": "LTR",
  "config_direction_rtl_short": "RTL",
  "config_direction_auto_short": "Auto",
  "date_invalid": "Invalid date",
  "phone_input_ltr_hint": "Phone numbers are displayed left-to-right",
  "mutation_error_toast_title": "Request failed",
  "aria_sidebar_navigation": "Application navigation",
  "documents_page_title": "Documents",
  "documents_no_fields": "No fields",
  "documents_edit_fields_title": "Edit contact details",
  "error_boundary_error_details": "Error details",
  "error_boundary_recovering_title": "Recovering…",
  "error_boundary_description": "Please refresh the page or try again.",
  "landing_nav_features": "Features",
  "landing_nav_pricing": "Pricing",
  "landing_nav_docs": "Docs",
  "landing_nav_contact": "Contact",
  "landing_nav_login": "Log in",
  "landing_nav_get_started": "Get Started",
  "landing_nav_solutions": "Solutions",
  "landing_nav_solutions_heading": "By use-case",
  "landing_nav_solutions_support_title": "Customer Support",
  "landing_nav_solutions_support_desc": "Resolve questions instantly, escalate only what needs a human",
  "landing_nav_solutions_sales_title": "Sales & Lead Generation",
  "landing_nav_solutions_sales_desc": "Qualify every visitor, capture leads, book demos on autopilot",
  "landing_hero_prefix": "AI agents that handle",
  "landing_hero_em": "support and sales",
  "landing_hero_suffix": "for your business.",
  "landing_hero_sub": "Train an agent on your own content in minutes. It answers customer questions, qualifies leads, and books demos — on your website, on WhatsApp, on every channel your customers use.",
  "landing_hero_cta_free": "Start my free trial",
  "landing_hero_cta_start": "Get started",
  "landing_hero_trusted_by": "Trusted by 1,200+ support and sales teams",
  "landing_hero_watch_demo": "Watch the 90-second demo",
  "landing_reel_s1_label": "Trained on your business",
  "landing_reel_s2_label": "Grounded in your documents",
  "landing_reel_s3_label": "Books demos, 24/7",
  "landing_reel_s4_label": "Live on WhatsApp & beyond",
  "landing_reel_kb_title": "Knowledge base",
  "landing_reel_kb_count": "4 sources",
  "landing_reel_kb_ready": "Indexed · ready to answer",
  "landing_reel_src_pricelist": "Pricing.pdf",
  "landing_reel_src_faq": "Help centre & FAQ",
  "landing_reel_src_web": "yourcompany.com",
  "landing_reel_src_policy": "Refund policy.docx",
  "landing_reel_chat_user": "What's included in the Pro plan?",
  "landing_reel_chat_ai": "Pro is *$49 per user / month* — priority support, advanced analytics, and full API access.",
  "landing_reel_book_day": "Thursday",
  "landing_reel_book_booked": "Booked",
  "landing_reel_book_pick": "Best open slot",
  "landing_reel_book_confirm": "Booked · Thu 3:00 PM",
  "landing_reel_book_noconflict": "Added to your calendar",
  "landing_reel_ch_caption": "One agent, every channel",
  "landing_reel_play": "Play demo",
  "landing_reel_pause": "Pause demo",
  "landing_reel_s_skills": "Switch on its skills",
  "landing_reel_s_leads": "Never miss a lead",
  "landing_reel_sources_title": "Sources",
  "landing_reel_add_source": "Add source",
  "landing_reel_skills_title": "Agent skills",
  "landing_reel_skill_book": "Book demos",
  "landing_reel_skill_answer": "Answer questions",
  "landing_reel_skill_remind": "Send follow-ups",
  "landing_reel_skill_leads": "Capture leads",
  "landing_reel_chat_user2": "Can I still get a refund after 20 days?",
  "landing_reel_book_month": "November",
  "landing_reel_leads_title": "Leads captured · this month",
  "landing_reel_leads_name": "Sara Al-Amir",
  "landing_reel_leads_via": "New lead · via WhatsApp",
  "landing_reel_chat_ai2": "Yes — our refund window is *30 days*, no questions asked.",
  "landing_reel_tab_sources": "Sources",
  "landing_reel_tab_skills": "Skills",
  "landing_reel_tab_chat": "Chat",
  "landing_reel_tab_booking": "Booking",
  "landing_reel_tab_leads": "Leads",
  "landing_reel_tab_channels": "Channels",
  "landing_reel_up_drop": "Drag & drop your documents",
  "landing_reel_up_hint": "PDF · DOCX · CSV — up to 10 MB",
  "landing_reel_cal_req": "Book Sara a demo — Thursday 3 PM",
  "landing_reel_cal_new": "Sara · Demo",
  "landing_reel_cal_ev1": "Layla · Onboarding",
  "landing_reel_cal_ev2": "Nour · Follow-up",
  "landing_reel_cal_done": "Done — added to Thursday",
  "landing_reel_kpi_booked": "Resolved",
  "landing_reel_kpi_reply": "Avg reply",
  "landing_reel_kpi_active": "Active",
  "landing_reel_goal_label": "Monthly goal",
  "landing_reel_pages": "pages",
  "landing_reel_src_indexed": "Indexed · ready to answer",
  "landing_reel_skill_book_desc": "Finds a slot and confirms the meeting in seconds",
  "landing_reel_skill_answer_desc": "Replies from your documents, with sources",
  "landing_reel_skill_remind_desc": "Chases every lead that goes quiet",
  "landing_reel_skill_leads_desc": "Saves the contact the moment they message",
  "landing_reel_cal_tool": "find_available_slot",
  "landing_reel_cal_tool_run": "Scanning Thursday for an open slot…",
  "landing_reel_cal_tool_done": "Found 3:00 PM",
  "landing_reel_cal_reply": "All set — Sara's demo is booked for *Thursday at 3:00 PM*.",
  "landing_ai_title": "Purpose-built for customer-facing AI",
  "landing_ai_sub": "Bavard fuses your documents, your calendar, and every messaging channel into agents your customers can't tell from your best employee.",
  "landing_ai_always_on": "Always on, never offline",
  "landing_ai_always_on_desc": "Weekends. Holidays. 3 AM on a Tuesday. Your AI replies to every customer instantly — so you never lose a booking to the competitor who answered first.",
  "landing_ai_fast": "Replies in under 3 seconds",
  "landing_ai_fast_desc": "Humans take minutes — sometimes hours — to reply. Bavard responds before your customer has time to open a second tab.",
  "landing_ai_conversational": "Sounds like you, not a bot",
  "landing_ai_conversational_desc": "No canned scripts. No \"please hold.\" Every reply adapts to your customer's tone — and switches language mid-sentence if they do.",
  "landing_ai_actions": "Real actions, not just words",
  "landing_ai_actions_desc": "Books appointments. Reads your calendar. Quotes prices from your catalog. Sends reminders. Reschedules. Hands off to a human when needed — all without leaving the chat.",
  "landing_features_title": "Five tools, one workspace",
  "landing_features_sub": "Replace your scattered stack — chat, calendar, knowledge base, analytics, CRM — with one connected platform.",
  "landing_bento_title": "Everything your customers feel, in one place",
  "landing_bento_sub": "Eight ways Bavard answers, books, and follows up across every channel — grounded in your real documents, calendar, and prices.",
  "landing_feature_controls": "Controls you set",
  "landing_feature_controls_desc": "Decide what the AI does on its own — auto-reply, escalate to a human, or hold for review. Plus per-staff roles and permissions.",
  "landing_bento_flow_title": "How Bavard works",
  "landing_feature_calendar": "Smart calendar",
  "landing_feature_calendar_desc": "Demos and meetings booked from chat land here in real time. Drag to reschedule, working-hours rules, five views — no double-booking.",
  "landing_feature_whatsapp": "AI support agent",
  "landing_feature_whatsapp_desc": "Answers, resolves, and follows up — grounded in your real docs, prices, and policies. Customers can't tell it from your best rep.",
  "landing_feature_bulk": "Every channel, one inbox",
  "landing_feature_bulk_desc": "WhatsApp, Telegram, Messenger, web chat, email. One AI handles them all — with one knowledge base, one tone, one history.",
  "landing_feature_analytics": "Dashboards that close the loop",
  "landing_feature_analytics_desc": "Resolution rate, deflection, response times, pipeline created. Know what the agent is closing — and where it hands off to your team.",
  "landing_feature_grid": "Notes in your own hand",
  "landing_feature_grid_desc": "Write freehand with a tablet pen, straight onto each contact — no bulky files, no typing, no forms. Every page is saved as a searchable digital record. Note-taking the way you've always done it, finally without the paper.",
  "landing_feature_rag": "Knowledge base",
  "landing_feature_rag_desc": "Drop in your help centre, pricing, and policies. The agent cites your real documents — never invents an answer, never fakes a price.",
  "landing_integration_title": "Every tool, connected through AI",
  "landing_integration_sub": "Documents train your AI. Conversations create bookings. Bookings feed your dashboard. One loop runs your business — automatically.",
  "landing_integration_channels": "Conversations",
  "landing_integration_ai": "AI Engine",
  "landing_integration_calendar": "Calendar",
  "landing_integration_analytics": "Analytics",
  "landing_integration_documents": "Documents",
  "landing_cloudflow_documents_desc": "Upload & index your business knowledge",
  "landing_cloudflow_ai_desc": "Intelligent orchestration layer",
  "landing_cloudflow_conversations_desc": "Multi-channel AI messaging",
  "landing_cloudflow_calendar_desc": "Automated booking & scheduling",
  "landing_cloudflow_analytics_desc": "Real-time insights & metrics",
  "landing_cloudflow_conn_docs_ai": "Knowledge feeds AI",
  "landing_cloudflow_conn_ai_conv": "AI powers responses",
  "landing_cloudflow_conn_conv_cal": "Chats create bookings",
  "landing_cloudflow_conn_conv_analytics": "Chat data flows in",
  "landing_cloudflow_conn_cal_analytics": "Booking data flows in",
  "landing_cloudflow_conn_docs_cal": "Availability context",
  "landing_ecosystem_title": "Chat, docs, calendar, analytics — already connected",
  "landing_ecosystem_sub": "Your agent answers from your documents. Qualified leads and booked meetings sync to your calendar. Every conversation feeds the dashboard. Zero glue code.",
  "landing_explore_item_chat_title": "Chat that resolves and converts",
  "landing_explore_item_chat_body": "Meet customers on your website, WhatsApp, and Instagram. The agent answers from your docs, resolves the issue, and captures the lead — all in one thread.",
  "landing_explore_item_cal_title": "Demos booked while you sleep",
  "landing_explore_item_cal_body": "Every meeting the agent books lands on the calendar in real time, colour-coded by status. Click any open day to drop one in yourself — no double-entry, no clashes.",
  "landing_explore_item_docs_title": "Docs your agent reads",
  "landing_explore_item_docs_body": "Write notes, playbooks, and files on a shared canvas that saves as you go. Your agent reads them, so every answer stays grounded in your own knowledge.",
  "landing_explore_chat_window": "Messages",
  "landing_explore_chat_search": "Search conversations",
  "landing_explore_chat_ai_pill": "AI Agent",
  "landing_explore_chat_today": "Today",
  "landing_explore_chat_online": "online",
  "landing_explore_chat_typing": "typing",
  "landing_explore_chat_waiting": "Waiting for reply…",
  "landing_explore_chat_send": "Send",
  "landing_explore_chat_c1_name": "Sarah Hassan",
  "landing_explore_chat_c1_time": "5 min ago",
  "landing_explore_chat_c1_preview": "Perfect, that sorts it.",
  "landing_explore_chat_c1_m1": "Hi! My order still says processing — #4821.",
  "landing_explore_chat_c1_m2": "Hi Sarah! #4821 shipped this morning and is out for delivery today. Want the tracking link?",
  "landing_explore_chat_c1_m3": "Yes please.",
  "landing_explore_chat_c1_m4": "Sent! It's in your email too. Anything else I can help with? 🌟",
  "landing_explore_chat_c1_event": "Resolved · no agent needed",
  "landing_explore_chat_c1_draft1": "Would you like delivery updates on WhatsApp?",
  "landing_explore_chat_c1_reply1": "Yes please, that'd be great!",
  "landing_explore_chat_c1_draft2": "All set — you'll get an update at every step.",
  "landing_explore_chat_c1_reply2": "No, that's everything. Thank you!",
  "landing_explore_chat_c2_name": "Adam Naji",
  "landing_explore_chat_c2_time": "2 h ago",
  "landing_explore_chat_c2_preview": "What's the difference between the plans?",
  "landing_explore_chat_c2_m1": "What's the difference between the plans?",
  "landing_explore_chat_c2_m2": "Standard covers the agent and knowledge base; Premium adds analytics, API access, and dedicated support. Want a 15-minute walkthrough?",
  "landing_explore_chat_c2_draft1": "Shall I book you a demo this week?",
  "landing_explore_chat_c2_reply1": "Yes, Thursday morning works.",
  "landing_explore_chat_c3_name": "Maria Costa",
  "landing_explore_chat_c3_time": "1 d ago",
  "landing_explore_chat_c3_preview": "Can I upgrade mid-cycle?",
  "landing_explore_chat_c3_m1": "Can I upgrade mid-cycle?",
  "landing_explore_chat_c3_m2": "Of course — you're on Premium now and I've prorated the difference.",
  "landing_explore_chat_c3_event": "Upgraded · Premium",
  "landing_explore_chat_c3_draft1": "Want a quick tour of what Premium unlocks?",
  "landing_explore_chat_c3_reply1": "Perfect, thank you so much!",
  "landing_explore_cal_title": "July 2025",
  "landing_explore_cal_month": "Month",
  "landing_explore_cal_week": "Week",
  "landing_explore_cal_day": "Day",
  "landing_explore_cal_sun": "Sun",
  "landing_explore_cal_mon": "Mon",
  "landing_explore_cal_tue": "Tue",
  "landing_explore_cal_wed": "Wed",
  "landing_explore_cal_thu": "Thu",
  "landing_explore_cal_fri": "Fri",
  "landing_explore_cal_sat": "Sat",
  "landing_explore_cal_more": "more",
  "landing_explore_cal_book_hint": "Click any day to add a meeting",
  "landing_explore_cal_toast_wa": "booked via WhatsApp",
  "landing_explore_cal_toast_ig": "booked via Instagram",
  "landing_explore_cal_ev_omar": "Omar K.",
  "landing_explore_cal_ev_lina": "Lina R.",
  "landing_explore_cal_ev_checkup": "Demo",
  "landing_explore_cal_ev_maria": "Maria C.",
  "landing_explore_cal_ev_karim": "Karim A.",
  "landing_explore_cal_ev_nour": "Nour S.",
  "landing_explore_cal_ev_sarah": "Sarah H.",
  "landing_explore_cal_ev_adam": "Adam N.",
  "landing_explore_cal_ev_layla": "Layla M.",
  "landing_explore_cal_ev_yusuf": "Yusuf T.",
  "landing_explore_cal_ev_you": "New meeting",
  "landing_explore_docs_page": "Account notes",
  "landing_explore_docs_saving": "Saving…",
  "landing_explore_docs_saved": "Saved",
  "landing_explore_docs_sticky": "Send the pricing deck by Friday!",
  "landing_explore_docs_checklist": "Deal prep",
  "landing_explore_docs_item1": "Confirm the seat count",
  "landing_explore_docs_item2": "Send the quote",
  "landing_explore_docs_item3": "Prepare the onboarding pack",
  "landing_explore_docs_item4": "Assign an account owner",
  "landing_explore_docs_hint": "Grab the pen and draw anywhere",
  "landing_eco_tab_inbox": "Inbox",
  "landing_eco_tab_documents": "Documents",
  "landing_eco_tab_datagrid": "Data Grid",
  "landing_eco_tab_dashboard": "Dashboard",
  "landing_eco_events_label": "events",
  "landing_eco_reservations": "reservations",
  "landing_eco_kpi_total_events": "Total Events",
  "landing_eco_kpi_messages": "Messages",
  "landing_eco_kpi_avg_response": "Avg Response",
  "landing_eco_kpi_conversion": "Conversion",
  "landing_eco_segment_standard": "Standard",
  "landing_eco_segment_followup": "Follow-up",
  "landing_eco_segment_new_client": "New Client",
  "landing_eco_segment_priority": "Priority",
  "landing_eco_funnel_conversations": "Conversations",
  "landing_eco_funnel_interested": "Interested",
  "landing_eco_funnel_booked": "Booked",
  "landing_eco_funnel_completed": "Completed",
  "landing_eco_col_client": "Client",
  "landing_eco_col_service": "Service",
  "landing_eco_col_date": "Date",
  "landing_eco_col_time": "Time",
  "landing_eco_col_status": "Status",
  "landing_eco_col_phone": "Phone",
  "landing_eco_filter_all": "All",
  "landing_eco_filter_today": "Today",
  "landing_eco_filter_this_week": "This Week",
  "landing_eco_filter_pending": "Pending",
  "landing_eco_status_confirmed": "Confirmed",
  "landing_eco_status_pending": "Pending",
  "landing_eco_status_cancelled": "Cancelled",
  "landing_eco_status_upcoming": "Upcoming",
  "landing_eco_status_completed": "Completed",
  "landing_eco_service_haircut": "Haircut",
  "landing_eco_service_coloring": "Coloring",
  "landing_eco_service_styling": "Styling",
  "landing_eco_service_facial": "Facial",
  "landing_eco_service_massage": "Massage",
  "landing_eco_service_highlights": "Highlights",
  "landing_eco_tag_vip": "VIP",
  "landing_eco_tag_regular": "Regular",
  "landing_eco_conv_thanks_tuesday": "Thanks! See you Tuesday",
  "landing_eco_conv_reschedule": "Can I reschedule to Thursday?",
  "landing_eco_conv_what_services": "What services do you offer?",
  "landing_eco_conv_confirmed": "Confirmed, thank you!",
  "landing_eco_conv_saturday": "Is Saturday available?",
  "landing_eco_time_2m": "2m ago",
  "landing_eco_time_8m": "8m ago",
  "landing_eco_time_15m": "15m ago",
  "landing_eco_time_1h": "1h ago",
  "landing_eco_time_2h": "2h ago",
  "landing_day_mon": "Mon",
  "landing_day_tue": "Tue",
  "landing_day_wed": "Wed",
  "landing_day_thu": "Thu",
  "landing_day_fri": "Fri",
  "landing_day_sat": "Sat",
  "landing_day_sun": "Sun",
  "landing_pricing_sub": "Every plan includes a 14-day free trial. No credit card. Cancel in two clicks.",
  "landing_pricing_monthly": "Monthly",
  "landing_pricing_annual": "Annual (save 20%)",
  "landing_pricing_currency_note": "Prices in {{code}}, excl. {{vat}}% VAT.",
  "landing_pricing_per_month": "per month",
  "landing_pricing_billed_annually": "per month, {{total}} billed annually",
  "landing_pricing_tier_chat": "Chat",
  "landing_pricing_tier_standard": "Standard",
  "landing_pricing_tier_premium": "Premium",
  "landing_pricing_desc_chat": "AI agent + knowledge base on one channel — for small teams getting started",
  "landing_pricing_desc_standard": "Add meeting scheduling, analytics, and your whole team — for growing support and sales teams",
  "landing_pricing_desc_premium": "Documents, advanced analytics, API access, dedicated support — for high-volume operations",
  "landing_pricing_cta_get_started": "Get Started",
  "landing_pricing_cta_free_trial": "Start Free Trial",
  "landing_pricing_whatsapp": "WhatsApp or Telegram messaging",
  "landing_pricing_rag": "AI knowledge base (RAG)",
  "landing_pricing_ai_assistant": "AI support & sales agent",
  "landing_pricing_ai_1000": "1,000 AI messages / month",
  "landing_pricing_staff_unlimited": "Unlimited staff users & AI agent presets",
  "landing_pricing_rag_auto_refresh": "Knowledge base auto-refresh",
  "landing_pricing_email_support": "Email support",
  "landing_pricing_everything_chat": "Everything in Chat",
  "landing_pricing_calendar": "Calendar & meeting scheduling",
  "landing_pricing_dashboard": "Analytics dashboard",
  "landing_pricing_ai_5000": "5,000 AI messages / month",
  "landing_pricing_waitlist_offers": "Waitlist & automatic slot offers",
  "landing_pricing_priority_support": "Priority support",
  "landing_pricing_everything_standard": "Everything in Standard",
  "landing_pricing_documents": "Document editor & canvas",
  "landing_pricing_advanced_analytics": "Advanced analytics & reports",
  "landing_pricing_ai_15000": "15,000 AI messages / month",
  "landing_pricing_api_access": "API access",
  "landing_pricing_dedicated_support": "Dedicated support",
  "landing_pricing_everything_chat_plus": "Everything in Chat, plus:",
  "landing_pricing_everything_standard_plus": "Everything in Standard, plus:",
  "landing_pricing_note_chat": "No credit card required",
  "landing_pricing_note_standard": "14-day free trial, cancel anytime",
  "landing_pricing_note_premium": "Cancel in two clicks",
  "landing_how_it_works_sub": "No engineers. No setup calls. No 30-day onboarding. Three steps and one cup of coffee.",
  "landing_step_1_title": "Upload your knowledge",
  "landing_step_1_desc": "Drop in your help centre, pricing, FAQs, and policies. The agent indexes everything in minutes — and starts citing it on the next message.",
  "landing_step_2_title": "Connect your channels",
  "landing_step_2_desc": "Add the website widget, WhatsApp, Telegram, or Messenger. Sync your calendar. Invite your team. The agent takes the next conversation.",
  "landing_step_3_title": "Let AI handle the rest",
  "landing_step_3_desc": "Answers, resolutions, demos booked, follow-ups — all automatic. Your team only sees what actually needs a human.",
  "landing_cta_title": "Your competitors are answering at 3 AM. Are you?",
  "landing_cta_sub": "Join 1,200+ teams using Bavard to deploy AI agents trained on their business — across every channel their customers use.",
  "landing_cta_start_trial": "Start my free trial",
  "landing_cta_contact_us": "Talk to us",
  "landing_cta_read_docs": "Read the docs",
  "landing_contact_label": "Talk to us",
  "landing_contact_title": "See Bavard answer your own customers",
  "landing_contact_sub": "Start free in a few minutes, or leave your number and we'll walk you through it on a call.",
  "landing_subscribe_panel_eyebrow": "Why Bavard",
  "landing_subscribe_panel_heading": "The AI agent platform built for service teams",
  "landing_subscribe_panel_intro": "Train Bavard on your documents in minutes. Deploy on WhatsApp, Telegram, and web. Built for businesses that serve customers in Arabic, English, or both.",
  "landing_subscribe_bullet_24_7_title": "24/7 — never offline",
  "landing_subscribe_bullet_24_7_desc": "Every customer gets an answer — weekends, holidays, 3 AM. Zero missed bookings. Zero lost revenue.",
  "landing_subscribe_bullet_fast_title": "Replies in under 3 seconds",
  "landing_subscribe_bullet_fast_desc": "Customers get a real answer before they think to open a competitor's chat. Average reply: 2.4 seconds.",
  "landing_subscribe_bullet_actions_title": "Real actions, not just words",
  "landing_subscribe_bullet_actions_desc": "Books appointments. Checks availability. Quotes prices. Sends reminders. Reschedules. Everything your support team does — instantly.",
  "landing_subscribe_bullet_natural_title": "Sounds like you, not a bot",
  "landing_subscribe_bullet_natural_desc": "No canned scripts. Every reply adapts to the customer's tone — and switches language mid-message if they do.",
  "landing_subscribe_pricing_teaser": "Plans start at the Chat tier — AI assistant, knowledge base, and WhatsApp or Telegram included.",
  "landing_subscribe_or_reach": "Or reach us directly",
  "landing_subscribe_cta": "Start my free trial",
  "landing_lead_form_eyebrow": "Leave your details",
  "landing_lead_form_heading": "Talk to us",
  "landing_lead_form_intro": "Tell us about your business. We'll call back within a day to walk you through Bavard live.",
  "landing_lead_form_privacy": "We won't share your info. One reply, no spam, opt out anytime.",
  "landing_contact_response_badge": "We reply within 24 hours",
  "landing_contact_info_heading": "Let's start a conversation",
  "landing_contact_info_desc": "Tell us about your team and we'll show you how Bavard handles your customer conversations — live, on your own number.",
  "landing_contact_email_label": "Email",
  "landing_contact_name_label": "Name",
  "landing_contact_name_placeholder": "Your name",
  "landing_contact_email_placeholder": "your@email.com",
  "landing_contact_whatsapp_cta": "Chat on WhatsApp",
  "landing_contact_whatsapp_badge": "Recommended",
  "landing_contact_whatsapp_desc": "The fastest way to reach us — we usually reply within minutes.",
  "landing_contact_phone_label": "Phone",
  "landing_contact_phone_placeholder": "Your phone number (optional)",
  "landing_contact_company_label": "Company",
  "landing_contact_company_placeholder": "Your company name (optional)",
  "landing_contact_message_label": "Message",
  "landing_contact_message_placeholder": "Tell us about your business needs…",
  "landing_contact_submit": "Send Message",
  "landing_contact_sending": "Sending…",
  "landing_contact_success": "Thank you! We'll be in touch soon.",
  "landing_contact_error": "Something went wrong. Please try again or reach out directly.",
  "landing_footer_brand_name": "Bavard",
  "landing_footer_brand_desc": "The complete platform for building and deploying AI agents that handle customer support and sales — on your website, WhatsApp, Telegram, and beyond.",
  "landing_footer_features": "Features",
  "landing_footer_pricing": "Pricing",
  "landing_footer_changelog": "Changelog",
  "landing_footer_documentation": "Documentation",
  "landing_footer_api_reference": "API Reference",
  "landing_footer_support": "Support",
  "landing_footer_get_in_touch": "Get in touch",
  "landing_footer_rights": "All rights reserved.",
  "landing_footer_linkedin": "LinkedIn",
  "landing_footer_youtube": "YouTube",
  "landing_footer_legal": "Legal",
  "landing_footer_newsletter_title": "Stay ahead with AI insights",
  "landing_footer_newsletter_desc": "Get product updates, AI agent tips, and best practices — straight to your inbox. No spam.",
  "landing_footer_newsletter_placeholder": "Enter your email address",
  "landing_footer_subscribe": "Subscribe",
  "landing_faq_label": "Frequently asked",
  "landing_faq_title": "Everything you'd ask on a sales call",
  "landing_faq_sub": "Setup, billing, languages, security — the questions teams ask before they sign up. Missing yours? Drop us a line.",
  "landing_faq_cat_started": "Getting started",
  "landing_faq_cat_whatsapp": "Messaging & AI agents",
  "landing_faq_cat_pricing": "Pricing & billing",
  "landing_faq_cat_security": "Security & languages",
  "landing_faq_search_placeholder": "Search questions…",
  "landing_faq_search_no_results": "No questions match your search.",
  "landing_faq_q_what": "What is Bavard?",
  "landing_faq_a_what": "Bavard is a platform for building AI agents that handle customer support and sales. Train an agent on your own content, deploy it on your website, WhatsApp, Telegram, or Messenger, and let it answer questions, capture leads, and book meetings — all from one dashboard.",
  "landing_faq_q_trial": "Is there a free trial?",
  "landing_faq_a_trial": "Yes — every plan includes a 14-day full-access trial with no credit card required. Connect a channel, train the agent on your content, and let it handle real conversations before you decide.",
  "landing_faq_q_setup_time": "How long does setup take?",
  "landing_faq_a_setup_time": "Most teams go live in under an hour. Sign up, upload your documents or paste your FAQs, connect WhatsApp Business or a Telegram bot, and the AI is ready to chat. No engineering work required.",
  "landing_faq_q_developer": "Do I need a developer to use Bavard?",
  "landing_faq_a_developer": "No. Training the agent, writing its instructions, and inviting teammates are all done from the dashboard. Premium plans also expose a REST API if you want to wire Bavard into your own systems.",
  "landing_faq_q_existing_number": "Can I use my existing WhatsApp Business number?",
  "landing_faq_a_existing_number": "Yes, but the number has to be migrated to the WhatsApp Business API — a Meta requirement. We guide you through verification and setup. Note that existing chat history can't be transferred during the migration.",
  "landing_faq_q_ai_training": "How is the AI trained on my business?",
  "landing_faq_a_ai_training": "Upload PDFs, paste FAQs, or sync your help centre from the dashboard. The retrieval engine grounds every answer in your sources, so the agent cites your real policies, prices, and product details rather than inventing them.",
  "landing_faq_q_languages": "What languages does the AI speak?",
  "landing_faq_a_languages": "English and Arabic are first-class — including full RTL layouts and Arabic-aware UX. The agent auto-detects each customer's language and replies in kind, so a single bot can serve both audiences.",
  "landing_faq_q_actions": "Can the agent take real actions, not just reply?",
  "landing_faq_a_actions": "Yes. It looks things up, books meetings against your calendar, sends follow-ups, captures leads, and hands off to a teammate when a request goes beyond its scope — all without leaving the chat.",
  "landing_faq_q_credits": "How do AI message credits work?",
  "landing_faq_a_credits": "Each plan includes a monthly pool of AI replies. One reply consumes one credit. Credits reset every month; if you run out, you can purchase top-ups from the billing page or upgrade your plan.",
  "landing_faq_q_whatsapp_fees": "Are WhatsApp message fees included in my plan?",
  "landing_faq_a_whatsapp_fees": "Your platform subscription is separate from Meta's per-conversation WhatsApp fees. Inbound service messages stay free; marketing and utility templates you initiate are billed by Meta at standard rates and passed through at cost — no markup.",
  "landing_faq_q_change_plan": "Can I upgrade, downgrade, or cancel anytime?",
  "landing_faq_a_change_plan": "Yes. Switch plans from your billing page — upgrades are prorated; downgrades and cancellations take effect at the end of the current cycle, and you keep full access until then. No cancellation fees.",
  "landing_faq_q_which_plan": "Which plan is right for my business?",
  "landing_faq_a_which_plan": "Chat is the entry tier — AI inbox, knowledge base, and WhatsApp or Telegram. Standard adds smart scheduling, the waitlist engine, and the staff dashboard. Premium unlocks document-grade AI, advanced analytics, API access, and dedicated support.",
  "landing_faq_q_security": "Is my data secure?",
  "landing_faq_a_security": "All traffic is encrypted in transit (TLS) and at rest. Each organization's documents and conversations are isolated, with role-based access controls for staff. Conversation content is never used to train shared AI models.",
  "landing_faq_q_arabic_hijri": "Do you support Arabic, RTL, and the Hijri calendar?",
  "landing_faq_a_arabic_hijri": "Yes. Arabic UI, RTL layouts, Hijri date handling, and bilingual templates are first-class — not bolted on. Built specifically for businesses serving Saudi Arabia and the wider GCC.",
  "landing_faq_q_integrations": "What integrations and APIs are available?",
  "landing_faq_a_integrations": "Out of the box: WhatsApp Business, Telegram, Instagram, X, document uploads, Stripe and Paymob billing, and Google sign-in. Premium plans add REST API access and outbound webhooks for connecting Bavard to your own systems.",
  "landing_faq_q_data_ownership": "Who owns the conversation data?",
  "landing_faq_a_data_ownership": "You do. Export contacts, conversations, and analytics as CSV or via the API at any time. Bavard acts as a processor under your privacy policy and deletes your data on request after cancellation.",
  "landing_faq_q_no_experience": "Do I need any technical experience to get started?",
  "landing_faq_a_no_experience": "No. If you can use WhatsApp or Telegram, you can run Bavard. Everything is set up from the dashboard with no code, and our team guides you from your first step all the way to launch.",
  "landing_faq_q_connect_systems": "How do I connect Bavard to my existing systems?",
  "landing_faq_a_connect_systems": "Bavard works with the tools you already use — WhatsApp Business, Telegram, Instagram, X, document uploads, and Stripe or Paymob — out of the box. Premium plans add a REST API to wire it into anything else. No engineering needed to get started.",
  "landing_faq_q_on_behalf": "Can the AI handle conversations on my behalf?",
  "landing_faq_a_on_behalf": "Yes. Bavard's AI agent replies, follows up, and keeps conversations moving across WhatsApp, Telegram, Messenger, web chat, and email — automatically and around the clock — handing off to your team only when a request needs a human.",
  "landing_faq_q_customize_tone": "Can I customize the AI's tone and style?",
  "landing_faq_a_customize_tone": "Yes. Shape the agent's persona, tone, and reply style to match your brand. It speaks Arabic and English natively, automatically detecting and matching each customer's language.",
  "landing_faq_q_review_transcripts": "Can I review what the AI said to my customers?",
  "landing_faq_a_review_transcripts": "Yes. Every conversation is logged in full and searchable in the shared inbox — read the complete transcript of any chat, step in to take over at any point, and export the history whenever you need it.",
  "landing_faq_q_customer_data": "Is it safe to let the AI handle my customers' data?",
  "landing_faq_a_customer_data": "Yes. Customer data is encrypted in transit and at rest, isolated per organization, and handled under strict privacy controls. Conversation content is never used to train shared AI models, and you remain the owner and data controller throughout.",
  "landing_faq_still_question": "Still have a question?",
  "landing_faq_contact_link": "Talk to us",
  "landing_demo_tab_booking": "Booking",
  "landing_demo_tab_services": "Services",
  "landing_demo_ai_retrieving": "AI retrieving data…",
  "landing_demo_channel": "Live Chat",
  "landing_integration_webchat": "Web Chat",
  "landing_integration_email": "Email",
  "landing_section_integrations_marquee": "Integrations",
  "landing_integrations_marquee_title": "Every channel. One AI.",
  "landing_integrations_marquee_sub": "Connect WhatsApp, Telegram, Messenger, web chat, and email. One knowledge base. One inbox. Every conversation.",
  "landing_demo_btn_9am": "9:00 AM",
  "landing_demo_btn_2pm": "3:00 PM",
  "landing_demo_btn_430pm": "4:30 PM",
  "landing_demo_event_booked": "Booked",
  "landing_demo_event_open": "Open",
  "landing_demo_event_haircut": "Haircut",
  "landing_demo_event_your_appt": "Your Appt",
  "landing_demo_c_booking_user_1": "Do you have any openings tomorrow afternoon?",
  "landing_demo_c_booking_ai_1": "Tomorrow afternoon *available slots*:",
  "landing_demo_c_booking_action_1": "Checking availability…",
  "landing_demo_c_booking_action_1_done": "Availability loaded",
  "landing_demo_c_booking_user_2": "Book me in at 3pm please",
  "landing_demo_c_booking_ai_2": "*Booked!* _Haircut_ confirmed for *tomorrow at 3:00 PM*.",
  "landing_demo_c_booking_action_2": "Creating appointment…",
  "landing_demo_c_booking_action_2_done": "Appointment confirmed",
  "landing_demo_c_booking_ai_3": "A reminder will be sent *1 hour before* your appointment.",
  "landing_demo_c_booking_action_3": "Scheduling reminder…",
  "landing_demo_c_booking_action_3_done": "Reminder set",
  "landing_demo_c_services_user_1": "What services do you offer and where are you located?",
  "landing_demo_c_services_ai_1": "*Our Services:*\n• _Haircut & Styling_ — from *$35*\n• _Color Treatment_ — from *$80*\n• _Mani/Pedi_ — from *$45*\n• _Facial Treatment_ — from *$60*\n• _Bridal Package_ — from *$250*",
  "landing_demo_c_services_action_1": "Searching service catalog…",
  "landing_demo_c_services_action_1_done": "Service catalog loaded",
  "landing_demo_c_services_user_2": "Where's your nearest branch?",
  "landing_demo_c_services_ai_2": "Here's our location:",
  "landing_demo_c_services_action_2": "Looking up locations…",
  "landing_demo_c_services_action_2_done": "Locations found",
  "landing_demo_c_rag_action_1_done": "Documents retrieved",
  "landing_demo_c_rag_action_2_done": "Documents retrieved",
  "landing_demo_doc_service_catalog": "Service Catalog",
  "landing_demo_doc_service_menu": "Service Menu & Pricing Guide",
  "landing_demo_doc_hair_services": "Hair Services",
  "landing_demo_doc_haircut_styling": "Haircut & Styling — from $35",
  "landing_demo_doc_color_treatment": "Color Treatment — from $80",
  "landing_demo_doc_highlights_balayage": "Highlights & Balayage — from $120",
  "landing_demo_doc_nail_spa": "Nail & Spa",
  "landing_demo_doc_manicure": "Manicure & Pedicure — from $45",
  "landing_demo_doc_facial": "Facial Treatment — from $60",
  "landing_demo_doc_massage": "Deep Tissue Massage — from $90",
  "landing_demo_doc_packages": "Packages",
  "landing_demo_doc_bridal": "Bridal Package — from $250",
  "landing_demo_doc_vip": "VIP Day Package — from $180",
  "landing_demo_doc_contact_location": "Contact & Location",
  "landing_demo_doc_contact_info": "Contact Information & Directions",
  "landing_demo_doc_address": "Address",
  "landing_demo_doc_address_line1": "123 Beauty Lane, 2nd Floor",
  "landing_demo_doc_address_line2": "Downtown District, Near Central Mall",
  "landing_demo_doc_getting_here": "Getting Here",
  "landing_demo_doc_metro": "Metro: Central Station (Exit B, 3 min walk)",
  "landing_demo_doc_parking": "Parking: Validated at Central Mall garage",
  "landing_demo_doc_contact": "Contact",
  "landing_demo_doc_studio_name": "LUXE STUDIO",
  "landing_demo_tab_rag": "Knowledge Base",
  "landing_demo_rag_drop_label": "Drop files here",
  "landing_demo_rag_processing": "Processing…",
  "landing_demo_rag_user_1": "What was our total revenue in Q3?",
  "landing_demo_rag_ai_1": "Searching the _Q3 Report_…",
  "landing_demo_rag_action_1": "Retrieving Q3-Report.pdf…",
  "landing_demo_rag_ai_2": "Total revenue in Q3 was *$2.4M*, up *+18%* vs Q2 with *342* new customers.",
  "landing_demo_rag_user_2": "Which region performed best?",
  "landing_demo_rag_ai_3": "Looking up _regional breakdown_…",
  "landing_demo_rag_action_2": "Scanning regional data…",
  "landing_demo_rag_ai_4": "*North America* led with *$890K (37%)*, followed by Europe at *$650K (27%)*.",
  "landing_capabilities_label": "Capabilities",
  "landing_capabilities_title": "Purpose-built for customer-facing AI",
  "landing_capabilities_sub": "Bavard fuses your documents, your calendar, and every messaging channel into agents your customers can't tell from your best employee.",
  "landing_cap_kb_eyebrow": "Grounded answers",
  "landing_cap_kb_title": "Answers compiled from across your files",
  "landing_cap_kb_body": "Add as many documents as you like — menus, price lists, policies, FAQs. The AI cross-references all of them to compile one accurate answer, and cites where it came from.",
  "landing_cap_kb_search": "Do you have any vegan options?",
  "landing_cap_kb_file_menu": "Menu",
  "landing_cap_kb_file_prices": "Price list",
  "landing_cap_kb_file_policies": "Policies",
  "landing_cap_kb_cited": "Cited from Menu.pdf",
  "landing_cap_kb_metric": "Cross-references every file — no matter how many.",
  "landing_cap_avail_eyebrow": "Always on",
  "landing_cap_avail_title": "Open every hour you're closed",
  "landing_cap_avail_body": "While you sleep, it keeps replying, booking, and capturing leads. No after-hours gap, no voicemail, no missed revenue.",
  "landing_cap_avail_coverage_label": "Always open",
  "landing_cap_avail_uptime_label": "Uptime",
  "landing_cap_avail_missed_label": "Missed messages",
  "landing_cap_avail_live": "Live",
  "landing_cap_avail_sample": "Replied to a customer · 3:42 AM",
  "landing_cap_resp_eyebrow": "Instant replies",
  "landing_cap_resp_title": "Replies before they think about leaving",
  "landing_cap_resp_body": "It answers in under two seconds, any hour, in Arabic or English — a human-quality reply while a person would still be typing 'hello'.",
  "landing_cap_resp_metric_label": "Average first reply",
  "landing_cap_resp_bavard": "Bavard AI",
  "landing_cap_resp_human": "Typical human",
  "landing_cap_kb_head": "Every file,\none answer",
  "landing_cap_kb_lead": "Bavard compiles answers from across all your documents.",
  "landing_cap_kb_rest": " Drop in menus, price lists, policies, FAQs — as many as you like. It cross-references every file to assemble one accurate reply and always cites where it came from. No matter how many files you add, nothing gets missed.",
  "landing_cap_kb_card": "Knowledge Base",
  "landing_cap_kb_sub": "files, all cross-referenced",
  "landing_cap_kb_desc": "Sources compiled into every answer",
  "landing_cap_avail_head": "Always on,\nnever closed",
  "landing_cap_avail_lead": "Bavard answers around the clock, every day of the year.",
  "landing_cap_avail_rest": " While you sleep it keeps replying, booking, and capturing leads — at 3 AM or on a holiday. No after-hours gap, no voicemail, no missed revenue. Your customers always get an instant response.",
  "landing_cap_avail_card": "Availability",
  "landing_cap_avail_sub": "around the clock",
  "landing_cap_avail_desc": "Messages handled across every hour of the day",
  "landing_cap_resp_head": "Replies in\nunder 2s",
  "landing_cap_resp_lead": "Bavard sends a human-quality reply in under two seconds.",
  "landing_cap_resp_rest": " Any hour, in Arabic or English, it answers before a person would finish reading the message — so customers never wait, never get left on read, and never bounce to a competitor while you are busy.",
  "landing_cap_resp_card": "Response Time",
  "landing_cap_resp_sub": "average first reply",
  "landing_cap_resp_desc": "First-reply time vs a human agent",
  "landing_bento_kb_title": "Knowledge Base",
  "landing_bento_kb_desc": "Upload your docs — AI answers customers instantly",
  "landing_bento_kb_question": "Do you have any vegan options?",
  "landing_bento_kb_answer": "Yes! We have 4 vegan dishes including our mushroom risotto and grilled vegetable platter.",
  "landing_bento_kb_source": "from Menu.pdf",
  "landing_bento_sched_title": "Smart Scheduling",
  "landing_bento_sched_desc": "AI books appointments directly from conversations",
  "landing_bento_sched_date": "Thursday, Mar 27",
  "landing_bento_sched_today": "Today",
  "landing_bento_sched_booked": "Booked",
  "landing_bento_sched_open": "Open",
  "landing_bento_sched_confirmed": "Confirmed",
  "landing_bento_sched_confirmation_sent": "Confirmation sent",
  "landing_bento_availability_title": "24/7 Availability",
  "landing_bento_availability_desc": "Never miss a customer inquiry",
  "landing_bento_availability_uptime": "Uptime",
  "landing_bento_availability_response": "Response",
  "landing_bento_availability_coverage": "Coverage",
  "landing_bento_availability_live": "Live",
  "landing_bento_availability_log": "Activity log",
  "landing_bento_activity_just_now": "Just now",
  "landing_bento_activity_replied": "Customer replied in 1.2s",
  "landing_bento_activity_booking": "Booking confirmed",
  "landing_bento_activity_doc_query": "Document query answered",
  "landing_bento_activity_availability_check": "Availability checked",
  "landing_bento_activity_followup": "Follow-up sent automatically",
  "landing_bento_activity_lead": "New lead captured",
  "landing_bento_activity_payment": "Payment link delivered",
  "landing_bento_activity_reschedule": "Reschedule processed",
  "landing_bento_replies_title": "Instant Replies",
  "landing_bento_replies_desc": "Intelligent responses in under 3 seconds",
  "landing_bento_replies_user_msg_1": "Any availability at 3pm?",
  "landing_bento_replies_user_msg_2": "Open hours tomorrow?",
  "landing_bento_replies_ai_reply": "Open 9-6! I have a 3 PM slot. Shall I book it?",
  "landing_bento_replies_avg": "avg response",
  "landing_features_preview_chat_title": "Chat",
  "landing_features_preview_chat_user_msg": "Hi, I need to book an appointment for tomorrow at 3pm",
  "landing_features_preview_chat_ai_reply": "Done! Booked for tomorrow, March 28 at 3:00 PM. Confirmation sent.",
  "landing_features_preview_kb_title": "Knowledge Base",
  "landing_features_preview_kb_search": "Search documents…",
  "landing_features_preview_file_service_catalog": "Service Catalog",
  "landing_features_preview_file_pricing_sheet": "Pricing Sheet",
  "landing_features_preview_file_company_policies": "Company Policies",
  "landing_features_preview_calendar_title": "Calendar",
  "landing_features_preview_calendar_available": "Available",
  "landing_features_preview_calendar_consult_with": "Sara M. - Consultation",
  "landing_features_preview_calendar_appt_label": "10:00 AM - Consultation",
  "landing_features_preview_calendar_confirm": "Confirm",
  "landing_features_preview_bulk_title": "Channels",
  "landing_features_preview_bulk_name": "Name",
  "landing_features_preview_bulk_phone": "Phone",
  "landing_features_preview_bulk_status": "Status",
  "landing_features_preview_bulk_active": "Active",
  "landing_features_preview_bulk_pending": "Pending",
  "landing_features_preview_analytics_title": "Dashboard",
  "landing_features_preview_analytics_response_rate": "Response Rate",
  "landing_features_preview_analytics_messages": "Messages",
  "landing_features_preview_analytics_bookings": "Bookings",
  "landing_features_preview_analytics_vs_last_month": "vs last month",
  "landing_features_preview_grid_title": "Data Grid",
  "landing_testimonials_label": "Testimonials",
  "landing_testimonials_title": "Loved by service teams worldwide",
  "landing_testimonials_sub": "From kitchens to clinics to property managers — see how teams use Bavard to win back their day.",
  "landing_testimonial_1_name": "Dr. Amal Saied",
  "landing_testimonial_1_role": "OB/GYN, Sehaty Gheir, Makkah, Saudi Arabia",
  "landing_testimonial_1_text": "Bavard handles 80% of our appointments automatically. Availability questions, follow-ups, rescheduling — patients get answers before our front desk picks up the phone.",
  "landing_testimonial_2_name": "Marcus Weber",
  "landing_testimonial_2_role": "Operations Director, Alpine Dental Group",
  "landing_testimonial_2_text": "Patients book appointments at 2am now. The AI knows our schedule and handles rescheduling without any staff involvement.",
  "landing_testimonial_3_name": "Priya Sharma",
  "landing_testimonial_3_role": "Founder, StyleBox Boutique",
  "landing_testimonial_3_text": "We uploaded our product catalog and price list. Now customers get instant, accurate answers about availability and sizing via WhatsApp.",
  "landing_testimonial_4_name": "James O'Connor",
  "landing_testimonial_4_role": "CEO, Dublin Property Management",
  "landing_testimonial_4_text": "Managing tenant inquiries across 200 units was a nightmare. Bavard reduced our response time from hours to seconds.",
  "landing_testimonial_rating": "Rating",
  "landing_testimonials_prev": "Previous testimonial",
  "landing_testimonials_next": "Next testimonial",
  "landing_nav_lang_toggle_aria": "Switch language",
  "endpoint_additional_providers": "Additional providers",
  "endpoint_context_length": "Context",
  "endpoint_max_output": "Max output",
  "endpoint_quantization_description": "Quantization: {{label}}. This model uses {{label}} quantization, which reduces model size and improves inference speed while maintaining acceptable quality.",
  "endpoint_tokens": "tokens",
  "language_already_available": "Language already available",
  "model_filter_add_favorite": "Add to favorites",
  "model_filter_author": "Model Author",
  "model_filter_open": "Open filter menu",
  "model_filter_remove_favorite": "Remove from favorites",
  "model_filter_variant_standard_description": "Standard models without specialized capabilities",
  "no_language_mapping_found": "No language mapping found for this country",
  "select_country": "Select Country",
  "timezone_list": "Timezone list",
  "timezone_no_matches": "No matches",
  "timezone_select_placeholder": "Select timezone",
  "translating": "Translating…",
  "add_and_translate": "Add & Translate",
  "add_language": "Add Language",
  "add_language_description": "Select a country to add its primary language. The language will be automatically translated using AI.",
  "workingHours": {
    "dayOfWeek": {
      "label": "Day of week"
    },
    "workingDays": {
      "title": "Working Hours",
      "description": "Choose working hours",
      "atLeastOneRequired": "At least one working day is required *",
      "endMustBeAfterStart": "End time must be after start time",
      "endTime": "End Time *",
      "startTime": "Start Time *",
      "slotDuration": "Slot Duration *",
      "selectDuration": "Select duration",
      "noValidDurations": "No valid durations",
      "missing": "Missing",
      "required": "Required"
    },
    "daySpecific": {
      "title": "Overrides",
      "description": "Set different hours for specific days",
      "addHours": "Add Day-specific Hours",
      "dayOfWeek": "Day of Week",
      "start": "Start",
      "end": "End",
      "endMustBeAfterStart": "End time must be after start time",
      "noOverrides": "No overrides added yet.",
      "noValidDurations": "No valid durations",
      "removeEntry": "Remove day-specific hours entry",
      "selectDuration": "Select duration",
      "slotDuration": "Slot Duration",
      "dayOfWeekHelp": "Select which working day to override. Each day can only have one override."
    },
    "customRanges": {
      "title": "Date Range Overrides",
      "description": "Set different working hours for specific date ranges",
      "addRange": "Add Date Range Override",
      "dateRange": "Date Range",
      "endMustBeAfterStart": "End time must be after start time",
      "endTime": "End Time",
      "from": "From",
      "to": "To",
      "startTime": "Start Time",
      "inherit": "Inherit",
      "inheritAlreadyMatches": "Already matches global working days",
      "inheritTooltip": "Copy global working days",
      "noRanges": "No custom ranges defined.",
      "rangeName": "Range Name",
      "rangeNamePlaceholder": "Range name",
      "removeRange": "Remove custom range",
      "resetToDefault": "Reset to default",
      "selectDuration": "Select duration",
      "slotDuration": "Slot Duration",
      "workingDays": "Working Days",
      "daySpecific": {
        "addHours": "Add Day-specific Hours",
        "description": "Set different hours for specific days within this range",
        "noOverrides": "No day-specific overrides."
      },
      "rangeNameHelp": "A label for this range (e.g. 'Summer hours'). Shown in the calendar toolbar when active.",
      "workingDaysHelp": "Which days are working days during this range. Overrides the global working days.",
      "recurrence": {
        "openBuilder": "Build a recurring range",
        "title": "Recurring range builder",
        "description": "Describe a repeating pattern and turn it into date range overrides.",
        "frequency": "Repeats",
        "daily": "Daily",
        "weekly": "Weekly",
        "monthly": "Monthly",
        "every": "Every",
        "onWord": "on",
        "dayWord": "day",
        "unitDay": "day",
        "unitWeek": "week",
        "unitMonth": "month",
        "unitDays": "days",
        "unitWeeks": "weeks",
        "unitMonths": "months",
        "onDays": "On these days",
        "monthlyOn": "On",
        "monthModeDate": "A day of the month",
        "monthModeWeekday": "A day of the week",
        "dayOfMonth": "Day of month",
        "ordinal": "Which one",
        "weekday": "Weekday",
        "ordinal1": "First",
        "ordinal2": "Second",
        "ordinal3": "Third",
        "ordinal4": "Fourth",
        "ordinalLast": "Last",
        "hours": "Hours",
        "startsOn": "Starts on",
        "ends": "Ends",
        "endsAfter": "After a number of times",
        "endsOn": "On a date",
        "noOccurrences": "This pattern produces no dates. Pick at least one day.",
        "summaryCollapsed": "Adds a single override spanning these dates, open only on the selected days.",
        "summaryExpanded": "Adds one single-day override per date.",
        "willAdd": "New override entries",
        "cancel": "Cancel",
        "addButton": "Add overrides"
      }
    },
    "inheritedDefault": " (default)",
    "grid": {
      "addRange": "Add time range",
      "removeRange": "Remove time range",
      "unavailable": "Unavailable",
      "overlap": "Time ranges overlap",
      "durationTooLong": "Slot duration is longer than the day's longest time range",
      "noWorkingDays": "At least one working day",
      "weekStartsOn": "Week starts on",
      "copyTooltip": "Copy times to…",
      "copyTimesTo": "Copy times to",
      "copyEveryDay": "Every day",
      "copyApply": "Apply",
      "dragToReorder": "Drag to reorder",
      "reorderHint": "Drag a day to the top to start the week there."
    }
  },
  "quickReplies": {
    "dialog": {
      "title": "Quick Replies",
      "description": "Create sections and quick reply badges. Click a badge in the chat bar to insert its text."
    },
    "placeholder": {
      "label": "Label",
      "text": "Message text"
    },
    "tooltip": {
      "addReply": "Add reply",
      "clickToEdit": "Click to edit",
      "clickToRename": "Click to rename",
      "deleteSection": "Delete section and all its replies"
    },
    "aria": {
      "dragReply": "Drag to reorder",
      "dragSection": "Drag to reorder section",
      "colorPicker": "{{name}} color picker"
    },
    "empty": {
      "noReplies": "Add at least one reply",
      "noSections": "No sections yet. Add one to get started."
    },
    "contextMenu": {
      "removeReply": "Remove quick reply",
      "deleteSection": "Delete section"
    },
    "confirmDelete": {
      "title": "Delete section?",
      "description": "This permanently deletes \"{{name}}\" and all of its quick replies.",
      "confirm": "Delete section"
    },
    "button": {
      "addSection": "Add Section",
      "save": "Save",
      "saving": "Saving"
    },
    "error": {
      "saveFailed": "Failed to save. Please try again."
    },
    "section": {
      "defaultName": "Section {{number}}"
    }
  },
  "chat_action_quick_replies": "Quick Replies",
  "chat_action_search": "Search messages",
  "back": "Back",
  "search": "Search",
  "config_loading_label": "Loading configuration",
  "config_back_to_app": "Back to app",
  "config_mode_standard": "Standard",
  "config_mode_advanced": "Advanced",
  "config_mode_aria_label": "Configuration mode",
  "config_mode_tooltip_standard": "Standard mode — show only common settings",
  "config_mode_tooltip_advanced": "Advanced mode — show all settings",
  "config_nav_event_types": "Event types",
  "config_nav_email_templates": "Email Templates",
  "config_import_no_differences": "No differences found. The imported configuration matches your current settings.",
  "config_import_found_sections": "Found {{count}} sections with changes. Review and select which to import.",
  "config_import_success": "Imported {{count}} fields successfully",
  "config_import_failed": "Failed to apply import: {{message}}",
  "config_import_ignored_fields": "{{count}} fields in the imported file were not recognized and were skipped.",
  "config_import_deactivate_types_warning": "This import removes {{count}} active event types ({{names}}). They stay active unless you confirm deactivation below.",
  "config_import_deactivate_types_toggle": "Deactivate the removed event types",
  "config_pending_save_failed": "Failed to save pending changes: {{message}}",
  "config_pending_save_success": "Changes saved",
  "config_save_success": "Configuration saved successfully",
  "config_save_failed": "Failed to save configuration: {{message}}",
  "config_import_unknown_error": "Unknown error occurred",
  "config_import_validation_summary": "Import failed — {{count}} field(s) invalid: {{fields}}. See the browser console for full details.",
  "config_import_version_outdated": "This configuration file uses an older or unsupported format. Re-export it from a current workspace, then import again.",
  "config_import_cancelled": "Import cancelled",
  "config_import_overwrite_title": "Import over unsaved changes?",
  "config_import_overwrite_description": "You have unsaved changes. Importing will preview the selected values on top of them. You can cancel the import to restore your changes.",
  "config_import_overwrite_confirm": "Continue import",
  "config_changes_discarded": "Changes discarded",
  "config_form_reset_to_defaults": "Form reset to defaults. Click Save to apply changes.",
  "email_template_name_label": "Template Name",
  "email_template_name_placeholder": "e.g. Welcome Email, Meeting Reminder",
  "email_template_name_required": "Template name is required",
  "email_template_subject_label": "Subject Line",
  "email_template_subject_placeholder": "e.g. Hello {{name}}, your appointment is confirmed",
  "email_template_subject_required": "Subject is required",
  "email_template_subject_hint": "Use {{name}} and {{email}} for personalization.",
  "email_template_body_label": "Email Body",
  "email_template_body_placeholder": "Write your email content here. Use {{name}} and {{email}} for personalization…",
  "email_template_body_required": "Email body is required",
  "email_template_available_variables": "Available variables:",
  "email_template_edit_title": "Edit Template",
  "email_template_new_title": "New Template",
  "email_template_save": "Save Template",
  "email_template_variable_recipient_name": "Recipient Name",
  "email_template_variable_recipient_email": "Recipient Email",
  "config_calendar_week_start_title": "Week Start Day",
  "config_calendar_week_start_description": "Set which day the week starts on",
  "config_calendar_views_title": "Calendar Views",
  "config_calendar_views_description": "Click a view to enable it; click the pin to set it as the default.",
  "config_calendar_views_default_label": "Default",
  "config_calendar_views_set_default": "Set as default",
  "config_calendar_views_validation": "Select at least one calendar view *",
  "config_calendar_view_timeGridWeek": "Week",
  "config_calendar_view_timeGridDay": "Day",
  "config_calendar_view_dayGridMonth": "Month",
  "config_calendar_view_listMonth": "List",
  "config_calendar_view_multiMonthYear": "Year",
  "config_event_time_format_title": "Event Time Format",
  "config_event_time_format_description": "Configure how event times are displayed",
  "config_event_time_format_aria": "Time format",
  "config_event_time_format_12h": "12-hour",
  "config_event_time_format_24h": "24-hour",
  "config_event_time_format_auto": "Responsive",
  "config_event_time_format_auto_tip": "Adapts between 12h and 24h based on the user's browser locale.",
  "config_event_time_format_hidden": "Hidden",
  "config_event_time_format_hidden_tip": "Hides the time label on calendar event blocks. Events still occupy their time slot.",
  "config_event_time_format_minutes_label": "Minutes",
  "config_event_time_format_minutes_tip": "Show or hide the minutes portion (e.g., 2 PM vs 2:30 PM).",
  "config_event_time_format_meridiem_label": "AM/PM",
  "config_event_time_format_meridiem_tip": "Show or hide the AM/PM suffix. Only applies in 12-hour format.",
  "config_event_time_format_preview": "Preview",
  "config_business_info_title": "Business Information",
  "config_business_info_description": "Configure your business details for AI responses and location sharing",
  "config_business_info_ai_hint": "These details are automatically shared with the AI assistant — no need to repeat them in the system prompt.",
  "config_business_name_label": "Business Name",
  "config_business_name_placeholder": "Your Business Name",
  "config_business_name_tip": "Shown to customers in AI-generated replies and WhatsApp or Telegram location pins.",
  "config_business_address_label": "Business Address",
  "config_business_address_placeholder": "Street Address, City, Country",
  "config_business_address_placeholder_full": "Street Address, City, Country, Postal Code",
  "config_business_address_tip": "Used in AI responses and included in location pins sent via WhatsApp or Telegram.",
  "config_business_google_maps_url_label": "Google Maps URL",
  "config_business_google_maps_url_placeholder": "https://maps.app.goo.gl/…",
  "config_business_maps_resolving": "Reading coordinates from the link…",
  "config_business_maps_resolved": "Coordinates filled from the link",
  "config_business_maps_not_found": "No coordinates found in that link",
  "config_business_maps_error": "Couldn't read that link — enter coordinates manually",
  "config_business_landmark_label": "Landmark / directions",
  "config_business_landmark_placeholder": "Near a well-known landmark",
  "config_business_floor_unit_label": "Floor / unit",
  "config_business_floor_unit_placeholder": "Floor and unit number",
  "config_business_coordinates_label": "Coordinates",
  "config_business_latitude_label": "Latitude",
  "config_business_longitude_label": "Longitude",
  "ai_unlimited_placeholder": "Unlimited",
  "ai_system_prompts_title": "System Prompts",
  "ai_system_prompts_description": "Configure AI system prompts for assistant behavior",
  "ai_assistant_prompt_label": "Assistant",
  "ai_assistant_prompt_description": "System prompt for regular assistant interactions",
  "ai_assistant_prompt_placeholder": "You are SYSTEM. Use the provided tools to inspect calendars, events, and send location pins. Reply in the language of the user's message; use Arabic only when that language is unclear.",
  "ai_system_agent_prompt_label": "System Agent Prompt",
  "ai_system_agent_prompt_description": "System prompt for system agent with batch operations",
  "ai_system_agent_prompt_placeholder": "You are an internal system agent with powerful batch operations. Use the provided tools to manage multiple events, query data, and perform bulk operations efficiently.",
  "prompt_versions_label": "Version history",
  "prompt_versions_current": "Current",
  "prompt_versions_load_into_editor": "Load into editor",
  "prompt_versions_revert": "Revert to this version",
  "prompt_versions_empty": "No saved versions yet",
  "prompt_versions_revert_success": "Prompt version restored",
  "system_defaults_prompt_label": "System Prompt",
  "system_defaults_prompt_description": "Instructions the AI follows when replying to customers via WhatsApp, Telegram, or Instagram.",
  "system_defaults_agent_prompt_description": "Instructions for the internal system agent handling batch and admin tasks.",
  "system_prompt_editor_placeholder": "Enter system prompt…",
  "system_prompt_toolbar_align_center": "Align center",
  "system_prompt_toolbar_align_left": "Align left",
  "system_prompt_toolbar_align_right": "Align right",
  "system_prompt_toolbar_aria": "Text formatting toolbar",
  "system_prompt_toolbar_blockquote": "Block quote",
  "system_prompt_toolbar_bold": "Bold",
  "system_prompt_toolbar_bullet_list": "Bulleted list",
  "system_prompt_toolbar_code_block": "Code block",
  "system_prompt_toolbar_heading": "Heading style",
  "system_prompt_toolbar_inline_code": "Inline code",
  "system_prompt_toolbar_italic": "Italic",
  "system_prompt_toolbar_ordered_list": "Numbered list",
  "system_prompt_toolbar_redo": "Redo",
  "system_prompt_toolbar_scroll_left": "Scroll toolbar left",
  "system_prompt_toolbar_scroll_right": "Scroll toolbar right",
  "system_prompt_toolbar_strike": "Strikethrough",
  "system_prompt_toolbar_task_list": "Task list",
  "system_prompt_toolbar_underline": "Underline",
  "system_prompt_toolbar_undo": "Undo",
  "event_notes_button_label": "Notes",
  "event_notes_button_unsaved": "Save the event first to add notes",
  "event_notes_dialog_title": "Event notes",
  "event_notes_dialog_description": "Free-form notes, structured fields, and a sketch canvas stored with this event.",
  "event_notes_tab_text": "Notes",
  "event_notes_tab_fields": "Fields",
  "event_notes_tab_canvas": "Canvas",
  "event_notes_text_placeholder": "Write notes about this event…",
  "event_notes_fields_empty": "No fields yet. Add key–value pairs to structure your notes.",
  "event_notes_field_key_placeholder": "Key",
  "event_notes_field_value_placeholder": "Value",
  "event_notes_add_field": "Add field",
  "event_notes_additional_fields": "Additional fields",
  "event_notes_remove_field": "Remove field",
  "column_select_placeholder": "Select…",
  "event_notes_cancel": "Cancel",
  "event_notes_save": "Save notes",
  "event_notes_saved": "Notes saved",
  "event_notes_save_failed": "Failed to save notes",
  "event_notes_load_failed": "Failed to load notes",
  "system_prompt_export_docx_failed": "Failed to export prompt as DOCX",
  "system_prompt_import_failed": "Failed to import file",
  "system_prompt_drop_failed": "Failed to load dropped file",
  "system_prompt_stats_words": "{{count}} words",
  "system_prompt_stats_tokens": "~{{count}} tokens",
  "system_prompt_stats_tokens_tooltip": "Approximate token count. Claude's exact tokenizer isn't public, so this is an estimate — dense scripts like Arabic use more tokens per character.",
  "reasoning_effort_label": "Reasoning effort",
  "reasoning_effort_tip": "Controls how much the AI thinks before responding. Higher = better quality but slower and more expensive.",
  "verbosity_label": "Verbosity",
  "verbosity_tip": "Controls how detailed and long the AI's responses are.",
  "max_output_tokens_label": "Max output tokens",
  "max_output_tokens_tip": "Maximum number of tokens (~words) the AI can generate per response. Leave empty for the model's default. Higher = longer possible replies but more cost.",
  "max_output_tokens_default_placeholder": "Default",
  "model_filter_active": "Active filters",
  "model_selector_search_placeholder": "Search models",
  "location_picker_trigger_label": "Pick Location",
  "location_picker_aria_trigger": "Pick location on map",
  "location_picker_title": "Pick Location",
  "location_picker_description": "Search, click on the map, or drag the marker to select a location.",
  "location_picker_close_dialog": "Close dialog",
  "location_picker_search_aria": "Search for a location",
  "location_picker_search_placeholder": "Search for a city, address, or place",
  "location_picker_searching": "Searching…",
  "location_picker_map_load_error": "Failed to load map component",
  "location_picker_try_refresh": "Please try refreshing the page",
  "rag_documents_title": "Knowledge Base Documents",
  "rag_documents_description": "Upload documents for the AI to search and reference.",
  "rag_failure_processing": "Processing failed. Retry, or contact support if it keeps failing.",
  "rag_failure_corrupt_file": "The file could not be read and may be corrupted. Export it again and re-upload.",
  "rag_failure_unsupported_format": "This file type can't be processed.",
  "rag_failure_empty_text": "No readable text was found in this file. If it's a scan, upload a clearer copy.",
  "rag_failure_duplicate": "This file's content is already in your knowledge base.",
  "rag_upload_dropzone_aria": "Document upload dropzone",
  "rag_delete_document_title": "Delete Document",
  "rag_delete_document_description": "Are you sure you want to delete \"{{filename}}\"? This will remove all indexed chunks and cannot be undone.",
  "rag_loading_documents": "Loading documents…",
  "rag_settings_title": "Search Settings",
  "rag_settings_description": "Configure embedding model and search threshold for document search",
  "rag_search_threshold_label": "Search Threshold",
  "rag_search_threshold_tip": "Minimum similarity score a document must reach to be returned. Lower = more results but less precise, higher = fewer but more relevant results.",
  "rag_threshold_more_results": "More results",
  "rag_threshold_stricter_matching": "Stricter matching",
  "rag_embedding_model_label": "Embedding Model",
  "rag_embedding_model_description": "Changing the model requires re-embedding all documents",
  "rag_embedding_model_multilingual_hint": "The default model, bge-m3, is multilingual and handles both Arabic and English well.",
  "rag_embedding_model_search_placeholder": "Search embedding models…",
  "rag_embedding_model_none_available": "No embedding models available",
  "rag_embedding_model_no_matches": "No models match your search",
  "rag_option_recommended": "Recommended",
  "rag_option_coming_soon": "Coming soon",
  "rag_embedding_strategy_label": "Embedding Strategy",
  "rag_embedding_strategy_tip": "Controls how document chunks are embedded. Contextual embedding prepends LLM-generated context to each chunk for better retrieval accuracy.",
  "rag_embedding_strategy_standard_label": "Standard",
  "rag_embedding_strategy_standard_description": "Direct embedding. Fast and cheap.",
  "rag_embedding_strategy_contextual_label": "Contextual",
  "rag_embedding_strategy_contextual_description": "Improves retrieval by adding LLM-generated context to each chunk before embedding (Anthropic contextual retrieval). More accurate but slower and costlier during ingestion.",
  "rag_embedding_strategy_late_label": "Late chunking",
  "rag_embedding_strategy_late_description": "Embeds the whole window first, then mean-pools each chunk (Jina late chunking). Strong on long or unstructured documents, with no LLM cost. Requires a configured Jina API key.",
  "rag_strategy_dialog_title": "Processing strategy",
  "rag_strategy_dialog_description": "Choose how {{filename}} is embedded. Switching re-embeds the existing chunks — the document is never re-parsed. Figures are estimated previews, not final charges; actual usage lands in your AI usage metrics.",
  "rag_strategy_current_badge": "Current",
  "rag_strategy_apply": "Apply strategy",
  "rag_strategy_late_unavailable": "Requires a configured Jina API key.",
  "rag_strategy_estimated_caption": "estimated",
  "rag_strategy_estimated_range_caption": "estimated range",
  "rag_strategy_chunks_caption": "{{count}} chunks",
  "rag_strategy_time_seconds": "~{{value}} sec",
  "rag_strategy_time_minutes": "~{{value}} min",
  "rag_strategy_estimate_loading": "Estimating cost…",
  "rag_strategy_estimate_error": "Couldn't estimate the processing cost. Try again.",
  "rag_strategy_processing_note": "This document is processing — wait until it finishes to switch its strategy.",
  "rag_strategy_preview_note": "Estimates are previews, not final charges. Actual usage appears in your AI usage metrics.",
  "rag_upload_estimate_title": "Estimated processing cost",
  "rag_upload_estimate_description": "Approximate cost to embed {{count}} selected file(s) before uploading.",
  "rag_upload_estimate_note": "Your organization's default strategy is applied on upload. You can switch a document's strategy afterward from its Processing strategy dialog.",
  "rag_upload_estimate_confirm": "Upload",
  "rag_reranking_label": "Reranking",
  "rag_reranking_tip": "When enabled, a cross-encoder re-scores search results for higher relevance at the cost of additional latency.",
  "rag_saved_queries_enabled_label": "Ready-made queries",
  "rag_saved_queries_enabled_description": "Let the assistant answer number questions about your spreadsheets using saved, pre-approved queries you manage per document.",
  "rag_saved_queries_only_label": "Only allow ready-made queries",
  "rag_saved_queries_only_description": "Turn off free-form data queries so the assistant can only run the ready-made queries you approved.",
  "rag_saved_queries_dialog_title": "Ready-made queries",
  "rag_saved_queries_dialog_description": "Saved queries the assistant can run for {filename}.",
  "rag_saved_queries_empty": "No ready-made queries yet.",
  "rag_saved_queries_generate_placeholder": "Describe a question in plain language, e.g. total orders by country",
  "rag_saved_queries_generate_button": "Generate query",
  "rag_saved_queries_generating": "Generating…",
  "rag_saved_queries_generate_failed": "Could not generate a query. Try rephrasing.",
  "rag_saved_queries_dry_run_ok": "Test run passed",
  "rag_saved_queries_dry_run_failed": "Test run failed",
  "rag_saved_queries_save_button": "Save query",
  "rag_saved_queries_saved": "Ready-made query saved",
  "rag_saved_queries_save_failed": "Could not save the query.",
  "rag_saved_queries_deleted": "Query removed",
  "rag_saved_queries_delete_aria": "Delete saved query",
  "rag_saved_queries_error": "Something went wrong",
  "rag_reranking_off_label": "Off",
  "rag_reranking_off_description": "Results ranked by hybrid search score only.",
  "rag_reranking_on_label": "On",
  "rag_reranking_on_description": "Cross-encoder re-ranks results for higher relevance. Adds ~200ms latency per search.",
  "rag_reranking_automatic_label": "Automatic",
  "rag_reranking_automatic_description": "The system decides per query whether to rerank, balancing relevance and latency.",
  "rag_change_embedding_model_title": "Change Embedding Model",
  "rag_change_embedding_model_confirm": "Confirm Change",
  "rag_change_embedding_model_description_intro": "Changing the embedding model requires re-processing all documents. When you save settings, this will:",
  "rag_change_embedding_model_bullet_reembed": "Re-embed all documents with the new model",
  "rag_change_embedding_model_bullet_progress": "Progress will be shown in real-time",
  "rag_change_embedding_model_search_available": "Search stays available during re-embedding.",
  "rag_model_switch_estimate_documents": "Documents",
  "rag_model_switch_estimate_chunks": "Chunks",
  "rag_model_switch_estimate_qa": "Q&A pairs",
  "rag_model_switch_estimate_cost": "Estimated cost",
  "rag_model_switch_estimate_duration": "Estimated time",
  "rag_model_switch_estimate_loading": "Estimating cost…",
  "rag_model_switch_estimate_failed": "This model cannot be used with the current knowledge-base storage. Choose another embedding model.",
  "rag_model_switch_estimate_disclaimer": "Estimated embedding cost — actual usage may vary.",
  "rag_model_switch_progress_title": "Re-embedding knowledge",
  "rag_model_switch_progress_count": "{{done}} of {{total}}",
  "rag_model_switch_progress_hint": "Search stays available while documents are re-embedded.",
  "rag_demo_search_placeholder": "Test search query…",
  "whatsapp_config_title": "Customer-channel tool permissions",
  "whatsapp_config_description": "Control which tools the AI can use across WhatsApp, Telegram, and Instagram",
  "whatsapp_test_button": "Test WhatsApp API Configuration",
  "whatsapp_testing": "Testing…",
  "whatsapp_test_passed": "WhatsApp API configuration test passed",
  "whatsapp_test_failed": "WhatsApp API configuration test failed",
  "whatsapp_test_error": "Failed to test WhatsApp configuration",
  "whatsapp_unexpected_error": "An unexpected error occurred",
  "whatsapp_result_passed": "Configuration Test Passed",
  "whatsapp_result_failed": "Configuration Test Failed",
  "config_nav_channels": "Channels",
  "cfgpage_section_channels_description": "Test connectivity for the messaging channels your assistant replies on.",
  "channels_card_description": "Safely verify the stored {{channel}} credentials with the provider. Secret values are never displayed.",
  "channels_test_button": "Test connection",
  "channels_testing": "Testing…",
  "channels_result_passed": "Connection Test Passed",
  "channels_result_failed": "Connection Test Failed",
  "channels_test_error": "Failed to test the connection",
  "channels_not_configured": "{{channel}} secrets are not fully configured.",
  "channels_not_configured_fields": "{{channel}} secrets are not fully configured. Missing: {{fields}}.",
  "notification_rule_untitled": "Untitled Rule",
  "notification_rule_delete": "Delete notification rule",
  "notification_select_template": "Select a template…",
  "notification_select_variable": "Select variable…",
  "notification_no_variables": "No variables found",
  "notification_map_variables_reminder": "Map all variables to save",
  "notification_variable_mapping_label": "Variable Mapping",
  "event_type_filter_search": "Search event types…",
  "event_type_filter_empty": "No event types found",
  "numeric_range_min_label": "Min",
  "numeric_range_max_label": "Max",
  "numeric_range_step_label": "Step",
  "numeric_range_step_tip": "Increment between values in the wheel picker (e.g., step=5 gives 0, 5, 10…).",
  "numeric_range_invalid_short": "Invalid",
  "numeric_range_invalid_suffix": "(invalid)",
  "column_data_type_text": "Text",
  "column_data_type_name": "Name",
  "column_data_type_number": "Number",
  "column_data_type_datetime": "Date & Time",
  "column_data_type_phone": "Phone",
  "column_data_type_dropdown": "Dropdown",
  "column_data_type_boolean": "Boolean",
  "column_data_type_date": "Date",
  "column_data_type_time": "Time",
  "column_editor_mode_input_label": "Keyboard Input",
  "column_editor_mode_input_description": "Standard keyboard input for typing values",
  "column_editor_mode_wheel_label": "Wheel Picker",
  "column_editor_mode_wheel_description": "Scroll wheel for selecting from options or numeric range",
  "column_editor_mode_dropdown_label": "Dropdown",
  "column_editor_mode_dropdown_description": "Dropdown menu for selecting from options",
  "column_database_field_user_name": "User Name",
  "column_database_field_user_phone": "User Phone",
  "column_database_field_user_email": "User Email",
  "column_database_field_user_role": "User Role",
  "column_database_field_profile_name": "Profile Name",
  "column_database_field_profile_age": "Profile Age",
  "column_database_field_preferred_language": "Preferred Language",
  "column_database_field_is_favorite": "Is Favorite",
  "column_database_field_event_datetime": "Event DateTime",
  "column_database_field_event_end": "Event End",
  "column_database_field_event_type": "Event Type",
  "column_database_field_event_status": "Event Status",
  "column_database_field_custom": "Custom (Metadata)",
  "column_database_group_user": "User",
  "column_database_group_profile": "Profile",
  "column_database_group_event": "Event",
  "column_database_group_other": "Other",
  "column_identifier_placeholder": "e.g., field_time_scheduled",
  "column_identifier_label": "Column Identifier *",
  "column_identifier_tip": "Unique key for this column, used as the i18n translation key. Spaces and dots are stripped.",
  "column_data_type_label": "Data Type *",
  "column_data_type_tip": "Determines how cell values are stored and validated (e.g., text, number, phone, date).",
  "column_data_type_placeholder": "Select data type",
  "column_data_type_empty": "No data type found.",
  "column_data_type_search": "Search data types",
  "column_width_label": "Width (px) *",
  "column_width_placeholder": "100",
  "column_width_required": "Width is required",
  "column_editor_mode_label": "Editor Mode",
  "column_editor_mode_tip": "How users edit cell values: keyboard input, scroll wheel picker, or dropdown list.",
  "column_editor_mode_select_fallback": "Select mode…",
  "column_database_field_label": "Database Field *",
  "column_database_field_tip": "The backend field this column reads from and writes to.",
  "column_database_field_placeholder": "Select database field",
  "column_database_field_empty": "No database field found.",
  "column_database_field_search": "Search database fields",
  "column_database_field_auto": "Auto",
  "column_database_field_missing": "Required - select a database field",
  "column_database_field_mismatch": "Field type mismatch - consider changing data type",
  "column_numeric_range_description": "Set the range for the numeric wheel picker",
  "column_section_configuration": "Configuration",
  "column_section_data_source": "Data Source",
  "column_section_numeric_range": "Numeric Range",
  "column_section_dropdown_options": "Dropdown Options",
  "column_section_name_parts": "Name Requirements",
  "column_name_parts_label": "Required name parts",
  "column_name_parts_tip": "Choose whether names must include first and last names, or first, middle, and last names.",
  "column_name_parts_two": "First + last",
  "column_name_parts_three": "First + middle + last",
  "column_name_parts_description": "Controls the minimum number of name parts accepted by this column.",
  "column_dropdown_options_empty": "No options yet — add one to enable selection.",
  "column_dropdown_options_placeholder": "Option value (e.g., appt_checkup)",
  "column_dropdown_options_add": "Add option",
  "column_dropdown_options_remove": "Remove option",
  "column_dropdown_options_drag": "Drag to reorder option",
  "column_dropdown_options_event_type_hint": "Auto-filled from your Event Types — edit them in the Schedule section.",
  "column_dropdown_options_event_type_empty": "No event types defined yet.",
  "column_missing_fields_prefix": "Missing:",
  "column_empty_state": "No columns configured yet.",
  "column_add_button": "Add Column",
  "column_derived_title": "From event types",
  "column_derived_description": "The grid also shows one column per event-type custom field. Edit them in Event Types → Custom Fields.",
  "column_derived_manage": "Event types",
  "column_documents_max_reached": "Documents form is limited to 4 fields.",
  "column_toggle_editable": "Editable",
  "column_toggle_required": "Required",
  "column_required_field": "Required",
  "column_delete_button": "Delete column",
  "column_drag_to_reorder_format": "Drag to reorder column {{n}}",
  "column_label_format": "Column {{n}}: {{title}}",
  "column_fallback_name": "Column {{n}}",
  "config_timezone_label": "Timezone",
  "config_timezone_description": "Determines calendar slots, timestamps, and AI responses.",
  "config_timezone_tip_extended": "Affects calendar slot times, document timestamps, and how the AI reports dates/times.",
  "config_default_country_label": "Default Country",
  "config_default_country_prefix_tip": "Pre-selects the country flag and dial code in all phone number fields.",
  "config_regional_settings_title": "Regional Settings",
  "config_regional_settings_description": "Configure timezone and default country for your business",
  "config_system_defaults_title": "System Defaults",
  "config_system_defaults_description": "Configure timezone, country prefix, and AI model preferences",
  "model_filter_badge_author": "Author",
  "model_filter_badge_variant": "Variant",
  "model_filter_badge_provider": "Provider",
  "model_filter_badge_param": "Param",
  "rag_status_pending": "Pending",
  "rag_status_processing": "Processing",
  "rag_status_completed": "Completed",
  "rag_status_failed": "Failed",
  "rag_doc_toggle_disable": "Disable document",
  "rag_doc_toggle_enable": "Enable document",
  "rag_doc_disabled_badge": "Disabled",
  "rag_sensitive_badge": "Sensitive",
  "rag_sensitive_badge_tooltip": "Contains sensitive data: {{types}}",
  "rag_sensitive_type_card": "Card numbers",
  "rag_sensitive_type_iban": "IBANs",
  "rag_sensitive_type_national_id": "National IDs",
  "rag_embedding_model_select_placeholder": "Select model…",
  "rag_embedding_model_count": "models",
  "location_picker_tile_street": "Street",
  "location_picker_tile_satellite": "Satellite",
  "location_picker_tile_terrain": "Terrain",
  "location_picker_tile_dark": "Dark",
  "location_picker_change_map_style": "Change map style",
  "location_picker_find_my_location": "Find my location",
  "location_picker_tile_roadmap": "Map",
  "location_picker_tile_hybrid": "Hybrid",
  "location_picker_maps_not_configured": "Map is unavailable",
  "location_picker_maps_not_configured_hint": "Enter coordinates manually, or paste a Google Maps link.",
  "location_picker_geolocation_unsupported": "Geolocation isn't supported by your browser.",
  "location_picker_geolocation_denied": "Couldn't get your location. Please enable location access and try again.",
  "config_reset_defaults_button": "Reset to Defaults",
  "config_reset_defaults_title": "Reset to Defaults",
  "config_reset_defaults_description_prefix": "This will reset all fields to their default values. You can review the changes and click",
  "config_reset_defaults_save_label": "Save",
  "config_reset_defaults_description_middle": " to apply them, or ",
  "config_reset_defaults_discard_label": "Discard",
  "config_reset_defaults_description_suffix": " to cancel.",
  "notif_reply": "Reply",
  "notif_dismiss": "Dismiss",
  "notification_view_event": "View event",
  "notification_view_vacation": "View vacation",
  "notif_panel_title": "Notifications",
  "notif_mark_all_read": "Mark all read",
  "notif_filter_all": "All",
  "notif_filter_unread": "Unread",
  "notif_filter_by_type": "Filter by type",
  "notif_type_all": "All types",
  "notif_type_messages": "Messages",
  "notif_type_events": "Events",
  "notif_section_today": "Today",
  "notif_section_earlier": "Earlier",
  "notif_see_all_activity": "See all activity →",
  "notif_empty_state": "You're all caught up.",
  "notif_loading_more": "Loading more…",
  "notif_end_of_list": "You've reached the end",
  "tours_skip": "Skip",
  "tours_back": "Back",
  "tours_next": "Next",
  "tours_get_started": "Get started",
  "tours_step_aria_label": "Step {n}",
  "tours_calendar_welcome_badge": "Welcome",
  "tours_calendar_welcome_title": "A calendar that gets out of your way.",
  "tours_calendar_welcome_body": "Your bookings, conversations, and AI agent — all in one quiet place. Take a quick tour to see what lives where.",
  "tours_calendar_chat_badge": "Step 1",
  "tours_calendar_chat_title": "Chat with every customer in one inbox.",
  "tours_calendar_chat_body": "The chat sidebar threads every WhatsApp, Telegram, Instagram, and webchat conversation alongside the calendar. Reply without ever leaving the page.",
  "tours_calendar_calendar_badge": "Step 2",
  "tours_calendar_calendar_title": "A calendar that bends to how you work.",
  "tours_calendar_calendar_body": "Drag, drop, and resize events. Switch between day, week, and month views — your changes save instantly.",
  "tours_calendar_agent_badge": "Step 3",
  "tours_calendar_agent_title": "Let the system agent handle the busywork.",
  "tours_calendar_agent_body": "Ask in plain language and the AI books, reschedules, and answers customers for you — with full traceability of what it did.",
  "tours_calendar_grid_badge": "Step 4",
  "tours_calendar_grid_title": "A spreadsheet view when you need to bulk-edit.",
  "tours_calendar_grid_body": "Pop into the data grid for a fast, keyboard-driven view of every customer and event. Edits sync back to the calendar in real time.",
  "tours_documents_welcome_badge": "Welcome",
  "tours_documents_welcome_title": "Everything you need to learn Bavard, in one place.",
  "tours_documents_welcome_body": "Guides, references, and live demos — built so you can ship faster. Here is a tour of what is around.",
  "tours_documents_browse_badge": "Step 1",
  "tours_documents_browse_title": "Browse by topic, jump anywhere.",
  "tours_documents_browse_body": "The sidebar groups every guide by area. Click into a section to expand it — the highlighted item is always where you are now.",
  "tours_documents_search_badge": "Step 2",
  "tours_documents_search_title": "Find anything in a couple of keystrokes.",
  "tours_documents_search_body": "Press the search box up top to fuzzy-match across every page. Results open inline so you keep your place.",
  "tours_documents_grid_badge": "Step 3",
  "tours_documents_grid_title": "Live demos you can actually click.",
  "tours_documents_grid_body": "Many pages embed real, interactive demos — including the data grid — so you can poke at features before wiring them in.",
  "tours_documents_pages_badge": "Step 4",
  "tours_documents_pages_title": "Every guide, in your language.",
  "tours_documents_pages_body": "Switch between languages from the toggle in the top bar. We translate the guides so you can learn in the language you think in.",
  "tours_dashboard_welcome_badge": "Welcome",
  "tours_dashboard_welcome_title": "Your numbers, finally in one view.",
  "tours_dashboard_welcome_body": "KPIs, trends, and conversation insights for your whole org. Take a quick tour of where each lives.",
  "tours_dashboard_overview_badge": "Step 1",
  "tours_dashboard_overview_title": "The KPIs that matter, at a glance.",
  "tours_dashboard_overview_body": "The overview tab shows your top metrics — bookings, response times, and active customers — in cards you can scan in seconds.",
  "tours_dashboard_trends_badge": "Step 2",
  "tours_dashboard_trends_title": "See the shape of your week.",
  "tours_dashboard_trends_body": "The trends tab plots your activity over time so you can catch growth, dips, and patterns before they become surprises.",
  "tours_dashboard_messages_badge": "Step 3",
  "tours_dashboard_messages_title": "Understand every conversation.",
  "tours_dashboard_messages_body": "The messages tab breaks down volume, length, and the words your customers use most — across every channel.",
  "tours_dashboard_insights_badge": "Step 4",
  "tours_dashboard_insights_title": "Turn data into decisions.",
  "tours_dashboard_insights_body": "Insights and feedback summaries surface what is working, what is not, and what to try next — all backed by your real data.",
  "uploads_cancel": "Cancel upload",
  "uploads_uploading": "Uploading…",
  "uploads_failed": "Upload failed",
  "uploads_retry": "Retry upload",
  "uploads_retry_all": "Retry all",
  "user_menu_dashboard": "Dashboard",
  "user_menu_account_settings": "Account settings",
  "user_menu_billing": "Billing",
  "user_menu_app_configuration": "App configuration",
  "user_menu_admin_dashboard": "Admin dashboard",
  "user_menu_playground": "Playground",
  "user_menu_sign_out": "Sign out",
  "user_menu_org_overview": "Overview",
  "user_menu_section_account": "Account",
  "user_menu_section_organization": "Organization",
  "user_menu_section_administration": "Administration",
  "user_menu_section_support": "Support",
  "admin_tabs_members": "Members",
  "account_page_title": "Account settings",
  "account_page_description": "Manage your credentials, sessions, and personal preferences.",
  "account_nav_group_security": "Security",
  "account_nav_group_personal": "Personal",
  "account_nav_credentials_sessions": "Credentials & sessions",
  "account_nav_profile": "Profile",
  "account_nav_notifications": "Notifications",
  "account_nav_appearance": "Appearance",
  "account_appearance_title": "Appearance",
  "account_appearance_description": "Customize the look and feel — theme color, light or dark mode, and component style. Changes apply instantly and follow you across devices.",
  "account_demo_locked_hint": "Preview only in the demo — this needs a real account. Sign up to change your password, add a passkey, link a provider, or delete your account.",
  "account_credentials_sessions_title": "Credentials & sessions",
  "account_credentials_sessions_description": "Review how you sign in and which devices have access to your account.",
  "account_sessions_title": "Active sessions",
  "account_sessions_subtitle_loading": "Loading active devices…",
  "account_sessions_subtitle": "{{count}} devices · 1 active now",
  "account_sessions_sign_out_others": "Sign out everywhere",
  "account_sessions_load_error": "We couldn't load your sessions.",
  "account_sessions_retry": "Retry",
  "account_sessions_confirm_others_title": "Sign out from other devices?",
  "account_sessions_confirm_others_body": "This will end your session on {{count}} other devices. You'll stay signed in here.",
  "account_sessions_confirm_cancel": "Cancel",
  "account_sessions_confirm_others_button": "Sign out everywhere",
  "account_session_this_device": "This device",
  "account_session_sign_out": "Sign out",
  "account_session_signing_out": "Signing out…",
  "account_session_current_action_label": "Current device — no action",
  "account_session_ip_unknown": "IP unknown",
  "account_session_revoke_success": "Session signed out.",
  "account_session_revoke_failed": "Could not sign out that session.",
  "account_session_revoke_others_success": "All other devices signed out.",
  "account_session_revoke_others_failed": "Could not sign out other sessions.",
  "account_passkeys_title": "Passkeys & security keys",
  "account_passkeys_subtitle": "Skip the password — sign in with your device or hardware key.",
  "account_passkeys_add": "Add a passkey",
  "account_passkeys_adding": "Adding…",
  "account_passkeys_empty_title": "No passkeys yet",
  "account_passkeys_empty_body": "Add one to skip the password — sign in instantly with Touch ID, Windows Hello, or a security key.",
  "account_passkeys_loading": "Loading passkeys…",
  "account_passkeys_error": "Couldn't load passkeys.",
  "account_passkeys_retry": "Retry",
  "account_passkeys_remove": "Remove",
  "account_passkeys_default_name": "Passkey",
  "account_passkeys_added_at": "Added {{date}}",
  "account_passkeys_add_success": "Passkey added.",
  "account_passkeys_add_failed": "Could not add passkey.",
  "account_passkeys_remove_success": "Passkey removed.",
  "account_passkeys_remove_failed": "Could not remove passkey.",
  "account_passkeys_remove_confirm_title": "Remove this passkey?",
  "account_passkeys_remove_confirm_body": "You'll no longer be able to sign in with this device or security key. You can add it again any time.",
  "account_passkeys_remove_confirm_cancel": "Cancel",
  "account_passkeys_remove_confirm_action": "Remove passkey",
  "account_connected_title": "Connected accounts",
  "account_connected_subtitle": "Link an external account to sign in without a password.",
  "account_connected_connect": "Connect",
  "account_connected_connecting": "Connecting…",
  "account_connected_connect_failed": "Could not start the connection.",
  "account_connected_disconnect": "Disconnect",
  "account_connected_status_loading": "Checking…",
  "account_connected_status_connected": "Connected",
  "account_connected_status_not_connected": "Not connected",
  "account_connected_error": "Couldn't load connected accounts.",
  "account_connected_retry": "Retry",
  "account_connected_disconnect_success": "{{provider}} disconnected.",
  "account_connected_disconnect_failed": "Could not disconnect {{provider}}.",
  "account_connected_disconnect_confirm_title": "Disconnect {{provider}}?",
  "account_connected_disconnect_confirm_body": "You'll no longer be able to sign in with {{provider}}. Make sure you still have your password or another sign-in method.",
  "account_connected_disconnect_confirm_cancel": "Cancel",
  "account_connected_disconnect_confirm_action": "Disconnect",
  "account_profile_tab_title": "Profile",
  "account_profile_tab_description": "Update your display name, email address, and password. Changes here update your account everywhere.",
  "account_profile_save": "Save",
  "account_profile_identity_title": "Identity",
  "account_profile_details_title": "Profile details",
  "account_profile_details_description": "Your name, avatar, and email address.",
  "account_profile_details_avatar_label": "Profile photo",
  "account_profile_identity_description": "How your name and avatar appear across the app.",
  "account_profile_identity_avatar_hint": "Click the avatar or drag an image onto it. We'll resize it to a square 256×256 thumbnail automatically.",
  "account_profile_identity_avatar_change": "Change avatar",
  "account_profile_identity_avatar_upload": "Upload image",
  "account_profile_identity_avatar_replace": "Replace image",
  "account_profile_identity_avatar_remove": "Remove",
  "account_profile_identity_avatar_unsupported": "That file isn't a supported image format.",
  "account_profile_identity_avatar_too_large": "Image is larger than 5 MB. Try a smaller file.",
  "account_profile_identity_avatar_decode_failed": "Could not read that image. Try a different file.",
  "account_profile_identity_name_label": "Display name",
  "account_profile_identity_name_placeholder": "Your name",
  "account_profile_identity_name_too_short": "Name must be at least 2 characters.",
  "account_profile_identity_name_too_long": "Name must be 50 characters or fewer.",
  "account_profile_identity_image_label": "Avatar",
  "account_profile_identity_image_placeholder": "https://example.com/avatar.png",
  "account_profile_identity_image_invalid": "That avatar isn't a valid image.",
  "account_profile_identity_save_success": "Profile updated.",
  "account_profile_identity_save_failed": "Could not update profile.",
  "account_profile_email_title": "Email address",
  "account_profile_email_description": "We use this address for sign-in, account recovery, and notifications.",
  "account_profile_email_label": "Email",
  "account_profile_email_placeholder": "you@example.com",
  "account_profile_email_required": "Email is required.",
  "account_profile_email_invalid": "Enter a valid email address.",
  "account_profile_email_verified_note": "Your current email is verified. Confirming the change requires a verification link sent to your new address.",
  "account_profile_email_save_success": "Email updated.",
  "account_profile_email_save_failed": "Could not change email.",
  "account_profile_email_verification_sent": "Verification email sent. Click the link to confirm the change.",
  "account_profile_password_title": "Password",
  "account_profile_password_description": "Use a strong password you don't reuse anywhere else.",
  "account_profile_password_current_label": "Current password",
  "account_profile_password_current_hint": "Verify your identity before making changes.",
  "account_profile_password_current_required": "Enter your current password.",
  "account_profile_password_current_invalid": "Current password is incorrect.",
  "account_profile_password_new_label": "New password",
  "account_profile_password_new_hint": "Use at least 8 characters and avoid reusing an old password.",
  "account_profile_password_too_short": "Password must be at least 8 characters.",
  "account_profile_password_confirm_label": "Confirm new password",
  "account_profile_password_confirm_required": "Confirm your new password.",
  "account_profile_password_mismatch": "Passwords do not match.",
  "account_profile_password_save_button": "Update password",
  "account_profile_password_save_success": "Password changed.",
  "account_profile_password_save_failed": "Could not change password.",
  "dashboard_heatmap_eyebrow": "Activity · weekly message volume",
  "dashboard_heatmap_axis_day": "Day",
  "dashboard_heatmap_axis_total": "Total",
  "dashboard_heatmap_table_label": "Message volume by day of week and hour of day",
  "dashboard_heatmap_avg_label": "Avg / hour",
  "dashboard_funnel_eyebrow": "AI booking funnel · current period",
  "dashboard_funnel_eyebrow_prefix": "AI booking funnel",
  "dashboard_funnel_heading": "Assistant conversation-to-booking journey",
  "dashboard_funnel_overall_desc": "{pct}% of inbound conversations returned for another AI-created booking. Manual bookings are excluded.",
  "dashboard_funnel_baseline": "baseline",
  "dashboard_funnel_carry": "{pct}% carry",
  "dashboard_funnel_kind_first_action": "First action",
  "dashboard_funnel_kind_conversion": "Conversion",
  "dashboard_funnel_kind_repeat": "Repeat",
  "dashboard_funnel_kind_exit": "Exit",
  "dashboard_funnel_kind_step": "Step",
  "dashboard_funnel_stat_activation": "Activation",
  "dashboard_funnel_stat_retention": "Retention",
  "dashboard_funnel_stat_overall": "Overall",
  "dashboard_funnel_stat_exit": "AI cancellation rate",
  "dashboard_funnel_stat_good": "good",
  "dashboard_funnel_stat_watch": "watch",
  "dashboard_funnel_stat_low": "low",
  "export_dialog_default_eyebrow": "Export",
  "export_dialog_close": "Close",
  "export_dialog_cancel": "Cancel",
  "export_dialog_export": "Export",
  "export_dialog_format_label": "Format",
  "export_dialog_date_range_label": "Date range",
  "export_dialog_include_label": "Include",
  "export_dialog_include_pii_label": "Include contact & location data",
  "export_dialog_include_pii_warning": "This export will contain phone numbers, business address, and map coordinates — store and share the file carefully.",
  "export_dialog_estimated_size": "Est. size",
  "export_dialog_subtitle_immediate": "Download starts immediately.",
  "export_dialog_subtitle_emailed": "We'll email you the download link.",
  "export_dialog_format_csv": "CSV",
  "export_dialog_format_csv_meta": "Spreadsheet · per-row data",
  "export_dialog_format_json": "JSON",
  "export_dialog_format_json_meta": "Raw, with metadata",
  "export_dialog_format_pdf": "PDF",
  "export_dialog_format_pdf_meta": "Print-ready report",
  "export_dialog_format_docx": "DOCX",
  "export_dialog_format_docx_meta": "Editable document",
  "export_dialog_format_html": "HTML",
  "export_dialog_format_html_meta": "Interactive · collapsible sections",
  "export_dialog_disabled_csv_nested": "Config is deeply nested — flatten doesn't fit.",
  "export_dialog_disabled_csv_text": "Single block of text — no rows to export.",
  "export_dialog_chat_title_prefix": "Conversation with",
  "export_dialog_chat_include_meta": "Include contact metadata",
  "export_dialog_chat_include_system": "Include system messages",
  "export_dialog_config_title": "Workspace config",
  "export_dialog_prompt_title_prefix": "AI prompt ·",
  "export_dialog_toast_success": "Export ready.",
  "export_dialog_toast_failed": "Export failed.",
  "export_dialog_toast_no_data": "Nothing to export yet.",
  "export_dialog_dashboard_title": "Dashboard analytics",
  "export_dialog_dashboard_include_stats": "Summary metrics",
  "export_dialog_dashboard_include_daily_trends": "Daily trends",
  "export_dialog_dashboard_include_type_distribution": "Event-type distribution",
  "export_dialog_dashboard_include_time_slots": "Time-slot heatmap",
  "export_dialog_dashboard_include_top_users": "Top users (PII)",
  "export_dialog_dashboard_include_conversation": "Conversation analysis",
  "export_dialog_dashboard_include_message_heatmap": "Message heatmap (24×7)",
  "export_dialog_dashboard_include_word_frequency": "Word frequency (PII-adjacent)",
  "export_dialog_dashboard_include_day_of_week": "Activity by day of week",
  "export_dialog_dashboard_include_monthly_trends": "Monthly trends",
  "export_dialog_dashboard_include_funnel": "Conversion funnel",
  "export_dialog_dashboard_include_user_segments": "User segments",
  "export_dialog_dashboard_include_avg_events_per_type": "Avg events per user, by type",
  "export_dialog_dashboard_include_capture_summary": "Lead & feedback counts",
  "export_dialog_dashboard_include_ai_usage": "AI / token usage",
  "export_dialog_dashboard_include_captured_leads": "Captured leads (PII)",
  "export_dialog_dashboard_include_summaries": "AI conversation summaries (PII)",
  "export_dialog_dashboard_include_feedbacks": "Customer feedback (PII)",
  "export_dialog_purge_pii": "Purge PII",
  "export_dialog_pii_excluded": "PII excluded ✓",
  "export_dialog_restore_defaults": "Restore defaults",
  "export_dialog_pdf_meta_exported": "Exported",
  "export_dialog_pdf_meta_range": "Range",
  "export_dialog_pdf_section_overview": "Hero metrics",
  "export_dialog_pdf_kpi_sub": "vs. previous period",
  "export_dialog_pdf_subtitle": "Period",
  "export_dialog_pdf_sparkline_label_events": "Events per day",
  "export_dialog_pdf_conv_total": "Total conversations",
  "export_dialog_pdf_conv_avg_msg": "Avg messages / conversation",
  "export_dialog_pdf_conv_median_msg": "Median messages / conversation",
  "export_dialog_pdf_conv_max_msg": "Max messages in one conversation",
  "export_dialog_pdf_conv_avg_resp_min": "Avg response time",
  "export_dialog_pdf_conv_resolution": "Resolution rate",
  "export_dialog_pdf_callout_response_title": "Response-time signal",
  "export_dialog_pdf_ai_input": "Input tokens",
  "export_dialog_pdf_ai_output": "Output tokens",
  "export_dialog_pdf_ai_total": "Total tokens",
  "export_dialog_pdf_ai_cost": "Spend",
  "export_dialog_pdf_ai_by_model": "By model",
  "export_dialog_pdf_methodology": "Methodology",
  "export_dialog_pdf_methodology_text": "Computed client-side from the active dashboard date range. Trends compare the selected window to the previous window of the same length. PII-bearing sections appear only when the operator opts in.",
  "insights_capture_leads": "Leads collected",
  "stat_total_events": "Total events",
  "stat_upcoming_events": "Upcoming events",
  "stat_cancelled_events": "Cancellations",
  "stat_total_users": "Total users",
  "stat_active_users": "Active users",
  "stat_total_messages": "Total messages",
  "stat_avg_response_time": "Avg response time",
  "stat_conversion_rate": "Conversion rate",
  "export_dialog_grid_title": "Grid data",
  "export_dialog_grid_column_fallback": "Column",
  "export_dialog_grid_channel_contacts_title": "Channel contacts",
  "export_dialog_grid_members_title": "Staff members",
  "export_dialog_grid_organizations_title": "Organizations",
  "export_dialog_summary_title_prefix": "Summary ·",
  "export_dialog_summary_disabled_csv": "Summary is a single document — CSV doesn't fit.",
  "command_palette_title": "Command palette",
  "command_palette_placeholder": "Search commands…",
  "command_palette_empty": "No matching commands.",
  "command_palette_group_navigation": "Navigation",
  "command_palette_group_account": "Account settings",
  "command_palette_group_config": "App configuration",
  "command_palette_group_admin": "Admin dashboard",
  "command_palette_group_billing": "Billing",
  "command_palette_group_dashboard": "Dashboard",
  "command_palette_group_system": "System",
  "command_palette_jump_to_account_section": "Jump to account section",
  "command_palette_jump_to_billing_section": "Jump to billing section",
  "command_palette_jump_to_config_section": "Jump to configuration section",
  "command_palette_open_admin_tab": "Open admin tab",
  "command_palette_open_dashboard_tab": "Open dashboard tab",
  "command_palette_nav_calendar": "Calendar",
  "command_palette_nav_dashboard": "Dashboard",
  "command_palette_nav_documents": "Documents",
  "command_palette_nav_account": "Account settings",
  "command_palette_nav_billing": "Billing",
  "command_palette_nav_config": "App configuration",
  "command_palette_nav_admin": "Admin dashboard",
  "command_palette_billing_subscription": "Subscription",
  "command_palette_billing_usage": "Usage",
  "command_palette_billing_history": "Billing history",
  "command_palette_billing_root": "Open billing",
  "command_palette_system_agent": "System agent",
  "command_palette_system_agent_desc": "Open the system agent in the chat sidebar",
  "command_palette_logout": "Sign out",
  "command_palette_theme_system": "Use system theme",
  "command_palette_theme_light": "Switch to light theme",
  "command_palette_theme_dark": "Switch to dark theme",
  "command_palette_locale_en": "English",
  "command_palette_locale_ar": "العربية",
  "command_palette_switch_language": "Switch language",
  "command_palette_hint_navigate": "to navigate",
  "command_palette_hint_select": "to select",
  "command_palette_hint_close": "to close",
  "feedback_modal_trigger_label": "Send feedback",
  "feedback_modal_title": "Send us feedback",
  "feedback_modal_subtitle": "Tell us what's broken, what's missing, or what's working. Goes straight to the team.",
  "feedback_modal_kind_legend": "What kind of feedback?",
  "feedback_modal_kind_bug": "Bug",
  "feedback_modal_kind_idea": "Idea",
  "feedback_modal_kind_praise": "Praise",
  "feedback_modal_kind_bug_desc": "Something isn't working the way you expect. Tell us the steps so we can reproduce.",
  "feedback_modal_kind_idea_desc": "A feature, an improvement, a workflow that would make your day easier.",
  "feedback_modal_kind_praise_desc": "Something we got right? We'd love to hear it.",
  "feedback_modal_placeholder_bug": "What happened? What did you expect instead? Steps to reproduce help a lot.",
  "feedback_modal_placeholder_idea": "Describe your idea — the problem it solves matters as much as the solution.",
  "feedback_modal_placeholder_praise": "Tell us what you liked. (We read every one of these.)",
  "feedback_modal_body_label": "Feedback details",
  "feedback_modal_attach_screenshot": "Attach a screenshot",
  "feedback_modal_remove_screenshot": "Remove screenshot",
  "feedback_modal_screenshot_too_large": "Screenshot must be under 5 MB.",
  "feedback_modal_include_console_logs": "Include recent console logs",
  "feedback_modal_cancel": "Cancel",
  "feedback_modal_send": "Send feedback",
  "feedback_modal_sending": "Sending…",
  "feedback_modal_success": "Thanks — your feedback was sent.",
  "feedback_modal_error": "Couldn't send feedback. Please try again.",
  "feedback_modal_discard_confirm": "Discard this feedback?",
  "feedback_admin_eyebrow": "Product feedback",
  "feedback_admin_title": "App feedback",
  "feedback_admin_subtitle": "Bug reports, ideas, and praise that your teammates have sent about Bavard itself.",
  "feedback_admin_filter_all": "All",
  "feedback_admin_filter_bug": "Bugs",
  "feedback_admin_filter_idea": "Ideas",
  "feedback_admin_filter_praise": "Praise",
  "feedback_admin_status_filter_all": "All status",
  "feedback_admin_status_new": "New",
  "feedback_admin_status_triaged": "Triaged",
  "feedback_admin_status_resolved": "Resolved",
  "feedback_admin_status_wontfix": "Won't fix",
  "feedback_admin_action_triage": "Mark triaged",
  "feedback_admin_action_resolve": "Mark resolved",
  "feedback_admin_action_dismiss": "Dismiss",
  "feedback_admin_expand": "Expand",
  "feedback_admin_collapse": "Collapse",
  "feedback_admin_show_console_log": "Show console log",
  "feedback_admin_hide_console_log": "Hide console log",
  "feedback_admin_screenshot_alt": "Feedback screenshot",
  "feedback_admin_empty_title": "No feedback yet",
  "feedback_admin_empty_body": "Your teammates haven't sent anything yet. Once they do, it'll show up here.",
  "feedback_admin_empty_filtered_title": "No feedback matches these filters",
  "feedback_admin_empty_filtered_body": "Try another category or status.",
  "dashboard_app_feedback": "App feedback",
  "dashboard_app_feedback_short": "Feedback",
  "dashboard_nav_app_feedback_desc": "Bug reports, ideas, and praise about Bavard from your team.",
  "account_nav_privacy_data": "Privacy & data",
  "account_privacy_tab_title": "Privacy & data",
  "account_privacy_tab_description": "Export your data, control retention windows, or delete your account.",
  "account_privacy_admin_badge": "Admin",
  "account_privacy_export_title": "Export your data",
  "account_privacy_export_description": "Download a single category as a formatted file, or bundle everything into a zip archive.",
  "account_export_instant_title": "Download a category",
  "account_export_instant_desc": "Pick a category and format for an instant, beautifully formatted download.",
  "account_export_action": "Export…",
  "account_export_archive_title": "Full data archive (.zip)",
  "account_export_archive_desc": "Bundle everything — including backups — into a zip; we'll email a download link when it's ready.",
  "account_export_toast_partial": "Exported a partial set — use the full data archive for everything.",
  "account_export_range_label": "Date range",
  "account_export_range_desc": "Counts and exports are scoped to this period.",
  "account_export_range_all_time": "All time",
  "account_export_open_dialog": "Export…",
  "account_export_archive_only": "Archive only",
  "account_export_format_archive": "Full archive (.zip)",
  "account_export_format_archive_meta": "Complete data — we'll email a download link.",
  "account_export_zip_forced_note": "One or more selected categories are too large for an instant download in this range, so the full .zip archive is the only option.",
  "account_privacy_export_include_legend": "Include in archive",
  "account_privacy_export_cat_conversations": "Conversations",
  "account_privacy_export_cat_conversations_desc": "Every chat you can read in this workspace.",
  "account_privacy_export_cat_events": "Events",
  "account_privacy_export_cat_events_desc": "Calendar events and bookings you own.",
  "account_privacy_export_cat_documents": "Documents",
  "account_privacy_export_cat_documents_desc": "Knowledge-base documents uploaded to this workspace (admins only).",
  "account_privacy_export_cat_backups": "Database backups",
  "account_privacy_export_cat_backups_desc": "Snapshots of your workspace database (admins only).",
  "account_privacy_export_cat_notifications": "Notifications",
  "account_privacy_export_cat_notifications_desc": "Events recorded by the notification system (admins only).",
  "account_privacy_export_generate": "Generate export",
  "account_privacy_export_loading": "Checking recent exports…",
  "account_privacy_export_running": "Building your archive — we'll email you the link.",
  "account_privacy_export_ready_download": "Download your archive",
  "account_privacy_export_idle_hint": "Pick at least one category, then generate.",
  "account_privacy_export_idle_ready": "Ready to generate when you are.",
  "account_privacy_export_error": "Something went wrong starting the export. Try again.",
  "account_privacy_export_started_toast": "Export queued",
  "account_privacy_export_started_toast_desc": "We'll email you the download link when your archive is ready.",
  "account_privacy_retention_title": "Data retention",
  "account_privacy_retention_description": "Choose how long each kind of record sticks around before automatic deletion.",
  "account_privacy_retention_readonly_banner": "Only org owners and admins can change retention rules.",
  "account_privacy_retention_row_conversations": "Conversations",
  "account_privacy_retention_row_audit_log": "Audit log",
  "account_privacy_retention_row_deleted_items": "Deleted items",
  "account_privacy_retention_row_notifications": "Notifications",
  "account_privacy_retention_preview_conversations": "Conversations older than {{count}} days will be permanently deleted at the end of each month.",
  "account_privacy_retention_preview_audit_log": "Audit-log entries older than {{count}} days will be purged at the end of each month.",
  "account_privacy_retention_preview_deleted_items": "Items in the trash older than {{count}} days will be permanently removed.",
  "account_privacy_retention_preview_notifications": "Notification records older than {{count}} days will be removed at the end of each month.",
  "account_privacy_retention_preview_indefinite_conversations": "Conversations are kept indefinitely. Nothing is auto-deleted.",
  "account_privacy_retention_preview_indefinite_audit_log": "Audit-log entries are kept indefinitely. Nothing is auto-deleted.",
  "account_privacy_retention_preview_indefinite_deleted_items": "Items in the trash are kept indefinitely. Nothing is auto-deleted.",
  "account_privacy_retention_preview_indefinite_notifications": "Notification records are kept indefinitely. Nothing is auto-deleted.",
  "account_privacy_retention_n_days": "{{count}} days",
  "account_privacy_retention_forever": "Forever",
  "account_privacy_retention_group_conversations": "Conversations & media",
  "account_privacy_retention_group_records": "Business records",
  "account_privacy_retention_group_system": "System & recovery",
  "account_privacy_retention_row_aria": "Retention period for {{label}}",
  "account_privacy_retention_summary": "{{deleting}} auto-delete · {{keeping}} kept",
  "account_privacy_delete_loading": "Loading…",
  "account_privacy_delete_title": "Delete account",
  "account_privacy_delete_description": "Permanently remove your account and all data you own. This action can be cancelled within 30 days.",
  "account_privacy_delete_row_now_title": "Right away",
  "account_privacy_delete_row_now_body": "You'll be signed out of every device. Other people in your workspace will see you as ‘deleted user’.",
  "account_privacy_delete_row_grace_title": "Within 30 days",
  "account_privacy_delete_row_grace_body": "You can sign back in to cancel. After the grace period, the deletion runs and cannot be undone.",
  "account_privacy_delete_row_legal_title": "Legal & compliance",
  "account_privacy_delete_row_legal_body": "We may keep minimal records (invoices, audit-required logs) for as long as the law requires.",
  "account_privacy_delete_request_button": "Request account deletion",
  "account_privacy_delete_confirm_warning": "Are you sure? Your account will be scheduled for deletion in 30 days.",
  "account_privacy_delete_confirm_cancel": "Keep my account",
  "account_privacy_delete_confirm_submit": "Schedule deletion",
  "account_privacy_delete_pending_title": "Account deletion scheduled",
  "account_privacy_delete_pending_description": "Your account will be permanently deleted on {date}. Cancel any time before then to keep your data.",
  "account_privacy_delete_days_label": "days left",
  "account_privacy_delete_cancel_button": "Cancel deletion request",
  "account_notifications_tab_title": "Notifications",
  "account_notifications_tab_description": "Choose when and how Bavard alerts you. These preferences are personal — they don't affect your teammates.",
  "account_notifications_master_title": "Master controls",
  "account_notifications_master_description": "Apply across every category. Sounds and channels can still be toggled per category below.",
  "account_notifications_sounds_enabled_label": "Sounds enabled",
  "account_notifications_sounds_enabled_description": "When off, no sound plays for any notification regardless of per-category settings.",
  "account_notifications_email_digest_label": "Email digest",
  "account_notifications_email_digest_description": "Roll up activity into an email instead of pinging me one-by-one.",
  "account_notifications_web_push_label": "Browser push",
  "account_notifications_web_push_description": "Show desktop notifications when Bavard is open in another tab.",
  "account_notifications_web_push_unsupported_title": "Push not supported",
  "account_notifications_web_push_unsupported_description": "Your browser doesn't support web push notifications.",
  "account_notifications_web_push_denied_title": "Permission denied",
  "account_notifications_web_push_denied_description": "Notifications are blocked. Enable them in your browser settings, then try again.",
  "account_notifications_web_push_dismissed_title": "Permission needed",
  "account_notifications_web_push_dismissed_description": "Web push needs your permission. Try again and choose Allow when prompted.",
  "account_notifications_web_push_unconfigured_title": "Push not configured",
  "account_notifications_web_push_unconfigured_description": "Web push isn't configured on this server. Contact your administrator.",
  "account_notifications_web_push_failed_title": "Couldn't enable push",
  "account_notifications_web_push_failed_description": "Something went wrong while enabling push notifications. Try again or refresh the page.",
  "account_notifications_column_inapp": "In-app",
  "account_notifications_column_sound": "Sound",
  "account_notifications_column_preview": "Preview sound",
  "account_notifications_preview_sound_aria": "Preview this category's sound",
  "account_notifications_group_messages_title": "Messages",
  "account_notifications_group_messages_description": "Conversations and customer feedback signals from your inbox.",
  "account_notifications_group_events_title": "Events",
  "account_notifications_group_events_description": "Bookings, rescheduling, and cancellations on your calendar.",
  "account_notifications_category_messageNew_label": "New message",
  "account_notifications_category_messageNew_description": "Someone messaged you in any conversation you can see.",
  "account_notifications_category_messageInOpenChat_label": "Message in open chat",
  "account_notifications_category_messageInOpenChat_description": "A new message arrived in the conversation you're currently viewing.",
  "account_notifications_category_conversationFeedback_label": "Customer feedback",
  "account_notifications_category_conversationFeedback_description": "The AI extracted positive or negative feedback from a conversation.",
  "account_notifications_category_eventCreated_label": "Event created",
  "account_notifications_category_eventCreated_description": "A new event was scheduled.",
  "account_notifications_category_eventModified_label": "Event modified",
  "account_notifications_category_eventModified_description": "An event was rescheduled, changed type, or reinstated after cancellation.",
  "account_notifications_category_eventCancelled_label": "Event cancelled",
  "account_notifications_category_eventCancelled_description": "An event was cancelled.",
  "account_notifications_mentions_title": "Mentions & messages",
  "account_notifications_mentions_description": "How loud should @-mentions be?",
  "account_notifications_mention_level_label": "Notify me on",
  "account_notifications_mention_level_all": "All messages",
  "account_notifications_mention_level_direct": "Only direct mentions",
  "account_notifications_mention_level_none": "Nothing",
  "config_nav_notification_rules": "Notification Rules",
  "feedbacks_summaries_segment_leads": "Leads",
  "leads_empty_title": "No leads captured yet",
  "leads_empty_body": "When the assistant collects lead information from a customer, it will appear here.",
  "leads_show_with_trashed": "Show trashed",
  "leads_show_active_only": "Active only",
  "leads_trashed_badge": "Trashed",
  "leads_soft_delete": "Move to trash",
  "leads_restore": "Restore",
  "leads_hard_delete": "Delete permanently",
  "leads_hard_delete_confirm": "Permanently delete this lead? This cannot be undone.",
  "collect_lead_fields_heading": "Lead fields",
  "collect_lead_loading": "Loading…",
  "collect_lead_no_fields_warning": "No fields configured. The assistant cannot collect leads until at least one field is added.",
  "collect_lead_add_field": "Add field",
  "custom_tool_section_title": "Custom actions",
  "custom_tool_section_description": "Org-defined tools that call your own HTTPS API. The AI can use them like any built-in tool.",
  "custom_tool_new_action": "New custom action",
  "custom_tool_badge_custom": "Custom",
  "custom_tool_badge_draft": "Draft",
  "custom_tool_requires_approval": "Requires approval before running",
  "custom_tool_plan_locked": "Custom actions aren't included in your current plan. Upgrade to define API-calling tools.",
  "custom_tool_loading": "Loading custom actions…",
  "custom_tool_empty": "No custom actions yet. Create one to let the AI call your API.",
  "custom_tool_enable": "Enable",
  "custom_tool_enabled_count": "{{count}} of {{limit}} enabled",
  "custom_tool_edit": "Edit action",
  "custom_tool_delete": "Delete",
  "custom_tool_deleted": "Custom action deleted",
  "custom_tool_delete_title": "Delete custom action?",
  "custom_tool_delete_confirm": "This permanently removes \"{{name}}\" and its stored secrets. This can't be undone.",
  "custom_tool_new_title": "New custom action",
  "custom_tool_edit_title": "Edit custom action",
  "custom_tool_wizard_description": "Define an HTTP request the AI can call as a tool. Each step saves on its own — you can leave and finish later.",
  "custom_tool_step_general": "General",
  "custom_tool_step_api": "API",
  "custom_tool_step_test": "Test",
  "custom_tool_step_data_access": "Data access",
  "custom_tool_field_name": "Action name",
  "custom_tool_field_name_hint": "The identifier the model calls. Letters, digits and underscores, 3–64 chars (e.g. check_order_status).",
  "custom_tool_field_when_to_use": "When to use",
  "custom_tool_field_when_to_use_placeholder": "Describe when the AI should call this action. Include example customer questions and example data.",
  "custom_tool_field_when_to_use_hint": "This becomes the tool description the model reads. Be specific about when to call it.",
  "custom_tool_field_requires_approval": "Require approval",
  "custom_tool_field_requires_approval_hint": "Pause for an operator to approve each call before it runs.",
  "custom_tool_target_label": "Used by",
  "custom_tool_target_assistant": "Assistant",
  "custom_tool_target_system_agent": "System agent",
  "custom_tool_target_both": "Both",
  "custom_tool_target_tooltip": "Which agent can call this action: the customer-facing assistant, the operator-facing system agent, or both.",
  "custom_tool_inputs_title": "Data inputs",
  "custom_tool_add_input": "Add input",
  "custom_tool_inputs_hint": "Values the AI collects from the conversation and passes into the request via {{variable}} tokens.",
  "custom_tool_input_name": "Name",
  "custom_tool_input_type": "Type",
  "custom_tool_input_type_text": "Text",
  "custom_tool_input_type_number": "Number",
  "custom_tool_input_type_boolean": "Boolean",
  "custom_tool_input_type_date": "Date",
  "custom_tool_input_description": "Description",
  "custom_tool_input_description_placeholder": "What this value is; guidance for the model.",
  "custom_tool_input_enum": "Allowed values (comma-separated, optional)",
  "custom_tool_input_required": "Required",
  "custom_tool_json_banner": "Requests send JSON and responses must be JSON (max 64 KB).",
  "custom_tool_field_method": "Method",
  "custom_tool_field_url": "URL (HTTPS)",
  "custom_tool_params_title": "Query parameters",
  "custom_tool_params_hint": "Auth values belong in headers — query params can leak into logs and proxies.",
  "custom_tool_param_key": "Key",
  "custom_tool_param_value": "Value",
  "custom_tool_add_param": "Add parameter",
  "custom_tool_headers_title": "Headers",
  "custom_tool_headers_hint": "Toggle secret to store a value encrypted in the vault; it's masked after saving.",
  "custom_tool_header_key": "Header",
  "custom_tool_header_value": "Value",
  "custom_tool_header_secret": "Secret",
  "custom_tool_add_header": "Add header",
  "custom_tool_field_body": "Body (JSON)",
  "custom_tool_add_variable": "Add variable:",
  "custom_tool_test_mode": "Test mode",
  "custom_tool_test_live": "Live response",
  "custom_tool_test_example": "Example response",
  "custom_tool_test_no_inputs": "This action has no data inputs.",
  "custom_tool_test_run": "Run test",
  "custom_tool_test_needs_api_save": "Save the API step before running a live test.",
  "custom_tool_test_status": "Status {{status}}",
  "custom_tool_test_duration": "{{ms}} ms",
  "custom_tool_test_size": "{{bytes}} bytes",
  "custom_tool_test_example_label": "Paste an example JSON response",
  "custom_tool_test_example_hint": "Use this when the API isn't ready. The Data access picker works off this sample.",
  "custom_tool_test_example_invalid": "Enter a valid JSON response before continuing.",
  "custom_tool_access_title": "Data access",
  "custom_tool_access_full": "Full data access",
  "custom_tool_access_full_hint": "The model sees the entire JSON response.",
  "custom_tool_access_limited": "Limited data access",
  "custom_tool_access_limited_hint": "The model sees only the response fields you choose below.",
  "custom_tool_access_paths_title": "Allowed response fields",
  "custom_tool_paths_empty": "Run a test or paste an example response to pick allowed fields.",
  "custom_tool_save_continue": "Save and continue",
  "custom_tool_continue": "Continue",
  "custom_tool_save": "Save",
  "custom_tool_back": "Back",
  "custom_tool_cancel": "Cancel",
  "custom_tool_saved": "Custom action saved",
  "custom_tool_save_failed": "Couldn't save the custom action",
  "custom_tool_finish_setup": "Finish setup to enable this action",
  "custom_tool_try_with_agent": "Try with agent",
  "custom_tool_export": "Export",
  "custom_tool_import_action": "Import",
  "custom_tool_col_name": "Action",
  "custom_tool_col_enabled": "Enabled",
  "custom_tool_export_failed": "Couldn't export the custom action",
  "custom_tool_import_success": "Custom action imported. Re-enter any secret headers, then enable it.",
  "custom_tool_import_failed": "Couldn't import the custom action",
  "collect_lead_field_label_aria": "Field label",
  "collect_lead_field_label_placeholder": "Label (e.g. Full name)",
  "collect_lead_field_name_aria": "Field key (lower_snake_case)",
  "collect_lead_field_type_aria": "Field type",
  "collect_lead_field_description_aria": "Field description for the assistant",
  "collect_lead_field_description_placeholder": "Description shown to the assistant (optional)",
  "collect_lead_field_remove_aria": "Remove field",
  "collect_lead_fields_save": "Save fields",
  "collect_lead_fields_reset": "Discard changes",
  "collect_lead_presets_toggle": "Presets",
  "collect_lead_presets_help": "Choose a starting point — replaces the current field list.",
  "collect_lead_preset_name_phone_email": "Name + Phone + Email",
  "collect_lead_preset_contact_company": "Contact + Company",
  "collect_lead_preset_appointment_intake": "Appointment intake",
  "account_privacy_retention_row_captured_leads": "Trashed leads",
  "account_privacy_retention_preview_captured_leads": "Trashed leads are permanently deleted after {{count}} days.",
  "account_privacy_retention_preview_indefinite_captured_leads": "Trashed leads are kept indefinitely.",
  "account_privacy_retention_row_chat_media": "Chat media",
  "account_privacy_retention_preview_chat_media": "Chat images are permanently deleted after {{count}} days; captions are kept.",
  "account_privacy_retention_preview_indefinite_chat_media": "Chat images are kept indefinitely.",
  "account_privacy_retention_row_documents": "Documents",
  "account_privacy_retention_preview_documents": "Documents untouched for {{count}} days are permanently deleted.",
  "account_privacy_retention_preview_indefinite_documents": "Documents are kept indefinitely.",
  "account_privacy_export_cat_captured_leads": "Captured leads",
  "account_privacy_export_cat_captured_leads_desc": "Leads collected by the assistant — values keyed by your configured fields.",
  "tooltipsDashboard": {
    "returningRate": "Share of booking customers with two or more bookings in the selected date range. Computed as repeat booking customers ÷ all booking customers.",
    "cpuUsage": "Live CPU load on the backend server, sampled from Prometheus every few seconds. Sustained values above 80% indicate the server is under stress.",
    "memoryUsage": "Live memory used by the backend process, sampled from Prometheus. The bar shows the share of available system memory consumed; the label shows the absolute value (MB/GB).",
    "totalEvents": "Total bookings scheduled to occur in the selected date range, including bookings that are currently cancelled.",
    "activeUsers": "Number of distinct customers with a non-cancelled booking inside the selected date range. Each customer is counted once.",
    "cancellations": "Bookings scheduled to occur in the selected date range whose current status is cancelled. Lower is better.",
    "conversionRate": "Share of customers who sent an inbound message in the selected date range and also had a non-cancelled booking in that range.",
    "avgResponseTime": "Average time the assistant takes to reply to an incoming user message, in seconds, across all conversations in the selected date range. Lower is better.",
    "newUsers": "Number of distinct customers with at least one booking inside the selected date range.",
    "returningUsers": "Number of customers with two or more bookings inside the selected date range.",
    "avgFollowups": "Average number of bookings after the first, among customers with multiple bookings in the selected date range.",
    "activityBreakdown": "Totals for reservations, cancellations, and modifications across the selected date range. Bars are scaled relative to the largest of the three counts.",
    "successRate": "Share of all event operations (bookings, cancellations, modifications combined) that completed without error in the selected date range. Higher means fewer failures.",
    "dailyTrendsOverview": "Day-by-day counts in the organization timezone. Bookings and current cancellations use the scheduled date; modifications use the modification date.",
    "timeAnalysis": "Charts that show WHEN activity happens — across hours of the day and days of the week — for the selected date range.",
    "eventDistribution": "Selected-period bookings by type and the average bookings per distinct booking customer for each type.",
    "userBehavior": "How users move through the funnel and how they segment by activity level in the selected date range.",
    "popularTimeSlots": "Bookings by scheduled hour (00:00–23:00) in the organization timezone for the selected date range.",
    "weeklyActivity": "Bookings and messages by organization-local weekday in the selected date range.",
    "avgEventsPerType": "Average bookings per distinct booking customer for each event type in the selected date range.",
    "typeDistribution": "Number of bookings by type in the selected date range.",
    "userSegments": "Distinct booking customers grouped by bookings in the selected range: 1, 2–5, or 6+.",
    "funnelHeading": "Drop-off from customers with an inbound message to an AI-created booking and then a second AI-created booking. Team, manual, and external bookings are excluded from booking stages.",
    "funnelActivation": "Of customers who sent an inbound message, the share for whom the assistant created a booking. Manual and external bookings are excluded.",
    "funnelRetention": "Of users with an AI-created booking, the share who later received another AI-created booking.",
    "funnelOverall": "End-to-end conversion from inbound conversation to a second AI-created booking. Manual and external bookings are excluded.",
    "funnelExit": "Cancellation rate among AI-created bookings only. Manual and external bookings are excluded. Lower is better.",
    "responseTimeAnalysis": "How quickly the assistant replies to incoming messages, in minutes. Compares the average, the typical (median), and the worst case across all conversations in the selected date range.",
    "responseAverage": "Mean reply time across every reply sample in the selected date range. Sensitive to outliers — a few very slow replies pull this up.",
    "responseMedian": "Middle reply time — half of replies are faster, half slower. More representative of the typical experience than the average.",
    "responseMaximum": "Slowest single reply observed in the selected date range. Useful for spotting worst-case latency.",
    "performanceScore": "Composite score (0–100) derived from the average reply time. 100 means instant replies; the score decays as the average grows.",
    "conversationAnalysis": "How long conversations get, measured in messages exchanged. Shows the average, the typical (median), and the longest single conversation in the selected date range.",
    "engagementLevel": "Categorical label (Low / Medium / High) based on the average messages per conversation. Higher engagement usually means richer interactions, but very high values can also signal users struggling to get answers.",
    "totalConversations": "Total number of conversations the assistant handled in the selected date range. Each conversation can contain many messages.",
    "totalMessages": "Total retained inbound and outbound messages across supported channels in the selected date range.",
    "avgMessagesPerConversation": "Average number of messages exchanged per conversation in the selected date range.",
    "messageVolumeHeatmap": "Messages by organization-local weekday and hour in the selected date range. Brighter cells are busier; hover for the exact count.",
    "peakHour": "Organization-local hour with the highest message volume in the selected date range.",
    "busiestDay": "Organization-local weekday with the highest message volume in the selected date range.",
    "avgPerHour": "Average messages per hour over a full week (168 hours), computed from totals in the selected date range.",
    "wordFrequency": "Top words spoken by the user vs. by the assistant in the selected date range. Switch tabs to compare. Common stopwords (a, the, and, etc.) are filtered out.",
    "mostActiveUsers": "Leaderboard of users ranked by either bookings made or messages sent in the selected date range. Click a row to open that user's conversation.",
    "responseTimeInsights": "Plain-language assessment of the assistant's average reply time over the selected date range. Colour-coded green/yellow/red based on thresholds (≤ 1 min excellent, ≤ 3 min good, etc.).",
    "conversationInsights": "Plain-language assessment of how engaged users are, based on average messages per conversation in the selected date range.",
    "businessInsights": "Curated tips drawn from your peak hours, retention rate, and response speed in the selected date range.",
    "leadsCollected": "Number of leads captured by the assistant via the lead-capture form in the selected date range. Each row in the Leads tab is one lead.",
    "positiveFeedback": "Number of feedback messages classified as positive sentiment in the selected date range.",
    "negativeFeedback": "Number of feedback messages classified as negative sentiment in the selected date range.",
    "neutralFeedback": "Number of feedback messages classified as neutral sentiment in the selected date range.",
    "aiTokenUsage": "AI tokens and USD cost recorded in the selected date range and channel filter, including input and output tokens."
  },
  "tooltipsAccount": {
    "profile": {
      "email": "Used for sign-in and important alerts. If your current email is verified, we'll send a confirmation link to the new address before switching — the change won't take effect until you click it.",
      "newPassword": "Minimum 8 characters. Use a unique password you don't reuse anywhere else; a long passphrase is stronger than a short complex one.",
      "currentPassword": "We need your existing password to confirm it's really you before changing it. If you've forgotten it, sign out and use the password-reset link."
    },
    "privacy": {
      "retention": {
        "section": "Auto-deletion windows for data your workspace stores. After the window passes, items are permanently removed and cannot be recovered. ‘Forever’ disables auto-delete for that category.",
        "conversations": "How long chat history is kept before automatic deletion. After this window, full message bodies are erased; aggregate counters used in analytics may be kept.",
        "auditLog": "How long admin-action logs (sign-ins, role changes, deletions) are kept. Shorter windows reduce storage; longer windows help with security forensics and compliance.",
        "deletedItems": "Items in the trash are recoverable until this window passes, after which they are permanently purged. ‘Forever’ keeps them until manually emptied.",
        "notifications": "How long delivered notification records are stored. This affects the in-app notification list — it does not cancel emails or push messages already sent.",
        "capturedLeads": "How long lead records collected by the assistant are kept. Set this longer than your sales cycle so leads aren't auto-purged before you act on them.",
        "chatMedia": "How long chat images are kept before automatic deletion. After this window the image is removed and only the caption/text remains. This never affects document images.",
        "documents": "How long a document is kept after it was last edited. After this window the whole document and its images are permanently deleted. This never affects chat images."
      },
      "export": {
        "section": "Generate a downloadable archive of your data. The bundle is built in the background, then a link is emailed to you and shown here when ready. Links typically expire after a few days.",
        "events": "Calendar events you've created or attended, with their full metadata.",
        "documents": "Files uploaded to the workspace knowledge base. Admin-only because it includes documents shared by other members.",
        "backups": "Database snapshots of the entire workspace. Admin-only — these can be very large and contain other users' data.",
        "notifications": "History of notifications delivered to members of the workspace. Admin-only.",
        "capturedLeads": "Leads captured by the assistant, with all the fields you've configured to collect."
      },
      "delete": {
        "section": "Schedules permanent deletion of your account in 30 days. You can cancel any time during the grace period by signing back in. After the grace period this is irreversible — data, sessions, and settings are erased."
      }
    },
    "sessions": {
      "section": "Every device or browser currently signed in to your account. ‘Sign out’ ends that session immediately and forces re-authentication on that device.",
      "signOutOthers": "Ends every session except this one. Use this if you've lost a phone, used a public computer, or suspect someone else has access."
    },
    "passkeys": {
      "section": "A passkey is a phishing-resistant credential tied to your device's biometrics or PIN (Touch ID, Windows Hello, hardware key). It replaces the password and cannot be reused on a fake site."
    },
    "notifications": {
      "sounds": "Plays a short tone when a notification arrives. Turning this off silences all categories at once; per-category sound switches are ignored until this is on.",
      "emailDigest": "Sends a periodic summary of activity to your email instead of one message per event. Useful if real-time emails are too noisy.",
      "webPush": "Lets the browser show notifications even when the tab isn't open. Requires a one-time browser permission and works only while the browser is running.",
      "mentionLevel": "Controls when @mentions notify you: ‘All’ for any thread, ‘Direct only’ for messages addressed straight to you, or ‘None’ to silence mentions entirely.",
      "inAppColumn": "Shows a notification badge and entry inside the app while you're using it.",
      "soundColumn": "Plays the notification tone for this category. Requires the master sound switch above to be on."
    }
  },
  "tooltipsPhoneSelector": {
    "selected": "The contact whose phone number is currently chosen for this field. It always sits at the top so you can see what's bound right now.",
    "favorites": "Pinned contacts you want quick access to. Open a contact's profile and toggle the star to add or remove it from this list.",
    "recent": "Contacts who messaged you most recently, sorted by their last message. They appear here automatically — no action needed.",
    "all": "Every contact in your workspace, sorted alphabetically. Type in the search box above to filter by name or phone number."
  },
  "tooltipsConfig": {
    "general": {
      "defaultCountryPrefix": "Used when phone numbers are entered without a country code. Pick the country your customers most often type from.",
      "availableThemes": "Color themes your team can choose from in the appearance picker. Disabling one hides it for everyone in this workspace.",
      "availableLanguages": "Languages users can switch to in the app. English is always on; turning others off removes them from the language menu.",
      "systemPrompt": "Master instructions the AI follows in every chat reply. Use it to set tone, persona, or any rules the AI must always obey.",
      "systemAgentPrompt": "Extra instructions for AI tasks that take actions (booking, lookups, etc.). Keep it focused on how the AI should use tools.",
      "latitude": "North–south coordinate of your business in decimal degrees (e.g. 24.7136). Use the map button if you don't know it.",
      "longitude": "East–west coordinate of your business in decimal degrees (e.g. 46.6753). Use the map button if you don't know it."
    },
    "calendarDisplay": {
      "firstDay": "Which day appears as the first column of the calendar week (e.g. Sunday vs. Monday). Match what your team is used to seeing.",
      "availableViews": "Calendar layouts your team can switch between (week, day, month, list, year). Star one to make it the default view.",
      "textDirection": "Forces calendar text left-to-right or right-to-left. Leave on Auto to follow the active language."
    },
    "emailTemplates": {
      "name": "Internal label so you can find this template later (e.g. 'Welcome email'). Customers never see this name.",
      "subject": "The subject line recipients see. You can drop in variables like {{name}} so each email is personalized.",
      "body": "The full email content. Use the variable chips below to insert recipient details automatically."
    },
    "notifications": {
      "ruleName": "Internal label for this notification rule (e.g. 'Day-before reminder'). Helps you find and edit it later.",
      "trigger": "What event causes this notification to send — a time-based reminder, a booking action, or a custom one-off send.",
      "daysBefore": "How many days before the event to send the reminder. 1 = the day before, 7 = a week ahead.",
      "daysAfter": "How many days after the event to send the follow-up. 1 = next day, 7 = a week later.",
      "delayHours": "Hours to wait after a no-show before sending the message. Half-hour steps are allowed (e.g. 1.5 = 90 minutes).",
      "delayMinutes": "Minutes to wait after the trigger before sending. Use 0 to send immediately, higher to give yourself a cancel-window.",
      "inactiveDays": "How many days a contact must be silent before the re-engagement message goes out. 30 = once a month-long lull is reached.",
      "sendAtTime": "Local time of day the message goes out. Combined with the day setting above, this is the exact send moment.",
      "scheduledAt": "The exact date and time this one-off custom message will be sent. Set in your business timezone.",
      "eventTypeFilter": "Limit this rule to specific event types (e.g. only consultations). Leave empty to apply to every event type.",
      "targetPhones": "Specific contacts who receive this message. Leave empty to send to the event's own contact instead.",
      "template": "The pre-approved WhatsApp template the message uses. Templates must be approved by Meta before they can send.",
      "reminderName": "The key the scheduler stores this reminder under. Letters, numbers, underscores and hyphens only — it must be unique.",
      "reminderSendTime": "Local time of day this reminder goes out, for events happening the next day."
    },
    "workingHours": {
      "startTime": "Earliest time of day appointments can be booked. Slots before this time will be hidden in the calendar.",
      "endTime": "Latest time of day appointments can be booked. Slots after this time will be hidden in the calendar.",
      "slotDuration": "How long each bookable slot lasts in hours. Must divide the working day evenly (e.g. 0.5h = 30-min slots).",
      "workingDaysGrid": "Days of the week your business takes bookings. Disabled days show as closed in the calendar.",
      "daySpecificDayOfWeek": "Pick which working day this override applies to. Each day can have only one override.",
      "daySpecificStart": "Start time used only on this day, replacing the default. Useful for short Fridays or late openings.",
      "daySpecificEnd": "End time used only on this day, replacing the default. Useful for short Fridays or late closings.",
      "daySpecificSlotDuration": "Override the slot length for this day only. Leave at default to inherit the global slot duration.",
      "customRangeDateRange": "The start and end calendar dates this override is active for (e.g. Dec 1–31). Outside these dates the global hours apply.",
      "customRangeStart": "Daily opening time during this range. Replaces the default start time only on these dates.",
      "customRangeEnd": "Daily closing time during this range. Replaces the default end time only on these dates.",
      "customRangeSlotDuration": "Slot length used during this range. Reset it to inherit the global slot duration."
    }
  },
  "billing": {
    "page_title": "Billing",
    "page_description": "Manage your subscription, view invoices, and track your organization's usage.",
    "loading": "Loading…",
    "error": "Failed to load billing data.",
    "subscription": {
      "title": "Subscription",
      "description": "Your current plan and renewal details.",
      "next_renewal": "Next renewal",
      "cancel_at_period_end": "Cancels at period end",
      "payment_method": "Payment method",
      "no_payment_method": "No card on file",
      "manage_button": "Manage billing",
      "manage_error": "Could not open the billing portal",
      "no_portal_contact_support": "To change your plan, please contact support.",
      "unconfigured": "Billing is not configured for this environment.",
      "cancel_button": "Cancel subscription",
      "cancel_confirm": "Cancel your subscription at the end of the current paid period? You'll keep access until then.",
      "cancel_success": "Your subscription will end at the close of the current paid period.",
      "cancel_error": "Could not cancel the subscription. Try again or contact support.",
      "upgrade_button": "Upgrade plan",
      "per_month": "month",
      "per_month_yearly": "month (billed yearly)",
      "excl_vat": "excl. {{vat}}% VAT",
      "status": {
        "none": "Inactive",
        "active": "Active",
        "trialing": "Trialing",
        "past_due": "Past due",
        "canceled": "Canceled"
      }
    },
    "history": {
      "title": "Billing history",
      "description": "Past invoices issued to your organization.",
      "column_date": "Date",
      "column_description": "Description",
      "column_amount": "Amount",
      "column_status": "Status",
      "column_invoice": "Invoice",
      "download_pdf": "Download PDF",
      "view_invoice": "View invoice",
      "subscription_invoice": "Subscription invoice",
      "empty_title": "No invoices yet",
      "empty_description": "Once your first payment is processed, your invoices will appear here.",
      "empty_no_customer": "Subscribe to a paid plan to start receiving invoices.",
      "empty_unconfigured": "Billing is not configured yet. Invoices will appear here after a payment provider is connected.",
      "invoice_status": {
        "draft": "Draft",
        "open": "Open",
        "paid": "Paid",
        "void": "Void",
        "uncollectible": "Uncollectible"
      }
    },
    "usage": {
      "title": "Usage",
      "description": "Your organization's quota usage for the current period.",
      "seats_label": "Staff seats",
      "messages_label": "AI messages",
      "storage_label": "Storage",
      "unlimited": "Unlimited",
      "period_resets_on": "Resets on {{date}}",
      "ai_pace": "On pace to reach your {cap} cap around {date}.",
      "ai_pace_this_month": "On pace to reach your {cap} cap this month."
    },
    "ai_spend_by_member": {
      "title": "AI spend by member",
      "description": "Inference spend attributed to each member over the period.",
      "assistant": "Customer messaging assistant"
    },
    "ai_cost_chart": {
      "forecast": "Forecast"
    }
  },
  "orgOverview": {
    "eyebrow": "Organization",
    "fallback_name": "Your organization",
    "plan_label": "{{plan}} plan",
    "since": "since {{date}}",
    "alerts": {
      "healthy": "Everything looks healthy — no billing or usage issues right now.",
      "past_due_title": "Payment is past due",
      "past_due_detail": "Update your payment method to avoid losing access.",
      "cancel_title": "Subscription ends soon",
      "cancel_detail": "Your plan cancels {{when}}.",
      "no_card_title": "No payment method on file",
      "no_card_detail": "Add a card so your next renewal doesn't fail.",
      "limit_reached_title": "{{label}} limit reached",
      "limit_reached_detail": "Upgrade your plan to keep adding more.",
      "near_limit_title": "{{label}} almost at the limit",
      "near_limit_detail": "{{pct}}% of your plan used.",
      "ai_over_title": "AI spend over the monthly cap",
      "ai_over_detail": "AI responses may be throttled until the period resets.",
      "ai_near_title": "AI spend at {{pct}}% of cap",
      "ai_near_detail": "Consider upgrading or topping up credits.",
      "ai_near_projected": "Projected {{amount}} by period end.",
      "credits_empty_title": "Credit balance is empty",
      "credits_empty_detail": "Ask your platform admin to top up AI credits.",
      "invites_pending_title": "Pending invitations",
      "invites_pending_detail": "{{count}} waiting to be accepted."
    },
    "usage": {
      "title": "Usage & spend",
      "seats": "Seats",
      "seats_caption": "of {{limit}} seats",
      "unlimited_seats_caption": "Unlimited seats",
      "messages": "AI messages",
      "messages_caption": "of {{limit}} this month",
      "storage": "Storage",
      "storage_caption": "of {{limit}}",
      "ai_spend": "AI spend",
      "ai_spend_caption": "of {{limit}} cap",
      "ai_projected": "projected {{amount}}",
      "this_month": "this month",
      "unavailable": "Usage data unavailable."
    },
    "billing": {
      "title": "Billing",
      "next_bill": "next bill",
      "renews": "Renews {{date}} · {{when}}",
      "no_upcoming": "No upcoming invoice",
      "cycle": "Billing cycle",
      "payment": "Payment",
      "no_card": "None on file",
      "credit_balance": "Credit balance",
      "credits": "{{count}} credits",
      "manage": "Manage billing",
      "not_configured": "Billing not configured.",
      "monthly": "monthly",
      "yearly": "yearly",
      "status": {
        "active": "Active",
        "trialing": "Trial",
        "past_due": "Past due",
        "canceled": "Canceled",
        "none": "No subscription"
      }
    },
    "people": {
      "title": "People",
      "manage": "Manage",
      "members": "members",
      "roles": "roles",
      "custom_roles": "custom roles",
      "pending_invites": "pending invites",
      "owners_admins": "Owners & admins",
      "secretaries": "Secretaries",
      "guests": "Guests",
      "roles_link": "Roles & permissions"
    },
    "activity": {
      "title": "Recent activity",
      "view_all": "View all",
      "empty": "No recent activity yet."
    },
    "quick_links": {
      "members": "Members",
      "members_desc": "Invite, edit, and remove",
      "roles": "Roles",
      "roles_desc": "Custom roles and grants",
      "billing": "Billing",
      "billing_desc": "Plan, invoices, credits",
      "settings": "Settings",
      "settings_desc": "Org configuration"
    },
    "countdown": {
      "overdue": "overdue",
      "today": "today",
      "tomorrow": "tomorrow",
      "in_days": "in {{n}} days"
    }
  },
  "dashboard_assistant": "Assistant",
  "dashboard_nav_assistant_desc": "AI outcomes, cost, and knowledge-base usage",
  "dashboard": {
    "outcomes": {
      "compared_previous": "vs previous period",
      "minutes_value": "{count} min",
      "hours_value": "{count} hr",
      "scheduling_title": "Scheduling outcomes",
      "no_show_hint": "No-shows among completed and no-show appointments",
      "no_show_counts": "{noShows} no-shows · {resolved} resolved",
      "no_resolved": "No resolved appointments",
      "no_show_rate": "No-show rate",
      "time_to_booking_hint": "Median from first observable inbound message to first booking",
      "booking_samples": "{count} observable contacts",
      "no_booking_samples": "No eligible samples",
      "time_to_first_booking": "Time to first booking",
      "no_show_by_type": "No-show rate by event type",
      "event_type": "Event type",
      "resolved": "Resolved",
      "containment_proxy_hint": "Telemetry proxy: AI-engaged threads without a requested human handoff",
      "containment_counts": "{handoffs} handoffs requested · {engaged} AI-engaged threads",
      "no_ai_threads": "No AI-engaged threads in this period",
      "handoff_free_rate": "Handoff-free rate",
      "ai_engaged_threads": "AI-engaged threads",
      "handoffs_requested": "handoffs requested",
      "no_shows": "no-shows",
      "minutes_short": "min",
      "observable_contacts": "observable contacts"
    },
    "assistant": {
      "roi_title": "AI outcomes",
      "cost_this_period": "AI cost this period",
      "cost_per_appointment": "Cost per booked appointment",
      "ai_share_of_operations": "AI share of operations",
      "actions_title": "What your AI did",
      "actions_empty": "No AI actions in this period yet.",
      "action_failed": "({count} failed)",
      "action_booked": "Booked {count} appointments",
      "action_rescheduled": "Rescheduled {count}",
      "action_cancelled": "Cancelled {count}",
      "action_answered": "Answered {count} questions using your documents",
      "action_handoff": "Handed {count} conversations to your team",
      "action_leads": "Collected {count} leads",
      "action_feedback": "Recorded {count} feedback notes",
      "action_menus": "Sent {count} menus & locations",
      "action_lookups": "Checked schedules & availability {count} times",
      "action_other": "Other actions {count}",
      "knowledge_base_storage": "Current knowledge base storage",
      "storage_caption": "Current snapshot · {limit} included",
      "retrieval_gaps_more_available": "More unanswered questions are available",
      "knowledge_base_title": "Knowledge base",
      "knowledge_base_empty": "Your AI hasn't drawn on your knowledge base yet.",
      "knowledge_base_headline": "{count}% of AI answers drew on your knowledge base",
      "most_referenced_documents": "Most referenced documents",
      "citations_count": "{count} citations",
      "coverage_footnote": "Based on {count}% of AI responses",
      "empty_state": "Your AI assistant's activity will appear here.",
      "operation_origin_desc": "Who handled each scheduling operation",
      "events_per_model": "Events created per model",
      "retrieval_gaps_title": "Questions without answers",
      "retrieval_gaps_desc": "Recent searches your AI couldn't answer from your knowledge base — upload documents to close the gap.",
      "retrieval_gaps_empty": "Your AI found sources for every question.",
      "retrieval_gaps_error": "Couldn't load unanswered questions.",
      "retrieval_gaps_no_query": "(no query text)",
      "retrieval_gaps_overflow": "+{count} more unanswered"
    }
  },
  "citation_status_verified": "Verified",
  "citation_status_partial": "Partially supported",
  "citation_status_contradicted": "Contradicted",
  "citation_status_not_verified": "Not verified",
  "citation_status_failed": "Verification failed",
  "citation_status_unverified": "Unverified",
  "citation_view_source": "View source",
  "citation_chip_aria": "Citation {number}",
  "citation_more_aria": "{count} more citations",
  "citation_quoted": "Quoted",
  "citation_untitled_source": "Untitled source",
  "citation_sources_count": "Sources ({count})",
  "citation_sources_title": "Sources",
  "citation_count": "{count} citations",
  "citation_pdf_load_error": "Could not load the document preview.",
  "citation_no_text_preview": "No text preview available for this source.",
  "citation_no_image_preview": "Image preview unavailable.",
  "citation_sheet_default": "Sheet",
  "citation_sheet_rows": "Rows {start}–{end}",
  "citation_region_counter": "{index} / {total}",
  "citation_prev_region": "Previous citation",
  "citation_next_region": "Next citation",
  "citation_view_page": "Page",
  "citation_view_text": "Text",
  "citation_check": "Check citations",
  "citation_preview_document": "Preview document",
  "metrics_agents": "Agents",
  "metrics_agents_mode": "Mode {mode}",
  "metrics_agents_tokens": "{tokens} tok",
  "metrics_agents_loops": "{loops} loops",
  "chat_action_rewind": "Rewind to here",
  "chat_rewind_failed": "Failed to rewind message",
  "admin_roles_tab_permissions": "Permissions",
  "admin_roles_tab_members": "Members",
  "admin_roles_members_column_name": "Name",
  "admin_roles_members_column_email": "Email",
  "admin_roles_members_column_org_role": "Org role",
  "admin_roles_members_column_assigned": "Assigned",
  "admin_roles_members_other_role_title": "Currently in another role — toggling will move them here",
  "admin_roles_members_assignment_failed": "Failed to update member assignment.",
  "admin_roles_members_failed_to_load": "Failed to load members.",
  "admin_roles_members_empty": "This organization has no members yet.",
  "config_event_colors_document_highlight_label": "Document Highlight",
  "config_event_colors_document_highlight_tip": "A distinct border color for events with attached documents.",
  "config_event_colors_document_picker_aria": "Document ring color picker",
  "config_event_colors_document_hex_aria": "Document ring hex value",
  "contact_active_label": "Active",
  "contact_add_contact": "Add contact",
  "contact_add_dialog_description": "Add a reachable phone number and the contact's name.",
  "contact_add_to_queue": "Add to queue",
  "contact_ai_auto_reply_label": "AI auto-reply",
  "contact_apply_button": "Apply",
  "contact_beneficiaries_count": "{{count}} beneficiaries",
  "contact_beneficiary_add": "Add beneficiary",
  "contact_beneficiary_add_desc": "Add a person booked under {{name}}. They have no phone of their own — reminders go to their contact.",
  "contact_beneficiary_delete": "Delete beneficiary",
  "contact_beneficiary_delete_desc": "Archive {{name}}? Their booking history stays and they can be restored later.",
  "contact_beneficiary_merge": "Merge into parent contact",
  "contact_beneficiary_merge_confirm": "Merge",
  "contact_beneficiary_merge_desc": "Merge {{name}} into {{parent}}? Their bookings move to {{parent}}, their document pages are appended to {{parent}}'s document, and {{name}} is removed. This can't be undone.",
  "contact_beneficiary_merge_failed": "Failed to merge into parent contact",
  "contact_beneficiary_move": "Move to another contact",
  "contact_beneficiary_move_desc": "Choose the contact who will book for {{name}} from now on.",
  "contact_beneficiary_name_placeholder": "Beneficiary name",
  "contact_beneficiary_pull": "Pull contact as beneficiary",
  "contact_beneficiary_pull_confirm": "Pull contact",
  "contact_beneficiary_pull_desc": "Choose a contact to become a beneficiary of {{name}}.",
  "contact_beneficiary_pull_warning": "This is a lossy operation: the contact loses their phone number, message history, saved conversation summaries, and active conversations. Their events and documents are kept.",
  "contact_beneficiary_pull_warning_named": "{{name}} will lose their phone number, message history, saved conversation summaries, and active conversations. Their events and documents are kept.",
  "contact_beneficiary_rename": "Rename",
  "contact_beneficiary_separate": "Separate into contact",
  "contact_beneficiary_separate_confirm": "Separate",
  "contact_beneficiary_separate_desc": "Give {{name}} their own phone number. They become a standalone contact and keep their bookings.",
  "contact_beneficiary_separate_merge_hint": "This number belongs to {{target}} — {{name}}'s bookings and document pages move to {{target}}, and {{name}} is removed. This can't be undone.",
  "contact_beneficiary_sibling_merge": "Merge into another beneficiary",
  "contact_beneficiary_sibling_merge_confirm": "Merge beneficiaries",
  "contact_beneficiary_sibling_merge_desc": "Choose which beneficiary will keep {{name}}'s bookings, conversations, and document pages.",
  "contact_beneficiary_sibling_merge_empty": "No other loaded beneficiaries are available under this contact.",
  "contact_beneficiary_sibling_merge_failed": "Failed to merge beneficiaries",
  "contact_beneficiary_sibling_merge_placeholder": "Select the beneficiary to keep",
  "contact_beneficiary_sibling_merge_target": "Beneficiary to keep",
  "contact_beneficiary_sibling_merge_warning": "{{source}} will be removed. Their bookings, conversations, and document pages move to {{target}}. This can't be undone.",
  "contact_beneficiary_sibling_merge_warning_generic": "The selected beneficiary will keep the combined bookings, conversations, and document pages. The other beneficiary will be removed. This can't be undone.",
  "contact_bookings_count": "{{count}} bookings",
  "contact_bool_no": "no",
  "contact_bool_yes": "yes",
  "contact_bulk_delete_failed": "Failed to delete contacts",
  "contact_change_reverted_toast": "Change reverted",
  "contact_changes_reverted_toast": "Changes reverted",
  "contact_changes_saved_toast": "Contact changes saved",
  "contact_channel_manual": "Manual",
  "contact_channel_system": "System",
  "contact_channel_web": "Web",
  "contact_channels_label": "Channels",
  "contact_collapse_details": "Collapse contact details",
  "contact_copy_contact_id": "Copy contact ID",
  "contact_copy_phone": "Copy phone",
  "contact_count": "{{count}} contacts",
  "contact_create_failed": "Failed to create contact",
  "contact_delete_contact": "Delete contact",
  "contact_delete_failed": "Failed to delete contact",
  "contact_deleted_badge": "Deleted",
  "contact_detail_activity_bookings": "Activity & bookings",
  "contact_detail_archived_at": "Archived at",
  "contact_detail_attached": "Attached",
  "contact_detail_beneficiaries": "Beneficiaries",
  "contact_detail_bookings": "Bookings",
  "contact_detail_channels_ai": "Channels & AI",
  "contact_detail_contact_id": "Contact ID",
  "contact_detail_country": "Country",
  "contact_detail_created": "Created",
  "contact_detail_documents": "Documents",
  "contact_detail_first_seen": "First seen",
  "contact_detail_identity": "Identity",
  "contact_detail_last_active": "Last active",
  "contact_detail_last_booking": "Last booking",
  "contact_detail_messages": "Messages",
  "contact_detail_next_booking": "Next booking",
  "contact_detail_nickname": "Nickname",
  "contact_detail_none": "None",
  "contact_details_label": "Details",
  "contact_diff_field_active": "active",
  "contact_diff_field_channel": "channel",
  "contact_diff_field_deleted": "deleted",
  "contact_diff_field_name": "name",
  "contact_diff_field_phone": "phone",
  "contact_edit_button": "Edit",
  "contact_edit_contact": "Edit contact",
  "contact_edit_contact_title": "Edit contact",
  "contact_edit_sheet_edit_description": "Update this contact's details. Changes are queued until you save the grid.",
  "contact_edit_sheet_new_description": "Fill in the contact details and tap Save.",
  "contact_expand_details": "Expand contact details",
  "contact_failed_to_load_appointments": "Failed to load appointments: {{message}}",
  "contact_failed_to_load_contacts": "Failed to load contacts: {{message}}",
  "contact_failed_to_load_history": "Failed to load history: {{message}}",
  "contact_favorite_label": "Favorite",
  "contact_favorite_update_failed": "Failed to update favorite",
  "contact_field_active": "Active",
  "contact_field_channel": "Channel",
  "contact_field_name": "Name",
  "contact_field_phone": "Phone",
  "contact_full_name_placeholder": "Full name",
  "contact_generic_label": "contact",
  "contact_history_actor_system": "system",
  "contact_history_by_actor": "by {{actor}}",
  "contact_history_description": "Change history and combined appointment record for this contact.",
  "contact_history_event_created": "Created",
  "contact_history_event_restored": "Restored",
  "contact_history_event_reverted": "Reverted",
  "contact_history_event_soft_deleted": "Soft-deleted",
  "contact_history_event_updated": "Updated",
  "contact_history_tab_appointments": "Appointments",
  "contact_history_tab_history": "History",
  "contact_history_title": "Contact",
  "contact_actions_group_history": "History",
  "contact_actions_group_manage": "Manage",
  "contact_id_copied_toast": "Contact ID copied",
  "contact_id_copy_failed_toast": "Couldn't copy contact ID",
  "contact_inactive_hint": "Inactive contacts are hidden from the assistant.",
  "contact_inactive_label": "Inactive",
  "contact_loading_ellipsis": "Loading...",
  "contact_loading_more": "Loading more contacts…",
  "contact_merge_failed": "Failed to merge contacts",
  "contact_messages_count": "{{count}} messages",
  "contact_new_badge": "New",
  "contact_new_contact_title": "New contact",
  "contact_no_appointments": "No appointments for this patient.",
  "contact_no_beneficiaries": "No beneficiaries",
  "contact_no_bookings": "No bookings",
  "contact_no_channels": "No channels",
  "contact_no_contact_details": "No contact details",
  "contact_no_contacts_found": "No contacts found",
  "contact_no_contacts_yet": "No contacts yet.",
  "contact_no_history_events": "No history events yet.",
  "contact_no_messages": "No messages",
  "contact_no_name": "(no name)",
  "contact_open_conversation": "Open conversation",
  "contact_org_contact_required_history": "Organization and contact are required to load history",
  "contact_org_required_create": "Organization is required to create contacts",
  "contact_org_required_delete": "Organization is required to delete contacts",
  "contact_org_required_fetch": "Organization is required to fetch contacts",
  "contact_org_required_list": "Organization is required to list contacts",
  "contact_org_required_merge": "Organization is required to merge contacts",
  "contact_org_required_restore": "Organization is required to restore contacts",
  "contact_org_required_revert_event": "Organization is required to revert contact events",
  "contact_org_required_stats": "Organization is required to load contact stats",
  "contact_org_required_unmerge": "Organization is required to un-merge contacts",
  "contact_org_required_update": "Organization is required to update contacts",
  "contact_page_subtitle": "Everyone your assistant talks to, across every channel.",
  "contact_page_title": "Contacts",
  "contact_row_save": "Save this contact",
  "contact_row_revert": "Discard this row's changes",
  "contact_phone_copied_toast": "Phone number copied",
  "contact_phone_copy_failed_toast": "Couldn't copy phone number",
  "contact_phone_e164_label": "Phone (E.164)",
  "contact_phone_editor_label": "Phone editor",
  "contact_picker_invalid_target": "This contact can't be chosen here.",
  "contact_restore_failed": "Failed to restore contact",
  "contact_revert_button": "Revert",
  "contact_revert_confirm_intro": "This will roll the contact back to the state captured at",
  "contact_revert_confirm_title": "Revert this change?",
  "contact_revert_discard_suffix": "will be discarded by this revert.",
  "contact_revert_event_failed": "Failed to revert contact event",
  "contact_revert_failed": "Failed to revert",
  "contact_revert_newer_change": "{{count}} newer changes",
  "contact_reverted_toast": "Reverted to the selected version",
  "contact_reverting_ellipsis": "Reverting…",
  "contact_save_failed": "Failed to save contacts",
  "contact_search_contacts": "Search contacts",
  "contact_search_placeholder": "Search by name or phone…",
  "contact_select_visible": "Select visible contacts",
  "contact_show_deleted": "Show deleted",
  "contact_state_ai_replies": "AI replies",
  "contact_state_archived": "Archived",
  "contact_state_blocked": "Blocked",
  "contact_state_manual": "Manual",
  "contact_stats_active": "Active",
  "contact_stats_active_hint": "Messaged in last 30 days",
  "contact_stats_new_hint": "Added since the 1st",
  "contact_stats_new_this_month": "New this month",
  "contact_stats_total_contacts": "Total contacts",
  "contact_stats_upcoming_bookings": "Upcoming bookings",
  "contact_stats_upcoming_hint": "Confirmed or pending event",
  "contact_status_toggle_activate": "Inactive — click to activate",
  "contact_status_toggle_deactivate": "Active — click to deactivate",
  "contact_summary_added": "{{count}} added",
  "contact_summary_deleted": "{{count}} deleted",
  "contact_summary_updated": "{{count}} updated",
  "contact_undo_bool_no": "No",
  "contact_undo_bool_yes": "Yes",
  "contact_undo_deselect_all": "Deselect all",
  "contact_undo_dialog_description": "Review what was saved and choose which contacts to roll back. Everything on the left is what it was before.",
  "contact_undo_dialog_title": "Undo saved changes",
  "contact_undo_failed": "Failed to undo changes",
  "contact_undo_fallback_label": "Contact",
  "contact_undo_keep_changes": "Keep changes",
  "contact_undo_kind_added": "Added",
  "contact_undo_kind_deleted": "Deleted",
  "contact_undo_kind_updated": "Updated",
  "contact_undo_revert_count": "Revert {{count}} changes",
  "contact_undo_select_all": "Select all",
  "contact_undo_selected": "Selected",
  "contact_undo_selected_count": "{{selected}} of {{total}} selected",
  "contact_unmerge_button": "Un-merge",
  "contact_unmerge_failed": "Failed to un-merge",
  "contact_unmerge_mutation_failed": "Failed to un-merge contact",
  "contact_unmerged_toast": "Contact un-merged",
  "contact_unmerging_ellipsis": "Un-merging…",
  "contact_unnamed": "Unnamed",
  "contact_unnamed_contact": "Unnamed contact",
  "contact_update_failed": "Failed to update contact",
  "contact_validation_duplicate_phone": "Another contact in this org already has this phone number.",
  "contact_validation_failed": "Validation failed",
  "contact_validation_name_required": "A name is required when adding a new contact.",
  "contact_validation_name_too_long": "Name must be 120 characters or fewer.",
  "contact_validation_phone_invalid_area": "Phone number is not valid for its country/area code.",
  "contact_validation_phone_invalid_format": "Phone number is incomplete or not in a recognized format.",
  "contact_validation_phone_required": "A phone number is required when no name is provided.",
  "contact_validation_phone_required_for_new_contact": "A phone number is required when adding a new contact.",
  "contact_validation_row_label": "Row {{row}}",
  "contact_verb_added": "Added",
  "contact_verb_deleted": "Deleted",
  "contact_verb_updated": "Updated",
  "contact_view_history": "View contact history",
  "mutation_error_generic": "Something went wrong. Please try again.",
  "mutation_error_org_roles_not_seeded": "Your organization's roles are not set up yet — contact an admin.",
  "feat_users_toast_create_failed": "Failed to create user",
  "feat_users_toast_update_failed": "Failed to update user",
  "feat_users_toast_delete_failed": "Failed to delete user",
  "feat_users_toast_update_profile_failed": "Failed to update profile",
  "feat_users_toast_save_document_failed": "Failed to save user document",
  "feat_users_toast_update_favorite_failed": "Failed to update favorite",
  "feat_users_toast_update_active_status_failed": "Failed to update active status",
  "feat_users_toast_modify_phone_failed": "Failed to modify phone",
  "feat_team_console_toast_send_notice_failed": "Failed to send notice",
  "feat_team_console_toast_update_member_status_failed": "Failed to update member status",
  "feat_team_console_toast_remove_member_failed": "Failed to remove member",
  "feat_config_toast_update_failed": "Failed to update configuration",
  "feat_config_toast_create_failed": "Failed to create configuration",
  "feat_auth_toast_delete_org_failed": "Failed to delete organization",
  "feat_playground_toast_upload_document_failed": "Failed to upload document",
  "feat_playground_toast_delete_document_failed": "Failed to delete document",
  "feat_playground_toast_toggle_document_failed": "Failed to toggle document",
  "feat_playground_toast_clear_failed": "Failed to clear playground",
  "feat_playground_toast_search_failed": "Search failed",
  "feat_playground_toast_agent_run_failed": "Agent run failed",
  "feat_playground_upload_cancel": "Cancel upload",
  "feat_playground_upload_dismiss": "Dismiss",
  "feat_playground_upload_cancel_hint_queued": "Nothing has been sent yet — this stops it completely.",
  "feat_playground_upload_cancel_hint_sending": "Stops sending. The server may already hold the file; if a document appears, it will be removed.",
  "feat_playground_upload_cancel_hint_accepted": "Deletes the document. Parsing or embedding already running will finish, and anything already spent stays spent.",
  "feat_playground_upload_client_bytes_caption": "Measured in your browser — bytes sent, not work done.",
  "feat_playground_upload_phase_queued": "Queued",
  "feat_playground_upload_phase_uploading": "Sending",
  "feat_playground_upload_phase_sent": "Awaiting server",
  "feat_playground_upload_phase_accepted": "Accepted",
  "feat_playground_upload_phase_cancelling": "Cancelling",
  "feat_playground_upload_phase_cancelled": "Cancelled",
  "feat_playground_upload_phase_failed": "Failed",
  "feat_playground_upload_phase_done": "Ingested",
  "feat_playground_upload_orphan_pending": "Checking whether the server kept a copy of this file.",
  "feat_playground_upload_orphan_reaped": "The server had kept a copy. It has been removed.",
  "feat_playground_upload_orphan_ambiguous": "More than one document could be this upload, so none was removed. Delete the extra one yourself.",
  "feat_playground_upload_orphan_unresolved": "No matching document turned up. If one appears later, remove it yourself.",
  "feat_playground_upload_too_large": "This file is larger than the upload limit.",
  "rag_stage_uploading_client": "Sending file",
  "rag_cost_source_actual": "actual",
  "rag_cost_source_unknown": "unpriced",
  "rag_cost_unknown_count": "{{count}} calls",
  "rag_stage_analyzing": "Analyzing file",
  "rag_stage_parsing": "Extracting text",
  "rag_stage_figures": "Reading figures",
  "rag_stage_summarizing": "Summarizing",
  "rag_stage_chunking": "Splitting into passages",
  "rag_stage_contextualizing": "Adding context",
  "rag_stage_embedding": "Embedding",
  "rag_stage_storing": "Saving index",
  "rag_stage_completed": "Ready",
  "rag_stage_failed": "Failed",
  "rag_stage_substep_progress": "{{label}} {{done}}/{{total}}",
  "pg_ingest_upload_client_hint": "Request bytes flushed by this browser. The server has not started work yet.",
  "feat_event_types_toast_save_failed": "Failed to save event type",
  "feat_event_types_toast_deactivate_failed": "Failed to deactivate event type",
  "feat_event_types_toast_reorder_failed": "Failed to reorder event types",
  "feat_event_types_toast_add_field_failed": "Failed to add field",
  "feat_event_types_toast_update_field_failed": "Failed to update field",
  "feat_event_types_toast_remove_field_failed": "Failed to remove field",
  "feat_event_types_toast_reorder_fields_failed": "Failed to reorder fields",
  "feat_roles_toast_create_failed": "Failed to create role",
  "feat_roles_toast_update_failed": "Failed to update role",
  "feat_roles_toast_delete_failed": "Failed to delete role",
  "feat_app_config_toast_upload_document_failed": "Failed to upload document",
  "feat_app_config_toast_delete_document_failed": "Failed to delete document",
  "feat_app_config_toast_toggle_document_failed": "Failed to toggle document",
  "feat_app_config_toast_apply_strategy_failed": "Failed to apply embedding strategy",
  "feat_app_config_toast_schema_preload_failed": "Failed to update schema preload",
  "feat_app_config_rag_schema_preload_label": "Preload schema",
  "feat_app_config_rag_schema_preload_tooltip": "Inject this spreadsheet's schema into the assistant prompt",
  "feat_app_config_toast_image_policy_failed": "Failed to update image handling",
  "rag_image_policy_label": "Images in answers",
  "rag_image_policy_tooltip": "Choose how this document's figures are used",
  "rag_image_policy_describe_label": "Describe",
  "rag_image_policy_attach_label": "Attach",
  "rag_image_policy_ocr_label": "Read text",
  "rag_image_policy_ignore_label": "Skip",
  "rag_image_policy_describe_hint": "A vision model writes a short description of each figure, and that description becomes searchable with the rest of the document.",
  "rag_image_policy_attach_hint": "The figure itself is sent to the assistant when the model can see images. No description is written, so a figure is only reachable through the text around it — never by a question that describes the picture.",
  "rag_image_policy_ocr_hint": "Text inside each figure is read out word for word and becomes searchable. Best for scans, screenshots and diagrams full of labels.",
  "rag_image_policy_ignore_hint": "Figures are skipped entirely — no description, no text, no stored image.",
  "rag_image_policy_ingest_note": "Changing this only affects answers once the document is processed again.",
  "rag_image_policy_reprocess_hint": "Use Replace on this row to reprocess it now.",
  "rag_image_policy_answer_note": "Takes effect immediately, from the next answer.",
  "rag_image_policy_inherits": "Following the organization default ({{mode}}).",
  "rag_image_policy_default_label": "Default for new documents",
  "rag_image_policy_default_tip": "How figures are handled in documents you upload from now on. Any document can override this from its own row.",
  "feat_app_config_rag_schema_preload_token_warning": "Preloaded schemas are large (~{{tokens}} tokens) and may slow responses.",
  "feat_app_config_toast_revert_prompt_failed": "Failed to revert prompt version",
  "feat_superadmin_toast_create_org_failed": "Failed to create organization",
  "feat_superadmin_toast_update_org_failed": "Failed to update organization",
  "feat_superadmin_toast_toggle_org_status_failed": "Failed to toggle organization status",
  "feat_superadmin_toast_update_org_secrets_failed": "Failed to update organization secrets",
  "feat_superadmin_toast_update_member_failed": "Failed to update member",
  "feat_superadmin_toast_delete_org_failed": "Failed to delete organization",
  "feat_superadmin_toast_create_member_failed": "Failed to create member",
  "feat_superadmin_toast_delete_member_failed": "Failed to delete member",
  "feat_superadmin_toast_delete_members_failed": "Failed to delete members",
  "feat_app_feedback_toast_update_status_failed": "Failed to update feedback status",
  "feat_account_privacy_toast_update_retention_failed": "Failed to update retention rules",
  "feat_account_privacy_toast_request_deletion_failed": "Failed to request account deletion",
  "feat_account_privacy_toast_cancel_deletion_failed": "Failed to cancel deletion request",
  "feat_account_sessions_toast_revoke_others_failed": "Failed to sign out other sessions",
  "feat_account_sessions_toast_add_passkey_failed": "Failed to add passkey",
  "feat_account_profile_toast_update_failed": "Failed to update profile",
  "feat_account_profile_toast_change_email_failed": "Failed to change email",
  "feat_billing_toast_checkout_failed": "Failed to start checkout",
  "feat_billing_toast_portal_failed": "Failed to open billing portal",
  "feat_billing_toast_cancel_failed": "Failed to cancel subscription",
  "feat_billing_toast_sync_failed": "Failed to sync billing",
  "feat_billing_toast_checkout_status_failed": "Failed to check checkout status",
  "feat_admin_plans_toast_create_draft_failed": "Failed to create draft plan",
  "feat_admin_plans_toast_update_pricing_failed": "Failed to update pricing",
  "feat_admin_plans_toast_publish_failed": "Failed to publish plan",
  "feat_admin_plans_toast_phase_out_failed": "Failed to phase out plan",
  "feat_admin_org_balance_toast_credit_failed": "Failed to credit organization",
  "admin_a_actions_for": "Actions for {{name}}",
  "admin_a_active": "Active",
  "admin_a_active_since": "Active {{since}}",
  "admin_a_activity": "Activity",
  "admin_a_add_member": "Add member",
  "admin_a_add_organization": "Add organization",
  "admin_a_ai_observability": "AI Observability",
  "admin_a_ai_runs": "AI Runs",
  "admin_a_amount_this_month": "{{amount}} this month",
  "admin_a_amount_total": "{{amount}} total",
  "admin_a_applying": "Applying…",
  "admin_a_authenticated_count": "{{count}} authenticated",
  "admin_a_avg_value": "avg {{value}}",
  "admin_a_balance_and_ledger": "Balance & Ledger",
  "admin_a_banned": "Banned",
  "admin_a_billing": "Billing",
  "admin_a_by_model": "By Model",
  "admin_a_by_organization": "By Organization",
  "admin_a_cache_hit_rate": "Cache Hit Rate",
  "admin_a_cache_read_write": "{{read}} read / {{write}} write",
  "admin_a_cache_savings_est": "Cache savings (est.)",
  "admin_a_cached_read_tokens": "{{count}} cached read tokens",
  "admin_a_cancel": "Cancel",
  "admin_a_catalog_estimate_vs_billed": "Catalog estimate vs billed cost",
  "admin_a_channel_contacts": "Channel Contacts",
  "admin_a_channels_and_secrets": "Channels & Secrets",
  "admin_a_chart_unavailable": "Chart unavailable",
  "admin_a_clear": "Clear",
  "admin_a_close_email_templates": "Close email templates",
  "admin_a_col_actual": "Actual",
  "admin_a_col_cache": "Cache",
  "admin_a_col_channel": "Channel",
  "admin_a_col_drift": "Drift",
  "admin_a_col_estimated": "Estimated",
  "admin_a_col_last_message": "Last Message",
  "admin_a_col_model": "Model",
  "admin_a_col_name": "Name",
  "admin_a_col_phone": "Phone",
  "admin_a_col_reasoning": "Reasoning",
  "admin_a_col_runs": "Runs",
  "admin_a_col_speed": "Speed",
  "admin_a_col_status": "Status",
  "admin_a_col_tool_err": "Tool Err",
  "admin_a_collapse_member_details": "Collapse member details",
  "admin_a_collapse_org_details": "Collapse organization details",
  "admin_a_confirm_quarantine": "Quarantine",
  "admin_a_confirm_release": "Release",
  "admin_a_confirm_suspend": "Suspend",
  "admin_a_confirm_unsuspend": "Unsuspend",
  "admin_a_contact_count": "{{count}} contact",
  "admin_a_contacts_count": "{{count}} contacts",
  "admin_a_copy_org_id": "Copy org ID",
  "admin_a_cost": "cost",
  "admin_a_cost_efficiency": "Cost Efficiency",
  "admin_a_credit_org": "Credit org…",
  "admin_a_credits": "Credits",
  "admin_a_initial_ai_credits_no_payment": "Initial AI credits (no payment)",
  "admin_a_credits_available": "Credits available",
  "admin_a_credits_lower": "credits",
  "admin_a_credits_value": "{{amount}} credits",
  "admin_a_custom_role": "Custom role",
  "admin_a_daily_trend": "Daily Trend",
  "admin_a_data_grid_unavailable": "Data grid unavailable",
  "admin_a_day_window": "{{days}} day window",
  "admin_a_default_suffix": "(default)",
  "admin_a_delayed": "Delayed",
  "admin_a_delete_member": "Delete member",
  "admin_a_delete_organization": "Delete organization",
  "admin_a_deleted": "Deleted",
  "admin_a_demo": "Demo",
  "admin_a_demo_org": "Demo org",
  "admin_a_details": "Details",
  "admin_a_done": "Done",
  "admin_a_edit_limits": "Edit limits",
  "admin_a_edit_limits_title": "Edit Limits",
  "admin_a_email": "Email",
  "admin_a_email_placeholder": "name@example.com…",
  "admin_a_email_templates": "Email Templates",
  "admin_a_enter_org": "Enter org",
  "admin_a_errored_aborted_runs": "errored / aborted runs",
  "admin_a_estimated_vs_actual": "Estimated vs Actual",
  "admin_a_expand_member_details": "Expand member details",
  "admin_a_expand_org_details": "Expand organization details",
  "admin_a_failed_count": "{{count}} failed",
  "admin_a_failed_to_load_channel_contacts": "Failed to load channel contacts: ",
  "admin_a_failed_to_load_ledger": "Failed to load ledger",
  "admin_a_failed_to_load_system_health": "Failed to load system health: ",
  "admin_a_failed_to_send_invitation": "Failed to send invitation",
  "admin_a_finish": "Finish",
  "admin_a_full_name": "Full name",
  "admin_a_healthy": "Healthy",
  "admin_a_identity": "Identity",
  "admin_a_internal_identifiers": "Internal identifiers",
  "admin_a_interval": "Interval",
  "admin_a_invalid_email": "Invalid email",
  "admin_a_invitation_sent_to": "Invitation sent to {{email}}",
  "admin_a_invite_member": "Invite Member",
  "admin_a_invite_member_desc": "Send an invitation email to add a new member to the organization.",
  "admin_a_job_queues": "Job Queues",
  "admin_a_joined": "Joined",
  "admin_a_last_active": "Last active",
  "admin_a_last_activity": "Last activity",
  "admin_a_last_sign_in": "Last Sign-in",
  "admin_a_latency_speed_cost": "Latency, speed, cost",
  "admin_a_list_price": "List price",
  "admin_a_loading": "loading",
  "admin_a_loading_ledger": "Loading ledger…",
  "admin_a_manage_secrets": "Manage secrets",
  "admin_a_manage_secrets_title": "Manage Secrets",
  "admin_a_member": "member",
  "admin_a_member_id": "Member ID",
  "admin_a_messages_all_time": "Messages (all time)",
  "admin_a_messages_per_month": "Messages / mo",
  "admin_a_messages_this_month": "Messages this month",
  "admin_a_messenger_page_id": "Messenger page ID",
  "admin_a_missing_performance": "Missing performance",
  "admin_a_missing_usage": "Missing usage",
  "admin_a_moderation": "Moderation",
  "admin_a_moderation_reason_placeholder": "Why is this action being taken? Shown when access is blocked.",
  "admin_a_name": "Name",
  "admin_a_new": "New",
  "admin_a_no_ai_cost_data": "No AI cost data in this window.",
  "admin_a_no_ai_model_metrics": "No AI model metrics in this window.",
  "admin_a_no_channel": "No channel",
  "admin_a_no_channel_contacts_found": "No channel contacts found",
  "admin_a_no_channel_contacts_yet": "No channel contacts yet.",
  "admin_a_no_credits_remaining": "No credits remaining",
  "admin_a_no_daily_trend_data": "No daily AI trend data in this window.",
  "admin_a_no_finish_data": "No finish data.",
  "admin_a_no_job_queue_data": "No job queue data available. Queue monitoring will show data when connected to a running server.",
  "admin_a_no_member_details": "No member details",
  "admin_a_no_members_found": "No members found",
  "admin_a_no_members_yet": "No members yet.",
  "admin_a_no_messages": "No messages",
  "admin_a_no_options": "No options",
  "admin_a_no_org_ai_metrics": "No organization AI metrics in this window.",
  "admin_a_no_organization_details": "No organization details",
  "admin_a_no_organization_selected": "No organization selected",
  "admin_a_no_organizations_found": "No organizations found",
  "admin_a_no_organizations_yet": "No organizations yet.",
  "admin_a_no_recent_activity": "No recent activity",
  "admin_a_no_restrictions": "No restrictions",
  "admin_a_no_secrets_set": "No secrets set",
  "admin_a_no_status_data": "No status data.",
  "admin_a_non_fatal_provider_warnings": "non-fatal provider warnings",
  "admin_a_none": "none",
  "admin_a_org_id": "Org ID",
  "admin_a_org_id_copied": "Org ID copied",
  "admin_a_org_name_placeholder": "Acme Inc.",
  "admin_a_organization": "Organization",
  "admin_a_organization_role": "Organization role",
  "admin_a_p95_latency": "p95 Latency",
  "admin_a_past_due": "Past due",
  "admin_a_plan": "Plan",
  "admin_a_plan_limits_vs_actual": "Plan limits vs actual",
  "admin_a_platform_overview": "Platform overview",
  "admin_a_presence": "Presence",
  "admin_a_presence_idle": "Idle",
  "admin_a_presence_offline": "Offline",
  "admin_a_presence_online": "Online",
  "admin_a_presence_unknown": "Unknown",
  "admin_a_quarantine": "Quarantine…",
  "admin_a_quarantine_confirm_title": "Quarantine {{name}}?",
  "admin_a_quarantine_desc": "Quarantine isolates the organization for investigation. The reason is recorded with a timestamp.",
  "admin_a_quarantined": "Quarantined",
  "admin_a_quotas_and_usage": "Quotas & Usage",
  "admin_a_realtime_connections": "Realtime Connections",
  "admin_a_realtime_rooms": "Realtime Rooms",
  "admin_a_reason": "Reason",
  "admin_a_reasoning_share": "Reasoning Share",
  "admin_a_reasoning_tokens": "{{count}} reasoning tokens",
  "admin_a_recent_activity": "Recent activity",
  "admin_a_release_confirm_title": "Release {{name}} from quarantine?",
  "admin_a_release_desc": "Lifts the quarantine and clears its timestamp.",
  "admin_a_release_quarantine": "Release quarantine…",
  "admin_a_reliability": "Reliability",
  "admin_a_restricted": "Restricted",
  "admin_a_retry": "Retry",
  "admin_a_role": "Role",
  "admin_a_role_admin": "Admin",
  "admin_a_role_guest": "Guest",
  "admin_a_role_member": "Member",
  "admin_a_role_owner": "Owner",
  "admin_a_role_secretary": "Secretary",
  "admin_a_save_first": "Save first",
  "admin_a_save_org_to_see_details": "Save the organization to see details",
  "admin_a_secret_keys": "Secret keys",
  "admin_a_secret_set": "{{count}} secret set",
  "admin_a_secrets_set": "{{count}} secrets set",
  "admin_a_seeded_demo_org": "Seeded demo organization",
  "admin_a_select_a_plan": "Select a plan",
  "admin_a_select_organization": "Select organization",
  "admin_a_select_visible_members": "Select visible members",
  "admin_a_send_invitation": "Send Invitation",
  "admin_a_sending": "Sending…",
  "admin_a_since": "Since {{date}}",
  "admin_a_slowest_p95_first": "Slowest p95 first",
  "admin_a_slug": "Slug",
  "admin_a_staff_members": "Staff Members",
  "admin_a_staff_seats": "Staff seats",
  "admin_a_staff_users": "Staff users",
  "admin_a_status_and_finish_reasons": "Status and finish reasons",
  "admin_a_storage": "Storage",
  "admin_a_subscription": "Subscription",
  "admin_a_superuser": "Superuser",
  "admin_a_superuser_only": "Superuser only",
  "admin_a_suspend": "Suspend…",
  "admin_a_suspend_confirm_title": "Suspend {{name}}?",
  "admin_a_suspend_desc": "Suspension blocks the organization's access until lifted. The reason is shown to blocked members and recorded with a timestamp.",
  "admin_a_suspended": "Suspended",
  "admin_a_system_status": "System Status",
  "admin_a_tool_calls_ratio": "{{errors}} / {{total}} tool calls",
  "admin_a_tool_err": "tool err",
  "admin_a_tool_error_rate": "Tool Error Rate",
  "admin_a_unassigned": "Unassigned",
  "admin_a_unnamed_contact": "Unnamed contact",
  "admin_a_unsuspend": "Unsuspend…",
  "admin_a_unsuspend_confirm_title": "Unsuspend {{name}}?",
  "admin_a_unsuspend_desc": "Restores the organization's access and clears the suspension timestamp.",
  "admin_a_uptime": "Uptime",
  "admin_a_user_email_placeholder": "user@example.com",
  "admin_a_user_id": "User ID",
  "admin_a_utc_buckets": "UTC buckets",
  "admin_a_value_per_response": "{{value}} / response",
  "admin_a_waiting": "Waiting",
  "admin_a_warnings": "Warnings",
  "admin_a_wasted": "wasted",
  "admin_a_wasted_spend": "Wasted spend",
  "admin_a_configured": "Configured",
  "admin_a_channels_linked": "{{channels}} linked",
  "admin_a_telegram_bot": "Telegram bot",
  "admin_a_telegram_linked": "Telegram linked",
  "admin_a_whatsapp_linked": "WhatsApp linked",
  "admin_a_whatsapp_telegram_linked": "WhatsApp + Telegram linked",
  "admin_a_whatsapp_phone_id": "WhatsApp phone ID",
  "admin_b_add_user_as_member_of_existing_org": "Add {{user}} as a member of an existing org.",
  "admin_b_api_keys": "API Keys",
  "admin_b_assign": "Assign",
  "admin_b_assign_to_existing": "Assign to existing",
  "admin_b_assign_to_existing_org_title": "Assign to existing organization",
  "admin_b_assign_to_new_org": "Assign to new org",
  "admin_b_assign_user_to_new_org_title": "Assign user to new organization",
  "admin_b_assigning": "Assigning…",
  "admin_b_assignment_failed": "Assignment failed",
  "admin_b_billing_label": "Billing",
  "admin_b_billing_monthly": "Monthly",
  "admin_b_billing_yearly": "Yearly",
  "admin_b_col_email": "Email",
  "admin_b_col_intended_billing": "Intended Billing",
  "admin_b_col_intended_plan": "Intended Plan",
  "admin_b_col_name": "Name",
  "admin_b_col_signed_up": "Signed up",
  "admin_b_continue_anyway": "Continue anyway",
  "admin_b_could_not_exit_impersonation": "Could not exit impersonation",
  "admin_b_create_org_and_assign": "Create org & assign",
  "admin_b_create_paid_org_desc": "Create a paid org for {{user}} and add them as owner. Subscription status is set to {{status}} (paid offline).",
  "admin_b_creating": "Creating…",
  "admin_b_defaults_to_slug": "Defaults to the slug",
  "admin_b_effective_label": "Effective:",
  "admin_b_engagement_active": "Active",
  "admin_b_engagement_dormant": "Dormant",
  "admin_b_engagement_low_activity": "Low Activity",
  "admin_b_exit": "Exit",
  "admin_b_exited_impersonation": "Exited impersonation",
  "admin_b_exiting": "Exiting…",
  "admin_b_failed_to_assign_user": "Failed to assign user",
  "admin_b_failed_to_load_organizations": "Failed to load organizations",
  "admin_b_failed_to_load_waiting_users": "Failed to load waiting users.",
  "admin_b_failed_to_save_secrets": "Failed to save secrets",
  "admin_b_failed_to_update_limits": "Failed to update limits",
  "admin_b_hide": "Hide",
  "admin_b_impersonating_badge": "Impersonating",
  "admin_b_inactive_suffix": "— inactive",
  "admin_b_integration_coverage": "Integration Coverage",
  "admin_b_leave_blank_plan_default": "Leave blank = plan default ({{value}})",
  "admin_b_loading_organizations": "Loading organizations…",
  "admin_b_lower_seat_limit_desc": "The new seat limit ({{seats}}) is below this organization's current member count ({{count}}). Existing members keep access, but no new invitations will be accepted until the limit is raised. Continue?",
  "admin_b_lower_seat_limit_title": "Lower seat limit below current usage?",
  "admin_b_member_role_distribution": "Member Role Distribution",
  "admin_b_messages_per_month": "{{count}} / mo",
  "admin_b_monthly_message_limit_label": "Monthly AI message limit",
  "admin_b_name_label": "Name",
  "admin_b_no_email": "No email",
  "admin_b_no_organizations": "No organizations",
  "admin_b_no_waiting_users_body": "When someone clicks “{{waitAction}}” on the pending-org screen they’ll appear here so you can manually create an org for them.",
  "admin_b_no_waiting_users_title": "No users waiting for assignment",
  "admin_b_onboarding_eyebrow": "Onboarding",
  "admin_b_optional_suffix": "(optional)",
  "admin_b_org_activity_ranking": "Organization Activity Ranking",
  "admin_b_org_engagement_health": "Org Engagement Health",
  "admin_b_organization_label": "Organization",
  "admin_b_override_badge": "override",
  "admin_b_pick_org_and_role": "Pick an org and role.",
  "admin_b_plan_chat": "Chat",
  "admin_b_plan_default_badge": "plan default",
  "admin_b_plan_default_value": "/ Plan default: {{value}}",
  "admin_b_plan_defaults_summary": "Defaults — {{seats}} staff seats · {{messages}} messages/mo · {{storage}} MiB storage",
  "admin_b_plan_distribution": "Plan Distribution",
  "admin_b_plan_label": "Plan: {{plan}}",
  "admin_b_plan_label_short": "Plan",
  "admin_b_plan_limits_eyebrow": "Plan controls",
  "admin_b_plan_limits_footer_note": "Overrides take effect immediately. Clearing returns the field to its plan default. Lowering a limit below the organization's current usage may block new invites or uploads but will not remove existing members or data.",
  "admin_b_plan_limits_section_title": "Override plan limits",
  "admin_b_plan_limits_subtitle": "Superadmin override. Blank = use the plan default.",
  "admin_b_plan_limits_title": "Plan limits: {{name}}",
  "admin_b_plan_limits_updated": "Plan limits updated",
  "admin_b_plan_premium": "Premium",
  "admin_b_plan_standard": "Standard",
  "admin_b_resource_distribution_per_org": "Resource Distribution per Org",
  "admin_b_role_admin": "Admin",
  "admin_b_role_guest": "Guest",
  "admin_b_role_label": "Role",
  "admin_b_role_owner": "Owner",
  "admin_b_role_secretary": "Secretary",
  "admin_b_seats_count": "{{count}} seats",
  "admin_b_secret_clear_badge": "clear",
  "admin_b_secret_enter_new_value": "Enter new value to overwrite",
  "admin_b_secret_group_ai_voice": "AI & Voice",
  "admin_b_secrets_group_messaging": "Messaging",
  "admin_b_secrets_group_developer_ai": "Developer & AI",
  "admin_b_secrets_section_eyebrow": "Integration credentials",
  "admin_b_secret_label_access_token": "Access Token",
  "admin_b_secret_label_api_key": "API Key",
  "admin_b_secret_label_app_id": "App ID",
  "admin_b_secret_label_app_password": "App Password",
  "admin_b_secret_label_app_secret": "App Secret",
  "admin_b_secret_label_application_id": "Application ID",
  "admin_b_secret_label_bot_id": "Bot ID",
  "admin_b_secret_label_bot_token": "Bot Token",
  "admin_b_secret_label_business_account_id": "Business Account ID",
  "admin_b_secret_label_instagram_account_id": "Instagram Account ID",
  "admin_b_secret_label_client_id": "Client ID",
  "admin_b_secret_label_client_secret": "Client Secret",
  "admin_b_secret_label_installation_id": "Installation ID",
  "admin_b_secret_label_page_access_token": "Page Access Token",
  "admin_b_secret_label_page_id": "Page ID",
  "admin_b_secret_label_personal_access_token": "Personal Access Token",
  "admin_b_secret_label_phone_number_id": "Phone Number ID",
  "admin_b_secret_label_private_key": "Private Key",
  "admin_b_secret_label_public_key": "Public Key",
  "admin_b_secret_label_service_account_json": "Service Account JSON",
  "admin_b_secret_label_signing_secret": "Signing Secret",
  "admin_b_secret_label_tenant_id": "Tenant ID",
  "admin_b_secret_label_webhook_secret": "Webhook Secret",
  "admin_b_secret_label_webhook_route_id": "Webhook Route ID",
  "admin_b_secret_label_webhook_secret_token": "Webhook Secret Token",
  "admin_b_secret_label_verify_token": "Verify Token",
  "admin_b_secret_instagram_access_token_help": "Access token for this organization's Instagram professional account. Existing values are never displayed.",
  "admin_b_secret_instagram_app_secret_help": "Meta app secret used to verify signed webhook payloads. Keep it private.",
  "admin_b_secret_instagram_verify_token_help": "Independent token Bavard and Meta use during webhook subscription verification.",
  "admin_b_secret_instagram_account_id_help": "Numeric Instagram professional-account ID used for tenant routing; this is not the username.",
  "admin_b_secret_telegram_bot_token_help": "Secret token issued by BotFather. Existing values are never displayed.",
  "admin_b_secret_telegram_bot_id_help": "Numeric identifier of the Telegram bot account; this is not the bot token.",
  "admin_b_secret_telegram_route_id_help": "Opaque, non-secret routing handle used in the webhook URL. Use a unique value for each organization.",
  "admin_b_secret_telegram_webhook_secret_help": "Secret token Telegram sends in the webhook verification header. Keep it private.",
  "admin_b_secret_not_set": "Not set",
  "admin_b_secret_set_badge": "set",
  "admin_b_secret_will_be_cleared": "Will be cleared on save",
  "admin_b_secrets_integration_sections": "Integration sections",
  "admin_b_secrets_missing_required": "Missing required: {{fields}}",
  "admin_b_secrets_invalid_fields": "Fix the invalid fields before saving: {{fields}}",
  "admin_b_secrets_saved": "Secrets saved successfully",
  "admin_b_secrets_subtitle": "Manage API keys and tokens. Existing secrets are never shown.",
  "admin_b_secrets_title": "Secrets: {{name}}",
  "admin_b_select_an_org": "Select an org",
  "admin_b_show": "Show",
  "admin_b_show_impersonation_status": "Show impersonation status",
  "admin_b_slug_already_taken": "That slug is already taken",
  "admin_b_slug_label": "Slug",
  "admin_b_staff_seat_limit_label": "Staff seat limit",
  "admin_b_storage_effective": "{{value}} MiB",
  "admin_b_storage_limit_label": "Storage limit (MiB)",
  "admin_b_storage_range_hint": "Greater than 0 – {{max}} MiB. Decimal allowed (e.g. 1.5).",
  "admin_b_this_user": "this user",
  "admin_b_unknown_organization": "Unknown organization",
  "admin_b_unlimited": "Unlimited",
  "admin_b_user_already_belongs_refreshing": "This user already belongs to an org. Refreshing the list.",
  "admin_b_user_already_member_of_org": "User is already a member of this org.",
  "admin_b_user_already_member_refreshing": "This user is already a member of an organization. Refreshing the list…",
  "admin_b_user_assigned_to_org": "User assigned to org",
  "admin_b_user_assigned_to_org_slug": "User assigned to org {{slug}}",
  "admin_b_wait_for_assignment": "Wait for assignment",
  "admin_b_waiting_users_desc": "Users who clicked “{{waitAction}}” on the pending-org screen. Use “{{assignAction}}” to create a paid org and add the user as owner.",
  "admin_b_waiting_users_title": "Waiting Users",
  "admin_b_whole_number_range_hint": "1 – {{max}}. Whole number.",
  "auth_anonymous_demo_failed": "Failed to start demo",
  "auth_back_to_home": "Back to home",
  "calendar_booking_horizon_limit": "Bookings of this type can be made at most {{days}} day(s) ahead (latest date: {{latestDate}})",
  "calendar_date_beyond_booking_horizon": "Date is beyond the booking horizon",
  "calendar_time_outside_working_hours": "Time is outside working hours",
  "cfg_all_event_types": "All event types",
  "cfg_auto_language_hint_already_set": "Already set to the country default ({{language}})",
  "cfg_auto_language_hint_fill_with": "Fill with {{language}} (the language for country {{countryPrefix}})",
  "cfg_auto_language_hint_no_country": "Pick a default country first to enable the country-derived shortcut",
  "cfg_auto_language_hint_no_mapping": "No language mapping for country \"{{countryPrefix}}\"",
  "cfg_auto_language_hint_not_enabled": "{{language}} is not enabled in display languages",
  "cfg_edit": "Edit",
  "cfg_email_template_created_toast": "Template created",
  "cfg_email_template_delete_confirm": "Delete email template?",
  "cfg_email_template_delete_failed_toast": "Failed to delete template",
  "cfg_email_template_deleted_toast": "Template deleted",
  "cfg_email_template_save_failed_toast": "Failed to save template",
  "cfg_email_template_updated_toast": "Template updated",
  "cfg_email_templates_description": "Create and manage email templates for your organization.",
  "cfg_email_templates_empty": "No templates yet. Create your first email template.",
  "cfg_event_types_none_configured": "No event types configured.",
  "cfg_feedback_summary_language_label": "Feedback summary language",
  "cfg_location_picker_lat": "Lat",
  "cfg_location_picker_lng": "Lng",
  "cfg_location_picker_loading_map": "Loading map…",
  "cfg_location_picker_locating": "Locating…",
  "cfg_location_picker_search_failed": "Location search failed. Please try again.",
  "cfg_location_picker_selected_location": "Selected Location",
  "cfg_location_picker_use_location": "Use location",
  "cfg_location_picker_use_my_location": "Use my location",
  "cfg_location_picker_use_this_location": "Use This Location",
  "cfg_model_benchmarks_title": "Benchmarks",
  "cfg_model_context_window_desc_model": "Maximum tokens this model can read in a single request — prompt plus prior conversation.",
  "cfg_model_context_window_desc_provider": "Maximum tokens this provider can read in a single request — prompt plus prior conversation.",
  "cfg_model_context_window_title": "Context window",
  "cfg_model_developer_label": "Developer",
  "cfg_model_hide_hosting_providers_aria": "Hide {{count}} hosting providers",
  "cfg_model_hide_providers_aria": "Hide {{count}} providers",
  "cfg_model_hosting_providers_desc": "{{count}} providers host this model. Tap to compare pricing, latency, and features.",
  "cfg_model_hosting_providers_title": "Hosting providers",
  "cfg_model_max_output_desc_provider": "Maximum tokens this provider can generate in a single response.",
  "cfg_model_pricing_desc_model_credits": "Credits charged per message. Expand to compare per-provider cost.",
  "cfg_model_pricing_desc_model_super": "Approximate cost per 1M tokens — input/output. Expand to compare per-provider pricing.",
  "cfg_model_pricing_desc_model_tier": "Relative cost of this model — more $ signs mean a pricier model tier.",
  "cfg_model_pricing_desc_provider_credits": "Credits charged per message when this provider answers.",
  "cfg_model_pricing_desc_provider_super": "Approximate cost per 1M tokens for this provider — input/output.",
  "cfg_model_pricing_desc_provider_tier": "Relative cost of this provider — more $ signs mean a pricier model tier.",
  "cfg_model_pricing_title_cost_per_message": "Cost per message",
  "cfg_model_pricing_title_cost_tier": "Cost tier",
  "cfg_model_providers_label": "Providers",
  "cfg_model_released_label": "Released",
  "cfg_model_show_hosting_providers_aria": "Show {{count}} hosting providers",
  "cfg_model_show_providers_aria": "Show {{count}} providers",
  "cfg_models_empty_connection_hint": "The OpenRouter servers may be down or you may have lost internet connection. Please check your connection and try again.",
  "cfg_models_empty_filters_hint": "Try adjusting your filters to see more results.",
  "cfg_notif_add_rule": "Add Rule",
  "cfg_notif_channel_email": "Email",
  "cfg_notif_channel_whatsapp": "WhatsApp",
  "cfg_notif_channels_label": "Delivery channels",
  "cfg_notif_channels_tooltip": "Which channels this notification sends over. WhatsApp is the default; pick one or more.",
  "cfg_notif_event_type_filter_label": "Event Type Filter",
  "cfg_notif_group_action_based": "Action-based",
  "cfg_notif_group_custom": "Custom",
  "cfg_notif_group_time_based": "Time-based",
  "cfg_notif_loading_templates": "Loading templates…",
  "cfg_notif_no_approved_templates": "No approved templates found.",
  "cfg_notif_no_templates_found": "No templates found",
  "cfg_notif_rule_name_label": "Rule Name",
  "cfg_notif_rule_name_placeholder": "e.g. Day-Before Reminder",
  "cfg_notif_search_templates": "Search templates…",
  "cfg_notif_select_target_contacts": "Select target contacts…",
  "cfg_notif_subtype_after_event": "After event",
  "cfg_notif_subtype_after_event_desc": "Send after the event",
  "cfg_notif_subtype_after_no_show": "After no-show",
  "cfg_notif_subtype_after_no_show_desc": "Send after a no-show",
  "cfg_notif_subtype_before_event": "Before event",
  "cfg_notif_subtype_before_event_desc": "Send before the event",
  "cfg_notif_subtype_custom_desc": "Send to specific contacts at a scheduled time",
  "cfg_notif_subtype_on_cancellation": "On cancellation",
  "cfg_notif_subtype_on_cancellation_desc": "When an event is cancelled",
  "cfg_notif_subtype_on_creation": "On creation",
  "cfg_notif_subtype_on_creation_desc": "When an event is created",
  "cfg_notif_subtype_on_modification": "On modification",
  "cfg_notif_subtype_on_modification_desc": "When an event is rescheduled",
  "cfg_notif_subtype_re_engagement": "Re-engagement",
  "cfg_notif_subtype_re_engagement_desc": "Reach out after inactivity",
  "cfg_notif_target_phones_count_hint": "{{count}} contacts will receive this notification.",
  "cfg_notif_target_phones_default_hint": "Sends to the event contact.",
  "cfg_notif_target_phones_done": "Done",
  "cfg_notif_target_phones_label": "Target Phones",
  "cfg_notif_target_phones_select_hint": "Select contacts to send this notification to.",
  "cfg_notif_target_phones_selected_count": "{{count}} contacts selected",
  "cfg_notif_template_no_variables": "This template has no variable placeholders.",
  "cfg_notif_trigger_label": "Trigger",
  "cfg_notif_whatsapp_template_label": "WhatsApp Template",
  "cfg_optional_suffix": "(optional)",
  "cfg_pick_a_language": "Pick a language",
  "cfg_pick_date_and_time": "Pick date & time",
  "cfg_provider_rail_scroll_down": "Scroll providers down",
  "cfg_provider_rail_scroll_up": "Scroll providers up",
  "cfg_reasoning_effort_desc_high": "Deep reasoning for complex tasks",
  "cfg_reasoning_effort_desc_low": "Light reasoning for simple tasks",
  "cfg_reasoning_effort_desc_medium": "Balanced reasoning for most work",
  "cfg_reasoning_effort_desc_off": "No thinking at all -- the model answers directly",
  "cfg_reasoning_effort_off_unavailable": "This model always thinks -- its reasoning cannot be turned off",
  "cfg_reasoning_effort_option_off": "Off",
  "cfg_reminder_add": "Add Reminder",
  "cfg_reminder_delete": "Delete reminder",
  "cfg_reminder_name_label": "Reminder key",
  "cfg_reminder_name_placeholder": "e.g. day-before",
  "cfg_reminder_name_missing_lead": "This reminder has no name yet.",
  "cfg_reminder_name_missing_reason": "The name is the key the scheduler stores the reminder under, so two unnamed reminders would collide.",
  "cfg_reminder_name_invalid_lead": "This name contains characters the scheduler cannot use.",
  "cfg_reminder_name_invalid_reason": "Use only letters, numbers, underscores and hyphens.",
  "cfg_reminder_send_time_label": "Send at",
  "cfg_reminder_untitled": "Untitled reminder",
  "cfg_reminders_description": "Sent the day before an event, at the time you set. Each reminder needs an approved template with every placeholder mapped.",
  "cfg_reminders_empty": "No reminders yet. Add one to message clients the day before their appointment.",
  "cfg_reminders_title": "Event Reminders",
  "cfg_remove_item_aria": "Remove {{name}}",
  "cfg_summary_language_label": "Summary language",
  "cfg_target_contacts_description": "Select target contacts",
  "cfg_target_contacts_label": "Target contacts",
  "cfg_tool_requires_approval_tooltip": "When enabled, the system agent must get admin approval in the chat before executing this tool.",
  "cfg_tool_not_available_chat_plan": "Not available on Chat plan",
  "cfg_tool_default_model_gate_reason": "The selected AI model can't call tools. Choose a model that lists 'tools' in its supported parameters to use this tool.",
  "cfg_model_disabled_no_tool_support": "This model can't call tools, and your assistant has tools enabled. Choose a model that lists 'tools' in its supported parameters.",
  "cfg_tool_scheduling_locked_reason": "Scheduling tools are not available on the Chat plan",
  "cfg_tool_business_location_locked_reason": "Fill in business name, address, and coordinates to enable this tool",
  "cfg_tool_channel_only": "{{channel}} only",
  "cfg_tool_channel_supported": "Supported on {{channel}}",
  "cfg_tooldesc_getCurrentDatetime": "Lets the AI know today's date and time.",
  "cfg_tooldesc_searchDocs": "Searches your uploaded knowledge to answer questions accurately.",
  "cfg_tooldesc_getDocumentSchemas": "Lets the AI see which documents and spreadsheets you've uploaded.",
  "cfg_tooldesc_queryStructuredData": "Looks up answers inside your uploaded spreadsheets (Excel/CSV).",
  "cfg_tooldesc_scheduleEvent": "Books an appointment for the customer in an open slot.",
  "cfg_tooldesc_joinWaitlist": "Adds the customer to the waitlist when no slot fits.",
  "cfg_tooldesc_modifyEvent": "Moves an existing appointment to a different time.",
  "cfg_tooldesc_cancelEvent": "Cancels a customer's appointment.",
  "cfg_tooldesc_getUserData": "Looks up the customer's profile and upcoming appointments.",
  "cfg_tooldesc_getAvailableTimeSlots": "Checks which times are free on a given day.",
  "cfg_tooldesc_searchAvailableAppointments": "Finds the next open appointment times across days.",
  "cfg_tooldesc_sendBusinessLocation": "Sends your business address and map location to the customer.",
  "cfg_tooldesc_sendInteractiveButtons": "Offers quick-reply buttons for short choices.",
  "cfg_tooldesc_sendInteractiveList": "Shows a tappable menu when there are several options.",
  "cfg_tooldesc_requestPhoneNumber": "Asks the customer to share their phone number when it's needed.",
  "cfg_tooldesc_handoffToHuman": "Hands the conversation to your team and pauses AI replies.",
  "cfg_tooldesc_saveFeedback": "Saves customer praise or complaints so you can review them later.",
  "cfg_tooldesc_collectLead": "Collects an interested customer's contact details for follow-up.",
  "cfg_tooldesc_scheduleEvents": "Books appointments for several customers at once.",
  "cfg_tooldesc_modifyEvents": "Reschedules several appointments at once.",
  "cfg_tooldesc_modifyEventRange": "Shifts or updates appointments across a date range.",
  "cfg_tooldesc_cancelEvents": "Cancels several appointments at once.",
  "cfg_tooldesc_cancelEventRange": "Cancels appointments across a date range.",
  "cfg_tooldesc_getEventSnapshots": "Looks up appointments across dates and customers.",
  "cfg_tooldesc_getAvailableSlotsBatch": "Checks availability across several dates at once.",
  "cfg_tooldesc_summarizeConversation": "Summarizes a customer conversation for you.",
  "cfg_tooldesc_getAnalytics": "Answers questions about your business numbers.",
  "cfg_tooldesc_getUsageBreakdown": "Shows your AI usage and remaining credits.",
  "cfg_tooldesc_getKnowledgeGaps": "Finds questions your knowledge base couldn't answer.",
  "cfg_tooldesc_renderChart": "Draws a chart from your data in the chat.",
  "cfg_tooldesc_manageKnowledgeSource": "Proposes adding, updating, or removing a knowledge source.",
  "cfg_tooldesc_ingestUploadedFile": "Adds a file you shared in chat to the knowledge base.",
  "cfg_tooldesc_triggerRetraining": "Refreshes the knowledge base from all enabled sources.",
  "cfg_tooldesc_getAgentSettings": "Reads your current assistant settings (read-only).",
  "cfg_tooldesc_getContactSnapshot": "Looks up a contact's full record.",
  "cfg_tooldesc_manageContact": "Proposes contact updates or removal (removal always needs your approval).",
  "cfg_tooldesc_manageBeneficiary": "Proposes merging or separating beneficiary records (merges always need approval).",
  "cfg_tooldesc_queryConversations": "Lists conversations by status, operator, or date.",
  "cfg_tooldesc_searchConversations": "Searches your conversation history.",
  "cfg_tooldesc_getConversationMetrics": "Shows response times, handoffs, and resolution stats.",
  "cfg_tooldesc_manageAutomation": "Proposes creating or changing an automation.",
  "cfg_tooldesc_startIntegrationConnection": "Creates a link to connect an integration in configuration.",
  "cfg_tooldesc_getChannelStatus": "Checks whether your WhatsApp, Telegram, and Instagram channels are connected.",
  "cfg_tooldesc_generateInsightsReport": "Builds a report of insights across your business data.",
  "cfg_tool_dependency_required_reason": "Included automatically while this section is on — the booking tools rely on it.",
  "cfg_tool_rag_no_documents_reason": "Upload documents to the knowledge base first — there is nothing for the AI to search yet.",
  "cfg_tool_bundle_available_to_label": "Available to",
  "cfg_tool_bundle_available_to_tooltip": "Choose who can look things up in your documents: the customer assistant, your system agent, or both.",
  "cfg_tool_channel_not_connected_reason": "None of the channels this tool works on ({{channels}}) are connected for your organization.",
  "cfg_tool_bundle_row_locked_reason": "Part of document retrieval — use the section switch to turn the whole bundle on or off.",
  "cfg_tool_bundle_structured_hint": "Spreadsheet lookups switch on automatically when you upload Excel or CSV files.",
  "cfg_tsec_group_assistant_label": "Customer assistant",
  "cfg_tsec_group_assistant_tooltip": "What the AI assistant that replies to your customers is allowed to do. Toggle a whole section on or off, or expand it to fine-tune individual permissions.",
  "cfg_tsec_group_system_agent_label": "System agent",
  "cfg_tsec_group_system_agent_tooltip": "Your operator-facing copilot in the chat sidebar. It manages the workspace itself: bulk scheduling, analytics, knowledge and contacts. Turning it off hides it from the sidebar entirely.",
  "cfg_tsec_system_agent_disabled_hint": "The system agent is turned off — it is hidden from the chat sidebar and none of its tools run.",
  "cfg_tsec_scheduling_label": "Booking & scheduling",
  "cfg_tsec_scheduling_tooltip": "Let the assistant check availability and book appointments for customers. Turning the section off pauses all of it while keeping your per-tool choices saved. Expand to control exactly which operations are allowed.",
  "cfg_tsec_knowledge_label": "Knowledge & data",
  "cfg_tsec_knowledge_tooltip": "One switch for document retrieval: the AI searches your uploaded knowledge to answer questions. Turn it off to stop the AI from reading your documents.",
  "cfg_tsec_engagement_label": "Customer interaction",
  "cfg_tsec_engagement_tooltip": "Optional conversation abilities — sharing your location, quick-reply buttons, human handoff, feedback capture, lead collection. Enable only what your business needs.",
  "cfg_tsec_sa_scheduling_label": "Bulk scheduling",
  "cfg_tsec_sa_scheduling_tooltip": "Batch booking operations across many customers and date ranges.",
  "cfg_tsec_sa_insights_label": "Analytics & insights",
  "cfg_tsec_sa_insights_tooltip": "Read-only reporting: analytics, usage, conversation search and summaries, charts and insight reports.",
  "cfg_tsec_sa_knowledge_label": "Knowledge management",
  "cfg_tsec_sa_knowledge_tooltip": "Let the agent propose knowledge-base changes: add or update sources, ingest uploaded files, retrain.",
  "cfg_tsec_sa_contacts_label": "Contacts & beneficiaries",
  "cfg_tsec_sa_contacts_tooltip": "Look up and manage contact and beneficiary records. Destructive operations always require your approval.",
  "cfg_tsec_sa_operations_label": "Automations & channels",
  "cfg_tsec_sa_operations_tooltip": "Agent settings, webhook automations, integrations, and channel status.",
  "cfg_tsec_other_label": "Other tools",
  "cfg_tsec_other_tooltip": "Recently added tools that haven't been categorized yet.",
  "cfg_tsec_enabled_count": "{{enabled}} of {{total}} on",
  "cfg_tool_col_tool": "Tool",
  "cfg_tool_col_approval": "Approval",
  "cfg_tool_col_enabled": "Enabled",
  "cfg_tool_agents_assistant": "Assistant",
  "cfg_tool_agents_system_agent": "System agent",
  "cfg_tool_agents_both": "Both",
  "cfg_tool_section_bulk_aria": "Toggle all {{section}} tools",
  "cfg_tool_row_config_aria": "Configure {{tool}}",
  "cfg_tool_requires_approval_aria": "Require approval for {{tool}}",
  "cfg_tool_enabled_aria": "Enable {{tool}}",
  "cfg_tool_collect_lead_disabled_hint": "Enable this tool to define which lead fields the assistant collects.",
  "cfg_tool_collect_lead_misconfigured": "Add at least one field below — the LLM cannot collect leads without a defined schema, and the config cannot be saved while this tool is enabled with no fields.",
  "cfgpage_apply_import": "Apply Import",
  "cfgpage_applying": "Applying…",
  "cfgpage_calendar_columns_description": "Columns shown on the calendar/data table page",
  "cfgpage_calendar_columns_title": "Calendar Columns",
  "cfgpage_choose_sections_to_import": "Choose sections to import",
  "cfgpage_configuration_sections_aria": "Configuration sections",
  "cfgpage_documents_columns_description": "Columns shown on the documents page",
  "cfgpage_documents_columns_title": "Documents Columns",
  "cfgpage_drop_to_import": "Drop to import",
  "cfgpage_export_failed": "Failed to export configuration: {{message}}",
  "cfgpage_failed_load_page": "Failed to load config page",
  "cfgpage_import_file_input_label": "Import configuration file",
  "cfgpage_import_parse_failed": "Failed to parse configuration: {{message}}",
  "cfgpage_import_tip_prefix": "Tip — use",
  "cfgpage_import_tip_suffix": "in the navigation to toggle entire sections at once.",
  "cfgpage_invalid_config_file": "Invalid configuration file",
  "cfgpage_release_to_import_config": "Release to import config",
  "cfgpage_section_ai_agents_description": "Configure multi-agent RAG answering: the researcher and verifier subagents that ground and fact-check knowledge-base answers",
  "cfgpage_section_ai_assistant_description": "Configure AI models, system prompts, and available tools",
  "cfgpage_section_appearance_description": "Choose the display languages available in your application",
  "cfgpage_section_business_description": "Configure business information, timezone, and regional settings",
  "cfgpage_section_calendar_display_description": "Customize how events appear, available views, time formats, and color schemes",
  "cfgpage_section_calendar_display_title": "Calendar Display",
  "cfgpage_section_columns_description": "Configure which columns are visible in data tables",
  "cfgpage_section_email_templates_description": "Create and manage email templates for your organization",
  "cfgpage_section_event_types_description": "Manage bookable event types — durations, capacity, booking rules, and colors",
  "cfgpage_section_eyebrow": "section",
  "cfgpage_section_notification_rules_description": "Configure when and how notifications are sent based on event lifecycle triggers. Each rule defines a trigger type, timing, target audience, and WhatsApp template.",
  "cfgpage_section_schedule_description": "Define working days, working hours, and custom calendar ranges",
  "cfgpage_select_fields_for_section": "Select fields for {{section}}",
  "cfgpage_selected_count": "{{count}} selected",
  "cfgpage_validation_fallback": "Validation",
  "chat_ai_disabled_tooltip": "AI disabled",
  "chat_ai_response_fallback": "AI response",
  "chat_clear_search_text": "Clear search text",
  "chat_close_search": "Close search",
  "chat_context_cache_hits": "Cache Hits",
  "chat_context_input": "Input",
  "chat_context_input_percent": "Input {{percent}}%",
  "chat_context_meter_summary": "Input: {{input}}%, Output: {{output}}%",
  "chat_context_output": "Output",
  "chat_context_output_percent": "Output {{percent}}%",
  "chat_context_total_cost": "Total Cost",
  "chat_document_action_added_suggestions_to": "Added suggestions to",
  "chat_document_action_adding_suggestions": "Adding suggestions",
  "chat_document_action_created": "Created",
  "chat_document_action_creating": "Creating",
  "chat_document_action_updated": "Updated",
  "chat_document_action_updating": "Updating",
  "chat_document_create_error": "Error creating document: {{error}}",
  "chat_document_for_document": "for document",
  "chat_document_shared_view_unsupported": "Viewing files in shared chats is currently not supported.",
  "chat_document_update_error": "Error updating document: {{error}}",
  "chat_edit_message_placeholder": "Edit your message",
  "chat_export_meta_contact": "Contact:",
  "chat_export_meta_exported": "Exported:",
  "chat_export_meta_messages": "Messages:",
  "chat_export_meta_phone": "Phone:",
  "chat_export_sender_assistant": "Assistant",
  "chat_export_sender_system_agent": "System Agent",
  "chat_export_sender_user": "User",
  "chat_export_sender_you": "You",
  "chat_image_attachment_alt": "Image attachment from message",
  "chat_invalid_document_output_format": "Invalid document output format",
  "chat_invalid_event_snapshot_format": "Invalid event snapshot format",
  "chat_invalid_interactive_buttons_input": "Invalid interactive buttons input",
  "chat_invalid_interactive_list_input": "Invalid interactive list input",
  "chat_interactive_selected_by_customer": "Selected by customer",
  "chat_invalid_suggestions_output_format": "Invalid suggestions output format",
  "chat_invalid_weather_data_format": "Invalid weather data format",
  "chat_metrics_activity": "Activity",
  "chat_metrics_audio_badge": "STT fallback",
  "chat_metrics_audio_duration": "Audio length",
  "chat_metrics_audio_fallback_description": "This voice message was converted to text because the selected chat model cannot accept audio.",
  "chat_metrics_audio_transcription": "Audio transcription",
  "chat_metrics_agent_role_main": "Main",
  "chat_metrics_agent_role_researcher": "Researcher",
  "chat_metrics_agent_role_verifier": "Verifier",
  "chat_metrics_cost": "Cost",
  "chat_metrics_estimated": "estimated",
  "chat_metrics_first_response": "First response",
  "chat_metrics_from_cache": "From cache",
  "chat_metrics_speed": "Speed",
  "chat_metrics_status": "Status",
  "chat_metrics_steps": "Steps",
  "chat_metrics_superseded": "Cancelled drafts",
  "chat_metrics_superseded_badge": "drafts merged",
  "chat_metrics_this_response": "This response",
  "chat_metrics_tokens": "Tokens",
  "chat_metrics_tool_calls": "Tool calls",
  "chat_metrics_total_time": "Total time",
  "chat_metrics_whole_chat": "Whole chat",
  "chat_next_match": "Next match",
  "chat_pasted_image_label": "Pasted image",
  "chat_attachment_upload_failed": "Failed to attach file",
  "chat_preview_file_label": "File",
  "chat_preview_image_label": "Image",
  "chat_previous_match": "Previous match",
  "chat_search_conversation": "Search conversation",
  "chat_search_jump_to_match": "Jump to match {{index}} of {{total}}",
  "chat_search_results_rail": "Search results",
  "chat_select_action": "Select",
  "chat_send_char_count": "Send · {{charCount}}/{{characterLimit}}",
  "chat_send_short": "Send",
  "chat_shell_ask_anything": "Ask anything…",
  "chat_system_agent_header": "System Agent Chat",
  "chat_tool_approval_allow": "Allow",
  "chat_tool_approval_always_allow": "Always allow",
  "chat_tool_approval_always_allow_tooltip": "Approve now and stop requiring approval for this tool across your organization. You can re-enable it anytime in Config → AI Assistant.",
  "chat_tool_always_allow_success": "This tool will no longer require approval.",
  "chat_tool_always_allow_error": "Couldn't update the approval setting. Please try again.",
  "chat_tool_status_approved": "Approved",
  "chat_tool_status_denied": "Denied",
  "chat_tool_status_error": "Error",
  "chat_tool_status_running": "Running",
  "chat_weather_hourly_forecast": "Hourly Forecast",
  "chat_weather_now": "Now",
  "chat_weather_sunrise": "Sunrise:",
  "chat_weather_sunset": "Sunset:",
  "chat_web_preview_console": "Console",
  "dash_ai_performance": "AI Performance",
  "dash_ai_token_usage_title": "AI Token Usage",
  "dash_api_calls_count": "{{count}} API calls",
  "dash_avg_duration": "avg {{value}}",
  "dash_badge_avg": "AVG",
  "dash_badge_max": "MAX",
  "dash_badge_med": "MED",
  "dash_bookings_abbr": "bkn",
  "dash_calls_count": "{{count}} calls",
  "dash_cost_efficiency": "Cost Efficiency",
  "dash_cost_per_response": "{{cost}} / response",
  "dash_export_none_selected": "(none selected)",
  "dash_latency": "Latency",
  "dash_messages_abbr": "msg",
  "dash_no_ai_usage_data": "No AI usage data for this period.",
  "dash_no_word_data": "No word data available",
  "dash_rank_aria": "Rank {{count}}",
  "dash_runs_count": "{{count}} runs",
  "dash_token_usage_input": "Input",
  "dash_token_usage_output": "Output",
  "dash_tool_calls_ratio": "{{errors}} / {{total}} tool calls",
  "dash_tool_errors": "Tool Errors",
  "dash_tooltip_input_tokens": "Input: {{value}}",
  "dash_tooltip_output_tokens": "Output: {{value}}",
  "dash_top_n_words": "Top {{count}} words",
  "dash_total_cost": "Total Cost",
  "dash_elevenlabs_transcription_cost": "ElevenLabs transcription",
  "dash_elevenlabs_transcription_detail": "Included in total cost · {{count}} transcriptions",
  "dash_elevenlabs_transcription_explainer": "Used when Audio Read is enabled and the selected model cannot receive audio natively.",
  "dash_word_bar_tooltip": "Bar {{count}}, value: {{value}}",
  "dash_word_occurrences_aria": "{{word}}: {{count}} occurrences",
  "demo_avatar_number": "Avatar {{n}}",
  "demo_comments_count": "{{count}} comments",
  "demo_connect": "Connect",
  "demo_disconnect": "Disconnect",
  "demo_open_integration": "Open integration",
  "demo_nav_stack_intro": "One anchored surface that drills through a stack of views instead of opening a second floating layer. Each keeps its placement, dims or morphs rather than jumping, and unwinds one level at a time with Escape.",
  "demo_nav_stack_morph_caption": "The whole surface morphs into the next view — width and height ease between them. For filter and detail panels.",
  "demo_nav_stack_nested_caption": "Parents stay visible and dimmed behind the child card, offset to the row you clicked. For action and context menus.",
  "demo_nav_stack_panel_caption": "The same navigation inline, with no floating layer — the frame behind sheets and swap-view regions.",
  "demo_open_menu": "Open menu",
  "demo_or_divider": "OR",
  "demo_section_bento": "Bento",
  "demo_section_buttons_actions": "Buttons & Actions",
  "demo_section_faq": "FAQ",
  "demo_section_form_controls": "Form Controls",
  "demo_section_indicators": "Indicators",
  "demo_section_marketing_panel": "Marketing Panel",
  "demo_section_menu_pill": "Menu Pill",
  "demo_section_navigable_overlays": "Navigable Overlays",
  "demo_section_real_time": "Real-time",
  "demo_section_skeletons": "Skeletons",
  "demo_section_surfaces_cards": "Surfaces & Cards",
  "demo_send": "Send",
  "demo_sign_in_with_apple": "Sign In with Apple",
  "demo_sign_in_with_github": "Sign In with GitHub",
  "demo_sign_in_with_google": "Sign In with Google",
  "demo_toggle_checkbox": "Toggle checkbox",
  "demo_toggle_connection": "Toggle connection",
  "demo_toggle_radio": "Toggle radio",
  "demo_toggle_switch": "Toggle switch",
  "demo_unread_count": "{{count}} unread",
  "docs_back_to_docs_index": "Back to docs index",
  "docs_breadcrumb": "Breadcrumb",
  "docs_calendar_demo_delete_confirm": "Are you sure you want to delete the event '{{title}}'",
  "docs_calendar_demo_interactive_hint": "Interactive -- click dates to add, click events to remove, drag to move",
  "docs_calendar_demo_new_title_prompt": "Please enter a new title for your event",
  "docs_calendar_demo_weekends": "Weekends",
  "docs_chat_demo_attach_file": "Attach file",
  "docs_chat_demo_copy": "Copy",
  "docs_chat_demo_edit": "Edit",
  "docs_chat_demo_emoji": "Emoji",
  "docs_chat_demo_online": "Online",
  "docs_chat_demo_record_voice": "Record voice",
  "docs_chat_demo_send_message": "Send message",
  "docs_chat_demo_type_message": "Type message…",
  "docs_close_navigation": "Close navigation",
  "docs_copied": "Copied",
  "docs_copy_code": "Copy code",
  "docs_copy_page": "Copy page",
  "docs_data_grid_demo_click_to_edit": "Click a name to edit",
  "docs_data_grid_demo_contacts_shown": "Contacts · {{count}} shown",
  "docs_data_grid_demo_history": "History ↗",
  "docs_doc_not_found": "Doc not found",
  "docs_home": "Docs home",
  "docs_label": "Docs",
  "docs_language": "Language",
  "docs_link_to_section": "Link to this section",
  "docs_next": "Next",
  "docs_no_doc_exists_at": "No doc exists at \"{{slug}}\".",
  "docs_no_matches": "No matches.",
  "docs_on_this_page": "On this page",
  "docs_open_app": "Open app",
  "docs_page_navigation": "Page navigation",
  "docs_phone_connector_demo_all": "All",
  "docs_phone_connector_demo_all_countries": "All Countries",
  "docs_phone_connector_demo_country": "Country",
  "docs_phone_connector_demo_documents": "Documents",
  "docs_phone_connector_demo_favorites": "Favorites",
  "docs_phone_connector_demo_has_document": "Has Document",
  "docs_phone_connector_demo_no_contacts_match": "No contacts match the selected filters",
  "docs_phone_connector_demo_no_countries_found": "No countries found",
  "docs_phone_connector_demo_no_document": "No Document",
  "docs_phone_connector_demo_no_matches_for": "No matches for \"{{search}}\"",
  "docs_phone_connector_demo_recent": "Recent",
  "docs_phone_connector_demo_registered": "Registered",
  "docs_phone_connector_demo_remove_filter": "Remove filter",
  "docs_phone_connector_demo_search_contacts": "Search contacts…",
  "docs_phone_connector_demo_search_countries": "Search countries…",
  "docs_phone_connector_demo_selected": "Selected",
  "docs_phone_connector_demo_status": "Status",
  "docs_phone_connector_demo_unregistered": "Unregistered",
  "docs_previous": "Previous",
  "docs_search_docs": "Search docs",
  "docs_search_documentation_ellipsis": "Search documentation…",
  "docs_search_ellipsis": "Search…",
  "docs_skip_to_content": "Skip to content",
  "docs_switch_to_dark_theme": "Switch to dark theme",
  "docs_switch_to_light_theme": "Switch to light theme",
  "docs_tab_n": "Tab {{n}}",
  "docs_tabs": "Tabs",
  "docs_toggle_navigation": "Toggle navigation",
  "evt_active_toggle_note": "Inactive types are hidden from new-booking pickers but kept for historical records.",
  "evt_add_event_type": "Add event type",
  "evt_after_buffer_label": "After buffer (minutes)",
  "evt_allow_multiple_future_label": "Allow multiple future events",
  "evt_allow_multiple_future_tooltip": "Whether ONE contact may hold more than one upcoming event of this type. Off (the default) limits each contact to one: booking another moves that contact's existing event to the new time instead of adding a second.",
  "evt_allow_multiple_per_day_label": "Allow multiple events per day",
  "evt_allow_multiple_per_day_tooltip": "Whether a contact's several upcoming events of this type may fall on the same day. When off, each contact is limited to one per calendar day, so their bookings must be spread across different days.",
  "evt_background_colour_label": "Background colour",
  "evt_background_colour_tooltip": "Background fill for conversation events on the calendar.",
  "evt_before_buffer_label": "Before buffer (minutes)",
  "evt_booking_horizon_label": "Booking horizon (days)",
  "evt_booking_horizon_tooltip": "How far into the future this persona can book events of this type, counted in calendar days from today. Leave blank for no limit.",
  "evt_color_conflict_hint": "Events of these types may be hard to tell apart on the calendar.",
  "evt_color_conflict_multiple": "Other event types already use very similar color schemes:",
  "evt_color_conflict_single": "Another event type already uses a very similar color scheme:",
  "evt_colors_fallback_note": "Any empty field falls back to the ring color, then to the org theme default.",
  "evt_colors_label": "Colors",
  "evt_colors_tooltip": "Background fill, ring/border, and text label render independently so each event can keep high contrast. Leave any field empty to inherit the org theme default.",
  "evt_coming_soon": "Coming soon",
  "evt_custom_fields_coming_soon_description": "Add per-event-type fields (text, number, date, select, etc.) that surface as data-table columns and validate incoming bookings.",
  "evt_custom_fields_save_first": "Save this event type first to start adding custom fields.",
  "evt_custom_fields_title": "Custom fields",
  "evt_deactivate_bookings_preserved": "{{count}} existing bookings will be preserved, but no new bookings of this type can be created.",
  "evt_deactivate_confirm": "Are you sure you want to deactivate “{{label}}”? This will be applied when you click the page-level Save.",
  "evt_deactivate_no_bookings": "No bookings use this type yet. Deactivation hides it from the create form but retains the historical record.",
  "evt_deactivate_title": "Deactivate event type",
  "evt_description_hint": "Shown to the AI assistant so it can share these details with guests — write price/details here.",
  "evt_description_label": "Description",
  "evt_resource_hint": "Group this type under a resource (a chalet, room, chair, ...). The calendar can then be scoped to one resource at a time.",
  "evt_resource_label": "Resource",
  "evt_resource_placeholder": "None",
  "evt_resource_new": "New resource…",
  "evt_resource_new_placeholder": "Resource name",
  "evt_resource_occupancy_label": "Maximum occupancy",
  "evt_resource_occupancy_hint": "How many bookings this resource holds at the same time, across every event type on it. Types on the same resource block each other only once this is reached. Shared by every type on the resource.",
  "evt_resource_occupancy_unlimited": "No limit",
  "calendar_occupancy_title": "Calendar occupancy",
  "calendar_occupancy_description": "Event types without a resource share the calendar: they block each other only once this many bookings overlap. Types on a resource use that resource's maximum occupancy instead.",
  "calendar_occupancy_label": "Maximum occupancy",
  "evt_drawer_description_conversation": "System-managed conversation events. Only label and background colour are editable.",
  "evt_drawer_description_scheduled": "Configure label, duration, capacity, and custom fields. Changes save with the page-level Save button.",
  "evt_drawer_title_edit": "Edit “{{label}}”",
  "evt_drawer_title_edit_conversation": "Edit conversation event",
  "evt_drawer_title_new": "New event type",
  "evt_invalid_draft_title": "This event type can't be saved yet",
  "evt_invalid_draft_description": "Some values are invalid, so these changes can't be queued for saving:",
  "evt_invalid_draft_discard": "Discard changes",
  "evt_row_pending_new": "New",
  "evt_row_pending_edited": "Modified",
  "evt_row_pending_removed": "Will be removed",
  "evt_duration_auto_computed_note": "Auto-computed from the org's slot duration ({{minutes}} min) and the max per-slot capacity.",
  "evt_duration_minutes_label": "Duration (minutes)",
  "evt_duration_minutes_tooltip": "How long bookings of this type run. Used to compute the end time and to block the slot from concurrent bookings.",
  "evt_duration_mode_auto_label": "Auto",
  "evt_duration_mode_label": "Duration mode",
  "evt_duration_mode_manual_label": "Manual",
  "evt_duration_mode_tooltip_auto_desc": "— derived from the org's slot duration divided by the max events per slot.",
  "evt_duration_mode_tooltip_manual_desc": "— fixed value you set below.",
  "evt_editor_heading": "Event types",
  "evt_editor_subtitle_advanced": "Click a card to edit duration, capacity, colors, and custom fields. Changes save with the page-level Save button.",
  "evt_editor_subtitle_standard": "Event types use the org-wide defaults (colors, slot duration, capacity). Switch to Advanced mode to customize them individually.",
  "evt_empty_state": "No event types yet. Create one to start taking bookings.",
  "evt_field_label_placeholder": "e.g. Priority",
  "evt_identifier_label": "Identifier",
  "evt_identifier_locked_note": "Identifier is locked once saved to avoid breaking existing bookings.",
  "evt_identifier_tooltip": "Stable programmatic key used by the API and calendar legend. Editable only while the event type is a draft.",
  "evt_label_placeholder": "e.g. Check Up",
  "evt_max_future_events_label": "Max future events per type",
  "evt_max_future_events_tooltip": "The total upcoming events of this type ONE contact may hold at once, whether or not they share a day ({{min}}–{{max}}).",
  "evt_max_per_slot_label": "Max per slot",
  "evt_max_per_slot_tooltip": "Maximum events this persona can schedule in a single time slot. Leave blank for unlimited.",
  "evt_max_span_label": "Allow multi-day bookings",
  "evt_max_span_nights_label": "Maximum nights",
  "evt_max_span_nights_tooltip": "The longest stay one booking of this type may cover, counted in nights.",
  "evt_max_span_tooltip": "Lets a booking of this type run over several nights, with the guest choosing a check-out date. The duration above becomes the shortest stay allowed.",
  "evt_min_notice_label": "Minimum booking notice (minutes)",
  "evt_min_notice_tooltip": "The shortest allowed gap between the booking request time and the scheduled start time.",
  "evt_no_custom_fields": "No custom fields yet. Add one below to extend the booking form and data-table columns.",
  "evt_queue_deactivation": "Queue deactivation",
  "evt_queue_field": "Queue field",
  "evt_queued_badge": "Queued",
  "evt_queued_fields_save_note": "Queued fields save with the page-level Save button.",
  "evt_requires_approval_label": "Require owner approval",
  "evt_requires_approval_tooltip": "New bookings of this type stay pending (and hold their dates) until you approve them.",
  "evt_requires_approval_ttl_label": "Approval window (hours)",
  "evt_requires_approval_ttl_tooltip": "How long a pending booking holds its dates before it lapses. Leave empty to hold until you act.",
  "evt_role_agent_label": "AI Agent",
  "evt_role_agent_tooltip": "Limits for events scheduled by the AI assistant or automated workflows.",
  "evt_role_secretary_label": "Secretary / UI",
  "evt_role_secretary_tooltip": "Limits for events scheduled manually via the calendar UI or secretary operations.",
  "evt_scheduling_stub_intro": "Advanced scheduling rules ship in a follow-up release. The controls below are placeholders for visibility.",
  "evt_show_in_grid": "Show in grid",
  "evt_similar_colors_detected": "Similar colors detected",
  "evt_soon_badge": "Soon",
  "evt_status_pending": "Pending approval",
  "evt_stub_booking_limits_description": "Cap how many bookings of this type can be taken per day / week / month.",
  "evt_stub_booking_limits_title": "Booking limits",
  "evt_stub_recurrence_description": "Let attendees book a recurring series in one step — daily / weekly / monthly.",
  "evt_stub_recurrence_title": "Recurrence",
  "evt_stub_seats_description": "Group bookings where one time slot holds multiple attendees (inspired by Cal.com's seat feature).",
  "evt_stub_seats_title": "Seats per time slot",
  "evt_system_event_type": "System event type.",
  "evt_system_event_type_description": "Conversations are tracked automatically. You can re-label this row and pick a calendar colour, but capacity and duration are not configurable.",
  "evt_tab_basics": "Basics",
  "evt_tab_duration": "Duration",
  "evt_tab_rules": "Rules",
  "evt_toast_add_field_failed": "Failed to add field",
  "evt_toast_add_field_success": "Event field added.",
  "evt_toast_deactivate_failed": "Failed to deactivate event type",
  "evt_toast_deactivate_success": "Event type removed.",
  "evt_toast_id_required": "EventType id is required",
  "evt_toast_org_required_add_field": "Active organization is required to add event field",
  "evt_toast_org_required_deactivate": "Active organization is required to deactivate event type",
  "evt_toast_org_required_flush": "Active organization is required to save event types",
  "evt_toast_org_required_generic": "Active organization is required",
  "evt_toast_org_required_list": "Active organization is required to load event types",
  "evt_toast_org_required_remove_field": "Active organization is required to remove event field",
  "evt_toast_org_required_reorder": "Active organization is required to reorder event types",
  "evt_toast_org_required_reorder_fields": "Active organization is required to reorder event fields",
  "evt_toast_org_required_save": "Active organization is required to save event type",
  "evt_toast_org_required_update_field": "Active organization is required to update event field",
  "evt_toast_remove_field_failed": "Failed to remove field",
  "evt_toast_remove_field_success": "Event field removed.",
  "evt_toast_reorder_failed": "Failed to reorder event types",
  "evt_toast_reorder_success": "Event types reordered.",
  "evt_toast_reorder_fields_failed": "Failed to reorder fields",
  "evt_toast_reorder_fields_success": "Event fields reordered.",
  "evt_toast_save_failed": "Failed to save event type",
  "evt_toast_save_success": "Event type saved.",
  "evt_toast_update_field_failed": "Failed to update field",
  "evt_toast_update_field_success": "Event field updated.",
  "feat_admin_org_balance_add_credits_button": "Add credits",
  "feat_admin_org_balance_all_loaded": "All loaded",
  "feat_admin_org_balance_column_balance": "Balance",
  "feat_admin_org_balance_column_credits_delta": "Δ Credits",
  "feat_admin_org_balance_column_description": "Description",
  "feat_admin_org_balance_column_kind": "Kind",
  "feat_admin_org_balance_column_usd_delta": "USD Δ",
  "feat_admin_org_balance_column_when": "When",
  "feat_admin_org_balance_credit_dialog_description": "Manually add credits to this organization. Recorded as a CREDIT_MANUAL transaction with you as the actor.",
  "feat_admin_org_balance_credit_dialog_title": "Credit organization",
  "feat_admin_org_balance_crediting_ellipsis": "Crediting...",
  "feat_admin_org_balance_credits_placeholder": "e.g. 1000",
  "feat_admin_org_balance_credits_to_add_label": "Credits to add",
  "feat_admin_org_balance_empty_all": "No balance transactions yet.",
  "feat_admin_org_balance_empty_filtered": "No transactions match this filter.",
  "feat_admin_org_balance_filter_all": "All",
  "feat_admin_org_balance_filter_debits": "Debits",
  "feat_admin_org_balance_filter_direction": "Direction",
  "feat_admin_org_balance_kind_adjustment_minus": "Adjustment −",
  "feat_admin_org_balance_kind_adjustment_plus": "Adjustment +",
  "feat_admin_org_balance_loaded_count": "{{count}} transactions loaded",
  "feat_admin_org_balance_reason_label": "Reason (optional)",
  "feat_admin_org_balance_reason_placeholder": "e.g. Onboarding starter credits",
  "feat_admin_org_balance_search_placeholder": "Search ledger…",
  "feat_admin_plans_add_row_button": "Add row",
  "feat_admin_plans_column_model": "Model",
  "feat_admin_plans_column_usd_micros": "USD-micros",
  "feat_admin_plans_create_draft_button": "Create draft",
  "feat_admin_plans_created_on": "created {{date}}",
  "feat_admin_plans_new_draft_description": "Clones pricing from the latest version of the slug. New rates become live when you publish.",
  "feat_admin_plans_new_draft_title": "New draft",
  "feat_admin_plans_no_notes": "No notes",
  "feat_admin_plans_no_plans": "No plans yet.",
  "feat_admin_plans_no_pricing_rows": "No pricing rows.",
  "feat_admin_plans_notes_label": "Notes",
  "feat_admin_plans_notes_placeholder": "Optional reason or context for this version",
  "feat_admin_plans_phase_out_button": "Phase out",
  "feat_admin_plans_pricing_invalid": "Each row needs a unique model, non-negative whole credits, and non-negative USD-micros.",
  "feat_admin_plans_publish_button": "Publish",
  "feat_admin_plans_remove_row_button": "Remove pricing row",
  "feat_admin_plans_save_before_publish": "Save pricing changes before publishing this version.",
  "feat_admin_plans_save_pricing_button": "Save pricing",
  "feat_admin_plans_slug_placeholder": "e.g. standard",
  "feat_admin_plans_slug_invalid": "Use at most 64 lowercase letters, digits, and single dashes only.",
  "feat_admin_plans_status_draft": "Draft",
  "feat_admin_plans_status_phased_out": "Phased out",
  "feat_admin_plans_status_published": "Published",
  "feat_billing_ai_spend_by_member_assistant": "Customer messaging assistant",
  "feat_billing_ai_spend_by_member_description": "Inference spend attributed to each member over the period.",
  "feat_billing_next_invoice_bill_date": "Estimated bill date",
  "feat_billing_next_invoice_title": "Your next bill",
  "feat_billing_next_invoice_unnamed_line": "Subscription charge",
  "feat_billing_usage_ai_cost_label": "AI cost (this month)",
  "feat_billing_usage_chart_cap_label": "Plan cap",
  "feat_billing_usage_chart_description": "Daily inference spend over the current billing period.",
  "feat_billing_usage_chart_range_all": "All time",
  "feat_billing_usage_chart_range_month": "This month",
  "feat_billing_usage_chart_title": "Daily AI cost",
  "feat_billing_usage_models_column_cache_read": "Cache read",
  "feat_billing_usage_models_column_cache_write": "Cache write",
  "feat_billing_usage_models_column_cost": "Cost",
  "feat_billing_usage_models_column_input": "Input",
  "feat_billing_usage_models_column_model": "Model",
  "feat_billing_usage_models_column_output": "Output",
  "feat_billing_usage_models_column_total": "Total tokens",
  "feat_billing_usage_models_description": "Per-model LLM usage with token counts, cache reads, and API cost.",
  "feat_billing_usage_models_title": "Usage by model",
  "feat_billing_usage_models_total_row": "Total",
  "feat_billing_usage_projected_label": "Projected end-of-month",
  "feat_billing_usage_upgrade_cta": "Upgrade to {{plan}}",
  "feat_calendar_density_compact": "Compact",
  "feat_calendar_density_default": "Default",
  "feat_calendar_density_spacious": "Spacious",
  "feat_component_style_embossed": "Embossed",
  "feat_component_style_flat": "Flat",
  "feat_documents_canvas_load_failed": "Failed to load document canvas.",
  "feat_documents_init_failed": "Failed to initialize document",
  "feat_documents_save_failed": "Failed to save document",
  "feat_documents_snapshot_damaged": "This document's data is damaged and can't be opened.",
  "feat_documents_snapshot_load_failed": "Failed to load snapshot",
  "feat_documents_snapshot_newer_version": "This document was saved by a newer version of the app. Refresh to update, then try again.",
  "feat_documents_tldraw_init_failed": "Unable to initialize TLDraw store.",
  "feat_documents_update_age_failed": "Failed to update user age",
  "feat_documents_update_name_failed": "Failed to update user name",
  "feat_documents_version_not_loaded": "Document version not loaded; cannot save",
  "feat_documents_viewport_save_failed": "Failed to save document viewport",
  "feat_fullscreen": "Fullscreen",
  "feat_language_switched_to_english": "Switched to English",
  "feat_org_balance_balance_label": "balance",
  "feat_org_balance_col_amount": "Amount",
  "feat_org_balance_col_balance": "Balance",
  "feat_org_balance_col_date": "Date",
  "feat_org_balance_col_description": "Description",
  "feat_org_balance_col_model": "Model",
  "feat_org_balance_col_usd": "USD",
  "feat_org_balance_credits_description": "AI responses are debited from this balance. Top-ups are applied by your platform admin.",
  "feat_org_balance_credits_title": "Credits",
  "feat_org_balance_credits_unit": "credits",
  "feat_org_balance_filter_model": "AI model",
  "feat_org_balance_kind_adjustment": "Adjustment",
  "feat_org_balance_kind_ai_usage": "AI usage",
  "feat_org_balance_kind_credit_manual": "Manual credit",
  "feat_org_balance_kind_payment": "Payment",
  "feat_org_balance_kind_refund": "Refund",
  "feat_org_balance_load_more": "Load more",
  "feat_org_balance_no_transactions": "No transactions yet.",
  "feat_org_balance_no_transactions_filtered": "No transactions match the filters.",
  "feat_org_balance_transactions_description": "Every credit change for this organization, newest first.",
  "feat_org_balance_transactions_title": "Credit transactions",
  "feat_org_balance_view_transactions": "View transactions",
  "feat_role_collapse_category": "Collapse {{label}}",
  "feat_role_expand_category": "Expand {{label}}",
  "feat_role_name_placeholder": "e.g. Editor",
  "feat_role_no_permissions": "No permissions available",
  "feat_role_permission_aria": "{{title}} permission",
  "feat_theme_changed_to": "Theme changed to {{theme}}",
  "feat_untitled_template": "Untitled template",
  "feat_vacation_delete_period_confirm": "Are you sure you want to delete {{periodLabel}}? This action cannot be undone.",
  "feat_vacation_delete_template_aria": "Delete template",
  "feat_vacation_delete_template_confirm": "Delete template \"{{templateLabel}}\"? This action cannot be undone.",
  "feat_vacation_delete_template_title": "Delete vacation template",
  "feat_vacation_edit_template_aria": "Edit template",
  "feat_vacation_message_label": "Vacation message",
  "feat_vacation_message_optional_placeholder": "Vacation message (optional)",
  "feat_vacation_message_write_placeholder": "Write the vacation message...",
  "feat_vacation_no_periods_hint": "Add a period to pause bookings",
  "feat_vacation_no_templates": "No templates yet",
  "feat_vacation_save_current_as_template": "+ Save current message as template",
  "feat_vacation_save_template": "Save template",
  "feat_vacation_template_default_name": "Vacation template",
  "feat_vacation_template_dialog_desc": "Save a short label and reusable vacation message.",
  "feat_vacation_template_edit_title": "Edit vacation template",
  "feat_vacation_template_label_short": "Template",
  "feat_vacation_template_name_label": "Template name",
  "feat_vacation_template_name_placeholder": "e.g. Holiday closure",
  "feat_vacation_template_save_title": "Save vacation template",
  "grid_add_button": "Add",
  "grid_choose_type": "Choose type",
  "grid_date_time_label": "Date & time",
  "grid_end_date_time_label": "End date & time",
  "grid_edit_event_title": "Edit event",
  "grid_event_type_aria": "Event type",
  "grid_events_export_title": "Events",
  "grid_new_event_title": "New event",
  "grid_no_events_for_date": "No events for this date.",
  "grid_ready_to_save": "Ready to save",
  "grid_validation_error_count": "{{count}} validation errors",
  "grid_validation_event_type_required": "Event type is required.",
  "grid_validation_phone_required": "Phone number is required.",
  "grid_validation_checkout_after": "Event end must be after the event start.",
  "grid_validation_checkout_not_allowed": "This event type has a fixed length, so an end time can't be chosen for it. Pick the start only.",
  "grid_validation_checkout_too_early": "The shortest booking of this type ends {{minimum}}. Choose that end or a later one.",
  "grid_validation_span_too_long": "This event type can be booked for at most {{max}} night(s); this one is {{nights}}.",
  "grid_span_hint": "Ends {{earliest}} at the earliest, up to {{max}} night(s).",
  "grid_span_hint_nights": "Pick a start, then an end up to {{max}} night(s) later.",
  "grid_validation_scheduled_time_required": "Scheduled time is required.",
  "landing_analytics_14day_trend": "14-day trend",
  "landing_analytics_this_month": "This month",
  "landing_analytics_vs_last_14days": "vs. last 14 days",
  "landing_cal_booking_count": "{{count}} booking",
  "landing_cal_day_aria": "Day {{day}}",
  "landing_cal_no_bookings": "no bookings",
  "landing_cal_open_day": "Open day · pick another date on the right",
  "landing_cal_today_schedule": "Today's schedule",
  "landing_chat_send": "Send",
  "landing_docs_annotate_page": "Annotate the page",
  "landing_explore_screenshot_soon": "Screenshot coming soon",
  "landing_flow_appointments": "Appointments",
  "landing_flow_appointments_desc": "Auto-Scheduled",
  "landing_flow_conn_appt": "AI books for customers",
  "landing_flow_conn_insights": "Everything tracked",
  "landing_flow_conn_kb": "AI answers from your docs",
  "landing_flow_insights": "Insights",
  "landing_flow_insights_desc": "Live Dashboard",
  "landing_flow_kb": "Knowledge Base",
  "landing_flow_kb_desc": "Your Business Docs",
  "landing_flow_messages": "Messages",
  "landing_flow_messages_desc": "Customer Conversations",
  "landing_hero_trust_conversations": "customer conversations handled",
  "landing_hero_trust_conversion": "resolved without a human",
  "landing_hero_trust_always_on": "always-on coverage",
  "landing_hero_trust_reply_speed": "starts replying in",
  "landing_kb_ingest_docs": "Ingest the source documents",
  "landing_pricing_toggle_aria": "Toggle annual billing",
  "landing_testimonials_aria": "Customer testimonials",
  "landing_uc_problem": "The problem",
  "landing_uc_solution": "The solution",
  "uc_support_eyebrow": "Customer Support",
  "uc_support_hero_prefix": "Resolve",
  "uc_support_hero_em": "69% of support questions",
  "uc_support_hero_suffix": "before a human ever sees them.",
  "uc_support_hero_sub": "Bavard answers from your help centre, looks things up, and closes the ticket in the chat. Your team only picks up what actually needs a person — on your website, WhatsApp, or wherever customers write.",
  "uc_support_hero_cta": "Start free trial",
  "uc_support_hero_cta2": "See a support demo",
  "uc_support_demo_name": "Support",
  "uc_support_demo_sub": "WhatsApp · online",
  "uc_support_demo_m1": "Hi — my order #4821 still says processing.",
  "uc_support_demo_m2": "It shipped this morning and is out for delivery today. Want the tracking link?",
  "uc_support_demo_m3": "Yes please",
  "uc_support_demo_m4": "Sent — it's in your email too.",
  "uc_support_demo_time": "9:12 PM",
  "uc_support_demo_card_title": "Resolved in one thread",
  "uc_support_demo_card_l1": "Order #4821 · out for delivery",
  "uc_support_demo_card_l2": "No agent needed",
  "uc_support_problems_title": "Sound familiar?",
  "uc_support_problems_sub": "Most support volume isn't hard — it's repetitive, and it arrives when nobody's watching the inbox.",
  "uc_support_problem1_title": "The same ten questions, all day",
  "uc_support_problem1_body": "Where's my order, how do refunds work, how do I reset my password. Easy answers, asked a hundred times a day, eating the hours your team should spend on the hard tickets.",
  "uc_support_problem2_title": "Customers write after you clock off",
  "uc_support_problem2_body": "Evenings, weekends, other time zones. A question that sits unanswered until morning is a customer who has already opened a competitor's chat.",
  "uc_support_problem3_title": "Escalations arrive with no context",
  "uc_support_problem3_body": "When a bot does hand over, your agent starts from zero — re-reading the thread, re-asking for the order number, and apologising for both.",
  "uc_support_solutions_title": "How Bavard handles your support",
  "uc_support_solutions_sub": "One agent trained on your own content — answering, resolving, and knowing exactly when to step aside.",
  "uc_support_sol1_kicker": "Grounded answers",
  "uc_support_sol1_title": "Answers from your real documents — never invented",
  "uc_support_sol1_body": "Upload your help centre, policies, and pricing once. The agent cross-references every file to compile one accurate reply and cites where it came from, so it never makes up a policy or a price.",
  "uc_support_sol1_b1": "Cites your uploaded docs on every answer",
  "uc_support_sol1_b2": "Says “I'll check with the team” instead of guessing",
  "uc_support_sol1_demo_title": "Support knowledge base",
  "uc_support_sol1_demo_cited": "“Refunds are accepted within 30 days of delivery, no reason required.” — from Refund policy.pdf",
  "uc_support_sol1_file1": "Refund policy",
  "uc_support_sol1_file2": "Help centre export",
  "uc_support_sol1_file3": "Shipping & delivery FAQ",
  "uc_support_sol2_kicker": "Around the clock",
  "uc_support_sol2_title": "Every message answered in seconds, at any hour",
  "uc_support_sol2_body": "The agent replies in under four seconds on every channel you connect — website chat, WhatsApp, Telegram, Messenger — in Arabic or English, matching whichever language the customer used.",
  "uc_support_sol2_b1": "One agent, one knowledge base, every channel",
  "uc_support_sol2_b2": "Switches language mid-conversation if the customer does",
  "uc_support_sol2_demo_sub": "WhatsApp · 3:42 AM",
  "uc_support_sol2_demo_m1": "Is my subscription still active?",
  "uc_support_sol2_demo_m2": "It is — active until 16 Feb, renewing monthly. Want me to switch you to annual and save 20%?",
  "uc_support_sol2_demo_m3": "No thanks, just checking",
  "uc_support_sol2_demo_m4": "No problem — anything else, I'm here.",
  "uc_support_sol2_demo_card_title": "Answered at 3:42 AM",
  "uc_support_sol2_demo_card_l1": "First reply in 2.1s",
  "uc_support_sol2_demo_card_l2": "Zero agents online",
  "uc_support_sol3_kicker": "Clean handoff",
  "uc_support_sol3_title": "Escalates to a human with the whole thread",
  "uc_support_sol3_body": "When a request goes beyond the agent's scope, it hands the conversation to your team in the shared inbox — full transcript, customer details, and what it already tried. Your agent picks up mid-sentence, not from scratch.",
  "uc_support_sol3_b1": "Full transcript and context on every escalation",
  "uc_support_sol3_b2": "Take over any conversation at any point",
  "uc_support_sol3_demo_title": "Shared inbox · today",
  "uc_support_sol3_row1_title": "Order #4821 · delivery status",
  "uc_support_sol3_row1_sub": "Resolved by the agent",
  "uc_support_sol3_row2_title": "Damaged item · wants a replacement",
  "uc_support_sol3_row2_sub": "Escalated to Nour · full context attached",
  "uc_support_sol3_row3_title": "Password reset",
  "uc_support_sol3_row3_sub": "Resolved by the agent",
  "uc_support_sol3_row4_title": "Bulk order enquiry",
  "uc_support_sol3_row4_sub": "Routed to sales",
  "uc_support_outcome_title": "What support teams get with Bavard",
  "uc_support_outcome_sub": "Fewer repetitive tickets, faster first replies, and a team that only touches the work worth their time.",
  "uc_support_outcome1_label": "to first reply — day, night, weekend",
  "uc_support_outcome2_label": "coverage — evenings, weekends, holidays",
  "uc_support_outcome3_label": "switched mid-conversation, with no handoff",
  "uc_support_cta_title": "Ready to stop answering the same question twice?",
  "uc_support_cta_sub": "Spin up a support agent trained on your own content in under an hour — no engineers, no setup calls.",
  "uc_support_cta_button": "Start free trial",
  "uc_sales_eyebrow": "Sales & Lead Generation",
  "uc_sales_hero_prefix": "Answer every lead in",
  "uc_sales_hero_em": "under 4 seconds",
  "uc_sales_hero_suffix": "— and book the meeting while it's still warm.",
  "uc_sales_hero_sub": "Bavard answers product and pricing questions in seconds, qualifies the lead in the conversation, and drops the meeting straight onto your reps' calendars — day, night, and weekends.",
  "uc_sales_hero_cta": "Start free trial",
  "uc_sales_hero_cta2": "See a sales demo",
  "uc_sales_demo_name": "Sales",
  "uc_sales_demo_sub": "Website chat · online",
  "uc_sales_demo_m1": "How much is it for a team of 40?",
  "uc_sales_demo_m2": "On Premium that's $39 per user / month annually — $1,560 a month. Want 15 minutes with someone to walk through it?",
  "uc_sales_demo_m3": "Sure, Thursday afternoon works",
  "uc_sales_demo_m4": "Booked — invite on its way.",
  "uc_sales_demo_time": "10:41 PM",
  "uc_sales_demo_card_title": "Demo booked",
  "uc_sales_demo_card_l1": "Thu 16 Jan · 3:00 PM",
  "uc_sales_demo_card_l2": "40 seats · Premium",
  "uc_sales_problems_title": "Sound familiar?",
  "uc_sales_problems_sub": "The pipeline is there — it leaks between the first question and the first meeting.",
  "uc_sales_problem1_title": "Leads go cold waiting for a reply",
  "uc_sales_problem1_body": "Someone asks about pricing at 9 PM. By the time a rep answers tomorrow, they've already booked a call with whoever replied first.",
  "uc_sales_problem2_title": "Reps spend their day on unqualified chats",
  "uc_sales_problem2_body": "Half the enquiries were never going to buy. Sorting them by hand is the most expensive way to find that out.",
  "uc_sales_problem3_title": "Follow-ups quietly stop happening",
  "uc_sales_problem3_body": "The deal that went quiet after the demo is the easiest revenue you're leaving on the table — every single month.",
  "uc_sales_solutions_title": "How Bavard works your pipeline",
  "uc_sales_solutions_sub": "One agent that answers, qualifies, books, and follows up — before a rep opens their laptop.",
  "uc_sales_sol1_kicker": "Never lose a lead",
  "uc_sales_sol1_title": "Answer in seconds, capture the contact instantly",
  "uc_sales_sol1_body": "The moment someone messages — website widget, WhatsApp, Instagram — the agent answers with real product and pricing detail and saves the contact to your CRM, before they cool off or message a competitor.",
  "uc_sales_sol1_b1": "Replies 24/7 across every connected channel",
  "uc_sales_sol1_b2": "Saves the contact the moment they message",
  "uc_sales_sol1_demo_sub": "Instagram · new lead",
  "uc_sales_sol1_demo_m1": "Do you integrate with our CRM?",
  "uc_sales_sol1_demo_m2": "We do — two-way sync, plus a REST API on Premium. What are you using today?",
  "uc_sales_sol1_demo_m3": "HubSpot, about 40 seats",
  "uc_sales_sol1_demo_m4": "Perfect fit — saved your details so nothing gets lost.",
  "uc_sales_sol1_demo_card_title": "Lead captured",
  "uc_sales_sol1_demo_card_l1": "40 seats · HubSpot",
  "uc_sales_sol1_demo_card_l2": "Qualified · via Instagram",
  "uc_sales_sol2_kicker": "Qualify in the conversation",
  "uc_sales_sol2_title": "Only the real ones reach a rep",
  "uc_sales_sol2_body": "The agent asks the questions you'd ask — team size, budget, timeline, current stack — scores the lead against your rules, and routes it. Good fits get a meeting; the rest get a helpful answer and a nurture sequence.",
  "uc_sales_sol2_b1": "Your qualifying questions, asked every time",
  "uc_sales_sol2_b2": "Routes by fit — meeting, nurture, or self-serve",
  "uc_sales_sol2_demo_title": "Pipeline · today",
  "uc_sales_sol2_row1_title": "Acme Co · 40 seats",
  "uc_sales_sol2_row1_sub": "Qualified → demo booked Thu 3 PM",
  "uc_sales_sol2_row2_title": "Solo freelancer",
  "uc_sales_sol2_row2_sub": "Routed to self-serve signup",
  "uc_sales_sol2_row3_title": "Northwind · 200 seats",
  "uc_sales_sol2_row3_sub": "Escalated to enterprise rep",
  "uc_sales_sol2_row4_title": "Studio Ten · evaluating",
  "uc_sales_sol2_row4_sub": "Nurture sequence started",
  "uc_sales_sol3_kicker": "Follow-ups that happen",
  "uc_sales_sol3_title": "Chases every deal that goes quiet",
  "uc_sales_sol3_body": "Bavard notices when a thread stalls and follows up — friendly, on-brand, in the lead's own language — until they reply or opt out. The revenue you already earned attention for doesn't quietly walk away.",
  "uc_sales_sol3_b1": "Automatic follow-up on stalled conversations",
  "uc_sales_sol3_b2": "Re-books no-shows without a rep lifting a finger",
  "uc_sales_sol3_demo_sub": "WhatsApp · follow-up",
  "uc_sales_sol3_demo_m1": "Hi Noor — you asked about the 40-seat plan last week. Still want that walkthrough?",
  "uc_sales_sol3_demo_m2": "Yes! Sorry, got buried. Friday?",
  "uc_sales_sol3_demo_m3": "Friday 11:00 it is — invite sent.",
  "uc_sales_sol3_demo_card_title": "Deal revived",
  "uc_sales_sol3_demo_card_l1": "Fri 17 Jan · 11:00 AM",
  "uc_sales_sol3_demo_card_l2": "Reactivated after 7 days",
  "uc_sales_outcome_title": "What sales teams get with Bavard",
  "uc_sales_outcome_sub": "Warmer leads, fuller calendars, and follow-ups that happen whether or not anyone remembers.",
  "uc_sales_outcome1_label": "leads left waiting overnight",
  "uc_sales_outcome2_label": "qualifying and booking across every channel",
  "uc_sales_outcome3_label": "every channel, one agent, one history",
  "uc_sales_cta_title": "Ready to stop losing leads to a slow reply?",
  "uc_sales_cta_sub": "Launch a sales agent trained on your own content in under an hour — no engineers, no setup calls.",
  "uc_sales_cta_button": "Start free trial",
  "uc_status_open": "Open",
  "uc_status_booked": "Booked",
  "uc_status_full": "Full",
  "uc_status_waitlist": "Waitlist",
  "lib_org_slug_available": "Slug is available",
  "lib_org_slug_check_failed": "Couldn't check availability — please try again",
  "lib_org_slug_check_failed_retry": "Couldn't check availability — try again",
  "lib_org_slug_checking": "Checking availability…",
  "lib_org_slug_hint": "Lowercase letters, digits, and dashes. 1–50 characters.",
  "lib_org_slug_invalid": "Invalid slug",
  "lib_org_slug_required": "Slug is required",
  "lib_org_slug_taken": "That slug is already taken",
  "lib_phone_combobox_required": "Phone combobox component required",
  "lib_phone_grid_editor_aria": "Phone",
  "lib_phone_select_placeholder": "Select a phone number",
  "lib_plan_guard_current_plan": "Current org plan",
  "lib_plan_guard_message": "Your organization plan does not include access to this page.",
  "lib_plan_guard_required_plan": "Required plan",
  "notif_reply_send_failed": "Failed to send",
  "page_accept_invitation_accept": "Accept",
  "page_accept_invitation_accept_failed": "Failed to accept invitation.",
  "page_accept_invitation_accepting": "Accepting…",
  "page_accept_invitation_administrator_fallback": "An administrator",
  "page_accept_invitation_as": "as",
  "page_accept_invitation_fetch_failed": "Failed to load invitation details.",
  "page_accept_invitation_go_to_sign_in": "Go to Sign In",
  "page_accept_invitation_has_invited": "has invited",
  "page_accept_invitation_load_failed": "This invitation could not be loaded. It may have expired or been revoked.",
  "page_accept_invitation_mismatch_middle": ", which does not match the invitation email (",
  "page_accept_invitation_mismatch_prefix": "Heads up: you are signed in as",
  "page_accept_invitation_mismatch_suffix": "). Sign out and sign in as the invited address to accept.",
  "page_accept_invitation_org_fallback": "an organization",
  "page_accept_invitation_payload_unexpected": "Invitation payload was unexpected. Please try again.",
  "page_accept_invitation_reject": "Reject",
  "page_accept_invitation_reject_failed": "Failed to reject invitation.",
  "page_accept_invitation_rejecting": "Rejecting…",
  "page_accept_invitation_status_prefix": "This invitation status is",
  "page_accept_invitation_status_suffix": ". It may have already been accepted or cancelled.",
  "page_accept_invitation_title": "Organization Invitation",
  "page_accept_invitation_to_join": "to join",
  "page_accept_invitation_your_account_fallback": "your account",
  "page_admin_description": "Manage organizations, members, and system health",
  "page_admin_eyebrow": "Superadmin",
  "page_admin_tab_feedback": "App Feedback",
  "page_admin_tab_plans": "Plans",
  "page_admin_tab_system": "System Health",
  "page_admin_tab_waiting": "Waiting Users",
  "page_admin_title": "Admin Dashboard",
  "page_admin_validation_description": "Please fill all required organization fields before saving.",
  "page_admin_validation_title": "Validation issues",
  "page_legal_dpa_description": "Controller–processor terms for business customers.",
  "page_legal_dpa_title": "Data Processing Addendum",
  "page_legal_index_description": "The terms and policies that govern Bavard.",
  "page_legal_nav_title": "Legal",
  "page_legal_not_found_description": "No legal document exists at this address.",
  "page_legal_not_found_title": "Document not found",
  "page_legal_privacy_description": "How we handle personal data, for accounts and end users.",
  "page_legal_privacy_title": "Privacy Policy",
  "page_legal_subprocessors_description": "Third parties that may process data to run the Service.",
  "page_legal_subprocessors_title": "Sub-processor List",
  "page_legal_terms_description": "The agreement that governs your use of Bavard.",
  "page_legal_terms_title": "Terms of Service",
  "page_no_active_organization": "No active organization.",
  "page_onboarding_checkout_continue": "Continue to payment",
  "page_onboarding_checkout_description_fallback": "Your organization is set up but payment hasn't been completed yet. Continue to Stripe to activate your subscription.",
  "page_onboarding_checkout_description_suffix": "is set up but payment hasn't been completed yet. Continue to Stripe to activate your subscription.",
  "page_onboarding_checkout_error_fallback": "Could not start checkout",
  "page_onboarding_checkout_redirecting": "Redirecting…",
  "page_onboarding_checkout_title": "Complete your subscription",
  "page_onboarding_success_payment_successful": "Payment successful",
  "page_onboarding_success_redirecting": "Redirecting you to the calendar…",
  "page_onboarding_success_verify_failed": "Failed to verify subscription",
  "page_onboarding_success_verifying_default": "We're activating your subscription. This usually takes just a few seconds.",
  "page_onboarding_success_verifying_slow": "This is taking a moment. We're confirming your payment with Stripe.",
  "page_onboarding_success_verifying_subscription": "Verifying your subscription",
  "page_pending_org_accept_invitation_failed": "Failed to accept invitation",
  "page_pending_org_activation_prefix": "Your organization has been created under",
  "page_pending_org_activation_suffix": "and is awaiting activation by a platform super user. You'll be forwarded to the app the moment it's activated — keep this tab open.",
  "page_pending_org_charged_plan_suffix": "plan, billed",
  "page_pending_org_charged_prefix": "You'll be charged for the",
  "page_pending_org_charged_suffix": "— continue to Stripe to complete payment.",
  "page_pending_org_check_again": "Check Again",
  "page_pending_org_create_and_continue": "Create & continue to payment",
  "page_pending_org_create_failed": "Could not create organization",
  "page_pending_org_create_no_id": "Org create returned no id",
  "page_pending_org_create_org_title": "Create your organization",
  "page_pending_org_create_own": "Create my own organization",
  "page_pending_org_creating": "Creating…",
  "page_pending_org_display_name_label": "Display name",
  "page_pending_org_display_name_placeholder": "Defaults to your handle",
  "page_pending_org_go_back": "Go back",
  "page_pending_org_handle_hint": "Pick a unique handle. Lowercase letters, digits, and dashes only — like a Discord channel name.",
  "page_pending_org_handle_label": "Handle",
  "page_pending_org_invitation_org_fallback": "Organization",
  "page_pending_org_invitations_title": "You have pending invitations",
  "page_pending_org_invited_suffix": " has been invited to join an organization.",
  "page_pending_org_optional_suffix": "(optional)",
  "page_pending_org_pending_activation_title": "Pending activation",
  "page_pending_org_role_prefix": "Role:",
  "page_pending_org_setup_title": "Set up your organization",
  "page_pending_org_signed_in_suffix": " is signed in. Create an organization to continue, or wait for an admin to assign you to one.",
  "page_pending_org_signing_out": "Signing out…",
  "page_pending_org_wait_for_assignment": "Wait for assignment",
  "page_pending_org_waiting_prefix": "We've flagged",
  "page_pending_org_waiting_suffix": "for a super user to assign you to an organization. You'll be forwarded to the app as soon as the assignment lands.",
  "page_pending_org_waiting_title": "Waiting for assignment",
  "page_team_title": "Team",
  "pg_actions_col_title": "Actions",
  "pg_add_bench": "Add bench",
  "pg_add_chat_bench_aria": "Add chat bench",
  "pg_add_chat_panel_aria": "Add chat panel",
  "pg_add_short": "add",
  "pg_add_to_panel_scope_aria": "Add to this panel's scope",
  "pg_ai_model_label": "AI Model",
  "pg_approve_all": "Approve all ({{count}})",
  "pg_benches": "Benches",
  "pg_broad": "Broad",
  "pg_broadcast_hint": "In any composer: Ctrl+Shift+Enter sends the message to every bench at once — one prompt, N pipelines.",
  "pg_calendar_event_count": "{{count}} events",
  "pg_calendar_viewing_date": "Viewing {{date}}",
  "pg_chat_description_no_rag": "Pure model — retrieval skipped.",
  "pg_chat_description_rag": "Retrieval over scoped docs.",
  "pg_clear_all_documents_description": "This will permanently delete {{count}} playground documents for the current org. Production documents are not touched.",
  "pg_clear_all_documents_title": "Clear all playground documents?",
  "pg_collapse_calendar_aria": "Collapse calendar",
  "pg_collapse_preview_aria": "Collapse preview",
  "pg_collapse_sandbox_sidebar_aria": "Collapse sandbox sidebar",
  "pg_collapse_sandbox_title": "Collapse sandbox (calendar + history)",
  "pg_collapse_tool_history_aria": "Collapse tool history",
  "pg_composer_placeholder": "Send a message…",
  "pg_configure_panel": "Configure {{name}}",
  "pg_configuring_panel": "configuring {{name}}",
  "pg_context_limit_help": "How many past turns to forward. Empty = unlimited.",
  "pg_context_message_limit_label": "Context message limit",
  "pg_delete_all": "Delete all",
  "pg_delete_document_aria": "Delete {{filename}}",
  "pg_delete_document_confirm_description": "This will permanently delete \"{{filename}}\" from the playground corpus.",
  "pg_delete_document_confirm_title": "Delete {{filename}}?",
  "pg_deny_all": "Deny all",
  "pg_documents_title": "Playground documents",
  "pg_documents_view_description": "Sandboxed corpus — drops auto-join {{name}}'s scope; the row Switch toggles per-panel inclusion.",
  "pg_samples_title": "Try a sample document",
  "pg_samples_description": "Each file carries a layout that trips up document parsers. Add one, then ask the assistant about it.",
  "pg_samples_adding": "Adding…",
  "pg_samples_fetch_failed": "Couldn't load that sample. Try again.",
  "pg_sample_hint_xlsx": "Title rows above the header, merged cells, two tables on one sheet, formulas, a totals row, an Arabic right-to-left sheet and an empty sheet.",
  "pg_sample_hint_csv": "Excel-style export: byte-order mark, quoted commas and line breaks, thousands separators and Arabic names.",
  "pg_sample_hint_docx": "Nested headings and lists, a table with merged cells, a chart image, a right-to-left Arabic section, headers/footers and a landscape page.",
  "pg_sample_hint_pdf": "Two-column pages, a repeated header and footer, tables, a chart image and a scanned page that needs OCR.",
  "pg_sample_hint_md": "Front matter, a table, nested lists, a code block whose '#' lines are not headings, and a long section with no subheadings.",
  "pg_sample_hint_txt": "Windows line endings, a 150-word single-sentence paragraph, Q&A pairs, a tab-aligned table and Arabic text.",
  "pg_sample_hint_png": "A bilingual menu with dot leaders between items and prices — read by OCR.",
  "pg_sample_hint_jpg": "A tilted, shadowed photo of a receipt — read by OCR.",
  "pg_embed_stat_title": "Tokens × pricing for indexing this doc",
  "pg_embedding_model_description": "Embeds documents uploaded here. Each document is searched with the model it was embedded with, so switching models affects new uploads only.",
  "pg_empty_hint_no_model": "Pick an AI model on the left first.",
  "pg_empty_hint_ready": "Send a message to start the conversation.",
  "pg_enable_rag_aria": "Enable knowledge base and document search",
  "pg_knowledge_base_title": "Knowledge Base",
  "pg_knowledge_base_description": "Enable document access and all document search tools together. Documents and search settings apply to this panel.",
  "pg_expand_calendar_aria": "Expand calendar",
  "pg_expand_preview_aria": "Expand preview",
  "pg_expand_tool_history_aria": "Expand tool history",
  "pg_export_bench_aria": "Export bench snapshot (JSON)",
  "pg_export_bench_title": "Export runs + diagnostics as JSON",
  "pg_file_size_title": "File size",
  "pg_focused": "Focused",
  "pg_following_config": "following config",
  "pg_generic_chunk_label": "Chunk #{{index}}",
  "pg_header_meta": "RAG test bench · {{count}} parallel pipelines · nothing touches org config",
  "pg_input_col_title": "Input",
  "pg_latency_col_title": "Latency",
  "pg_latest": "latest",
  "pg_load_saved_prompt_placeholder": "Load a saved prompt…",
  "pg_load_saved_prompt_version_aria": "Load a saved prompt version",
  "pg_loading_preview": "Loading preview…",
  "pg_max_results_label": "Max results",
  "pg_model_section_title": "Model",
  "pg_model_selector_description": "Used for every chat turn.",
  "pg_n_more": "+{{count}} more",
  "pg_no_chunks_available": "No chunks available for {{filename}}.",
  "pg_no_events_in_range": "No events in range",
  "pg_no_model": "no model",
  "pg_no_passes_yet": "No passes yet",
  "pg_no_sandbox_events": "No sandbox events yet. The agent's calendar tools will populate this view.",
  "pg_no_tool_calls_yet": "No tool calls yet. Calls the agent makes will appear here.",
  "pg_open_sandbox_sidebar_aria": "Open sandbox sidebar",
  "pg_open_sandbox_title": "Open sandbox (calendar + history)",
  "pg_output_error_col_title": "Output / Error",
  "pg_page_chunk_label": "Page {{page}}",
  "pg_panel_status_aria": "Status: {{status}}",
  "pg_panel_status_error": "error",
  "pg_panel_status_idle": "idle",
  "pg_panel_status_ready": "ready",
  "pg_panel_status_running": "running",
  "pg_passes_chunks_summary": "{{count}} passes · {{chunks}} chunks",
  "pg_pending_approvals_notice": "{{count}} tool calls awaiting your decision. Resolve in the history table — the next message you send forwards your decisions to the agent.",
  "pg_prompt_kind_assistant": "Assistant",
  "pg_prompt_kind_system_agent": "System agent",
  "pg_query_embedding_tokens_title": "Query embedding tokens",
  "pg_rag_section_description": "Ground answers in your documents.",
  "pg_remove_from_panel_scope_aria": "Remove from this panel's scope",
  "pg_remove_panel_aria": "Remove panel",
  "pg_rerank_auto": "Auto",
  "pg_reset_playground": "Reset playground",
  "pg_reset_to_config": "Reset to config",
  "pg_retrieval": "Retrieval",
  "pg_retrieval_empty_hint": "Retrieved chunks land here after each RAG pass — similarity per chunk, per turn.",
  "pg_agent_mode_caption": "Per-run override for this bench. It never changes the organization's answering mode.",
  "pg_agent_mode_unknown": "Loading the organization's answering mode…",
  "pg_agent_mode_no_stream_title": "The answer starts after the research",
  "pg_agent_mode_no_stream_body": "The researcher gathers evidence first, so the reply starts later. Mode 4 then streams it word by word; mode 5 streams it only when no further check can replace it, otherwise it appears once verified.",
  "pg_agent_mode_ignored_title": "Settings this mode does not use",
  "pg_agent_mode_ignored_expected": "Expected from the server's contract — run once to see what this bench actually ignored.",
  "pg_agent_mode_ignored_observed": "Reported by the server for the last run in this mode.",
  "pg_agent_mode_inactive_tools_title": "Tools not available in this mode",
  "pg_citation_chip_aria": "Citation {{marker}}",
  "pg_citation_location_file_only": "Whole document — no page position",
  "pg_citation_marker_caption": "Source [{{marker}}]",
  "pg_citation_reason_no_document": "The cited document is no longer in the corpus.",
  "pg_citation_reason_no_layout": "This document was indexed without page layout, so the passage can't be highlighted.",
  "pg_citation_reason_no_page_model": "This file type has no pages to point at.",
  "pg_citation_reason_quote_not_located": "The quoted text couldn't be found on the page.",
  "pg_citation_reason_resolution_failed": "The passage position couldn't be resolved.",
  "pg_citations_sandbox_label": "Sources · sandbox",
  "pg_citations_turn_local_note": "Citations belong to this turn only and are not saved.",
  "pg_ingest_title": "Preparing document",
  "pg_ingest_aria": "Document ingestion progress",
  "pg_ingest_outcome_completed": "Ready to search",
  "pg_ingest_outcome_failed": "Ingestion failed",
  "pg_ingest_parse_mode_local": "Local parser",
  "pg_ingest_parse_mode_managed": "Managed parser",
  "pg_ingest_status_pending": "Queued for processing",
  "pg_ingest_status_processing": "Processing",
  "pg_ingest_cost_actual_title": "Cost the providers reported for this ingestion",
  "pg_ingest_cost_estimated_title": "Estimated from token counts and list prices",
  "pg_ingest_cost_unknown_title": "Calls whose cost couldn't be priced",
  "pg_ingest_cost_not_reported": "No provider reported an actual cost",
  "pg_ingest_cost_show_breakdown": "Show breakdown",
  "pg_ingest_cost_hide_breakdown": "Hide breakdown",
  "pg_ingest_cost_ephemeral_hint": "This breakdown lives in this tab only and is gone after a reload.",
  "pg_retrieval_agent_query_title": "Query the agent searched with",
  "pg_retrieval_agent_summary": "{{count}} agent searches · {{hits}} hits",
  "pg_retrieval_feed_agent_search": "agent search",
  "pg_retrieval_feed_agent_search_hint": "The agent called the search tool itself during the turn.",
  "pg_retrieval_feed_prompt_context": "prompt context",
  "pg_retrieval_feed_prompt_context_hint": "Retrieved before the turn and placed in the prompt.",
  "pg_retrieval_leg_keyword": "KW",
  "pg_retrieval_leg_keyword_title": "Matched by the keyword (full-text) search",
  "pg_retrieval_leg_semantic": "SEM",
  "pg_retrieval_leg_semantic_title": "Matched by the semantic (vector) search",
  "pg_retrieval_measure_cos": "cos",
  "pg_retrieval_measure_cos_title": "Cosine similarity between the query and the chunk",
  "pg_retrieval_measure_rerank": "rerank",
  "pg_retrieval_measure_rerank_title": "Relevance score from the reranker",
  "pg_retrieval_measure_rrf": "rrf",
  "pg_retrieval_measure_rrf_title": "Reciprocal-rank fusion of the semantic and keyword results",
  "pg_runs_all_benches": "runs all benches",
  "pg_sandbox": "Sandbox",
  "pg_sandbox_sidebar_aria": "Sandbox sidebar",
  "pg_search_stat_title": "Cumulative cost of query-vector embeddings that returned a chunk from this doc",
  "pg_select_ai_model": "Select AI model",
  "pg_select_embedding_model": "Select embedding model…",
  "pg_settings_sheet_description": "Configure the active chat panel: RAG toggle, AI model, retrieval, and system prompt.",
  "pg_settings_title_panel": "Settings — {{name}}",
  "pg_sidebar_summary_no_rag": "Pure model chat — no retrieval.",
  "pg_sidebar_summary_rag": "Drop docs and chat with retrieval.",
  "pg_strategy_contextual_hint": "Prefix each chunk with doc context",
  "pg_strategy_standard_hint": "Chunk → embed as-is",
  "pg_stricter": "Stricter",
  "pg_structure_preview": "Structure preview",
  "pg_system_prompt_description": "Optional. Goes in front of every turn.",
  "pg_table_chunk_label": "Table chunk #{{index}}",
  "pg_tool_col_title": "Tool",
  "pg_tool_history_title": "Tool history",
  "pg_tool_status_approved": "Approved",
  "pg_tool_status_awaiting": "Awaiting",
  "pg_tool_status_denied": "Denied",
  "pg_tool_status_failed": "Failed",
  "pg_tool_status_ok": "OK",
  "pg_tool_status_pending": "Pending",
  "pg_tool_status_running": "Running",
  "pg_tools_section_description": "Sandboxed override — config-page locks (plan, model gating) are ignored.",
  "pg_touched_stat_title": "Number of agent runs whose retrieval pass surfaced a chunk from this doc",
  "pg_docling_badge": "Parser",
  "pg_docling_checked_at": "checked at {{time}}",
  "pg_docling_checking": "Checking…",
  "pg_docling_collapse_label": "Hide document parser status",
  "pg_docling_error_title": "The document parser returned an error",
  "pg_docling_key_rejected_hint": "The service is up but refused the key, so restarting it won't help. Check DOCLING_SERVE_API_KEY on the server.",
  "pg_docling_key_rejected_title": "The document parser rejected our API key",
  "pg_docling_recheck": "Recheck",
  "pg_docling_start_hint": "Start it with",
  "pg_docling_unreachable_local_title": "The local document parser isn't running",
  "pg_docling_unreachable_managed_title": "The managed document parser isn't responding",
  "pg_docling_unreachable_title": "The document parser isn't responding",
  "pg_docling_upload_blocked": "PDF and Word uploads will fail until it's back. Spreadsheets, text and images still upload.",
  "phone_input_placeholder": "Add phone number",
  "reset_password_error_failed": "Failed to reset password",
  "team_account_status_desc_active": "Temporarily disable this member. They keep their data but can't sign in until reactivated.",
  "team_account_status_desc_inactive": "This member is disabled and can't sign in. Reactivate to restore access.",
  "team_action_deactivate": "Deactivate member",
  "team_action_reactivate": "Reactivate member",
  "team_action_remove_from_org": "Remove from organization",
  "team_action_remove_member": "Remove member",
  "team_action_removing": "Removing…",
  "team_action_saving": "Saving…",
  "team_action_send_notice": "Send notice",
  "team_action_send_warning": "Send warning",
  "team_action_sending": "Sending…",
  "team_actor_ai": "AI agent",
  "team_actor_external": "External user",
  "team_actor_member": "Org member",
  "team_actor_system": "System",
  "team_actor_unknown": "Unknown",
  "team_avatar_fallback_name": "Member",
  "team_badge_banned": "Banned",
  "team_badge_verified": "Verified",
  "team_chat_history": "Chat history",
  "team_col_when": "When",
  "team_confirm_remove_desc": "{{name}} will lose access to this organization. Their account and data are preserved, and you can re-invite them later.",
  "team_confirm_remove_title": "Remove member?",
  "team_danger_owner_desc": "Organization owners can't be removed.",
  "team_danger_remove_desc": "Remove this member from the organization. Their account and data are preserved, but they lose access to this org.",
  "team_day_earlier": "Earlier",
  "team_dialog_member_detail_desc": "Profile, activity, sessions, and management for {{name}}.",
  "team_dialog_member_detail_sr": "Member detail",
  "team_export_title_member_activity": "Member activity",
  "team_heading_subtitle": "Monitor activity, presence, and access across your organization.",
  "team_heading_title": "Team",
  "team_kind_event": "Event",
  "team_kind_joined": "Joined",
  "team_kind_other": "Other",
  "team_kind_role": "Role",
  "team_kind_signed_in": "Sign-in",
  "team_label_title": "Title",
  "team_last_active": "last active {{time}}",
  "team_made_by": "Made by {{actor}} • {{timestamp}}",
  "team_member_for": "member for {{duration}}",
  "team_member_not_found": "Member not found.",
  "team_no_active_sessions": "No active sessions.",
  "team_no_activity_filtered": "No activity matches these filters.",
  "team_no_activity_yet": "No activity yet.",
  "team_no_org_activity": "No recent organization activity.",
  "team_notify_sheet_desc": "Reaches {{name}} as an in-app push on their devices and is recorded on their activity timeline.",
  "team_notify_sheet_title": "Send a notice",
  "team_placeholder_message": "What should they know?",
  "team_placeholder_notice_title": "e.g. Reminder about today's schedule",
  "team_placeholder_warning_title": "e.g. Double-booked a slot",
  "team_presence_idle": "Idle",
  "team_presence_offline": "Offline",
  "team_presence_online": "Online",
  "team_role_admin": "Admin",
  "team_role_guest": "Guest",
  "team_role_owner": "Owner",
  "team_role_secretary": "Secretary",
  "team_row_account_created": "Account created",
  "team_row_active_sessions": "Active sessions",
  "team_row_ban_reason": "Ban reason",
  "team_row_custom_role": "Custom role",
  "team_row_email": "Email",
  "team_row_last_sign_in": "Last sign-in",
  "team_row_member_since": "Member since",
  "team_row_org_role": "Org role",
  "team_search_activity_placeholder": "Search activity…",
  "team_section_account_status_title": "Account status",
  "team_section_communicate_desc": "Send an in-app push to this member's devices, recorded on their timeline.",
  "team_section_communicate_title": "Communicate",
  "team_section_danger_zone_title": "Danger zone",
  "team_self_membership_notice": "You're viewing your own membership. Status and removal actions aren't available for your own account.",
  "team_session_active": "{{ip}} · active {{time}}",
  "team_session_expires": "Expires {{time}}",
  "team_session_impersonated": "Impersonated",
  "team_severity_notice": "Notice",
  "team_severity_warning": "Warning",
  "team_stat_active_week": "Active this week",
  "team_stat_dormant": "Dormant",
  "team_stat_online_now": "Online now",
  "team_stat_pending_invites": "Pending invites",
  "team_stat_seats_used": "Seats used",
  "team_tab_manage": "Manage",
  "team_tab_overview": "Overview",
  "team_tab_sessions": "Sessions",
  "team_this_member": "this member",
  "team_time_days_ago": "{{n}}d ago",
  "team_time_hours_ago": "{{n}}h ago",
  "team_time_just_now": "just now",
  "team_time_minutes_ago": "{{n}}m ago",
  "team_time_never": "never",
  "team_toast_deactivated_msg": "{{name}} can no longer sign in.",
  "team_toast_deactivated_title": "Member deactivated",
  "team_toast_delivered": "Delivered to {{count}} devices.",
  "team_toast_notice_sent": "Notice sent",
  "team_toast_reactivated_msg": "{{name}} can sign in again.",
  "team_toast_reactivated_title": "Member reactivated",
  "team_toast_recorded_timeline": "Recorded on the member's timeline.",
  "team_toast_removed_msg": "{{name}} was removed from the organization.",
  "team_toast_removed_title": "Member removed",
  "team_toast_warning_sent": "Warning sent",
  "team_unknown_ip": "Unknown IP",
  "team_word_activity": "Activity",
  "team_word_members": "Members",
  "ui_a_ai_off_label": "AI off",
  "ui_a_ai_off_tooltip": "AI auto-reply is off for this contact",
  "ui_a_backend_banner_collapse_label": "Show connection status",
  "ui_a_calendar_aria_label": "Calendar",
  "ui_a_calendar_back_to_calendar": "Back to calendar",
  "ui_a_calendar_month_short_apr": "Apr",
  "ui_a_calendar_month_short_aug": "Aug",
  "ui_a_calendar_month_short_dec": "Dec",
  "ui_a_calendar_month_short_feb": "Feb",
  "ui_a_calendar_month_short_jan": "Jan",
  "ui_a_calendar_month_short_jul": "Jul",
  "ui_a_calendar_month_short_jun": "Jun",
  "ui_a_calendar_month_short_mar": "Mar",
  "ui_a_calendar_month_short_may": "May",
  "ui_a_calendar_month_short_nov": "Nov",
  "ui_a_calendar_month_short_oct": "Oct",
  "ui_a_calendar_month_short_sep": "Sep",
  "ui_a_calendar_next_year": "Next year",
  "ui_a_calendar_previous_year": "Previous year",
  "ui_a_calendar_select_month_current": "Select month, currently {{month}}",
  "ui_a_calendar_range_from": "Starts",
  "ui_a_calendar_range_to": "Ends",
  "ui_a_calendar_select_time": "Select time",
  "ui_a_calendar_select_year_current": "Select year, currently {{year}}",
  "ui_a_calendar_selected_suffix": "selected",
  "ui_a_calendar_this_year": "This year",
  "ui_a_calendar_week_number": "Week",
  "ui_a_calendar_weekday_short_fri": "Fr",
  "ui_a_calendar_weekday_short_mon": "Mo",
  "ui_a_calendar_weekday_short_sat": "Sa",
  "ui_a_calendar_weekday_short_sun": "Su",
  "ui_a_calendar_weekday_short_thu": "Th",
  "ui_a_calendar_weekday_short_tue": "Tu",
  "ui_a_calendar_weekday_short_wed": "We",
  "ui_a_code_diff_show_full": "Show full diff",
  "ui_a_copy_failed": "Copy failed",
  "ui_a_emoji_loading_favorites": "Loading favorites…",
  "ui_a_emoji_next_favorites_page": "Next favorites page",
  "ui_a_emoji_previous_favorites_page": "Previous favorites page",
  "ui_a_feedback_message_required": "Message is required",
  "ui_a_feedback_message_too_long": "Message is too long",
  "ui_a_feedback_org_required": "Organization is required to submit feedback",
  "ui_a_onboarding_go_to_step": "Go to step {{step}}",
  "ui_a_onboarding_navigation": "Onboarding navigation",
  "ui_a_onboarding_step_of_total": "Step {{step}} of {{total}}",
  "ui_a_pagination_go_to_next": "Go to next page",
  "ui_a_pagination_go_to_previous": "Go to previous page",
  "ui_a_pagination_more_pages": "More pages",
  "ui_a_pagination_nav_label": "pagination",
  "ui_a_pagination_next": "Next",
  "ui_a_pagination_previous": "Previous",
  "ui_a_pricing_select_plan": "Select a Plan",
  "ui_a_pricing_yearly": "Yearly",
  "ui_a_slider_value": "Slider value",
  "ui_a_toggle_expand": "Toggle expand",
  "ui_a_validation_errors_announce": "{{count}} validation error(s): {{messages}}",
  "ui_a_validation_errors_resolved": "All validation errors resolved.",
  "ui_a_waveform_idle": "Audio waveform idle",
  "ui_a_waveform_live": "Live audio waveform",
  "ui_a_waveform_processing": "Processing audio",
  "ui_b_data_grid_clear_sort": "Clear sort",
  "ui_b_data_grid_collapse_detail_row": "Collapse detail row",
  "ui_b_data_grid_collapse_item": "Collapse {{item}}",
  "ui_b_data_grid_column_menu": "{{label}} column menu",
  "ui_b_data_grid_detail_column": "Detail",
  "ui_b_data_grid_expand_detail_row": "Expand detail row",
  "ui_b_data_grid_expand_item": "Expand {{item}}",
  "ui_b_data_grid_loading_row": "Loading table row",
  "ui_b_data_grid_no_history_yet": "No history yet",
  "ui_b_data_grid_reset_width": "Reset width",
  "ui_b_data_grid_resize_column": "Resize {{label}} column",
  "ui_b_data_grid_sort_column": "Sort {{label}}",
  "ui_b_data_grid_view_history": "View history",
  "ui_b_morph_surface_sent": "Sent",
  "ui_b_scrollbar_scroll_down": "Scroll down",
  "ui_b_scrollbar_scroll_up": "Scroll up",
  "ui_b_toolbar_add_row": "Add row",
  "ui_b_toolbar_clear_search": "Clear search",
  "ui_b_toolbar_columns": "Columns",
  "ui_b_toolbar_columns_visible_count": "{{visible}} of {{total}} visible",
  "ui_b_toolbar_delete_selected": "Delete selected rows",
  "ui_b_toolbar_selected_count": "{{count}} selected",
  "ui_b_toolbar_export": "Export...",
  "ui_b_toolbar_filters": "Filters",
  "contact_filter_state": "State",
  "contact_filter_flags": "Flags",
  "contact_filter_favorites": "Favorites",
  "contact_filter_bookings": "Bookings",
  "contact_filter_bookings_any": "Has bookings",
  "contact_filter_bookings_upcoming": "Upcoming booking",
  "contact_filter_bookings_none": "No bookings",
  "contact_filter_created": "Created",
  "member_filter_role": "Role",
  "member_filter_superuser": "Superuser",
  "member_filter_sign_in": "Sign-in",
  "member_filter_never_signed_in": "Never signed in",
  "member_filter_has_signed_in": "Has signed in",
  "ui_b_toolbar_fullscreen": "Fullscreen",
  "ui_b_toolbar_hide_deleted": "Hide deleted",
  "ui_b_toolbar_revive_selected": "Revive selected rows",
  "ui_b_toolbar_save_changes": "Save changes",
  "ui_b_toolbar_saving": "Saving...",
  "ui_b_toolbar_search_placeholder": "Search...",
  "ui_b_toolbar_search_shortcut": "Search (Ctrl+F)",
  "ui_b_toolbar_search_table": "Search table",
  "ui_b_toolbar_show_all_columns": "Show all columns",
  "wgt_account_settings_sections_aria": "Account settings sections",
  "wgt_contact_action_enable_ai": "Enable AI",
  "wgt_contact_actions_menu_aria": "Contact actions",
  "wgt_contact_add_favorite": "Add favorite",
  "wgt_contact_archive": "Archive contact",
  "wgt_contact_block_set_inactive": "Block (set inactive)",
  "wgt_contact_clear_failed": "Failed to clear conversation",
  "wgt_contact_export_conversation": "Export conversation",
  "wgt_contact_export_preparing": "Preparing export…",
  "wgt_contact_load_messages_failed": "Failed to load messages",
  "wgt_contact_open_documents": "Open documents",
  "wgt_contact_remove_favorite": "Remove favorite",
  "wgt_contact_restore": "Restore contact",
  "wgt_contact_save_first": "Save first",
  "wgt_contact_unblock_set_active": "Unblock (set active)",
  "wgt_contact_view_change_history": "View change history",
  "wgt_documents_add_files_failed": "Could not add files to the document.",
  "wgt_documents_checklist_add_item": "Add item",
  "wgt_documents_checklist_delete_item": "Delete item",
  "wgt_documents_checklist_hint": "Double-click to edit",
  "wgt_documents_checklist_item_placeholder": "List item",
  "wgt_documents_checklist_title_placeholder": "Checklist",
  "wgt_documents_checklist_toggle_item": "Toggle item",
  "wgt_documents_checklist_tool": "Checklist",
  "wgt_documents_enter_fullscreen": "Enter fullscreen",
  "wgt_documents_export_failed": "Could not export the document.",
  "wgt_documents_export_tldr": "Export .tldr file",
  "wgt_documents_import_confirm_body": "Importing “{{fileName}}” replaces everything on this canvas, and autosave will overwrite the saved copy on the server.",
  "wgt_documents_import_confirm_export_first": "Export current, then replace",
  "wgt_documents_import_confirm_replace": "Replace",
  "wgt_documents_import_confirm_title": "Replace this canvas?",
  "wgt_documents_import_failed_damaged": "This file is damaged and can't be imported.",
  "wgt_documents_import_failed_newer": "This file was made by a newer version of tldraw. Refresh the app and try again.",
  "wgt_documents_import_failed_not_tldraw": "This file is not a tldraw file.",
  "wgt_documents_import_failed_too_old": "This file uses a legacy tldraw format that can't be imported.",
  "wgt_documents_import_tldr": "Import .tldr file…",
  "wgt_documents_offline_start_blank": "Start a blank document",
  "wgt_documents_offline_start_blank_warning": "If a document already exists on the server, your work will come back as a conflict to resolve once you reconnect.",
  "wgt_documents_offline_unavailable_description": "This document has never been opened on this device, so there is no local copy to load. Reconnect to open it.",
  "wgt_documents_offline_unavailable_title": "Not available offline",
  "wgt_documents_table_add_column": "Add column",
  "wgt_documents_table_add_row": "Add row",
  "wgt_documents_table_cell_checkbox": "Toggle value",
  "wgt_documents_table_cell_select": "Select value",
  "wgt_documents_table_cell_value": "Cell value",
  "wgt_documents_table_column_name": "Column name",
  "wgt_documents_table_column_name_placeholder": "Column",
  "wgt_documents_table_column_type": "Column type",
  "wgt_documents_table_delete_column": "Delete column",
  "wgt_documents_table_delete_row": "Delete row",
  "wgt_documents_table_empty": "No rows",
  "wgt_documents_table_hint": "Double-click to edit",
  "wgt_documents_table_options": "Options",
  "wgt_documents_table_options_placeholder": "Comma-separated options",
  "wgt_documents_table_tool": "Table",
  "wgt_documents_table_type_checkbox": "Checkbox",
  "wgt_documents_table_type_number": "Number",
  "wgt_documents_table_type_select": "Select",
  "wgt_documents_table_type_text": "Text",
  "wgt_documents_table_untitled_column": "Untitled",
  "wgt_documents_unable_to_load_canvas": "Unable to load canvas",
  "wgt_documents_voice_note_cancel": "Cancel",
  "wgt_documents_voice_note_delete": "Delete recording",
  "wgt_documents_voice_note_hint": "Click record to capture a voice note",
  "wgt_documents_voice_note_no_org": "No organization selected",
  "wgt_documents_voice_note_record": "Record",
  "wgt_documents_voice_note_stop": "Stop",
  "wgt_documents_voice_note_tool": "Voice note",
  "wgt_documents_voice_note_upload_failed": "Voice note upload failed",
  "wgt_documents_voice_note_uploading": "Uploading…",
  "wgt_root_error_backend_check_1": "Refresh after the backend reports it is ready.",
  "wgt_root_error_backend_check_2": "Check that the API URL matches the running server.",
  "wgt_root_error_backend_description": "The frontend loaded, but a request to the API could not complete. This usually means the server is still starting, stopped, or the backend URL is wrong.",
  "wgt_root_error_backend_dev_check_1": "Start the server with `bun dev:server`.",
  "wgt_root_error_backend_dev_check_2": "`VITE_BACKEND_URL` defaults to `http://127.0.0.1:4000`.",
  "wgt_root_error_backend_title": "The backend is not reachable",
  "wgt_root_error_module_check_1": "Refresh the page after the frontend finishes starting.",
  "wgt_root_error_module_check_2": "If this keeps happening, close this tab and open the app again from the current frontend URL.",
  "wgt_root_error_module_description": "This tab is open, but the browser could not download the route module it needs. A refresh usually fixes this after a frontend restart or deploy.",
  "wgt_root_error_module_dev_check_1": "Make sure `bun dev` is still running on port 3000.",
  "wgt_root_error_module_dev_check_2": "If Vite restarted, wait for it to finish compiling before refreshing.",
  "wgt_root_error_module_title": "The page code could not be loaded",
  "wgt_root_error_open_start_page": "Open start page",
  "wgt_root_error_status_backend": "Backend connection",
  "wgt_root_error_status_module": "Frontend module",
  "wgt_root_error_status_unknown": "Application error",
  "wgt_root_error_technical_details": "Technical details",
  "wgt_root_error_unknown_check_1": "Refresh the page.",
  "wgt_root_error_unknown_check_2": "Open the technical details and check the browser console if the error repeats.",
  "wgt_root_error_unknown_description": "Refresh can recover from a restart, deploy, or short-lived connection issue. If it keeps happening, the technical details below should point to the failing part.",
  "wgt_root_error_unknown_title": "The page hit an unexpected error",
  "wgt_root_error_what_to_check": "What to check",
  "wgt_router_go_home": "Go home",
  "wgt_router_loading_page": "Loading page",
  "wgt_router_page_not_found": "Page not found",
  "wgt_tldraw_load_error_description": "The drawing editor could not be loaded. Please refresh the page to try again.",
  "wgt_tldraw_load_error_title": "Failed to load editor",
  "wgt_tours_theme_mode_system_short": "Sys",
  "name_validation_has_digits": "Name cannot contain digits.",
  "name_validation_invalid": "Name is not valid.",
  "name_validation_invalid_chars": "Name can only contain letters, spaces, and hyphens.",
  "name_validation_required": "Name is required.",
  "name_validation_too_long": "Name is too long (max 50 characters).",
  "name_validation_too_short": "Name must include at least two words.",
  "name_validation_words_too_short": "Each word in the name must be at least two characters.",
  "chat_drop_here_to_mention": "Drop here to mention",
  "chat_release_to_mention_contact": "Release to mention contact",
  "admin_organizations": "Organizations",
  "cfg2_ai_context_message_limit_label": "Context Message Limit",
  "cfg2_ai_context_message_limit_tip": "How many past messages are sent to the AI per request. Lower = cheaper, higher = more conversation history. Leave empty for unlimited.",
  "cfg_ai_processing_card_title": "Agent File Access",
  "cfg_ai_processing_card_description": "Control receipt, AI reading, and sending independently for every file family and agent.",
  "cfg_ai_audio_read_cost_title": "Audio Read can incur ElevenLabs transcription costs",
  "cfg_ai_audio_read_cost_description": "When enabled, voice messages are sent natively to audio-capable models. For models without native audio, ElevenLabs transcribes each recording and bills by audio duration. Turn Audio Read off to disable both native audio processing and ElevenLabs transcription; recordings remain stored and playable.",
  "cfg_ai_process_images_label": "Process incoming images",
  "cfg_ai_process_images_tooltip": "When on, the AI looks at incoming images and uses them to answer. When off, images are still received, stored, and viewable, but the AI ignores them. Applies even if the selected model can see images.",
  "cfg_ai_process_audio_label": "Process incoming voice messages",
  "cfg_ai_process_audio_tooltip": "When on, models with audio support hear the original voice message; other models receive a billed ElevenLabs text transcription. When off, voice messages remain stored and playable but are not passed to the AI.",
  "cfg2_ai_fallback_model_hint": "Try another model if the primary fails.",
  "cfg2_ai_fallback_auto_primary_hint": "Auto routing already picks and falls back across models, so no separate fallback is needed.",
  "cfg2_ai_fallback_model_label": "Fallback AI Model",
  "cfg2_ai_knowledge_base_description": "Upload reference documents and tune retrieval settings for document search",
  "cfg2_rag_retrieval_gaps_title": "Retrieval gaps",
  "cfg2_rag_retrieval_gaps_description": "Recent searches your knowledge base couldn't answer — candidates for new documents.",
  "cfg2_rag_retrieval_gaps_summary": "{{count}} no-hit searches in the last {{days}} days",
  "cfg2_rag_retrieval_gaps_empty": "No retrieval gaps in the last {{days}} days.",
  "cfg2_rag_retrieval_gaps_empty_query": "(no query text)",
  "cfg2_rag_retrieval_gaps_error": "Couldn't load retrieval telemetry.",
  "cfg2_ai_model_config_description": "Select AI models for automated replies and agent workflows",
  "cfg2_ai_model_config_title": "AI Model Configuration",
  "cfg2_ai_primary_model_description": "Select a specific AI model for automated replies and agent workflows.",
  "cfg2_ai_primary_model_label": "Primary AI Model",
  "cfg2_ai_tools_card_description": "Choose what the AI is allowed to do. Each section has a master switch; expand it to fine-tune individual tools. Use the + button to add custom actions that call your own API.",
  "cfg2_ai_tools_card_title": "AI Tools",
  "cfg2_feature_include_reasoning_description": "Can include reasoning in response. The model can optionally include its internal reasoning process in the output when requested.",
  "cfg2_feature_include_reasoning_label": "Inc. Reasoning",
  "cfg2_feature_parallel_description": "Supports parallel tool calls. The model can execute multiple tools simultaneously instead of sequentially, improving response speed.",
  "cfg2_feature_parallel_label": "Parallel",
  "cfg2_feature_reasoning_description": "Supports reasoning output. The model can show its step-by-step thinking process and explain how it arrives at conclusions.",
  "cfg2_feature_response_format_description": "Supports JSON response format. The model can return responses in valid JSON format, useful for programmatic integration.",
  "cfg2_feature_structured_description": "Supports structured output schema. The model can return data in a predefined JSON schema format, ensuring consistent output structure.",
  "cfg2_feature_structured_label": "Structured",
  "cfg2_feature_tools_description": "Supports function/tool calling. The model can execute functions, call APIs, and use external tools to perform actions beyond text generation.",
  "cfg2_feature_web_search_description": "Supports web search capabilities. The model can search the internet to find current information and answer questions with up-to-date data.",
  "cfg2_modality_audio_description": "Accepts audio as input.",
  "cfg2_modality_audio_label": "Audio",
  "cfg2_modality_embeddings_description": "Produces dense vector embeddings as output.",
  "cfg2_modality_embeddings_label": "Embeddings",
  "cfg2_modality_file_description": "Accepts file attachments (PDF, docs, …) as input.",
  "cfg2_modality_image_description": "Accepts images as input (vision / multimodal).",
  "cfg2_modality_text_description": "Accepts plain text as input.",
  "cfg2_modality_video_description": "Accepts video frames as input.",
  "cfg2_modality_video_label": "Video",
  "cfg2_model_context_tokens": "{{count}} tokens",
  "cfg2_model_providers_count": "{{count}} hosts",
  "cfg2_model_stat_agentic": "Agentic",
  "cfg2_model_stat_agentic_sublabel": "tool calling",
  "cfg2_model_stat_coding": "Coding",
  "cfg2_model_stat_intelligence": "Intelligence",
  "cfg2_model_stat_latency": "Latency",
  "cfg2_model_stat_latency_sublabel": "first token",
  "cfg2_model_stat_math": "Math",
  "cfg2_model_stat_speed": "Speed",
  "cfg2_model_stat_speed_sublabel": "tok/sec",
  "cfg2_notif_field_days_after_label": "Days After",
  "cfg2_notif_field_days_before_label": "Days Before",
  "cfg2_notif_field_delay_hours_label": "Delay Hours",
  "cfg2_notif_field_inactive_days_label": "Inactive Days",
  "cfg2_notif_field_scheduled_datetime_label": "Scheduled Date & Time",
  "cfg2_notif_field_send_at_time_label": "Send At Time",
  "cfg2_notif_unit_day_after": "day after event",
  "cfg2_notif_unit_day_before": "day before event",
  "cfg2_notif_unit_day_inactivity": "day of inactivity",
  "cfg2_notif_unit_days_after": "days after event",
  "cfg2_notif_unit_days_before": "days before event",
  "cfg2_notif_unit_days_inactivity": "days of inactivity",
  "cfg2_notif_unit_delay_minute": "minute after trigger",
  "cfg2_notif_unit_delay_minutes": "minutes after trigger",
  "cfg2_notif_unit_hour_no_show": "hour after no-show",
  "cfg2_notif_unit_hours_no_show": "hours after no-show",
  "cfg2_rag_document_count": "{{count}} documents",
  "cfg2_rag_drop_files_here": "Drop files here…",
  "cfg2_rag_dropzone_browse_hint": "Drag & drop files or click to browse",
  "cfg2_rag_dropzone_size_hint": "Up to 10MB per file",
  "cfg2_rag_file_too_large": "File \"{{filename}}\" is too large. Maximum size is 10MB.",
  "cfg2_rag_file_unsupported_type": "File \"{{filename}}\" has unsupported type. Allowed: PDF, DOCX, XLSX, CSV, MD, TXT, PNG, JPG.",
  "rag_viewer_aria": "Document viewer",
  "rag_viewer_save": "Save and re-index",
  "rag_viewer_markdown_face": "Markdown view",
  "rag_viewer_rendered": "Rendered",
  "rag_viewer_raw": "Raw",
  "rag_viewer_edit_locked": "Editing is available once processing finishes.",
  "rag_viewer_too_large_to_edit": "This file is too large to edit here.",
  "rag_viewer_reindexing": "Re-indexing {{progress}}%",
  "rag_viewer_unsupported": "Preview isn't available for this file type.",
  "rag_viewer_layout_unavailable": "A formatted preview isn't available for this document yet.",
  "rag_viewer_download_original": "Download original",
  "rag_viewer_load_failed": "Couldn't load this document.",
  "rag_viewer_file_unavailable": "The original file isn't stored for this document.",
  "rag_viewer_text_truncated": "Showing the first {{shown}} of {{total}} characters. Files this large are read-only here.",
  "rag_viewer_keep_editing": "Keep editing",
  "rag_viewer_discard_title": "Discard unsaved changes?",
  "rag_viewer_discard_description": "Your edits to {{filename}} haven't been saved.",
  "rag_viewer_add_row": "Add row",
  "rag_viewer_add_column": "Add column",
  "rag_viewer_delete_row": "Delete row",
  "rag_viewer_delete_column": "Delete column",
  "rag_viewer_columns_capped": "Showing the first {{shown}} of {{total}} columns.",
  "rag_viewer_empty_sheet": "This sheet is empty.",
  "rag_upload_progress": "Uploading {{percent}}%",
  "rag_retry_action": "Retry processing",
  "rag_retry_started_toast": "Processing restarted",
  "rag_retry_failed_toast": "Couldn't restart processing",
  "staged_knowledge_unsupported_type": "File \"{{filename}}\" has unsupported type. Allowed: PDF, DOCX, XLSX, CSV, MD, TXT, ZIP.",
  "pg_stat_chunks": "chunks",
  "pg_stat_embed": "embed",
  "pg_stat_search": "search",
  "pg_stat_touched": "touched",
  "chat_character_limit": "Character limit {{limit}}",
  "cfg2_rag_no_documents_yet": "No documents uploaded yet. Upload your first document to enable semantic search.",
  "cfg2_rag_storage_capacity_label": "Knowledge base storage",
  "cfg2_rag_storage_full_hint": "Storage full — delete documents or upgrade your plan to add more.",
  "cfg2_rag_storage_limit_reached": "Storage limit reached. Delete documents or upgrade your plan to add more.",
  "cfg2_system_defaults_ai_model_description": "Primary model for automated replies and agent workflows.",
  "cfg2_system_defaults_ai_model_label": "AI Model",
  "cfg2_system_defaults_fallback_model_tip": "Automatically tries this model when the primary model fails or is unavailable.",
  "cfg2_system_defaults_prompts_description": "Configure AI system prompts for assistant behavior",
  "cfg2_system_prompt_drop_release_label": "Release to replace content",
  "cfg2_system_prompt_edit_field_aria": "Edit {{label}}",
  "cfg2_system_prompt_exit_button": "Exit",
  "cfg2_system_prompt_heading_1": "Heading 1",
  "cfg2_system_prompt_heading_2": "Heading 2",
  "cfg2_system_prompt_heading_3": "Heading 3",
  "cfg2_system_prompt_import_tooltip": "Import file (txt, markdown, docx, pdf)",
  "cfg2_system_prompt_paragraph": "Paragraph",
  "cfg2_system_prompt_quick_export_docx": "Quick export · DOCX",
  "cfg2_system_prompt_quick_export_txt": "Quick export · TXT",
  "clear_all": "Clear all",
  "date_picker_label": "Date & time",
  "date_time_placeholder": "Pick date & time",
  "done": "Done",
  "edit": "Edit",
  "failed_to_load_calendar": "Failed to load calendar",
  "failed_to_load_dashboard": "Failed to load dashboard",
  "failed_to_load_documents": "Failed to load documents",
  "failed_to_load_viewer": "Failed to load viewer",
  "main_navigation": "Main navigation",
  "nav_rail_collapse": "Collapse navigation",
  "nav_rail_expand": "Expand navigation",
  "model_selector_label": "Select model",
  "msg_no_data": "No data",
  "no": "No",
  "phone_select_or_create": "Phone number",
  "pull_to_refresh": "Pull to refresh",
  "refreshing": "Refreshing…",
  "styles": "Styles",
  "toast_handoff_description": "AI auto-reply disabled for this conversation. A human should take over.",
  "toast_handoff_resumed_short": "AI auto-reply re-enabled",
  "toast_handoff_short": "Handoff to human",
  "toast_handoff_title": "Handoff to human • {{name}}",
  "yes": "Yes",
  "account_notifications_always_immediate": "Always immediate",
  "account_notifications_category_assignedToYou_description": "A conversation was assigned directly to you.",
  "account_notifications_category_assignedToYou_label": "Assigned to you",
  "account_notifications_category_budgetCapReached_description": "An AI budget cap stopped further usage.",
  "account_notifications_category_budgetCapReached_label": "Budget cap reached",
  "account_notifications_category_campaignFinished_description": "A WhatsApp campaign finished sending.",
  "account_notifications_category_campaignFinished_label": "Campaign completed",
  "account_notifications_category_handoffRequested_description": "A conversation needs help from your team.",
  "account_notifications_category_handoffRequested_label": "Handoff requested",
  "account_notifications_category_lowBalance_description": "Your organization credit balance is running low.",
  "account_notifications_category_lowBalance_label": "Low balance",
  "account_notifications_category_mention_description": "A teammate mentioned you in a note.",
  "account_notifications_category_mention_label": "Mention",
  "account_notifications_category_slaBreach_description": "A conversation breached its response target.",
  "account_notifications_category_slaBreach_label": "SLA breach",
  "account_notifications_category_templateHealth_description": "A WhatsApp template was rejected, paused, or disabled.",
  "account_notifications_category_templateHealth_label": "Template health",
  "account_notifications_category_waitlistActivity_description": "A booking waitlist changed.",
  "account_notifications_category_waitlistActivity_label": "Waitlist activity",
  "account_notifications_column_email": "Email",
  "account_notifications_column_webpush": "Push",
  "account_notifications_email_enabled_label": "Email notifications",
  "account_notifications_email_frequency_digest": "Daily digest",
  "account_notifications_email_frequency_immediate": "Immediately",
  "account_notifications_email_frequency_label": "Email frequency",
  "account_notifications_group_billing_title": "Billing",
  "account_notifications_group_team_title": "Team",
  "account_notifications_push_devices_current": "This device",
  "account_notifications_push_devices_description": "Browsers currently registered to receive web push notifications.",
  "account_notifications_push_devices_empty": "No browsers are registered for push notifications.",
  "account_notifications_push_devices_last_used": "Last used",
  "account_notifications_push_devices_revoke": "Revoke",
  "account_notifications_push_devices_revoke_failed": "Could not revoke this push device. Please try again.",
  "account_notifications_push_devices_title": "Push devices",
  "account_notifications_quiet_hours_label": "Quiet hours",
  "account_privacy_export_expired": "Your last archive expired. Generate a new one.",
  "account_privacy_export_failed": "Your last export failed. Generate a new one.",
  "account_privacy_retention_stop_semantic_1_month": "1 month",
  "account_privacy_retention_stop_semantic_1_year": "1 year",
  "account_privacy_retention_stop_semantic_3_months": "3 months",
  "account_privacy_retention_stop_semantic_6_months": "6 months",
  "account_sessions_freshness_required": "For your security, sign in again to view and manage your active sessions.",
  "account_sessions_sign_in_again": "Sign in again",
  "account_sessions_subtitle_verification": "Verification required to view active devices",
  "campaigns_add_contacts": "Add contacts",
  "campaigns_ai_replies": "AI replies",
  "campaigns_all_statuses": "All statuses",
  "campaigns_approved_template": "Approved template",
  "campaigns_audience": "Audience",
  "campaigns_audience_clear": "Clear all",
  "campaigns_audience_count": "{{count}} contacts in this audience",
  "campaigns_audience_description": "Only contacts who have reached you on WhatsApp can be selected.",
  "campaigns_audience_empty": "No contacts selected yet",
  "campaigns_audience_empty_description": "Search your WhatsApp contacts by name or number and add anyone you want this campaign to reach.",
  "campaigns_daily_cap_exceeded": "This audience is {{selected}} contacts, but only {{remaining}} can be reached in the next 24 hours. Remove contacts or send the rest tomorrow.",
  "campaigns_daily_cap_summary": "WhatsApp allows {{limit}} unique contacts per rolling 24 hours. {{used}} used, {{remaining}} left.",
  "campaigns_audience_remove": "Remove {{name}}",
  "campaigns_cancel": "Cancel",
  "campaigns_cancel_confirm_description": "Cancel {{name}}? Queued recipients will no longer be sent.",
  "campaigns_cancel_confirm_title": "Cancel campaign?",
  "campaigns_cancel_error": "Campaign could not be cancelled.",
  "campaigns_configuration": "Configuration",
  "campaigns_contact": "Contact",
  "campaigns_contacts": "contacts",
  "campaigns_content": "Content",
  "campaigns_delivered": "Delivered",
  "campaigns_delivery_counters": "Delivery counters",
  "campaigns_delivery_funnel": "Delivery funnel",
  "campaigns_delivery_replies": "Delivery and replies",
  "campaigns_description": "Send approved WhatsApp templates to a selected audience and follow delivery in real time.",
  "campaigns_detail_error": "Campaign could not be loaded.",
  "campaigns_diagnostic": "Diagnostic",
  "campaigns_draft_audience_notice": "{{count}} selected contacts will be materialized and revalidated when this draft is sent.",
  "campaigns_draft_template_notice": "The approved template content is frozen into an immutable snapshot when this draft is sent.",
  "campaigns_drop_off": "drop-off",
  "campaigns_email_templates_description": "Reusable email templates for confirmations and reminders.",
  "campaigns_email_templates_title": "Email Templates",
  "campaigns_empty": "No campaigns yet",
  "campaigns_empty_description": "Create a draft to select content and an audience.",
  "campaigns_example": "Example",
  "campaigns_failed": "Failed",
  "campaigns_filter_status": "Filter by status",
  "campaigns_human_takeover": "Human takeover",
  "campaigns_invalid_fields": "Check the campaign name, phone number ID, template, and variable mappings.",
  "campaigns_list_aria": "Campaign list",
  "campaigns_load_error": "Campaigns could not be loaded.",
  "campaigns_loading": "Loading campaigns…",
  "campaigns_loading_detail": "Loading campaign…",
  "campaigns_mapping_json_error": "Variable mappings must be a JSON object.",
  "campaigns_meta_billing_warning": "Campaigns send utility templates only. Each recipient counts toward your plan's monthly message allowance.",
  "campaigns_meta_limits": "Meta limits",
  "campaigns_name": "Campaign name",
  "campaigns_nav_label": "Campaigns",
  "campaigns_new": "New campaign",
  "campaigns_no_campaign_matches": "No campaigns match this filter.",
  "campaigns_no_recipient_matches": "No recipients match this filter.",
  "campaigns_outbound": "Outbound",
  "campaigns_outbound_breadcrumb": "Outbound / Campaigns",
  "campaigns_phone": "Phone",
  "campaigns_phone_number_id": "WhatsApp phone number ID",
  "campaigns_quality_unavailable": "quality unavailable",
  "campaigns_queued": "Queued",
  "campaigns_read": "Read",
  "campaigns_read_replied": "Read / replied",
  "campaigns_recipients": "recipients",
  "campaigns_recipients_title": "Recipients",
  "campaigns_replied": "Replied",
  "campaigns_replies": "Replies",
  "campaigns_save_draft": "Save draft",
  "campaigns_save_error": "Campaign could not be saved.",
  "campaigns_search_placeholder": "Search name or phone",
  "campaigns_search_recipients": "Search recipients",
  "campaigns_select_template": "Select a template",
  "campaigns_templates_utility_only": "Only approved utility templates can be sent. Marketing messages are not included in your plan because Meta charges for each one.",
  "campaigns_templates_hidden_not_covered": "{{count}} approved templates are hidden because Meta categorized them as marketing or authentication, which your plan does not include. Edit them to be purely transactional and resubmit them to use them here.",
  "campaigns_send_now": "Send now",
  "campaigns_send_confirm_description": "Send {{name}} to {{count}} selected contacts? The eligible audience and template will be frozen before delivery begins.",
  "campaigns_send_confirm_title": "Send campaign now?",
  "campaigns_send_error": "Campaign could not be sent.",
  "campaigns_sending": "Sending",
  "campaigns_sent": "Sent",
  "campaigns_status": "Status",
  "campaigns_status_cancelled": "Cancelled",
  "campaigns_status_completed": "Completed",
  "campaigns_status_delivered": "Delivered",
  "campaigns_status_draft": "Draft",
  "campaigns_status_failed": "Failed",
  "campaigns_status_queued": "Queued",
  "campaigns_status_read": "Read",
  "campaigns_status_replied": "Replied",
  "campaigns_activity": "Activity",
  "campaigns_overview": "Overview",
  "campaigns_name_label": "Name",
  "campaigns_channel_label": "Channel",
  "campaigns_channel_whatsapp": "WhatsApp",
  "campaigns_row_actions": "Campaign actions",
  "campaigns_replies_label": "Replies",
  "campaigns_sent_at": "Sent at",
  "campaigns_snapshot_unavailable": "Snapshot unavailable",
  "campaigns_distribution": "Distribution",
  "campaigns_open": "Open",
  "campaigns_recipients_count": "Recipients ({{shown}} of {{total}})",
  "campaigns_media_image": "Image",
  "campaigns_media_video": "Video",
  "campaigns_media_document": "Document",
  "campaigns_status_sending": "Sending",
  "campaigns_status_sent": "Sent",
  "campaigns_tab_campaigns": "Campaigns",
  "campaigns_tab_campaigns_tooltip": "Broadcasts you send to a selected audience",
  "campaigns_tab_email_templates": "Email Templates",
  "campaigns_tab_email_templates_tooltip": "Reusable email templates for confirmations and reminders",
  "campaigns_tab_whatsapp_templates": "WhatsApp Templates",
  "campaigns_tab_whatsapp_templates_tooltip": "Meta-approved message templates your campaigns and reminders send",
  "campaigns_title": "Campaigns",
  "campaigns_limit_remaining": "{{count}} left in this 24-hour window.",
  "campaigns_limit_unlimited": "unlimited",
  "campaigns_limit_unverified_hint": "This portfolio currently allows 250 unique recipients per rolling 24 hours. Meta controls tier increases. Approximately {{count}} slots are available.",
  "campaigns_unavailable": "unavailable",
  "campaigns_whatsapp_only_notice": "Campaigns send WhatsApp templates. Instagram, Telegram and X are conversation-only channels and cannot be broadcast to.",
  "campaigns_unique_contacts_24h": "unique contacts in 24h",
  "campaigns_unnamed": "Unnamed",
  "campaigns_unnamed_contact": "Unnamed contact",
  "campaigns_variable_mappings": "Variable mappings (component-scoped JSON)",
  "cfg_ai_audio_label": "Audio",
  "cfg_ai_audio_matrix_tooltip": "Each switch independently controls whether that agent may receive or send audio.",
  "cfg_ai_audio_unsupported_tooltip": "The selected model does not support audio input.",
  "cfg_ai_images_label": "Images",
  "cfg_ai_images_matrix_tooltip": "Each switch independently controls whether that agent may receive or send images.",
  "cfg_ai_images_unsupported_tooltip": "The selected model does not support image input.",
  "cfg_ai_media_type_column": "Media type",
  "cfg_ai_processing_assistant_title": "AI assistant (contacts)",
  "cfg_ai_processing_system_agent_title": "System agent (dashboard)",
  "cfg_ai_receive_direction": "Receive",
  "cfg_ai_read_direction": "Read",
  "cfg_ai_send_direction": "Send",
  "cfg_ai_media_images": "Images",
  "cfg_ai_media_audio": "Audio and voice notes",
  "cfg_ai_media_video": "Video",
  "cfg_ai_media_pdf": "PDF",
  "cfg_ai_media_document": "Documents & files",
  "cfg_ai_media_effective_policy": "Effective access is shown after plan and model limits.",
  "cfg_ai_media_effective_policy_tip": "A switch only takes effect when both the organization plan and its own setting allow it. Reading also requires a compatible model or local parser.",
  "cfg_ai_media_plan_disabled_reason": "This action is unavailable on the organization's current plan.",
  "cfg_ai_media_runtime_unsupported_reason": "This preference is saved, but the selected model or local parser cannot currently perform it.",
  "cfg_system_agent_process_audio_label": "Allow audio uploads",
  "cfg_system_agent_process_audio_tooltip": "When off, audio cannot be uploaded, previewed, recorded, or sent to the system agent, even if its model supports audio.",
  "cfg_system_agent_process_images_label": "Allow image uploads",
  "cfg_system_agent_process_images_tooltip": "When off, images cannot be uploaded, previewed, or sent to the system agent, even if its model supports images.",
  "cfgpage_section_event_types_title": "Events",
  "chat_voice_recording_too_short": "Recording was too short. Hold the button a little longer and try again.",
  "command_palette_billing_spend_policy": "AI spend guardrails",
  "command_palette_nav_campaigns": "Campaigns",
  "contact_beneficiary_demote": "Move to a contact",
  "contact_beneficiary_demote_confirm": "Move as beneficiary",
  "contact_beneficiary_demote_desc": "Choose the contact who will manage {{name}} as a beneficiary.",
  "contact_beneficiary_demote_warning_named": "{{name}} will lose their phone number, message history, saved conversation summaries, and active conversations. Their events and documents will be kept. This can't be undone.",
  "dashboard_event_statuses": "Event statuses",
  "dashboard_event_statuses_description": "Events by configured status in this date range",
  "event_status_cancelled": "Cancelled",
  "event_status_completed": "Completed",
  "event_status_config_add": "Add status",
  "event_status_config_color": "Status color",
  "event_status_config_description": "Choose the statuses available from the calendar. Changes are saved immediately; Confirmed, Completed, and No-show cannot be removed.",
  "event_status_config_edit": "Edit status",
  "event_status_config_heading": "Event statuses",
  "event_status_config_name": "Status name",
  "event_status_config_name_placeholder": "e.g. Arrived",
  "event_status_config_protected": "This default status cannot be removed",
  "event_status_config_remove": "Remove status",
  "event_status_config_remove_failed": "Could not remove the event status",
  "event_status_config_removed": "Event status removed.",
  "event_status_config_save_failed": "Could not save the event status",
  "event_status_config_saved": "Event status saved.",
  "event_status_config_update": "Update",
  "event_status_confirmed": "Confirmed",
  "event_status_error_already_cancelled": "This event is already cancelled.",
  "event_status_error_already_completed": "This event is already completed.",
  "event_status_error_already_confirmed": "This event is already confirmed.",
  "event_status_error_already_no_show": "This event is already marked as no-show.",
  "event_status_error_booking_horizon": "This event is outside the allowed booking period.",
  "event_status_error_cannot_cancel": "This event cannot be cancelled in its current status.",
  "event_status_error_complete_cancelled": "A cancelled event cannot be marked as completed.",
  "event_status_error_complete_no_show": "A no-show event cannot be marked as completed.",
  "event_status_error_conflict": "This event changed elsewhere. Refresh and try again.",
  "event_status_error_day_closed": "That day is closed for bookings.",
  "event_status_error_generic": "Could not update the event status. Please try again.",
  "event_status_error_no_show_cancelled": "A cancelled event cannot be marked as no-show.",
  "event_status_error_no_show_completed": "A completed event cannot be marked as no-show.",
  "event_status_error_not_cancelled": "Only a cancelled event can be confirmed.",
  "event_status_error_not_found": "This event could not be found.",
  "event_status_error_not_slot_start": "Appointments do not start at that time.",
  "event_status_error_phone_mismatch": "This contact already has a different phone number.",
  "event_status_error_phone_taken": "That phone number already belongs to another contact.",
  "event_status_error_reinstate_failed": "This event could not be restored.",
  "event_status_error_reinstate_slot_taken": "That time is taken, so this event cannot be restored to it.",
  "event_status_error_reschedule_failed": "This event could not be moved.",
  "event_status_error_schedule_failed": "This event could not be booked.",
  "event_status_error_slot_full": "That time slot is fully booked.",
  "event_status_error_slot_unavailable": "This time slot is no longer available.",
  "event_status_error_user_capacity": "This contact has reached the allowed booking limit.",
  "event_status_no_show": "No-show",
  "event_status_picker_label": "Set event status",
  "feat_org_balance_cap_fallback_default": "We're currently unable to answer automatically — a team member will get back to you.",
  "feat_org_balance_spend_policy_behavior": "At-cap behavior",
  "feat_org_balance_spend_policy_cap": "Monthly cap (credits, blank for none)",
  "feat_org_balance_spend_policy_degrade": "Switch to fallback model (soft threshold)",
  "feat_org_balance_spend_policy_description": "Set low-balance alerts and a monthly billed-credit budget.",
  "feat_org_balance_spend_policy_hard_stop": "Pause AI replies (bounded overshoot)",
  "feat_org_balance_spend_policy_message": "Customer notice",
  "feat_org_balance_spend_policy_period_spend": "Current-period AI spend",
  "feat_org_balance_spend_policy_reached": "Cap reached",
  "feat_org_balance_spend_policy_save": "Save guardrails",
  "feat_org_balance_spend_policy_soft_cap_note": "Charges happen after delivery, so concurrent replies may slightly exceed a hard-stop cap. Fallback mode is a soft threshold and continues spending.",
  "feat_org_balance_spend_policy_thresholds": "Low-balance thresholds (%)",
  "feat_org_balance_spend_policy_title": "AI spend guardrails",
  "notif_org_balance_low_body": "Your organization is running low on AI credits.",
  "notif_org_balance_low_title": "Low credit balance",
  "notif_org_budget_cap_body": "Your current-period AI credit budget has been reached.",
  "notif_org_budget_cap_title": "AI credit budget reached",
  "booking_requirements_description": "Choose which contact details every event-creation surface must collect. At least one is required.",
  "booking_requirements_title": "Booking contact requirements",
  "booking_require_name_label": "Require a contact name",
  "booking_require_name_tooltip": "Blocks event creation until the contact has a name.",
  "booking_require_phone_label": "Require a phone number",
  "booking_require_phone_tooltip": "Blocks event creation until the contact has a phone number normalized for the configured country.",
  "waitlist_active_entries": "Active entries",
  "waitlist_active_holds": "Active holds",
  "waitlist_claims_week": "Claims this week",
  "waitlist_config_description": "Offer newly available slots fairly and reserve short-lived holds while customers confirm.",
  "waitlist_contact": "Contact",
  "waitlist_description": "Track queued customers, slot offers, active holds, and successful claims.",
  "waitlist_desired_time": "Desired time",
  "waitlist_empty": "No waitlist entries match these filters.",
  "waitlist_enable": "Enable waitlist",
  "waitlist_enable_first": "Enable the waitlist first.",
  "waitlist_event_type": "Event type",
  "waitlist_eyebrow": "Bookings",
  "waitlist_joined": "Joined",
  "waitlist_nav_label": "Waitlist",
  "waitlist_offer_batch_size": "Customers offered each round",
  "waitlist_offers": "Offers",
  "waitlist_open_offers": "Open offers",
  "waitlist_position": "Position",
  "waitlist_status": "Status",
  "waitlist_title": "Waitlist",
  "waitlist_ttl_minutes": "Offer expiry (minutes)",
  "whatsapp_templates_add_button": "Add button",
  "whatsapp_templates_body": "Message body",
  "whatsapp_templates_builder_description": "Create a Meta-approved template with examples for every variable.",
  "whatsapp_templates_builder_title": "Create WhatsApp template",
  "whatsapp_templates_button_phone": "Phone number",
  "whatsapp_templates_button_text": "Button label",
  "whatsapp_templates_button_type": "Button type",
  "whatsapp_templates_button_url": "Website URL",
  "whatsapp_templates_buttons": "Buttons",
  "whatsapp_templates_category": "Category",
  "whatsapp_templates_category_plan_hint": "Only utility (transactional) templates are included in your plan. Marketing and authentication templates are not, because Meta charges for every one of those messages.",
  "whatsapp_templates_not_covered_badge": "Not included in plan",
  "whatsapp_templates_not_covered_reason": "Meta categorized this template as marketing or authentication, which your plan does not include, so it cannot be sent. Edit it to be purely transactional and resubmit it for review.",
  "whatsapp_templates_count": "{count} templates",
  "whatsapp_templates_create": "Create template",
  "whatsapp_templates_create_error": "Could not create the template.",
  "whatsapp_templates_create_success": "Template submitted to Meta.",
  "whatsapp_templates_delete_confirm": "Delete this WhatsApp template?",
  "whatsapp_templates_delete_error": "Could not delete the template.",
  "whatsapp_templates_delete_success": "Template deleted.",
  "whatsapp_templates_description": "Message templates registered with Meta. Campaigns and reminders can only send a template Meta has approved.",
  "whatsapp_templates_edit": "Edit",
  "whatsapp_templates_edit_error": "Could not edit the template.",
  "whatsapp_templates_edit_success": "Template changes submitted to Meta.",
  "whatsapp_templates_edit_title": "Edit WhatsApp template",
  "whatsapp_templates_empty": "No WhatsApp templates yet.",
  "whatsapp_templates_examples": "Variable examples",
  "whatsapp_templates_footer": "Footer",
  "whatsapp_templates_header": "Header",
  "whatsapp_templates_header_none": "No header",
  "whatsapp_templates_header_text": "Text header",
  "whatsapp_templates_inline_create": "Create a new template",
  "whatsapp_templates_language": "Language",
  "whatsapp_templates_media_unsupported": "Media headers must be managed in Meta because an uploaded media handle is required.",
  "whatsapp_templates_name": "Template name",
  "whatsapp_templates_not_configured": "Connect a WhatsApp Business account to manage templates.",
  "whatsapp_templates_parameters": "Variable format",
  "whatsapp_templates_permission_missing": "The connected Meta account cannot manage templates.",
  "whatsapp_templates_preview": "Your message preview appears here.",
  "whatsapp_templates_remove_button": "Remove button",
  "whatsapp_templates_save": "Save changes",
  "whatsapp_templates_stale": "Showing the last synchronized template data.",
  "whatsapp_templates_submit": "Submit to Meta",
  "whatsapp_templates_title": "WhatsApp Templates",
  "setup_wizard_title": "Welcome! Let's set up your assistant",
  "setup_wizard_subtitle": "A few quick steps and your AI assistant is ready to talk to your customers.",
  "setup_step_business_title": "Your business",
  "setup_step_business_description": "Tell us who you are — your assistant introduces your business by this name.",
  "setup_step_ai_title": "AI assistant",
  "setup_step_ai_description": "Choose the AI model and how your assistant should behave. Pick a template — no writing needed.",
  "setup_step_schedule_title": "Working hours",
  "setup_step_schedule_description": "Set your timezone and working days so bookings land at the right times.",
  "setup_step_whatsapp_title": "Messaging",
  "setup_step_whatsapp_description": "Connect WhatsApp, Telegram, Instagram, X, or any combination.",
  "setup_step_messaging_title": "Connect messaging",
  "setup_step_messaging_description": "Connect at least one customer channel: WhatsApp, Telegram, Instagram, or X.",
  "setup_step_finish_title": "Finish",
  "setup_step_finish_description": "Everything checks out? Step inside.",
  "setup_business_name_label": "Business name",
  "setup_business_name_placeholder": "e.g. Salma Dental Clinic",
  "setup_business_name_hint": "You can fill in the address and other details later in Settings.",
  "setup_test_in_playground": "Try your assistant in the Playground",
  "setup_whatsapp_connected": "Your customer messaging channel is connected. Customers can message you and the assistant will reply.",
  "setup_whatsapp_waiting": "Connect WhatsApp, Telegram, Instagram, or X to continue — this page checks automatically.",
  "setup_whatsapp_refresh": "Check again",
  "setup_messaging_connected": "Your messaging channel is connected. Customers can message you on WhatsApp, Telegram, Instagram, or X and the assistant will reply on that channel.",
  "setup_messaging_waiting": "Connect WhatsApp, Telegram, Instagram, or X to continue. This page checks automatically after your organization credentials are saved.",
  "setup_messaging_refresh": "Check again",
  "setup_back": "Back",
  "setup_continue": "Continue",
  "setup_enter_app": "Finish & enter",
  "setup_finished_toast": "Setup complete — welcome aboard!",
  "setup_finish_requirements_error": "A step isn't finished yet. Please review the highlighted steps.",
  "setup_awaiting_admin_title": "Almost there",
  "setup_awaiting_admin_description": "Your workspace is still being set up by your administrator. You'll get access as soon as they finish.",
  "setup_prompt_picker_label": "Assistant personality",
  "setup_prompt_picker_placeholder": "Choose a starting point…",
  "setup_prompt_picker_templates_group": "Templates",
  "setup_prompt_picker_presets_group": "Your presets",
  "setup_prompt_picker_custom": "Custom instructions",
  "setup_prompt_instructions_label": "Instructions",
  "setup_prompt_save_as_preset": "Save as preset",
  "setup_prompt_preset_name_placeholder": "Preset name",
  "setup_prompt_preset_added": "Preset added — it's saved with your settings.",
  "setup_prompt_preset_too_long": "These instructions are too long to save as a preset (20,000 characters max).",
  "setup_prompt_preset_limit_reached": "You've reached the maximum of 50 saved presets. Delete one to add another.",
  "setup_prompt_template_support_name": "Customer support",
  "setup_prompt_template_support_description": "Answers questions and resolves issues",
  "setup_prompt_template_sales_name": "Sales assistant",
  "setup_prompt_template_sales_description": "Presents your services and captures leads",
  "setup_prompt_template_booking_name": "Booking assistant",
  "setup_prompt_template_booking_description": "Books and manages appointments",
  "setup_prompt_template_general_name": "General assistant",
  "setup_prompt_template_general_description": "A friendly all-round helper",
  "settings_editor_minimal_mode": "Minimal Mode",
  "settings_editor_minimal_mode_desc": "Hide advanced styling controls (fill, dash, color picker) in the editor toolbar",
  "settings_editor_minimal_enabled": "Minimal mode enabled",
  "settings_editor_minimal_disabled": "Minimal mode disabled",
  "admin_b_ai_preset_limit_label": "AI agent preset limit",
  "admin_b_custom_tool_limit_label": "Custom action limit",
  "feat_billing_usage_presets_deleted": "Deleted preset",
  "feat_billing_usage_presets_description": "Reporting breakdown for each AI configuration.",
  "feat_billing_usage_presets_column_preset": "Preset",
  "feat_billing_usage_presets_title": "Usage by agent preset",
  "feat_billing_usage_presets_unattributed": "Earlier usage",
  "config": {
    "aiAssistant": {
      "qaPairs": {
        "title": "Curated Q&A",
        "description": "Author question-and-answer pairs the assistant replies with word-for-word.",
        "counter": "{{count}} pairs · {{used}} / {{cap}}",
        "addButton": "Add Q&A",
        "importButton": "Import .xlsx",
        "empty": "No Q&A pairs yet. Add one to answer common questions instantly.",
        "loadError": "Couldn't load Q&A pairs.",
        "selectAllAria": "Select all Q&A pairs",
        "bulk": {
          "selected": "{{count}} selected",
          "clear": "Clear",
          "delete": "Delete selected"
        },
        "status": {
          "pending": "Queued",
          "processing": "Processing",
          "completed": "Live",
          "failed": "Failed"
        },
        "row": {
          "selectAria": "Select Q&A pair",
          "enabledAria": "Q&A pair active state",
          "timesAsked": "Asked {{count}}×",
          "neverAsked": "Not asked yet",
          "actionsAria": "Q&A actions",
          "edit": "Edit",
          "stats": "Usage stats",
          "delete": "Delete"
        },
        "delete": {
          "title": "Delete Q&A pair?",
          "description": "\"{{title}}\" will be removed from your knowledge base. This can't be undone.",
          "confirm": "Delete"
        },
        "deleteMany": {
          "title": "Delete {{count}} Q&A pairs?",
          "description": "The selected Q&A pairs will be permanently removed. This can't be undone."
        },
        "editor": {
          "createTitle": "Add Q&A",
          "editTitle": "Edit Q&A",
          "description": "Give the assistant a set of questions and one verbatim answer.",
          "titleLabel": "Title",
          "titlePlaceholder": "e.g. Refund policy",
          "titleRequired": "Title is required",
          "questionsLabel": "Question variants",
          "questionsMax": "Up to {{max}} variants",
          "questionsHint": "Add every phrasing your customers use, in each language.",
          "questionAria": "Question variant {{index}}",
          "questionPlaceholder": "How do I request a refund?",
          "removeQuestionAria": "Remove question",
          "questionRequired": "Add at least one question",
          "addQuestion": "Add question",
          "answerLabel": "Answer",
          "answerDescription": "Sent word-for-word when a question matches.",
          "answerPlaceholder": "Write the exact reply the assistant should send…",
          "answerRequired": "Answer is required",
          "answerTooLarge": "Answer is too large",
          "counter": "{{chars}} / {{max}} chars · {{bytes}} bytes",
          "save": "Save",
          "cancel": "Cancel"
        },
        "stats": {
          "title": "Usage",
          "timesAsked": "Times asked",
          "lastAsked": "Last asked",
          "created": "Created",
          "never": "Never",
          "last90Days": "Last 90 days",
          "noActivity": "No activity yet"
        },
        "toast": {
          "created": "Q&A pair added.",
          "updated": "Q&A pair updated.",
          "deleted": "Q&A pair deleted.",
          "deletedMany": "Deleted {{count}} Q&A pairs.",
          "imported": "Imported {{created}} Q&A pairs ({{skipped}} skipped).",
          "importedNoSkip": "Imported {{created}} Q&A pairs.",
          "createFailed": "Couldn't create Q&A pair.",
          "updateFailed": "Couldn't update Q&A pair.",
          "deleteFailed": "Couldn't delete Q&A pair.",
          "importFailed": "Couldn't import Q&A pairs."
        }
      },
      "autoRefresh": {
        "label": "Auto refresh",
        "description": "Keep linked web sources current on a schedule.",
        "cadenceLabel": "Refresh cadence",
        "daily": "Daily",
        "weekly": "Weekly",
        "helper": "URL sources are re-crawled on schedule; files and Q&A are always instantly live.",
        "refreshNow": "Refresh now",
        "refreshedToast": "Refresh started — {{count}} jobs queued",
        "failedToast": "Couldn't start the refresh"
      }
    },
    "aiPresets": {
      "active": "Active",
      "modelAuto": "Automatic model",
      "fields": {
        "name": "Preset name",
        "description": "Description (optional)",
        "id": "Preset ID",
        "createdAt": "Created",
        "updatedAt": "Updated"
      },
      "actions": {
        "cancel": "Cancel",
        "create": "Create preset",
        "save": "Save changes",
        "activate": "Activate",
        "edit": "Edit…",
        "editActive": "Edit in AI Assistant tab",
        "test": "Test in Playground",
        "duplicate": "Duplicate",
        "delete": "Delete",
        "new": "New preset…",
        "manage": "Manage presets…"
      },
      "switcher": {
        "label": "Active agent preset",
        "switched": "Switched to '{{name}}'"
      },
      "create": {
        "title": "Create agent preset",
        "description": "Build a draft configuration without changing the live assistant.",
        "startFrom": "Start from",
        "current": "Current configuration",
        "blank": "Blank preset",
        "duplicate": "Duplicate an existing preset",
        "template": "Starter template",
        "success": "Preset created",
        "switch": "Switch to it"
      },
      "edit": {
        "title": "Edit agent preset",
        "description": "Changes to an inactive preset do not affect live conversations.",
        "prompt": "System prompt",
        "promptDescription": "Instructions used by this preset.",
        "tools": "Tools",
        "success": "Preset updated"
      },
      "manage": {
        "title": "Manage agent presets",
        "description": "Edit, test, duplicate, activate, or remove presets.",
        "duplicated": "Preset duplicated",
        "deleted": "Preset deleted",
        "deleteTitle": "Delete preset?",
        "deleteDescription": "Delete '{{name}}'? Prompt history and document selection for this preset will also be removed."
      },
      "dirty": {
        "title": "Unsaved AI Assistant changes",
        "description": "Save changes to '{{name}}' before switching presets?",
        "save": "Save and switch",
        "discard": "Discard and switch"
      },
      "quota": {
        "meter": "{{used}} of {{limit}} presets",
        "unlimited": "{{used}} presets · unlimited",
        "reached": "Preset limit reached — {{used}} of {{limit}}"
      },
      "rag": {
        "scope": "Documents used by this preset",
        "scopeDescription": "The global enabled switch remains the organization-wide kill switch.",
        "all": "All documents",
        "selected": "Selected documents",
        "allSummary": "All docs",
        "selectedSummary": "Selected docs",
        "disabledGlobally": "Disabled for all presets",
        "selectDocument": "Include {{name}} in this preset",
        "saved": "Document access updated",
        "failed": "Could not update document access."
      },
      "templates": {
        "none": {
          "name": "No template",
          "description": "Start with an empty prompt."
        },
        "support": {
          "name": "Support",
          "description": "Helpful customer support and issue resolution."
        },
        "sales": {
          "name": "Sales",
          "description": "Lead qualification and product guidance."
        },
        "booking": {
          "name": "Booking",
          "description": "Appointment discovery and scheduling."
        }
      },
      "errors": {
        "nameConflict": "A preset with this name already exists.",
        "quota": "Your plan's preset limit has been reached.",
        "deleteActive": "Switch to another preset before deleting this one.",
        "generic": "The preset could not be updated."
      },
      "playground": {
        "testing": "Testing preset '{{name}}'",
        "switch": "Switch to this preset",
        "ragLimitation": "Playground retrieval currently follows the active preset's document scope."
      },
      "channels": {
        "all": "All channels",
        "allDescription": "The preset every channel uses unless it has its own.",
        "railLabel": "Choose which channel to configure",
        "override": "Custom preset",
        "inherits": "Inherits the default",
        "inheritOption": "Inherit the default ({{name}})",
        "pick": "Preset for {{channel}}",
        "pickDescription": "Replies on {{channel}} use this preset — its instructions, model, tools and pipeline.",
        "bound": "{{channel}} now uses '{{name}}'",
        "cleared": "{{channel}} follows the default preset again",
        "notConnected": "Not connected yet — you can still choose a preset now.",
        "pipelineSingle": "Single agent",
        "pipelineResearcher": "Researched answers",
        "pipelineVerifier": "Researched and verified",
        "usedBy": "Used by {{channels}}",
        "deleteWarning": "{{channels}} will fall back to the default preset."
      }
    }
  },
  "ragDocuments": {
    "replace": {
      "action": "Replace",
      "tooltip": "Replace this file",
      "failedToast": "Couldn't replace the document",
      "startedToast": "Document replacement started.",
      "duplicateTitle": "Already in your knowledge base",
      "duplicateToast": "\"{{filename}}\" matches a document you already have — re-uploading won't update it. Use Replace to update a document.",
      "duplicateCta": "Replace instead"
    },
    "summary": {
      "timesRetrieved": "Times retrieved",
      "retrievalCount": "{{count}} retrievals",
      "lastUsed": "used {{time}}",
      "lastRetrieved": "Last retrieved",
      "notUsedYet": "Not used yet",
      "never": "Never",
      "created": "Added",
      "statsAction": "Usage stats",
      "statsTitle": "Document usage",
      "last90Days": "Last 90 days",
      "files": "Files",
      "urls": "Web pages",
      "qaPairs": "Q&A",
      "needsRefresh": "Needs refresh",
      "lastRefreshed": "Last refreshed {{time}}"
    }
  },
  "field_status": "Status",
  "chat_tool_chart_title": "Chart",
  "chat_tool_chart_invalid": "This chart could not be rendered. The raw values are shown below.",
  "chat_tool_chart_show_table": "Show accessible data table",
  "chat_tool_analytics_title": "Analytics",
  "chat_tool_insights_title": "Insights report",
  "chat_tool_insight_label": "Insight",
  "chat_tool_knowledge_title": "Knowledge",
  "chat_tool_conversations_title": "Conversations",
  "chat_tool_contact_title": "Contact snapshot",
  "chat_tool_open_contact": "Open contacts",
  "chat_tool_automations_title": "Automations",
  "chat_tool_status_title": "Connection status",
  "chat_tool_connect": "Manage connections",
  "chat_tool_contact_change_preview": "Contact change preview",
  "chat_tool_contact_source": "Source contact",
  "chat_tool_contact_target": "Target contact",
  "chat_tool_contact_records_affected": "Records affected",
  "chat_tool_contact_delete_warning": "This contact will be soft-deleted after approval.",
  "chat_staged_upload_too_large": "Knowledge files must be 50 MB or smaller.",
  "chat_staged_upload_too_many": "You can stage up to 5 files per message.",
  "chat_daily_quota_reached": "The daily system-agent limit has been reached.",
  "chat_daily_quota_limit": "Daily limit",
  "chat_daily_quota_resets": "Resets at",
  "chat_daily_quota_upgrade": "Review plan and usage",
  "cfg_tool_approval_locked_contact_delete": "Contact deletion always requires approval; the switch still controls updates.",
  "cfg_tool_approval_locked_beneficiary_merge": "Beneficiary merges always require approval; the switch still controls separation.",
  "contact_identity_section": "Contact identity",
  "contact_link_action": "Link",
  "contact_link_title": "Link contact identity",
  "contact_link_description": "Link this contact to a canonical contact without deleting either record.",
  "contact_link_confirm": "Link contact",
  "contact_link_success": "Contact linked.",
  "contact_link_failed": "Could not link contact.",
  "contact_unlink_action": "Unlink",
  "contact_unlink_title": "Unlink contact identity",
  "contact_unlink_description": "Detach this contact from its canonical contact. Existing history stays intact.",
  "contact_unlink_confirm": "Unlink contact",
  "contact_unlink_success": "Contact unlinked.",
  "contact_unlink_failed": "Could not unlink contact.",
  "contact_merge_duplicate_action": "Merge duplicate",
  "contact_merge_duplicate_hint": "Merge duplicate contacts",
  "contact_merge_title": "Merge duplicate contact",
  "contact_merge_description": "Permanently consolidate the duplicate into the surviving contact. This cannot be undone.",
  "contact_merge_direction_title": "Choose the surviving contact",
  "contact_merge_direction_hint": "The most recently active contact survives by default.",
  "contact_merge_swap_direction": "Swap direction",
  "contact_merge_preview_loading": "Preparing an authoritative preview…",
  "contact_merge_preview_failed": "The merge preview could not be loaded. Nothing has changed.",
  "contact_merge_preview_title": "Merge preview",
  "contact_merge_target_label": "Duplicate contact",
  "contact_merge_target_search": "Search contacts",
  "contact_merge_role_source": "Selected contact",
  "contact_merge_role_loser": "Will be merged",
  "contact_merge_role_winner": "Will survive",
  "contact_merge_created": "Created",
  "contact_merge_last_activity": "Last activity",
  "contact_merge_bookings": "Bookings",
  "contact_merge_confirm": "Merge permanently",
  "contact_identity_action_pending": "Working…",
  "contact_merge_count_events": "Events",
  "contact_merge_count_conversations": "Conversations",
  "contact_merge_count_messages": "Messages",
  "contact_merge_count_beneficiaries": "Beneficiaries",
  "contact_merge_count_summaries": "Summaries",
  "contact_merge_count_capturedLeads": "Captured leads",
  "contact_merge_count_feedbacks": "Feedback",
  "contact_merge_count_identifiers": "Identifiers",
  "contact_merge_count_waitlistEntries": "Waitlist entries",
  "contact_merge_count_slotOfferCandidates": "Slot offers",
  "contact_merge_fields_title": "Resolved contact fields",
  "contact_merge_field": "Field",
  "contact_merge_winner_value": "Survivor",
  "contact_merge_loser_value": "Duplicate",
  "contact_merge_resolved_value": "Result",
  "contact_merge_field_name": "Name",
  "contact_merge_field_nickname": "Nickname",
  "contact_merge_field_phoneE164": "Phone",
  "contact_merge_field_channel": "Channel",
  "contact_merge_field_countryCode": "Country",
  "contact_merge_field_isActive": "Active",
  "contact_merge_identifiers_title": "Identifiers",
  "contact_merge_primary_identifier": "Primary identifier: {{value}}",
  "contact_merge_primary_badge": "Primary",
  "contact_merge_retired_badge": "Retired",
  "contact_merge_retained_badge": "Retained",
  "contact_merge_threads_title": "Conversation threads",
  "contact_merge_thread_messages": "{{count}} messages",
  "contact_merge_thread_read_only": "Preserved as read-only history",
  "contact_merge_thread_retained": "Retained on the surviving contact",
  "contact_merge_warnings_title": "Review warnings",
  "contact_merge_warning_blocked": "The contacts have different blocked states.",
  "contact_merge_warning_legacy_cluster": "The duplicate already belongs to a legacy identity cluster.",
  "contact_merge_warning_beneficiary": "Beneficiary name collision: {{name}}",
  "contact_merge_warning_event": "Event time collision: {{at}}",
  "CONTACT_MERGE_SELF": "A contact cannot be merged into itself.",
  "CONTACT_NOT_FOUND": "One of the contacts no longer exists.",
  "CONTACT_MERGE_TOMBSTONE": "This contact has already been permanently merged.",
  "CONTACT_MERGE_IS_BENEFICIARY": "A beneficiary cannot be consolidated as a contact.",
  "CONTACT_MERGE_WINNER_NOT_ROOT": "Choose the canonical contact as the survivor.",
  "CONTACT_MERGE_DOCUMENT_INVALID": "A linked document prevents this merge.",
  "CONTACT_UNMERGE_HARD_MERGED": "A permanent merge cannot be unlinked.",
  "contact_merge_success": "Contacts merged successfully.",
  "contact_history_event_merged_in": "Duplicate merged in",
  "contact_history_event_merged_away": "Merged into another contact",
  "contact_history_merge_non_revertible": "Permanent merge",
  "ui_b_filters_add": "Add filter",
  "ui_b_filters_clear_all": "Clear all",
  "ui_b_filters_max": "Max",
  "ui_b_filters_min": "Min",
  "ui_b_filters_no_values": "No matches.",
  "ui_b_filters_op_after": "after",
  "ui_b_filters_op_before": "before",
  "ui_b_filters_op_between": "between",
  "ui_b_filters_op_contains": "contains",
  "ui_b_filters_op_ends_with": "ends with",
  "ui_b_filters_op_eq": "=",
  "ui_b_filters_op_gt": ">",
  "ui_b_filters_op_includes_all": "includes all",
  "ui_b_filters_op_is": "is",
  "ui_b_filters_op_is_any_of": "is any of",
  "ui_b_filters_op_is_empty": "is empty",
  "ui_b_filters_op_is_not": "is not",
  "ui_b_filters_op_is_not_any_of": "is not any of",
  "ui_b_filters_op_is_not_empty": "is not empty",
  "ui_b_filters_op_lt": "<",
  "ui_b_filters_op_neq": "≠",
  "ui_b_filters_op_not_contains": "does not contain",
  "ui_b_filters_op_starts_with": "starts with",
  "ui_b_filters_operator": "{{label}} operator",
  "ui_b_filters_remove": "Remove {{label}} filter",
  "ui_b_filters_search_values": "Search…",
  "ui_b_filters_select_placeholder": "Select…",
  "ui_b_filters_value": "{{label}} value",
  "member_filter_last_sign_in": "Last sign-in date",
  "sync_conflict_matrix_property": "Property",
  "sync_conflict_matrix_version": "Version",
  "sync_conflict_matrix_date": "Modified date",
  "sync_conflict_matrix_time": "Modified time",
  "sync_conflict_matrix_size": "JSON size",
  "sync_conflict_matrix_pages": "Pages",
  "sync_conflict_local_version": "Version {{version}} + local edits",
  "sync_conflict_unversioned_local": "Unversioned local edits",
  "sync_conflict_differences_title": "Where the versions differ",
  "sync_conflict_page_column": "Page",
  "sync_conflict_status_column": "State",
  "sync_conflict_items_column": "Items (device / server)",
  "sync_conflict_status_conflicted": "Conflicting edits",
  "sync_conflict_status_changed": "Different",
  "sync_conflict_status_unchanged": "Identical",
  "sync_conflict_status_local_only": "Only on this device",
  "sync_conflict_status_server_only": "Only on the server",
  "sync_conflict_untitled_page": "Untitled page",
  "sync_conflict_document_bucket": "Document-level items",
  "sync_conflict_conflicting_items": "Conflicting items: {{count}}",
  "sync_conflict_show_page": "Show this page in both previews",
  "sync_preview_page_count": "Page {{current}} of {{total}}",
  "leads_fields_saved_toast": "Lead fields saved.",
  "leads_fields_save_failed": "Could not save lead fields.",
  "leads_updated_toast": "Lead updated.",
  "leads_update_failed": "Could not update the lead.",
  "leads_moved_to_trash_toast": "Lead moved to trash.",
  "leads_delete_failed": "Could not move the lead to trash.",
  "leads_restored_toast": "Lead restored.",
  "leads_restore_failed": "Could not restore the lead.",
  "leads_deleted_permanently_toast": "Lead permanently deleted.",
  "leads_hard_delete_failed": "Could not permanently delete the lead.",
  "toast_vacation_update_failed": "Could not update vacation periods.",
  "toast_vacation_period_deleted": "Vacation period deleted.",
  "toast_vacation_delete_failed": "Could not delete the vacation period.",
  "toast_vacation_template_created": "Vacation template created.",
  "toast_vacation_template_updated": "Vacation template updated.",
  "toast_vacation_template_deleted": "Vacation template deleted.",
  "toast_vacation_template_create_failed": "Could not create the vacation template.",
  "toast_vacation_template_update_failed": "Could not update the vacation template.",
  "toast_vacation_template_delete_failed": "Could not delete the vacation template.",
  "waitlist_join_success": "Customer added to the waitlist.",
  "waitlist_join_failed": "Could not add the customer to the waitlist.",
  "waitlist_cancel_success": "Waitlist entry cancelled.",
  "waitlist_cancel_failed": "Could not cancel the waitlist entry.",
  "summaries_deleted_toast": "Summary deleted.",
  "summaries_delete_failed": "Could not delete the summary.",
  "feedbacks_deleted_toast": "Feedback deleted.",
  "feedbacks_delete_failed": "Could not delete the feedback.",
  "feedbacks_comment_added_toast": "Comment added.",
  "feedbacks_comment_add_failed": "Could not add the comment.",
  "contact_consolidate_success": "Contacts consolidated.",
  "feat_org_balance_spend_policy_saved": "AI spend guardrails saved.",
  "feat_org_balance_spend_policy_save_failed": "Could not save AI spend guardrails.",
  "account_notifications_push_devices_revoke_success": "Push device revoked.",
  "account_notifications_preferences_update_failed": "Could not update notification preferences.",
  "chat_ai_toggle_failed": "Could not update the conversation's AI setting.",
  "messenger_bulk_archive_empty_toast": "There are no read conversations to archive.",
  "messenger_bulk_archived_toast": "Archived {{count}} conversations.",
  "messenger_bulk_archive_failed": "Could not archive all read conversations.",
  "messenger_archived_toast": "Conversation archived.",
  "messenger_unarchived_toast": "Conversation unarchived.",
  "messenger_archive_failed": "Could not archive the conversation.",
  "messenger_unarchive_failed": "Could not unarchive the conversation.",
  "messenger_label_assigned_toast": "Label assigned.",
  "messenger_label_assign_failed": "Could not assign the label.",
  "messenger_label_removed_toast": "Label removed.",
  "messenger_label_remove_failed": "Could not remove the label.",
  "messenger_label_create_failed": "Could not create the label.",
  "messenger_label_created_assignment_failed": "The label was created, but could not be assigned to the conversation.",
  "messenger_label_created_toast": "Label created.",
  "campaigns_updated_toast": "Campaign updated.",
  "campaigns_update_error": "Campaign could not be updated.",
  "campaigns_sent_toast": "Campaign launch started.",
  "campaigns_draft_saved_toast": "Campaign draft saved.",
  "campaigns_cancelled_toast": "Campaign cancelled.",
  "citation_check_failed": "Could not check the citations.",
  "messenger_label_deleted_toast": "Label deleted.",
  "messenger_label_delete_failed": "Could not delete the label.",
  "pending_org_intent_update_failed": "Could not save your organization setup choice.",
  "admin_a_suspend_success": "Organization suspended.",
  "admin_a_unsuspend_success": "Organization access restored.",
  "admin_a_quarantine_success": "Organization quarantined.",
  "admin_a_release_success": "Organization released from quarantine.",
  "feat_app_feedback_toast_status_updated": "Feedback status updated.",
  "feat_admin_org_balance_toast_credit_success": "Added {{count}} credits to the organization.",
  "feat_admin_plans_toast_create_draft_success": "Plan draft created.",
  "feat_admin_plans_toast_update_pricing_success": "Plan pricing saved.",
  "feat_admin_plans_toast_publish_success": "Plan published.",
  "feat_admin_plans_toast_phase_out_success": "Plan phased out.",
  "feat_playground_toast_delete_document_success": "Playground document deleted.",
  "feat_playground_toast_toggle_document_success": "Playground document status updated.",
  "feat_playground_toast_clear_success": "Playground cleared.",
  "feat_account_privacy_toast_request_deletion_success": "Account deletion scheduled.",
  "feat_account_privacy_toast_cancel_deletion_success": "Account deletion cancelled.",
  "feat_app_config_toast_upload_document_started": "Knowledge document added; processing started.",
  "feat_app_config_toast_delete_document_success": "Knowledge document deleted.",
  "feat_app_config_toast_schema_preload_enabled": "Schema preload enabled.",
  "feat_app_config_toast_schema_preload_disabled": "Schema preload disabled.",
  "feat_app_config_toast_image_policy_updated": "Document image handling updated.",
  "feat_app_config_toast_document_enabled": "Knowledge document enabled.",
  "feat_app_config_toast_document_disabled": "Knowledge document disabled.",
  "feat_app_config_toast_apply_strategy_started": "Embedding strategy applied; reprocessing started.",
  "contact_blocked_toast": "Contact blocked.",
  "contact_unblocked_toast": "Contact unblocked.",
  "contact_archived_toast": "Contact archived.",
  "contact_restored_toast": "Contact restored.",
  "contact_beneficiary_added_toast": "Beneficiary added.",
  "contact_beneficiary_renamed_toast": "Beneficiary renamed.",
  "contact_beneficiary_moved_toast": "Beneficiary moved.",
  "contact_beneficiary_merged_toast": "Beneficiaries merged.",
  "contact_beneficiary_separated_toast": "Beneficiary separated into a contact.",
  "contact_beneficiary_pulled_toast": "Contact moved under this contact.",
  "contact_beneficiary_demoted_toast": "Contact moved to beneficiaries.",
  "contact_beneficiary_archived_toast": "Beneficiary archived.",
  "cfg_val_google_maps_url": "Enter a Google Maps link (for example https://maps.app.goo.gl/… or https://www.google.com/maps?q=…).",
  "cfg_val_column_problem": "Column \"{{column}}\" {{reason}}",
  "cfg_val_column_missing_generic": "is missing {{field}}.",
  "cfg_val_column_identifier": "has no identifier. The identifier is the key each row's value is stored under, so the column can never hold data without one.",
  "cfg_val_column_data_type": "has no data type. The grid picks its editor (text box, date picker, dropdown, …) from the data type and cannot render the cell without it.",
  "cfg_val_column_width": "has no width. The grid lays columns out in pixels and skips any column whose width is unset.",
  "cfg_val_column_database_field": "is not mapped to a record field. Pick the record field it reads from — an unmapped column shows blank for every row.",
  "cfg_val_column_type_mismatch": "is mapped to a record field whose type does not match the column's data type. Change one of the two so they agree, or the grid will fail to parse existing values.",
  "cfg_val_column_dropdown_options": "is a dropdown with no options. Add at least one option value, or nothing can ever be selected in this column.",
  "cfg_val_working_days_empty": "No working day is switched on. With every day closed the calendar can never offer a bookable slot, so no appointment can be made at all.",
  "cfg_val_default_hours_missing": "The default opening and closing time is incomplete. Every working day without its own override falls back to this range, so slots cannot be generated until both times are set.",
  "cfg_val_default_hours_order": "The default closing time ({{end}}) is not after the opening time ({{start}}), so the working day has zero or negative length. Overnight ranges are not supported — use a date-range override instead.",
  "cfg_val_slot_duration_missing": "The slot duration is missing or zero. The calendar builds bookable slots by dividing each working day by this value, which is impossible at zero length.",
  "cfg_val_slot_division_minute": "{{scope}} runs {{start}}–{{end}} ({{minutes}} minutes), which a {{duration}} slot does not divide evenly — 1 minute would be left over at the end of the day. Pick a slot duration that fits a whole number of times, or move the closing time.",
  "cfg_val_slot_division_minutes": "{{scope}} runs {{start}}–{{end}} ({{minutes}} minutes), which a {{duration}} slot does not divide evenly — {{remainder}} minutes would be left over at the end of the day. Pick a slot duration that fits a whole number of times, or move the closing time.",
  "cfg_val_scope_default_day": "The default working day",
  "cfg_val_scope_day_override": "The {{day}} override",
  "cfg_val_event_types_empty": "No event type is defined. An event type is the thing a customer books (a consultation, a check-up, …) — with none configured the assistant's scheduling tools and the booking flow have nothing to offer.",
  "cfg_val_event_type_no_id": "Event type #{{n}} has no identifier. The identifier is what bookings, reminders, and the assistant's tools reference, so the row cannot be saved without it.",
  "cfg_val_event_type_no_name": "Event type #{{n}} has no name. The name is what customers see when picking what to book and what the assistant reads back to them.",
  "cfg_val_booking_requirements": "Both “Require name” and “Require phone” are off, so a booking could be created with no way to identify or contact the customer. Turn at least one back on.",
  "cfg_val_day_override_order": "The {{day}} override closes at {{end}}, which is not after its {{start}} opening time. That range covers no time at all, so {{day}} would have zero slots.",
  "cfg_val_range_override_hours": "Date range override \"{{label}}\" has a working-hours problem: a closing time that is not after its opening time, or hours that its slot duration does not divide evenly. Open the override and fix the times it flags — while it is invalid the calendar cannot generate slots for the dates it covers.",
  "cfg_val_day_overlapping_ranges": "Day {{day}} has overlapping working-hour ranges",
  "cfg_val_slot_duration_positive": "Slot duration must be positive",
  "cfg_val_event_type_required": "At least one event type is required",
  "cfg_val_id_required": "ID is required",
  "cfg_val_reminder_name_required": "A reminder needs a name.",
  "cfg_val_reminder_name_too_long": "Keep the reminder name under 50 characters.",
  "cfg_val_reminder_no_name": "Reminder #{{n}} has no name. {{reason}}",
  "cfg_val_reminder_bad_name": "Reminder name \"{{name}}\" contains characters the scheduler cannot use. {{reason}}",
  "cfg_val_reminder_no_template": "Reminder \"{{label}}\" has no message template selected. WhatsApp only delivers pre-approved templates, so this reminder would be dropped at send time.",
  "cfg_val_reminder_no_language": "Reminder \"{{label}}\" has no template language. A template is approved per language, so the provider needs to know which localisation to send.",
  "cfg_val_reminder_unmapped_vars": "Reminder \"{{label}}\" leaves {{vars}} unmapped. Every placeholder in the template must be bound to a booking field, or the provider rejects the message.",
  "cfg_val_rule_no_name": "Notification rule #{{n}} has no name. The name is how the rule is identified in the delivery log, so an unnamed rule is untraceable once it fires.",
  "cfg_val_rule_no_template": "Notification rule \"{{label}}\" has no message template selected. WhatsApp only delivers pre-approved templates, so this rule would be dropped at send time.",
  "cfg_val_rule_unmapped_vars": "Notification rule \"{{label}}\" leaves {{vars}} unmapped. Every placeholder in the template must be bound to a value, or the provider rejects the message.",
  "cfg_val_rule_no_recipients": "One-off rule \"{{label}}\" has no recipients. A custom rule is not tied to a booking, so it has no audience to derive — pick at least one phone number to send it to.",
  "cfg_val_rule_no_send_time": "One-off rule \"{{label}}\" has no send date and time. A custom rule fires at an absolute moment rather than relative to a booking, so it never fires without one.",
  "cfg_val_custom_rule_scheduled_at": "Scheduled date & time is required for custom rules",
  "cfg_val_no_calendar_view": "No calendar view is enabled. The calendar page renders one of these views, so with none enabled it has nothing to show.",
  "cfg_val_default_view_not_enabled": "\"{{view}}\" is set as the default view but is not one of the enabled views, so the calendar would open on a view nobody can switch back to. Enable it, or pick a default from the enabled list.",
  "cfg_val_must_be_one_of": "Must be one of: {{values}}",
  "cfg_val_no_theme_enabled": "No theme is enabled. Every member picks their appearance from this list, so an empty list leaves the app with no theme to render.",
  "cfg_val_no_language_enabled": "No display language is enabled. The app, the notification templates, and the assistant's language-backed tools all resolve their language from this list.",
  "cfg_val_no_calendar_columns": "The calendar grid has no columns. Every booking field shown in the grid comes from this list, so the grid would render as an empty table.",
  "cfg_val_no_document_columns": "The documents grid has no columns. Every field shown in the documents table comes from this list, so the table would render empty.",
  "cfg_val_language_required": "At least one language is required",
  "cfg_val_english_required": "English (en) must always be included",
  "cfg_val_system_prompt_missing": "The assistant has no instructions. Without them it replies with generic model behaviour instead of your business's tone, policies, and boundaries. Write a prompt in the instructions editor, or apply one of the saved assistant presets from the switcher at the top of this section.",
  "cfg_val_context_window_label": "{{model}}'s {{tokens}}-token context window",
  "cfg_val_system_prompt_over_context": "The instructions are roughly {{tokens}} tokens, which does not fit inside {{window}}. The prompt is sent with every single message, so the request would be rejected before the customer's question is even read. Shorten it, or pick a model with a larger window.",
  "cfg_val_system_prompt_no_headroom": "The instructions are roughly {{tokens}} tokens and {{window}} leaves only {{left}} for everything else — less than the {{reserved}} tokens reserved for the reply and the conversation history. Shorten the prompt, lower the max output tokens, or pick a model with a larger window.",
  "cfg_val_max_output_above_window": "Max output tokens ({{tokens}}) claims {{model}}'s entire {{window}}-token window, leaving nothing for the prompt or the customer's message. Reserve output room well below the window.",
  "cfg_val_model_cannot_call_tools": "{{model}} does not support function calling, but tools are switched on below. The assistant would silently never invoke any of them — it could not book, look anything up, or read the knowledge base. Pick a tool-capable model or turn every tool off.",
  "cfg_val_the_selected_model": "the selected model",
  "cfg_val_the_selected_model_caps": "The selected model",
  "cfg_val_kb_source": "{{count}} knowledge-base source",
  "cfg_val_kb_sources": "{{count}} knowledge-base sources",
  "cfg_val_kb_tools_off": "You have uploaded {{sources}}, but knowledge-base tools are switched off, so the assistant can never read any of them. Turn the knowledge-base tools back on, or remove the sources.",
  "cfg_val_kb_retrieval_disabled": "You have uploaded {{sources}}, but no document-retrieval tool is enabled, so the assistant has no way to search them. Enable the knowledge-base (document search) tool.",
  "cfg_val_kb_no_embedding_model": "You have uploaded {{sources}}, but no embedding model is selected. Uploaded documents are searched by comparing embeddings, so without one every knowledge-base lookup returns nothing.",
  "cfg_val_scheduling_actions_disabled": "Scheduling is switched on for the assistant, but every booking action (book, reschedule, cancel, join waitlist) is disabled. The assistant can read availability out loud and then do nothing with it — enable at least one booking action, or turn the scheduling tools off entirely.",
  "cfg_val_researcher_model_missing": "Answering mode {{mode}} runs a researcher sub-agent before replying, but no researcher model is selected, so that step has nothing to run on. Pick a model, or drop back to mode 1 (single agent).",
  "cfg_val_verifier_model_missing": "Answering mode 5 verifies every draft answer before sending it, but no verifier model is selected, so verification has nothing to run on. Pick a model, or drop back to mode 4.",
  "cfg_val_lead_fields_missing": "Lead collection is switched on but no lead field is defined, so the assistant would ask for nothing and store nothing. Add at least one field to collect, or turn lead collection off.",
  "cfg_val_save_feedback_language": "Feedback capture is switched on but its summary language is not one of the enabled display languages, so every summary it writes would be in a language the app cannot render. Pick a language from the enabled list.",
  "cfg_val_summarize_language": "Conversation summaries are switched on but the summary language is not one of the enabled display languages, so every summary would be written in a language the app cannot render. Pick a language from the enabled list.",
  "cfg_val_tool_language_required": "{{label}} is required for {{tool}}.",
  "cfg_val_tool_language_not_enabled": "Summary language must be one of the enabled display languages.",
  "cfg_val_fallback_not_allowed": "When the primary AI model is 'auto', it already handles fallback routing. Disable the fallback or pick a concrete primary model first.",
  "cfg_val_fallback_required": "Choose a fallback for the primary AI model — select a model, or use 'auto'.",
  "cfg_val_fallback_invalid_model": "Fallback AI model must be a valid model selection",
  "cfg_val_fallback_same_as_primary": "Fallback AI model cannot use the same model and provider as the primary AI model. Select a different model or provider.",
  "cfg_req_business_name": "The assistant introduces itself with your business name, and every notification template signs off with it. Left blank, customers get messages from an unnamed sender.",
  "cfg_req_business_address": "The assistant answers “where are you?” from this field and it is injected into every set of directions it gives. Left blank, it has to tell customers it does not know where the business is.",
  "cfg_req_business_floor_unit": "The floor or unit is the last leg of the directions the assistant gives — a street address alone leaves customers standing in the lobby. Put “Ground floor” here if there is only one.",
  "cfg_req_business_landmark": "The nearby landmark is what the assistant uses to orient customers who cannot find the entrance from the street address alone. Name the closest well-known building or junction.",
  "cfg_req_business_maps_url": "This is the map link the assistant sends when a customer asks for directions. Dropping a pin with the picker below fills it in for you.",
  "cfg_req_country_prefix": "Every phone number typed without a country code is normalised against this prefix. Left blank, local numbers cannot be matched to their contact and messages are delivered to nobody.",
  "cfg_req_timezone": "Every booking time, reminder send-time, and timestamp the assistant quotes is resolved in this timezone. Left blank there is no way to tell what “3pm” means.",
  "cfg_req_llm_model": "No AI model is selected, so the assistant has nothing to run on — it cannot reply to a single message. Pick the model it should use.",
  "cfg_req_working_days": "Availability is generated from the open days. With none selected the calendar can never offer a bookable slot.",
  "cfg_req_default_working_hours": "Every working day without its own override falls back to these opening and closing times, so slots cannot be generated until both are set.",
  "cfg_req_event_types": "An event type is the thing a customer books. With none defined the booking flow and the assistant's scheduling tools have nothing to offer.",
  "cfg_req_generic": "{{label}} is required for your plan and is currently empty. Fill it in to save.",
  "cfg_val_label_working_days": "Working Days",
  "cfg_val_label_default_hours": "Default Working Hours",
  "cfg_val_label_slot_duration": "Slot Duration",
  "cfg_val_label_event_types": "Event Types",
  "cfg_val_label_booking_requirements": "Booking Requirements",
  "cfg_val_label_day_override": "Overrides — {{day}}",
  "cfg_val_label_range_override": "Date Range Override — {{label}}",
  "cfg_val_label_reminder": "Reminder — {{label}}",
  "cfg_val_label_notification_rule": "Notification Rule — {{label}}",
  "cfg_val_label_available_views": "Available Calendar Views",
  "cfg_val_label_default_view": "Default Calendar View",
  "cfg_val_label_themes": "Themes",
  "cfg_val_label_languages": "Languages",
  "cfg_val_list_calendar_columns": "Calendar Columns",
  "cfg_val_list_documents_columns": "Documents Columns",
  "cfg_val_label_document_columns": "Document Columns",
  "cfg_val_label_system_prompt": "System Prompt",
  "cfg_val_label_max_output_tokens": "Max Output Tokens",
  "cfg_val_label_ai_model": "AI Model",
  "cfg_val_label_ai_tools": "AI Tools",
  "cfg_val_label_kb_tools": "Knowledge Base Tools",
  "cfg_val_label_embedding_model": "Embedding Model",
  "cfg_val_label_researcher_model": "Researcher Model",
  "cfg_val_label_verifier_model": "Verifier Model",
  "cfg_val_label_lead_collection": "Lead Collection",
  "cfg_val_label_feedback_language": "Feedback summary language",
  "cfg_val_label_summary_language": "Summary language",
  "cfg_val_section_appearance_themes": "Appearance > Themes",
  "cfg_val_section_appearance_languages": "Appearance > Languages",
  "cfg_val_section_calendar_columns": "Data > Calendar Columns",
  "cfg_val_section_documents_columns": "Data > Documents Columns",
  "cfg_val_context_appearance_data": "Appearance & Data",
  "cfg_val_weekday_sunday": "Sunday",
  "cfg_val_weekday_monday": "Monday",
  "cfg_val_weekday_tuesday": "Tuesday",
  "cfg_val_weekday_wednesday": "Wednesday",
  "cfg_val_weekday_thursday": "Thursday",
  "cfg_val_weekday_friday": "Friday",
  "cfg_val_weekday_saturday": "Saturday",
  "cfg_val_weekday_unknown": "Day {{n}}",
  "cfg_val_latitude_range": "Latitude must be between -90 and 90 degrees.",
  "cfg_val_longitude_range": "Longitude must be between -180 and 180 degrees.",
  "cfg_val_country_prefix_shape": "Enter a dialling prefix as + followed by 1–4 digits (for example +966).",
  "cfg_val_timezone_unknown": "Pick a timezone from the list — this is not a recognised IANA timezone name.",
  "campaigns_capacity_preview": "{{eligible}} eligible recipients · {{unique}} new daily recipients · {{monthly}} monthly sends available",
  "campaigns_capacity_unavailable": "Capacity unavailable. Refresh before sending.",
  "campaigns_capacity_checking": "Checking sending capacity…",
  "campaigns_setup_required": "WhatsApp setup required",
  "campaigns_sender_blocked": "WhatsApp sender restricted",
  "campaigns_capacity_reserved": "{{count}} recipients reserved",
  "campaigns_capacity_delivered": "{{count}} recipients observed delivered",
  "campaigns_monthly_capacity": "Monthly campaign sends: {{used}} used · {{reserved}} reserved · {{limit}} allowed",
  "campaigns_capacity_next": "Next expected capacity release: {{time}}",
  "campaigns_capacity_checked": "Last successful check: {{time}}",
  "campaigns_refresh_capacity": "Refresh capacity",
  "campaigns_worker_required": "Campaign worker required"
}
